(function() {
    'use strict';

    angular
        .module('soopkitchenApp', [
            'ngStorage',
            'ngResource',
            'ngCookies',
            'angularConsent',
            'ngAria',
            'ngCacheBuster',
            'ngFileUpload',
            'ui.bootstrap',
            'ui.bootstrap.datetimepicker',
            'ui.router',
            'infinite-scroll',
            // jhipster-needle-angularjs-add-module JHipster will add new module here
            'angular-loading-bar',
            'jsonFormatter',
            'daterangepicker'
        ])
        .run(run);

    run.$inject = ['stateHandler'];

    function run(stateHandler) {
        stateHandler.initialize();
    }
})();

(function () {
    'use strict';

    angular
        .module('soopkitchenApp')
        .factory('User', User);

    User.$inject = ['$resource'];

    function User ($resource) {
        var service = $resource('api/users/:login', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'save': { method:'POST' },
            'update': { method:'PUT' },
            'delete':{ method:'DELETE'}
        });
        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('soopkitchenApp')
        .factory('ProfileService', ProfileService);

    ProfileService.$inject = ['$http'];

    function ProfileService($http) {

        var dataPromise;

        var service = {
            getProfileInfo : getProfileInfo
        };

        return service;

        function getProfileInfo() {
            if (angular.isUndefined(dataPromise)) {
                dataPromise = $http.get('api/profile-info').then(function(result) {
                    if (result.data.activeProfiles) {
                        var response = {};
                        response.activeProfiles = result.data.activeProfiles;
                        response.ribbonEnv = result.data.ribbonEnv;
                        response.inProduction = result.data.activeProfiles.indexOf("prod") !== -1;
                        response.swaggerEnabled = result.data.activeProfiles.indexOf("swagger") !== -1;
                        return response;
                    }
                });
            }
            return dataPromise;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('soopkitchenApp')
        .directive('pageRibbon', pageRibbon);

    pageRibbon.$inject = ['ProfileService', '$rootScope'];

    function pageRibbon(ProfileService, $rootScope) {
        var directive = {
            replace : true,
            restrict : 'AE',
            template : '<div class="ribbon hidden"><a href="" >{{ribbonEnv}}</a></div>',
            link : linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            ProfileService.getProfileInfo().then(function(response) {
                if (response.ribbonEnv) {
                    scope.ribbonEnv = response.ribbonEnv;
                    element.addClass(response.ribbonEnv);
                    element.removeClass('hidden');
                }
            });
        }
    }
})();


/**
 * Created by ttsounis on 01/02/18.
 */
(function() {
    'use strict';
    angular
        .module('soopkitchenApp')
        .factory('SoopkitchenUtils', SoopkitchenUtils);

    SoopkitchenUtils.$inject = ['$rootScope', 'Planning'];

    function SoopkitchenUtils($rootScope, Planning) {

        var defaultSwalParams = {
            customClass: 'swal-custom'
        };

        return {
            invokeSweetAlert : invokeSweetAlert,
            invokeSweetAlertWithParams : invokeSweetAlertWithParams,
            prettyError : prettyError,
            processResponse : processResponse,
            prettyConfirm : prettyConfirm,
            panicConfirm : panicConfirm,
            unlockPrompt : unlockPrompt,
            bookmarkPrompt : bookmarkPrompt,
            saveBaselinePrompt : saveBaselinePrompt,
            sanityChecksResult : sanityChecksResult,
            showPlanChanges : showPlanChanges,
            unlockPlan : unlockPlan,
            lockPlan : lockPlan,
            dateToSeconds: dateToSeconds,
            timeToSeconds : timeToSeconds,
            secondsToTime : secondsToTime,
            secondsElapsedFrom : secondsElapsedFrom,
            timeStringElapsed : timeStringElapsed,
            addTimeStringToDate : addTimeStringToDate,
            roundDecimals : roundDecimals,
            formattedDate : formattedDate,
            formatIsoZuluDateString : formatIsoZuluDateString,
            isValidDate : isValidDate,
            sort : sort,
            removeIndexFromArray : removeIndexFromArray,
            padNumber : padNumber,
            getDayOfYear : getDayOfYear,
            extractArrayFromMap: extractArrayFromMap,
            styleForInstantEvent: styleForInstantEvent,
            updatePlanFromDialog : updatePlanFromDialog,
            prettyConfirmHtml: prettyConfirmHtml,
            prettyHtml: prettyHtml,
            resultEMCMandQuiet: resultEMCMandQuiet
        };

        function padNumber(num, size) {
            var s = num + "";
            while (s.length < size) s = "0" + s;
            return s;
        }

        function getDayOfYear(date) {
            return padNumber(moment.utc(date).format('DDD'), 3);
        }

        function invokeSweetAlert(title, text, type, callback) {
            invokeSweetAlertWithParams({title: title, text: text, type: type}, callback);
        }

        function invokeSweetAlertWithParams(params, callback) {
            var fullParams = Object.assign({}, defaultSwalParams, params);
            swal(fullParams, callback);
        }

        function prettyError(response, callback) {
            prettyAlert(response, '', '', callback);
        }

        function processResponse(response, title, message, callback) {
             prettyAlert(response, title, message, callback);
        }

        function prettyAlert(response, title, message, callback) {
            if (response.status === 0) {
                invokeSweetAlert('Server not reachable', 'Server not reachable', 'error', callback);
            } else {
                var errorHeaders = Object.keys(response.headers()).filter(function (header) {
                    return header.indexOf('app-detailserror-') >= 0;
                });
                if (errorHeaders.length > 0) {
                    processErrorHeaders(response, title, message, errorHeaders, callback);
                }
                else if (response.status >= 200 && response.status < 299) {
                    invokeSweetAlert(title, message, 'success', callback);
                } else {
                    processRestOfTheErrors(response, callback);
                }
            }
        }

        function processErrorHeaders(response, title, message, errorHeaders, callback) {
            var type = 'error';
            if (response.status >= 200 && response.status < 299) {
                type = 'warning';
            }
            var newTitle = response.headers("X-soopkitchenApp-titleError");
            if (title) {
                newTitle = title + ', ' + newTitle;
            }
            var details = '';
            if (message) {
                details = '<h4>' + prepareStringForHtml(message) + '</h4><hr/>'
            }
            details += '<div class="table-wrapper-scroll-x table-wrapper-scroll-y">';
            for (var i = 0; i < errorHeaders.length; i++) {
                var error = prepareStringForHtml(response.headers(errorHeaders[i]));
                details += '<div class="div-in-error">' + error + '</div>';
            }
            details += '</div>';
            invokeSweetAlertWithParams({
                title: newTitle,
                text: details,
                html: true,
                type: type,
                customClass: 'swal-wide',
                showCancelButton: callback != null,
                confirmButtonColor: "#DD6B55"
            }, callback);
        }

        function processRestOfTheErrors(response, callback) {
            var headers = Object.keys(response.headers()).filter(function (header) {
                return header.indexOf('app-error', header.length - 'app-error'.length) !== -1 || header.indexOf('app-params', header.length - 'app-params'.length) !== -1;
            }).sort();
            var errorHeader = response.headers(headers[0]);
            if (errorHeader) {
                invokeSweetAlert('Error', errorHeader, 'error', callback);
            }
        }

        function prettyConfirm(title, text, callback) {
            invokeSweetAlertWithParams({
                title: title,
                text: text,
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: "#DD6B55"
            }, callback);
        }

        function prettyConfirmHtml(title, text, callback) {
            invokeSweetAlertWithParams({
                title: title,
                text: text,
                html: true,
                customClass: 'swal-wide',
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: "#DD6B55"
            }, callback);
        }

        function prettyHtml(title, text, type, callback) {
            invokeSweetAlertWithParams({
                title: title,
                text: text,
                html: true,
                customClass: 'swal-wide',
                type: type,
                showCancelButton: true,
                confirmButtonColor: "#DD6B55"
            }, callback);
        }

        function panicConfirm(title, text, callback) {
            invokeSweetAlertWithParams({
                title: "<h1>Panic Button</h1>",
                text: "<img  height='183' width='245' src='content/images/panic.jpg'/> <br>" + text,
                showCancelButton: true,
                html: true,
                confirmButtonColor: "#DD6B55"
            }, callback);
        }

        function unlockPrompt(title, text, callback) {
            invokeSweetAlertWithParams({
                title: title,
                text: text,
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                html: true
            }, callback);
        }

        function bookmarkPrompt(callback) {
            invokeSweetAlertWithParams({
                title: "Bookmark",
                text: "Your about to bookmark the status of the plan. Please add a comment",
                type: "input",
                showCancelButton: true,
                closeOnConfirm: false,
                animation: "slide-from-top",
                inputPlaceholder: "Comment"
            }, callback);
        }

        function saveBaselinePrompt(callback) {
            invokeSweetAlertWithParams({
                title: "Saving Baseline",
                text: "Your about to save the baseline for the plan. Please add a comment",
                type: "input",
                showCancelButton: true,
                closeOnConfirm: false,
                animation: "slide-from-top",
                inputPlaceholder: "Comment"
            }, callback);
        }

        function resultEMCMandQuiet(response, callback, confirmationMessage) {
            var type = 'success';
            var happenings = response.eventsTimeline.happenings;

            var text = '<div class="table-wrapper-scroll-x table-wrapper-scroll-y">'
            text += '<table class="jh-table table table-striped"><tbody>';
            text += '<thead><tr>';
            text += '<th>Dates</th>';
            text += '</tr></thead>';
            // for (var i = 0; i < happenings.length; i++) { text+=happenings[i].startDate + "-" + happenings[i].endDate+ "\n"; }
            var fullMsg = "";
            for (var i = 0; i < happenings.length; i++) {
                var cssClass = 'class="label label-info"';
                text += '<tr>';
                var check = '<span ' + cssClass + '>' + happenings[i].startDate + "-" + happenings[i].endDate + '<br>' + '</span> ';
                text += '<td nowrap style="text-align:left;vertical-align:top">' + check + '</td>';
                text += '</tr>';
            }
            text += '</tbody></table></div>';
            if (confirmationMessage != null) {
                text+="<div>"+confirmationMessage+"</div>";
            }
            invokeSweetAlertWithParams({
                title: "EMC",
                showCancelButton: callback != null,
                text: text,
                html: true,
                type: type,
                customClass: 'swal-wide',
                animation: "slide-from-top",
            }, callback);
        }
        function sanityChecksResult(response, callback, confirmationMessage) {
            var type = 'success';
            var data = angular.fromJson(response.data);

            var text = '<div class="table-wrapper-scroll-x table-wrapper-scroll-y">'
            text += '<table class="jh-table table table-striped"><tbody>';
            text += '<thead><tr>';
            text += '<th>Check</th>';
            text += '<th>Messages</th>';
            text += '</tr></thead>';
            for (var i = 0; i < data.length; i++) {

                var cssClass = 'class="label label-info"';
                if (data[i].status === 'FAILED') {
                    type = 'error';
                    cssClass = 'class="label label-danger"';
                }

                var fullMsg = '';
                for (var j = 0; j < data[i].msg.length; j++) {
                    fullMsg += prepareStringForHtml(data[i].msg[j]) + '<br>';
                }

                text += '<tr>';
                var check = '<span ' + cssClass + '>' + prepareStringForHtml(data[i].status) + '</span> ' + prepareStringForHtml(data[i].name);
                text += '<td nowrap style="text-align:left;vertical-align:top">' + check + '</td>';
                text += '<td nowrap style="text-align:left;vertical-align:top">' + fullMsg + '</td>';
                text += '</tr>';
            }
            text += '</tbody></table></div>';
            if (confirmationMessage != null) {
                text+="<div>"+confirmationMessage+"</div>";
            }
            invokeSweetAlertWithParams({
                title: "Sanity Checks",
                showCancelButton: callback != null,
                text: text,
                html: true,
                type: type,
                customClass: 'swal-wide',
                animation: "slide-from-top",
            }, callback);
        }

        function showPlanChanges(response, callback) {
            var messages = response.messages || []; // Extract messages list

            var text = '<div class="table-wrapper-scroll-y">';
            text += '<table class="jh-table table table-striped"><tbody>';

            for (var i = 0; i < messages.length; i++) {
                text += '<tr>';
                text += '<td style="text-align:left;vertical-align:top">';
                text += prepareStringForHtmlChanges(messages[i]); // Ensure proper formatting
                text += '</td>';
                text += '</tr>';
            }

            text += '</tbody></table></div>';

            invokeSweetAlertWithParams({
                title: "Plan Changes",
                showCancelButton: false,
                text: text,
                html: true,
                type: 'info',
                customClass: 'swal-wide',
                animation: "slide-from-top",
            }, callback);
        }




        function unlockPlan(label, planType, successCallback) {
            Planning.unlock(
                {
                    planType: planType,
                    planLabel: label,
                },
                function () {
                    successCallback();
                },
                function () {
                }
            );
        }

        function lockPlan(label, planType, successCallback) {
            Planning.lock(
                {
                    planType: planType,
                    planLabel: label,
                },
                function () {
                    invokeSweetAlert('Nice', 'You locked plan ' + label, 'success');
                    successCallback();
                },
                function () {
                    invokeSweetAlert('Ooops', 'There was a problem locking the plan', 'error');
                }
            );
        }

        function dateToSeconds(inputDate) {
          var dateObject;
          if (inputDate == null) {
            return 0;
          } else if (inputDate instanceof Date) {
            dateObject = inputDate;
          } else {
            dateObject = new Date(inputDate);
          }
          return dateObject.getTime() / 1000;
        }

        function timeToSeconds (timeString) {
            var totalSeconds = 0;
            var numberString = "";
            if (isNaN(timeString[timeString.length-1]) === false) return 0;
            for (var i = 0; i < timeString.length; i++) {
                if (isNaN(timeString[i])) {
                    switch(timeString[i]) {
                        case "d":
                            totalSeconds += (3600*24) * parseInt(numberString) ;
                            break;
                        case "h":
                            totalSeconds += (3600) * parseInt(numberString) ;
                            break;
                        case "m":
                            totalSeconds +=  60 * parseInt(numberString) ;
                            break;
                        case "s":
                            totalSeconds += parseInt(numberString) ;
                            break;
                        default:
                            return 0;
                            break;
                    }
                    numberString = "";
                } else {
                    numberString =  numberString + timeString[i];
                }
            }
            return totalSeconds;
        }

        function secondsElapsedFrom(anchorDate, currentDate) {
            var anchorDateSeconds = Date.parse(anchorDate).valueOf() / 1000;
            var currentDateSeconds = Date.parse(currentDate).valueOf() / 1000;
            return currentDateSeconds - anchorDateSeconds;
        }

        function timeStringElapsed(anchorDate, currentDate) {
            return secondsToTime (secondsElapsedFrom(anchorDate, currentDate));
        }

        function addTimeStringToDate(anchorDate, timeString) {
            var seconds = timeToSeconds(timeString);
            return new Date(Date.parse(anchorDate).valueOf() + seconds * 1000);
        }

        function secondsToTime (secs) {
            secs = Math.round(secs);
            var days =  Math.floor( secs / (24*60*60));

            var divisor_for_hours = secs % (60 * 60 *24);
            var hours = Math.floor( divisor_for_hours / (60*60));

            var divisor_for_minutes = secs % (60 * 60);
            var minutes = Math.floor(divisor_for_minutes / 60);

            var divisor_for_seconds = divisor_for_minutes % 60;
            var seconds = Math.ceil(divisor_for_seconds);

            var obj = {
                "d": days,
                "h": hours,
                "m": minutes,
                "s": seconds
            };

            var time = "";
            if (obj.d > 0) {
                time += obj.d + 'd';
            }
            if (obj.h > 0) {
                time += obj.h + 'h';
            }
            if (obj.m > 0) {
                time += obj.m + 'm';
            }
            if (obj.s > 0) {
                time += obj.s + 's';
            }
            return time;
        }

        function roundDecimals (number, n) {
            if (number == null) return "";
            return Number(number.toFixed(n)).toString();
        }

        function formattedDate(date) {
            if (date == null) return "";
            return  date.toISOString().split('.')[0]+"Z";
        }

        function formatIsoZuluDateString(dateStr) {
            if (!dateStr) return "";
            return  dateStr.substring(0, 10) + " " + dateStr.substring(11, 16);
        }

        function isValidDate(date) {
            return (Date.parse(date) >0 && false === isNaN(Date.parse(date)));
        }

        function sort(listOccurrences, predicate, reverse) {
            listOccurrences.sort(function(a, b) {
                var condition;
                if (isNaN(a[predicate])) {
                    if (!a[predicate] && !b[predicate]) {
                        return 0;
                    }
                    if (!a[predicate] && b[predicate]) {
                        condition = 1;
                    }
                    else if (a[predicate] && !b[predicate]) {
                        condition = -1;
                    }
                    else if (String(a[predicate]).toUpperCase() === String(b[predicate].toUpperCase())) {
                        return 0;
                    } else {
                        condition = String(a[predicate]).toUpperCase() > String(b[predicate].toUpperCase());
                    }
                } else {
                    if (a[predicate] === b[predicate]) {
                        return 0;
                    }
                    condition = a[predicate] > b[predicate];
                }
                if (reverse) {
                    condition = !condition;
                }
                if (condition) {
                    return 1;
                } else if (false === condition) {
                    return -1;
                }
                return 0;
            });
            return listOccurrences;
        }

        function prepareStringForHtml(str) {
            return str.replace('&', '&amp;').replace('<', '&lt;').replace('>', '&gt;');
        }

        function prepareStringForHtmlChanges(str) {
            if (typeof str !== 'string') {
                str = String(str);  // Convert to string if needed
            }
            return str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
        }

        function removeIndexFromArray(array, index) {
            if (index !== -1) {
                array.splice(index, 1);
            }
        }
        function extractArrayFromMap(map, id) {
            var array = [];
            for (var key in map) {
                // check if the property/key is defined in the object itself, not in parent
                if (map.hasOwnProperty(key)) {
                    var obj = map[key];
                    obj[id] = key;
                    array.push(obj);
                }
            }
            return array;
        }
        function styleForInstantEvent(style) {
            style += "width:10px; ";
            style += "height: 10px; ";
            style += "height: 10px; ";
            style += "border: 2px solid ";
            style += "-webkit-transform: rotate(45deg) skew(15deg, 15deg); ";
            style += "-moz-transform: rotate(45deg) skew(15deg, 15deg); ";
            style += "-ms-transform: rotate(45deg) skew(15deg, 15deg); ";
            style += "-o-transform: rotate(45deg) skew(15deg, 15deg); ";
            style += "transform: rotate(45deg) skew(15deg, 15deg);";
            return style;
        }

        function updatePlanFromDialog(data) {
            $rootScope.$broadcast('updateList', {
                data: data
            });
        }
    }
})();

/**
 * Created by esalazar on 9/27/17.
 */
(function() {
    'use strict';
    angular
        .module('soopkitchenApp')
        .factory('FileUploadService', FileUploadService);

    FileUploadService.$inject = [ 'Upload'];

    function FileUploadService( Upload ) {

        return {
            uploadFiles : uploadFiles,
            progressCallback: progressCallback
        };

        function progressCallback() {
            //Nothing at present
        }
        function uploadFiles(files, urlService, label, successCallback, errorCallback, progressCallback, desc) {
            if (files && files.length) {
                Upload.upload({
                    url: urlService,
                    data: {
                        files: files, label : label, description : desc
                    },
                    arrayKey:''
                }).then(successCallback, errorCallback, progressCallback);
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('soopkitchenApp')
        .factory('Sessions', Sessions);

    Sessions.$inject = ['$resource'];

    function Sessions ($resource) {
        return $resource('api/account/sessions/:series', {}, {
            'getAll': { method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('soopkitchenApp')
        .factory('Register', Register);

    Register.$inject = ['$resource'];

    function Register ($resource) {
        return $resource('api/register', {}, {});
    }
})();

(function() {
    'use strict';

    angular
        .module('soopkitchenApp')
        .factory('Principal', Principal);

    Principal.$inject = ['$q', 'Account', 'JhiTrackerService'];

    function Principal ($q, Account, JhiTrackerService) {
        var _identity,
            _authenticated = false;

        var service = {
            authenticate: authenticate,
            hasAnyAuthority: hasAnyAuthority,
            hasAuthority: hasAuthority,
            identity: identity,
            getUserInstruments: getUserInstruments,
            isInUsers: isInUsers,
            isUser: isUser,
            isAuthenticated: isAuthenticated,
            isIdentityResolved: isIdentityResolved
        };

        return service;

        function authenticate (identity) {
            _identity = identity;
            _authenticated = identity !== null;
        }

        function hasAnyAuthority (authorities) {
            if (!_authenticated) {
                return $q.when(false);
            }
            
            return this.identity().then(function(_id) {
                for (var i = 0; i < authorities.length; i++) {
                    if (_id.authorities && _id.authorities.indexOf(authorities[i]) !== -1) {
                        return true;
                    }
                }
            }, function(){
                return false;
            });
        }

        function hasAuthority (authority) {
            if (!_authenticated) {
                return $q.when(false);
            }

            return this.identity().then(function(_id) {
                return _id.authorities && _id.authorities.indexOf(authority) !== -1;
            }, function(){
                return false;
            });
        }

        function getUserInstruments () {
            if (!_authenticated) {
                return [];
            }
            return this.identity().then(function(_id) {
                return _id.instruments;
            }, function() {
                return [];
            });
        }

        function isUser (login) {
            if (!_authenticated) {
                return $q.when(false);
            }

            return this.identity().then(function(_id) {
                return _id.login && _id.login === login;
            }, function(){
                return false;
            });
        }

        function isInUsers (logins) {
            if (!_authenticated) {
                return $q.when(false);
            }

            return this.identity().then(function(_id) {
                for (var i = 0; i < logins.length; i++) {
                    if (_id.login && _id.login === logins[i]) {
                        return true;
                    }
                }
            }, function(){
                return false;
            });
        }
        
        function identity (force) {
            var deferred = $q.defer();

            if (force === true) {
                _identity = undefined;
            }

            // check and see if we have retrieved the identity data from the server.
            // if we have, reuse it by immediately resolving
            if (angular.isDefined(_identity)) {
                deferred.resolve(_identity);

                return deferred.promise;
            }

            // retrieve the identity data from the server, update the identity object, and then resolve.
            Account.get().$promise
                .then(getAccountThen)
                .catch(getAccountCatch);

            return deferred.promise;

            function getAccountThen (account) {
                _identity = account.data;
                _authenticated = true;
                deferred.resolve(_identity);
                JhiTrackerService.connect();
            }

            function getAccountCatch () {
                _identity = null;
                _authenticated = false;
                deferred.resolve(_identity);
            }
        }

        function isAuthenticated () {
            return _authenticated;
        }

        function isIdentityResolved () {
            return angular.isDefined(_identity);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('soopkitchenApp')
        .factory('PasswordResetInit', PasswordResetInit);

    PasswordResetInit.$inject = ['$resource'];

    function PasswordResetInit($resource) {
        var service = $resource('api/account/reset_password/init', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('soopkitchenApp')
        .factory('PasswordResetFinish', PasswordResetFinish);

    PasswordResetFinish.$inject = ['$resource'];

    function PasswordResetFinish($resource) {
        var service = $resource('api/account/reset_password/finish', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('soopkitchenApp')
        .factory('Password', Password);

    Password.$inject = ['$resource'];

    function Password($resource) {
        var service = $resource('api/account/change_password', {}, {});

        return service;
    }
})();

/*
 * ---license-start---
 * Solar Orbiter Science Operations software
 * ----
 * Copyright (C) 2012 - 2018 European Space Agency - Solar Orbiter SOC
 * ----
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Lesser General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Lesser Public License for more details.
 *
 * You should have received a copy of the GNU General Lesser Public
 * License along with this program.  If not, see
 * <http://www.gnu.org/licenses/lgpl-3.0.html>.
 * ---license-end---
 */
(function () {
    'use strict';

    angular
        .module('soopkitchenApp')
        .directive('isUserTables', isUser);

    isUser.$inject = ['Principal'];

    function isUser(Principal) {

        var directive = {
            restrict: 'A',
            link: linkFunc,
            scope :{isUserTables:'@' }
        };

        return directive;

        function linkFunc(scope, element, attrs) {

            var authority = attrs.hasAuthority.replace(/\s+/g, '');
            var user = attrs.isUserTables.replace(/\s+/g, '');

            var setVisible = function () {
                element.removeClass('hidden');
            };

            var setHidden = function () {
                element.addClass('hidden');
            };

            var defineVisibility = function (reset, currentUser) {

                if (reset) {
                    setVisible();
                }

                Principal.hasAuthority(authority)
                    .then(function (result) {
                        if (result) {
                            setVisible();
                        } else {
                            Principal.isUser(currentUser)
                                .then(function (result) {
                                    if (result) {
                                        setVisible();
                                    } else {
                                        setHidden();
                                    }
                                });
                        }
                    });
            };

            if (user.length > 0) {
                defineVisibility(true, user);
            }
            scope.$watch('isUserTables', function (newValue) {
                defineVisibility(true, newValue);
            });
        }
    }
})();

/*
 * ---license-start---
 * Solar Orbiter Science Operations software
 * ----
 * Copyright (C) 2012 - 2018 European Space Agency - Solar Orbiter SOC
 * ----
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Lesser General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Lesser Public License for more details.
 *
 * You should have received a copy of the GNU General Lesser Public
 * License along with this program.  If not, see
 * <http://www.gnu.org/licenses/lgpl-3.0.html>.
 * ---license-end---
 */
(function () {
    'use strict';

    angular
        .module('soopkitchenApp')
        .directive('isUser', isUser);

    isUser.$inject = ['Principal'];

    function isUser(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var user = attrs.isUser.replace(/\s+/g, '');

            var setVisible = function () {
                element.removeClass('hidden');
            };
            var setHidden = function () {
                if (!element.attr('show')) {
                    element.addClass('hidden');
                }
            };
            var defineVisibility = function (reset) {
                if (reset) {
                    setVisible();
                }

                Principal.isUser(user)
                    .then(function (result) {
                        if (result) {
                            element.attr('show', 'true');
                            setVisible();
                        } else {
                            setHidden();
                        }
                    });
            };

            if (user.length > 0) {
                defineVisibility(true);

                scope.$watch(function () {
                    return Principal.isAuthenticated();
                }, function () {
                    defineVisibility(true);
                });
            }
        }
    }
})();

/*
 * ---license-start---
 * Solar Orbiter Science Operations software
 * ----
 * Copyright (C) 2012 - 2018 European Space Agency - Solar Orbiter SOC
 * ----
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Lesser General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Lesser Public License for more details.
 *
 * You should have received a copy of the GNU General Lesser Public
 * License along with this program.  If not, see
 * <http://www.gnu.org/licenses/lgpl-3.0.html>.
 * ---license-end---
 */
(function () {
    'use strict';

    angular
        .module('soopkitchenApp')
        .directive('isInUsers', isInUsers);

    isInUsers.$inject = ['Principal'];

    function isInUsers(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            
            var users = attrs.isInUsers.replace(/\s+|\[|\]|\"/g, '').split(',');
            var authorities = attrs.isInUsersAuthorities.replace(/\s+/g, '').split(',');
            
            var setVisible = function () {
                element.removeClass('hidden');
            };
            
            var setHidden = function () {
                if (!element.attr('show')) {
                    element.addClass('hidden');
                }
            };

            var defineVisibility = function (reset) {

                if (reset) {
                    setVisible();
                }

                Principal.hasAnyAuthority(authorities).then(
                    function (result) {
                        if (result) {
                            Principal.isInUsers(users).then(
                                function (result) {
                                    if (result) {
                                        element.attr('show', 'true');
                                        setVisible();
                                    } else {
                                        setHidden();
                                    }
                                }
                            );
                        } else {
                            setHidden();
                        }
                    }
                );
            };

            if (users.length > 0) {
                defineVisibility(true);

                scope.$watch(function () {
                    return Principal.isAuthenticated();
                }, function () {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('soopkitchenApp')
        .directive('hasAuthority', hasAuthority);

    hasAuthority.$inject = ['Principal'];

    function hasAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authority = attrs.hasAuthority.replace(/\s+/g, '');
            var setVisible = function () {
                element.removeClass('hidden');
            };
            var setHidden = function () {
                if (!element.attr('show')) {
                    element.addClass('hidden');
                }
            };
            
            var defineVisibility = function (reset) {

                if (reset) {
                    setVisible();
                }

                Principal.hasAuthority(authority)
                    .then(function (result) {
                        if (result) {
                            element.attr('show', 'true');
                            setVisible();
                        } else {
                            setHidden();
                        }
                    });
            };

            if (authority.length > 0) {
                defineVisibility(true);

                scope.$watch(function () {
                    return Principal.isAuthenticated();
                }, function () {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('soopkitchenApp')
        .directive('hasAnyAuthority', hasAnyAuthority);

    hasAnyAuthority.$inject = ['Principal'];

    function hasAnyAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authorities = attrs.hasAnyAuthority.replace(/\s+/g, '').split(',');

            var setVisible = function () {
                element.removeClass('hidden');
            };
            var setHidden = function () {
                if (!element.attr('show')) {
                    element.addClass('hidden');
                }
            };
            var defineVisibility = function (reset) {

                if (reset) {
                    setVisible();
                }
                
                Principal.hasAnyAuthority(authorities)
                    .then(function (result) {
                        if (result) {
                            element.attr('show', 'true');
                            setVisible();
                        } else {
                            setHidden();
                        }
                    });
            };

            if (authorities.length > 0) {
                defineVisibility(true);

                scope.$watch(function () {
                    return Principal.isAuthenticated();
                }, function () {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('soopkitchenApp')
        .factory('AuthServerProvider', AuthServerProvider);

    AuthServerProvider.$inject = ['$http', '$localStorage' , 'JhiTrackerService'];

    function AuthServerProvider ($http, $localStorage , JhiTrackerService) {
        var service = {
            getToken: getToken,
            hasValidToken: hasValidToken,
            login: login,
            logout: logout,
            getUsersByAuthority: getUsersByAuthority
        };

        return service;

        function getToken () {
            var token = $localStorage.authenticationToken;
            return token;
        }

        function hasValidToken () {
            var token = this.getToken();
            return !!token;
        }

        function login (credentials) {
            var data = 'j_username=' + encodeURIComponent(credentials.username) +
                '&j_password=' + encodeURIComponent(credentials.password) +
                '&remember-me=' + credentials.rememberMe + '&submit=Login';

            return $http.post('api/authentication', data, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).success(function (response) {
                return response;
            });
        }

        function logout () {
            JhiTrackerService.disconnect();

            
            // logout from the server
            $http.post('api/logout').success(function (response) {
                delete $localStorage.authenticationToken;
                // to get a new csrf token call the api
                $http.get('api/account');
                return response;
            });
            
        }
        function getUsersByAuthority(success,failure, authoritiesToAdd) {
            $http({
                method: 'GET',
                url: 'api/usersByAuthority',
                params: {
                    "authorities" : authoritiesToAdd
                }
            }).then(success,failure);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('soopkitchenApp')
        .factory('Auth', Auth);

    Auth.$inject = ['$rootScope', '$state', '$sessionStorage', '$q', 'Principal', 'AuthServerProvider', 'Account', 'LoginService', 'Register', 'Activate', 'Password', 'PasswordResetInit', 'PasswordResetFinish', 'JhiTrackerService'];

    function Auth ($rootScope, $state, $sessionStorage, $q, Principal, AuthServerProvider, Account, LoginService, Register, Activate, Password, PasswordResetInit, PasswordResetFinish, JhiTrackerService) {
        var service = {
            activateAccount: activateAccount,
            authorize: authorize,
            changePassword: changePassword,
            createAccount: createAccount,
            getPreviousState: getPreviousState,
            login: login,
            logout: logout,
            resetPasswordFinish: resetPasswordFinish,
            resetPasswordInit: resetPasswordInit,
            resetPreviousState: resetPreviousState,
            storePreviousState: storePreviousState,
            updateAccount: updateAccount
        };

        return service;

        function activateAccount (key, callback) {
            var cb = callback || angular.noop;

            return Activate.get(key,
                function (response) {
                    return cb(response);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function authorize (force) {
            var authReturn = Principal.identity(force).then(authThen);

            return authReturn;

            function authThen () {
                var isAuthenticated = Principal.isAuthenticated();

                // an authenticated user can't access to login and register pages
                if (isAuthenticated && $rootScope.toState.parent === 'account' && ($rootScope.toState.name === 'login' || $rootScope.toState.name === 'register')) {
                    $state.go('home');
                }

                // recover and clear previousState after external login redirect (e.g. oauth2)
                if (isAuthenticated && !$rootScope.fromState.name && getPreviousState()) {
                    var previousState = getPreviousState();
                    resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }

                if ($rootScope.toState.data.authorities && $rootScope.toState.data.authorities.length > 0 && !Principal.hasAnyAuthority($rootScope.toState.data.authorities)) {
                    if (isAuthenticated) {
                        // user is signed in but not authorized for desired state
                        $state.go('accessdenied');
                    }
                    else {
                        // user is not authenticated. stow the state they wanted before you
                        // send them to the login service, so you can return them when you're done
                        storePreviousState($rootScope.toState.name, $rootScope.toStateParams);

                        // now, send them to the signin state so they can log in
                        $state.go('accessdenied').then(function() {
                            LoginService.open();
                        });
                    }
                }
            }
        }

        function changePassword (newPassword, callback) {
            var cb = callback || angular.noop;

            return Password.save(newPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function createAccount (account, callback) {
            var cb = callback || angular.noop;

            return Register.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    this.logout();
                    return cb(err);
                }.bind(this)).$promise;
        }

        function login (credentials, callback) {
            var cb = callback || angular.noop;
            var deferred = $q.defer();

            AuthServerProvider.login(credentials)
                .then(loginThen)
                .catch(function (err) {
                    this.logout();
                    deferred.reject(err);
                    return cb(err);
                }.bind(this));

            function loginThen (data) {
                Principal.identity(true).then(function(account) {
                    JhiTrackerService.sendActivity();
                    deferred.resolve(data);
                });
                return cb();
            }

            return deferred.promise;
        }


        function logout () {
            AuthServerProvider.logout();
            Principal.authenticate(null);
        }

        function resetPasswordFinish (keyAndPassword, callback) {
            var cb = callback || angular.noop;

            return PasswordResetFinish.save(keyAndPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function resetPasswordInit (mail, callback) {
            var cb = callback || angular.noop;

            return PasswordResetInit.save(mail, function() {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function updateAccount (account, callback) {
            var cb = callback || angular.noop;

            return Account.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function getPreviousState() {
            var previousState = $sessionStorage.previousState;
            return previousState;
        }

        function resetPreviousState() {
            delete $sessionStorage.previousState;
        }

        function storePreviousState(previousStateName, previousStateParams) {
            var previousState = { "name": previousStateName, "params": previousStateParams };
            $sessionStorage.previousState = previousState;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('soopkitchenApp')
        .factory('Activate', Activate);

    Activate.$inject = ['$resource'];

    function Activate ($resource) {
        var service = $resource('api/activate', {}, {
            'get': { method: 'GET', params: {}, isArray: false}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('soopkitchenApp')
        .factory('Account', Account);

    Account.$inject = ['$resource'];

    function Account ($resource) {
        var service = $resource('api/account', {}, {
            'get': { method: 'GET', params: {}, isArray: false,
                interceptor: {
                    response: function(response) {
                        // expose response
                        return response;
                    }
                }
            }
        });

        return service;
    }
})();

(function () {
    'use strict';

    angular
        .module('soopkitchenApp')
        .factory('Administration', Administration);

    Administration.$inject = ['$resource'];

    function Administration ($resource) {
        var service = $resource('api/administration', {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                } },
        });
        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('soopkitchenApp')
        .controller('NavbarController', NavbarController);

    NavbarController.$inject = ['$state', 'Auth', 'Principal', 'ProfileService', 'LoginService'];

    function NavbarController ($state, Auth, Principal, ProfileService, LoginService) {
        var vm = this;

        vm.isNavbarCollapsed = true;
        vm.isAuthenticated = Principal.isAuthenticated;

        ProfileService.getProfileInfo().then(function(response) {
            vm.inProduction = response.inProduction;
            vm.swaggerEnabled = response.swaggerEnabled;
        });

        vm.login = login;
        vm.logout = logout;
        vm.toggleNavbar = toggleNavbar;
        vm.collapseNavbar = collapseNavbar;
        vm.$state = $state;

        function login() {
            collapseNavbar();
            LoginService.open();
        }

        function logout() {
            collapseNavbar();
            Auth.logout();
            $state.go('home');
        }

        function toggleNavbar() {
            vm.isNavbarCollapsed = !vm.isNavbarCollapsed;
        }

        function collapseNavbar() {
            vm.isNavbarCollapsed = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('soopkitchenApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('error', {
                parent: 'app',
                url: '/error',
                data: {
                    authorities: [],
                    pageTitle: 'Error page!'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/error.html'
                    }
                }
            })
            .state('accessdenied', {
                parent: 'app',
                url: '/accessdenied',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/accessdenied.html'
                    }
                }
            });
    }
})();

(function() {
    'use strict';

    angular
        .module('soopkitchenApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('home', {
            parent: 'app',
            url: '/',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/home/home.html',
                    controller: 'HomeController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('soopkitchenApp')
        .controller('HomeController', HomeController);

    HomeController.$inject = ['$scope', 'Principal', 'LoginService', '$state', 'Administration'];

    function HomeController ($scope, Principal, LoginService, $state, Administration) {
        var vm = this;

        vm.account = null;
        vm.isAuthenticated = null;
        vm.userRegistrationEnabled = false;

        vm.login = LoginService.open;
        vm.register = register;
        $scope.$on('authenticationSuccess', function() {
            getAccount();
        });

        getAccount();

        function getAccount() {
            Principal.identity().then(function(account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
            });
            Administration.get({}, function(result) {
                vm.userRegistrationEnabled = result.userRegistrationEnabled;
            });
        }
        function register () {
            $state.go('register');
        }
    }
})();

/*
 * ---license-start---
 * Solar Orbiter Science Operations software
 * ----
 * Copyright (C) 2012 - 2018 European Space Agency - Solar Orbiter SOC
 * ----
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Lesser General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Lesser Public License for more details.
 *
 * You should have received a copy of the GNU General Lesser Public
 * License along with this program.  If not, see
 * <http://www.gnu.org/licenses/lgpl-3.0.html>.
 * ---license-end---
 */
(function () {
    'use strict';

    angular
        .module('soopkitchenApp')
        .directive('wait', wait);

    wait.$inject = [];

    function wait() {
        return {
            template: '<div id="contain"><h2>...Loading....</h2>\n' +
                '    <div class=\'wrap\' id=\'wrap1\'>\n' +
                '        <div class=\'ball\' id=\'ball1\'></div>\n' +
                '    </div>\n' +
                '    <div class=\'wrap\' id=\'wrap2\'>\n' +
                '        <div class=\'ball\' id=\'ball2\'></div>\n' +
                '    </div>\n' +
                '    <div class=\'wrap\' id=\'wrap3\'>\n' +
                '        <div class=\'ball\' id=\'ball3\'></div>\n' +
                '    </div>\n' +
                '    <div class=\'wrap\' id=\'wrap4\'>\n' +
                '        <div class=\'ball\' id=\'ball4\'></div>\n' +
                '    </div></div>'
        };
    }
})();

(function () {
    'use strict';

    angular.module('soopkitchenApp').controller('UnsoopifyPlanController', UnsoopifyPlanController);

    UnsoopifyPlanController.$inject = ['$uibModalInstance', 'parameters', 'SoopkitchenUtils', 'Planning'];
    
    function UnsoopifyPlanController($uibModalInstance, parameters, SoopkitchenUtils, Planning) {

        var vm = this;
        vm.labelToUnsoopify = parameters.labelToUnsoopify;
        vm.internalVersionToUnsoopify = parameters.internalVersionToUnsoopify;
        vm.planLabel = null;
        vm.save = save;
        vm.clear = clear;
        
        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            Planning.unsoopify(
                {
                    planLabel: vm.planLabel,
                    planLabelToUnsoopify : vm.labelToUnsoopify,
                    internalVersionToUnsoopify : vm.internalVersionToUnsoopify,
                },
                function successCallback(response) {
                    $uibModalInstance.dismiss('cancel');
                }, function errorCallback(response) {
                    SoopkitchenUtils.prettyError(response);
                }
            );
        }
    }
})();

// FUNCTIONS

// check there are no whitespaces
function isWhitespace(str) {
    return str.trim().length === 0;
}

// total color update
function updateTotal(td, total) {
    td.innerHTML = total.toFixed(3);// round to 3 decimal places
    td.style.color = "white";
    td.style.backgroundColor = "red";
    var oneHandred = 100;
    if (total.toFixed(3) === oneHandred.toFixed(3)) {
        td.style.backgroundColor = "blue";
    }
}

// calculate total value after modification
function editCell(cell) {
    var content = cell.innerHTML.trim();
    cell.classList.remove("error");
    if (isNaN(content)) {
        cell.classList.add("error");
        return;
    }
    var row = cell.parentNode;

    var total = 0;
    for (var i = 1; i < 11; i++) {
        total += parseFloat(row.cells[i].innerHTML);
    }
    updateTotal(row.cells[11], total);
    console.log("Total: " + row.cells[11].innerHTML);
}

// date format validator
function valiDate(dateInput) {
    var regex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/;
    return regex.test(dateInput);
}
// calculate total value after modification
function editCellDate(cell) {
    var dateStr = cell.innerHTML.trim();
    if (valiDate(dateStr)) {
        cell.classList.remove("error");
        cell.removeAttribute("title");

    } else {
        cell.classList.add("error");
        cell.setAttribute("title",
            "The format YYYY-MM-ddTHH:mm:SS.sssZ is an ISO 8601 formatted date string in UTC time zone."
        );
    }
}

// duplicate row function
function duplicateRow(buttonRow) {
    var row = buttonRow.closest("tr");
    var table = row.parentNode;
    var newRow = row.cloneNode(true);
    table.insertBefore(newRow, row.nextSibling);
}
// delete row function
function deleteRow(buttonRow) {
    var row = buttonRow.closest("tr");
    var table = document.getElementById("tdrTable");
    table.deleteRow(row.rowIndex);
}


// show/hide commetn text area
function toggleTextArea(columnFunction) {
    var x = columnFunction.getElementsByClassName("comment-textarea")[0];
    if (x.style.display === "none") {
        x.style.display = "block";
    } else {
        x.style.display = "none";
    }
}

// sorting date column
function sortTableDate(colIndex) {
    var table = document.getElementById("tdrTable");
    var rows = table.rows;
    var switching = true;
    var shouldSwitch = false;
    var dir = "asc"; // set initial sort direction to ascending
    var switchCount = 0;
    while (switching) {
        switching = false;
        var pos;
        for (var i = 1; i < rows.length - 1; i++) {
            shouldSwitch = false;
            var x = rows[i].getElementsByTagName("TD")[colIndex];
            var y = rows[i + 1].getElementsByTagName("TD")[colIndex];
            if (dir === "asc") {
                if (x.innerHTML.toLowerCase() > y.innerHTML.toLowerCase()) {
                    shouldSwitch = true;
                    pos = i;
                    break;
                }
            } else if (dir === "desc") {
                if (x.innerHTML.toLowerCase() < y.innerHTML.toLowerCase()) {
                    shouldSwitch = true;
                    pos = i;
                    break;
                }
            }
        }
        if (shouldSwitch) {
            rows[pos].parentNode.insertBefore(rows[pos + 1], rows[pos]);
            switching = true;
            switchCount++;
        } else {
            if (switchCount === 0 && dir === "asc") {
                dir = "desc";
                switching = true;
            }
        }
    }
    rows[0].getElementsByTagName("TD")[0].innerHTML = "<label onclick='sortTableDate(0);' class='label-td'>Date ↓</label>";
    if (dir === "asc") {
        rows[0].getElementsByTagName("TD")[0].innerHTML = "<label onclick='sortTableDate(0);' class='label-td' >Date ↑</label>";
    }

    return dir;
}

(function () {
    'use strict';

    angular.module('soopkitchenApp').controller('SoopifyPlanController', SoopifyPlanController);

    SoopifyPlanController.$inject = ['$uibModalInstance', 'parameters', 'SoopkitchenUtils', 'Planning'];
    
    function SoopifyPlanController($uibModalInstance, parameters, SoopkitchenUtils, Planning) {

        var vm = this;
        vm.labelToSoopify = parameters.labelToSoopify;
        vm.internalVersionToSoopify = parameters.internalVersionToSoopify;
        vm.planLabel = null;
        vm.soopTypes = [];
        vm.selectedSoopType = null;
        vm.selectedSoopLeadInstrument = null;
        vm.instruments = ['EUI', 'Metis', 'PHI', 'SPICE', 'STIX', 'SoloHI', 'EPD', 'MAG', 'RPW', 'SWA'];
        vm.save = save;
        vm.clear = clear;
        
        loadSoopTypes();
        
        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            Planning.soopify(
                {
                    planLabel: vm.planLabel,
                    leadInstrument: vm.selectedSoopLeadInstrument,
                    soopType: vm.selectedSoopType,
                    planLabelToSoopify : vm.labelToSoopify,
                    internalVersionToSoopify : vm.internalVersionToSoopify,
                },
                function successCallback(data) {
                    SoopkitchenUtils.updatePlanFromDialog(data);
                    $uibModalInstance.dismiss('cancel');
                }, function errorCallback(response) {
                    SoopkitchenUtils.prettyError(response);
                }
            );
        }
        function loadSoopTypes() {
            Planning.getSoopTypes(
                {},
                function successCallback(data, status, headers, config) {
                    if (data) {
                        data = angular.fromJson(data);
                        vm.soopTypes = [];
                        vm.soopTypes.push("");
                        data.forEach(function (item, index) {
                            vm.soopTypes.push(item);
                        });
                        vm.selectedSoopType = vm.soopTypes[0];
                    }
                },
                function errorCallback(response) {
                });
        }
    }
})();

(function () {
    'use strict';
    angular
        .module('soopkitchenApp')
        .factory('SoopService', SoopService);

    SoopService.$inject = ['SoopkitchenUtils', '$http'];

    function SoopService(SoopkitchenUtils, $http) {

        return {
            moveSoop: moveSoop,
        };

        function successMoveSOOP(soopType, soopInstanceId, time, cut, extraCallback) {
            return function (response) {
                var verb = 'copied';
                if (cut) verb = 'moved';
                var title = "SOOP Instance has been " + verb;
                var msg = "SOOP Instance '[" + soopType + ',' + soopInstanceId + "]' has been " + verb + " to " + time;
                SoopkitchenUtils.processResponse(
                    response,
                    title,
                    msg,
                    extraCallback(response)
                );
            }
        }

        function getFailureCallback(extraCallback) {
            return function(response) {
                if (extraCallback) {
                    extraCallback();
                } 
                SoopkitchenUtils.prettyError(response);
            }
        }

        function moveSoop(planType, planLabel, soopInstanceId, encodedSoopType, soopType, anchorTime, cut, successCallback, errorCallback) {
            $http({
                method: 'PUT',
                url: 'api/' + planType + '/soop-move',
                params: {
                    'planLabel': planLabel,
                    'soopInstanceId': soopInstanceId,
                    'encodedSoopType': encodedSoopType,
                    'anchorDate': anchorTime,
                    'copy': !cut
                }
            }).then(successMoveSOOP(soopType, soopInstanceId, anchorTime, cut, successCallback), getFailureCallback(errorCallback));
        }

    }
})();

(function () {
    'use strict';

    angular.module('soopkitchenApp').controller('SetEfecsVersionController', SetEfecsVersionController);

    SetEfecsVersionController.$inject = ['$controller','$sce','$uibModalInstance', 'parameters', 'SoopkitchenUtils', 'Planning', '$http'];

    function SetEfecsVersionController($controller, $sce, $uibModalInstance, parameters, SoopkitchenUtils, Planning, $http) {

        var vm = this;
        var title = 'Set the E-FECS version and the Prime identifier for Plan <span class="label label-info">' + parameters.label + '</span>';
        angular.extend(this, $controller('SoopkitchenDialogController', {"title": title, $sce: $sce, $uibModalInstance:$uibModalInstance}));

        /**** Properties ****/

        vm.efecsVersion = parameters.currentVersion;
        vm.prime = parameters.prime;

        /**** Methods ****/
        //Override Methods from SoopkitchenDialogController
        vm.save = setEfecsVersion;

        function updateEfecs() {
            Planning.setEfecsVersion(
                {
                    planLabel: parameters.label,
                    efecsVersion: vm.efecsVersion,
                    prime: vm.prime
                },
                function successCallback(data) {
                    SoopkitchenUtils.updatePlanFromDialog(data);
                    $uibModalInstance.dismiss('cancel');

                }, function errorCallback(response) {
                    SoopkitchenUtils.prettyError(response);
                }
            );
        }

        function setEfecsVersion() {
            $http({
                method: 'GET',
                url: 'api/plan/checks/' + parameters.label,
            }).then(function successCallback(response) {
                SoopkitchenUtils.sanityChecksResult(response, updateEfecs, "Click OK to set the EFECS version");
                }, function errorCallback(response) {
                    SoopkitchenUtils.prettyError(response);
            });
        }
    }
})();

(function () {
    'use strict';

    angular.module('soopkitchenApp').controller('RenamePlanController', RenamePlanController);

    RenamePlanController.$inject = ['$uibModalInstance', 'parameters', 'SoopkitchenUtils', 'Planning', 'PlanTypes'];
    
    function RenamePlanController($uibModalInstance, parameters, SoopkitchenUtils, Planning, PlanTypes) {

        var vm = this;
        vm.planType = parameters.planType;
        vm.existingLabel = parameters.label;
        vm.newPlanLabel = '';
        
        vm.rename = rename;
        vm.clear = clear;

        function clear(status) {
            $uibModalInstance.dismiss(status);
        }

        function rename() {
            Planning.rename(
                {
                    planType: vm.planType,
                    planLabel: vm.existingLabel,
                    newPlanLabel: vm.newPlanLabel,
                },
                function successCallback(response) {
                    SoopkitchenUtils.invokeSweetAlert("Nice!", "You have renamed the plan " + vm.existingLabel + " to " + vm.newPlanLabel, "success", vm.clear('success'));
                },
                function errorCallback(response) {
                    SoopkitchenUtils.prettyError(response)
                }
            )
        }
    }
})();

var imageList = [];
var storeSizesGlobal;
var selective_size_rpw = 2950.0;

function fetchDataEpsMemory(data, storeSizes, sci_sizes) {
    try {
        if (!data) {
            console.warn("No Data file selected. Falling back to default path.");
            return;
        }

        var lines = data.split('\n');

        for (var i = 0; i < lines.length; i++) {
            var line = lines[i];
            var words = line.trim().split('\t');

            if (words.length > 0 && words[0].includes('Data_store:') && !words[0].includes('#')) {
                storeSizes[words[1]] = parseFloat(words[4]);
            }
        }

        for (var key in storeSizes) {
            if (storeSizes.hasOwnProperty(key) && key.includes('SCI')) {
                sci_sizes.push(storeSizes[key]);
            }
        }
    } catch (error) {
        console.error("Error loading file:", error);
    }
}

function fetchDataEps(data, dataArr) {
    try {
        if (!data) {
            console.warn("No Data file selected. Falling back to default path.");
            return;
        }

        var columnNames = ['DDATE', 'DL', 'Tot_Accum_DL', 'tot_mem', 'tot_mem_acc', 'OMM_Mem', 'OMM_Accum', 'PYLDHK_Mem', 'PYLDHK_Accum',
            'LL_Mem', 'LL_Accum', 'SSMM_TAC_Mem', 'SSMM_TAC_Accum', 'EPD_SSMM', 'SSMM_EPD_Accum', 'EUI_SSMM',
            'SSMM_EUI_Accum', 'MAG_SSMM', 'SSMM_MAG_Accum', 'MET_SSMM', 'SSMM_MET_Accum', 'PHI_SSMM',
            'SSMM_PHI_Accum', 'RPW_SSMM', 'SSMM_RPW_Accum', 'SHI_SSMM', 'SSMM_SHI_Accum', 'SPI_SSMM',
            'SSMM_SPI_Accum', 'STX_SSMM', 'STX_Accum', 'SWA_SSMM', 'SSMM_SWA_Accum', 'SSMM_MAG_TRG_Mem',
            'SSMM_MAG_TRG_Accum', 'SSMM_SD1_Mem', 'SSMM_SD1_Acumm', 'SSMM_SD2_Mem', 'SSMM_SD2_Acumm',
            'SSMM_SD3_Mem', 'SSMM_SD3_Acumm', 'SSMM_SD4_Mem', 'SSMM_SD4_Acumm', 'SSMM_SD5_Mem', 'SSMM_SD5_Acumm',
            'SSMM_SD6_Mem', 'SSMM_SD6_Acumm', 'SSMM_SD7_Mem', 'SSMM_SD7_Acumm', 'SSMM_SD8_Mem', 'SSMM_SD8_Acumm',
            'SSMM_SD9_Mem', 'SSMM_SD9_Acumm', 'SSMM_SD0_Mem', 'SSMM_SD0_Acumm', 'EUI_Upld', 'EUI_Downld',
            'EUI_Mem', 'EUI_Accum', 'MET_Upld', 'MET_Downld', 'MET_Mem', 'MET_Accum', 'PHI_Upld', 'PHI_Downld',
            'PHI_Mem', 'PHI_Accum', 'SHI_Upld', 'SHI_Downld', 'SHI_Mem', 'SHI_Accum', 'SPI_Upld', 'SPI_Downld',
            'SPI_Mem', 'SPI_Accum', 'STX_Upld', 'STX_Downld', 'STX_Mem', 'STX_Accum', 'EPD_Upld', 'EPD_Downld',
            'EPD_Mem', 'EPD_Accum', 'MAG_Upld', 'MAG_Downld', 'MAG_Mem', 'MAG_Accum', 'RPW_Upld', 'RPW_Downld',
            'RPW_Mem', 'RPW_Accum', 'SWA_Upld', 'SWA_Downld', 'SWA_Mem', 'SWA_Accum', 'PF_Upld', 'PF_Downld',
            'PF_Mem', 'PF_Accum'
        ];

        var rows = data.split("\n");
        for (var i = 25; i < rows.length; i++) {
            var row = rows[i].split(",");
            var obj = {};
            for (var j = 0; j < columnNames.length; j++) {
                obj[columnNames[j]] = row[j];
            }
            dataArr.push(obj);
        }

    } catch (error) {
        console.error("Error loading file:", error);
    }
}

function fetchDataEpsPasses(data, dataArrUnd) {

    try {
        if (!data) {
            console.warn("No Data file selected. Falling back to default path.");
            return;
        }

        var columnNamesUnd = ['Pass', 'DDATE', 'EndTime', 'Duration', 'Overall_Pass_Capacity', 'Overall_Used_Capacity',
            'Overall_Unused_Capacity', 'HGA_Pass_Capacity', 'HGA_Used_Capacity', 'HGA_Unused_Capacity'
        ];

        var rows = data.split("\n");
        for (var i = 24; i < rows.length; i++) {
            var row = rows[i].split(",");
            var obj = {};
            for (var j = 0; j < columnNamesUnd.length; j++) {
                obj[columnNamesUnd[j]] = row[j];
            }
            dataArrUnd.push(obj);
        }

    } catch (error) {
        console.error("Error loading file:", error);
    }

}

// General Fucntions to extract data
function fetchDataLat(data, dataArr) {

    if (!data) {
        console.warn("No Data file selected. Falling back to default path.");
        return;
    }

    var columnNames = ['DDATE', 'OMM_first', 'OMM_last', 'OMM_remain', 'OMM_over', 'OMM_down', 'SSMM_PYLD_HK_first', 'SSMM_PYLD_HK_last',
        'SSMM_PYLD_HK_remain', 'SSMM_PYLD_HK_over', 'SSMM_PYLD_HK_down', 'SSMM_PYLD_LL_first',
        'SSMM_PYLD_LL_last', 'SSMM_PYLD_LL_remain', 'SSMM_PYLD_LL_over', 'SSMM_PYLD_LL_down', 'SSMM_TAC_first',
        'SSMM_TAC_last', 'SSMM_TAC_remain', 'SSMM_TAC_over', 'SSMM_TAC_down', 'SSMM_EPD_SCI_first',
        'SSMM_EPD_SCI_last', 'SSMM_EPD_SCI_remain', 'SSMM_EPD_SCI_over', 'SSMM_EPD_SCI_down',
        'SSMM_EUI_SCI_first', 'SSMM_EUI_SCI_last', 'SSMM_EUI_SCI_remain', 'SSMM_EUI_SCI_over',
        'SSMM_EUI_SCI_down', 'SSMM_MAG_SCI_first', 'SSMM_MAG_SCI_last', 'SSMM_MAG_SCI_remain',
        'SSMM_MAG_SCI_over', 'SSMM_MAG_SCI_down', 'SSMM_MET_SCI_first', 'SSMM_MET_SCI_last',
        'SSMM_MET_SCI_remain', 'SSMM_MET_SCI_over', 'SSMM_MET_SCI_down', 'SSMM_PHI_SCI_first',
        'SSMM_PHI_SCI_last', 'SSMM_PHI_SCI_remain', 'SSMM_PHI_SCI_over', 'SSMM_PHI_SCI_down',
        'SSMM_RPW_SCI_first', 'SSMM_RPW_SCI_last', 'SSMM_RPW_SCI_remain', 'SSMM_RPW_SCI_over',
        'SSMM_RPW_SCI_down', 'SSMM_SHI_SCI_first', 'SSMM_SHI_SCI_last', 'SSMM_SHI_SCI_remain',
        'SSMM_SHI_SCI_over', 'SSMM_SHI_SCI_down', 'SSMM_SPI_SCI_first', 'SSMM_SPI_SCI_last',
        'SSMM_SPI_SCI_remain', 'SSMM_SPI_SCI_over', 'SSMM_SPI_SCI_down', 'SSMM_STX_SCI_first',
        'SSMM_STX_SCI_last', 'SSMM_STX_SCI_remain', 'SSMM_STX_SCI_over', 'SSMM_STX_SCI_down',
        'SSMM_SWA_SCI_first', 'SSMM_SWA_SCI_last', 'SSMM_SWA_SCI_remain', 'SSMM_SWA_SCI_over',
        'SSMM_SWA_SCI_down', 'SSMM_MAG_TRG_first', 'SSMM_MAG_TRG_last', 'SSMM_MAG_TRG_remain',
        'SSMM_MAG_TRG_over', 'SSMM_MAG_TRG_down', 'SSMM_SD1_first', 'SSMM_SD1_last', 'SSMM_SD1_remain',
        'SSMM_SD1_over', 'SSMM_SD1_down', 'SSMM_SD2_first', 'SSMM_SD2_last', 'SSMM_SD2_remain', 'SSMM_SD2_over',
        'SSMM_SD2_down', 'SSMM_SD3_first', 'SSMM_SD3_last', 'SSMM_SD3_remain', 'SSMM_SD3_over', 'SSMM_SD3_down',
        'SSMM_SD4_first', 'SSMM_SD4_last', 'SSMM_SD4_remain', 'SSMM_SD4_over', 'SSMM_SD4_down', 'SSMM_SD5_first',
        'SSMM_SD5_last', 'SSMM_SD5_remain', 'SSMM_SD5_over', 'SSMM_SD5_down', 'SSMM_SD6_first', 'SSMM_SD6_last',
        'SSMM_SD6_remain', 'SSMM_SD6_over', 'SSMM_SD6_down', 'SSMM_SD7_first', 'SSMM_SD7_last',
        'SSMM_SD7_remain', 'SSMM_SD7_over', 'SSMM_SD7_down', 'SSMM_SD8_first', 'SSMM_SD8_last',
        'SSMM_SD8_remain', 'SSMM_SD8_over', 'SSMM_SD8_down', 'SSMM_SD9_first', 'SSMM_SD9_last',
        'SSMM_SD9_remain', 'SSMM_SD9_over', 'SSMM_SD9_down', 'SSMM_SD0_first', 'SSMM_SD0_last',
        'SSMM_SD0_remain', 'SSMM_SD0_over', 'SSMM_SD0_down'
    ];

    var rows = data.split("\n");
    for (var i = 27; i < rows.length; i++) {
        var row = rows[i].split(",");
        var obj = {};
        for (var j = 0; j < columnNames.length; j++) {
            obj[columnNames[j]] = row[j];
        }
        dataArr.push(obj);
    }
    console.log(dataArr);
}

// Functions and global variables for particular plots

// NonSci
var ommMemTrace;
var pyldhkMemTrace;
var llMemTrace;
var ssmmTacMemTrace;
var ommMemDashedTrace;
var pyldhkMemDashedTrace;
var llMemDashedTrace;
var ssmmTacMemDashedTrace;

 // RS
var euiSsmmDashedTrace;
var metSsmmDashedTrace;
var phiSsmmDashedTrace;
var shiSsmmDashedTrace;
var spiSsmmDashedTrace;
var stxSsmmDashedTrace;
 // IS
var epdSsmmDashedTrace;
var magSsmmDashedTrace;
var rpwSsmmDashedTrace;
var swaSsmmDashedTrace;
// selective limit
var rpwSsmmDottedTrace;

 // IS_Norm
var epdSsmmTrace;
var magSsmmTrace;
var rpwSsmmTrace;
var swaSsmmTrace;

 // RateIS
var epdDownldTrace;
var magDownldTrace;
var rpwDownldTrace;
var swaDownldTrace;

 // RateRS
var metDownldTrace;
var shiDownldTrace;
var spiDownldTrace;
var stxDownldTrace;

 // OutputAccumFlsh
var phiAccumTrace;
var euiAccumTrace;

 // OutputAccumFlsh
var dlTrace;
function extractDataTraces(data) {

    // NonSci
    ommMemTrace         = createScatterTrace(data, 'OMM_Mem', 'red');
    pyldhkMemTrace      = createScatterTrace(data, 'PYLDHK_Mem', 'blue');
    llMemTrace          = createScatterTrace(data, 'LL_Mem', 'orange');
    ssmmTacMemTrace     = createScatterTrace(data, 'SSMM_TAC_Mem', 'green');

    ommMemDashedTrace       = createDashedLineTrace(data, 'OMM', 'red');
    pyldhkMemDashedTrace    = createDashedLineTrace(data, 'SSMM_PYLD_HK', 'blue');
    llMemDashedTrace        = createDashedLineTrace(data, 'SSMM_PYLD_LL', 'orange');
    ssmmTacMemDashedTrace   = createDashedLineTrace(data, 'SSMM_TAC', 'green');

    // RS
    euiSsmmDashedTrace = createDashedLineTrace(data, 'SSMM_EUI_SCI', 'magenta');
    metSsmmDashedTrace = createDashedLineTrace(data, 'SSMM_MET_SCI', 'black');
    phiSsmmDashedTrace = createDashedLineTrace(data, 'SSMM_PHI_SCI', 'green');
    shiSsmmDashedTrace = createDashedLineTrace(data, 'SSMM_SHI_SCI', 'orange');
    spiSsmmDashedTrace = createDashedLineTrace(data, 'SSMM_SPI_SCI', 'blue');
    stxSsmmDashedTrace = createDashedLineTrace(data, 'SSMM_STX_SCI', 'red');
    // IS
    epdSsmmDashedTrace = createDashedLineTrace(data, 'SSMM_EPD_SCI', 'green');
    magSsmmDashedTrace = createDashedLineTrace(data, 'SSMM_MAG_SCI', 'orange');
    rpwSsmmDashedTrace = createDashedLineTrace(data, 'SSMM_RPW_SCI', 'blue');
    swaSsmmDashedTrace = createDashedLineTrace(data, 'SSMM_SWA_SCI', 'red');

    rpwSsmmDottedTrace = createDottedLineTraceRPWSelectiveLimit(data, 'SSMM_RPW_SCI', 'blue');


    // IS_Norm
    epdSsmmTrace = createScatterTrace(data, 'EPD_SSMM', 'green');
    magSsmmTrace = createScatterTrace(data, 'MAG_SSMM', 'orange');
    rpwSsmmTrace = createScatterTrace(data, 'RPW_SSMM', 'blue');
    swaSsmmTrace = createScatterTrace(data, 'SWA_SSMM', 'red');

    // RateIS
    epdDownldTrace = createScatterTrace(data, 'EPD_Downld', 'green');
    magDownldTrace = createScatterTrace(data, 'MAG_Downld', 'orange');
    rpwDownldTrace = createScatterTrace(data, 'RPW_Downld', 'blue');
    swaDownldTrace = createScatterTrace(data, 'SWA_Downld', 'red');

    // RateRS
    metDownldTrace = createScatterTrace(data, 'MET_Downld', 'black');
    shiDownldTrace = createScatterTrace(data, 'SHI_Downld', 'orange');
    spiDownldTrace = createScatterTrace(data, 'SPI_Downld', 'blue');
    stxDownldTrace = createScatterTrace(data, 'STX_Downld', 'red');

    // OutputAccumFlsh
    phiAccumTrace = createScatterTrace(data, 'PHI_Accum', 'green');
    euiAccumTrace = createScatterTrace(data, 'EUI_Accum', 'magenta');

    // OutputAccumFlsh
    dlTrace = createScatterTrace(data, 'DL', 'blue');

}

var markerSsmmTrace;
var markerPhiTrace;
var markerMetTrace;
var markerSpiTrace;
var markerShiTrace;
var markerStxTrace;
"use strict";

function extractDataTracesLatencyRs(data) {
    markerSsmmTrace = createMarkerScatterTrace(data, 'SSMM_EUI_SCI_last', 'magenta', 'triangle-down');
    markerPhiTrace = createMarkerScatterTrace(data, 'SSMM_PHI_SCI_last', 'green', 'triangle-up');
    markerMetTrace = createMarkerScatterTrace(data, 'SSMM_MET_SCI_last', 'black', 'star');
    markerSpiTrace = createMarkerScatterTrace(data, 'SSMM_SPI_SCI_last', 'blue', 'octagon');
    markerShiTrace = createMarkerScatterTrace(data, 'SSMM_SHI_SCI_last', 'orange', 'square');
    markerStxTrace = createMarkerScatterTrace(data, 'SSMM_STX_SCI_last', 'red', 'diamond');
}

var epdLatTrace;
var magLatTrace;
var rpwLatTrace;
var swaLatTrace;
function extractDataTracesLatencyIs(data) {

    swaLatTrace = createScatterTrace(data, 'SSMM_SWA_SCI_last', 'red');
    rpwLatTrace = createScatterTrace(data, 'SSMM_RPW_SCI_last', 'blue');
    magLatTrace = createScatterTrace(data, 'SSMM_MAG_SCI_last', 'orange');
    epdLatTrace = createScatterTrace(data, 'SSMM_EPD_SCI_last', 'green');

}

var pyldHkLatTrace;
var ommLatTrace;
var pyldLlLatTrace;
function extractDataTracesLatencyNonSci(data) {
    pyldHkLatTrace = createScatterTrace(data, 'SSMM_PYLD_HK_last', 'blue');
    ommLatTrace = createScatterTrace(data, 'OMM_last', 'orange');
    pyldLlLatTrace = createScatterTrace(data, 'SSMM_PYLD_LL_last', 'green');
}

function extractDataTracesIsNorm(data) {
    // IS_Norm
    epdSsmmTrace = createScatterTrace(data, 'EPD_SSMM',  'green');
    magSsmmTrace = createScatterTrace(data, 'MAG_SSMM',  'orange');
    rpwSsmmTrace = createScatterTrace(data, 'RPW_SSMM',  'blue');
    swaSsmmTrace = createScatterTrace(data, 'SWA_SSMM',  'red');
}

var unusedTrace;
var usedTrace;
var passTrace;
function extractDataTracesUnd(data) {
    unusedTrace   = createScatterTrace(data, 'Overall_Unused_Capacity',  'blue');
    usedTrace   = createScatterTrace(data, 'Overall_Used_Capacity',  'orange');
    passTrace   = createScatterTrace(data, 'Overall_Pass_Capacity',  'black');
}

var unusedOverTrace;
var usedOverTrace;
var passOverTrace;
function extractDataTracesTotAccumDl(data) {
    unusedOverTrace   = createScatterTrace(data, 'Overall_Unused_Capacity',  'blue');
    usedOverTrace   = createScatterTrace(data, 'Overall_Used_Capacity',  'orange');
    passOverTrace   = createScatterTrace(data, 'Overall_Pass_Capacity',  'black');
}

var euiSsmmTrace;
var metSsmmTrace;
var phiSsmmTrace;
var shiSsmmTrace;
var spiSsmmTrace;
var stxSsmmTrace;
function extractDataTracesRsNorm(data) {
    // RS_Norm
    euiSsmmTrace = createScatterTrace(data, 'EUI_SSMM', 'magenta');
    metSsmmTrace = createScatterTrace(data, 'MET_SSMM', 'black');
    phiSsmmTrace = createScatterTrace(data, 'PHI_SSMM', 'green');
    shiSsmmTrace = createScatterTrace(data, 'SHI_SSMM', 'orange');
    spiSsmmTrace = createScatterTrace(data, 'SPI_SSMM', 'blue');
    stxSsmmTrace = createScatterTrace(data, 'STX_SSMM', 'red');
}

var totalRealTrace;
function extractDataTracesTotalReal(data) {
    totalRealTrace   = createScatterTrace(data, 'TotalReal',  'green');
}

// General functions
function createMarkerScatterTrace(data, yKey, color, markerSymbol) {
    return {
        x: data.map(function (d) {
            return d.DDATE;
        }),
        y: data.map(function (d) {
            var val = d[yKey];
            // If the value is a dash or a plus sign, return null so Plotly won't try to draw it
            // and it won't break the axis numeric scale.
            if (val === '-' || val === '+') {
                return null;
            }
            // Force conversion to a number (float)
            var num = parseFloat(val);
            return isNaN(num) ? null : num;
        }),
        type: 'scatter',
        mode: 'markers',
        name: yKey,
        marker: {
            symbol: markerSymbol,
            color: color,
            size: 10
        }
    };
}

function createScatterTrace(data, yKey, color) {
    return {
        x: data.map(function (d) {
            return d.DDATE;
        }),
        y: data.map(function (d) {
            return d[yKey];
        }),
        type: 'scatter',
        mode: 'lines',
        name: yKey,
        line: {
            color: color
        }
    };
}
function createDashedLineTrace(data, yKey, color) {
    return {
        x: data.map(function(d) {
            return d.DDATE;
        }),
        y: Array.apply(null, Array(data.length)).map(function() {
            return storeSizesGlobal[yKey];
        }),
        mode: 'lines',
        name: yKey,
        line: {
            color: color,
            dash: 'dash' // Dashed line
        },
    };
}

function createDottedLineTraceRPWSelectiveLimit(data, yKey, color) {
    return {
        x: data.map(function(d) {
            return d.DDATE;
        }),
        y: Array.apply(null, Array(data.length)).map(function() {
            //selective_size_rpw = 2950.0
            return storeSizesGlobal[yKey] - selective_size_rpw;
        }),
        mode: 'lines',
        name: yKey + '_limit',
        line: {
            color: color,
            dash: 'dot' // Dotted line
        },
    };
}

function createDashedLineFixedTrace(data, name, number, color) {
    var dashedLine = {
        x: data.map(function (d) {
            return d.DDATE;
        }),
        y: Array(data.length).fill(number),
        mode: 'lines',
        name: name,
        line: {
            color: color,
            dash: 'dot' // Dotted line
        }
    };
    return dashedLine;
}


function getMinMaxY(dataY) {
    // Combine all Y-axis data into a single array
    var allYData = [].concat.apply([], dataY.map(function (trace) {
        return trace.y;
    })).filter(function (value) {
        return !isNaN(value);
    });

    // Calculate minY and maxY from the combined data
    var minY = Math.min.apply(Math, allYData);
    var maxY = Math.max.apply(Math, allYData);
    return { minY: minY, maxY: maxY };
}

function chunkMinMax(dataToCalculate) {
    var chunkSize = 1000; // Adjust the chunk size as needed

    // Combine all Y-axis data into a single array for data
    var allYData = [].concat.apply([], dataToCalculate.map(function(trace) {
        return trace.y.filter(function(value) {
            return !isNaN(value);
        });
    }));

    // Split data into chunks
    var splitData = [];
    for (var i = 0; i < allYData.length; i += chunkSize) {
        var chunk = allYData.slice(i, i + chunkSize);
        splitData.push(chunk);
    }

    // Calculate minY and maxY for each chunk
    var minValues = [];
    var maxValues = [];

    splitData.forEach(function(chunk) {
        var chunkMin = Math.min.apply(null, chunk);
        var chunkMax = Math.max.apply(null, chunk);
        minValues.push(chunkMin);
        maxValues.push(chunkMax);
    });

    // Now, minValues and maxValues contain the minimum and maximum values for each chunk
    // Calculate minY and maxY from the combined data
    var minY = Math.min.apply(null, minValues);
    var maxY = Math.max.apply(null, maxValues);

    return { minY: minY, maxY: maxY };
}


function formatTickLabel(date) {
    var parts = date.split('_');
    return parts[0]; // Return the part before the underscore
}

var defHeight = 800;
var defWidth = 1200;
var defHovermode = "closest";
var defTickfont = 22;
var defTitleFontSize = 30;
var defAxisFontSize = 25;
function getLayout(dataOrig, plotTitle, xTitle, yTitle) {
    var minY = arguments.length <= 4 || arguments[4] === undefined ? null : arguments[4];
    var maxY = arguments.length <= 5 || arguments[5] === undefined ? null : arguments[5];

    return {
        dragmode: 'drag',
        height: defHeight,
        width: defWidth,
        hovermode: defHovermode,
        title: {
            text: plotTitle,
            font: {
                size: defTitleFontSize
            }
        },
        xaxis: {
            title: {
                text: xTitle,
                show: true,
                font: {
                    size: defAxisFontSize
                }
            },
            tickfont: {
                size: defTickfont
            },
            tickvals: dataOrig.map(function (d, index) {
                return index % Math.ceil(dataOrig.length / 5) === 0 ? d.DDATE : null;
            }),
            ticktext: dataOrig.map(function (d, index) {
                return index % Math.ceil(dataOrig.length / 5) === 0 ? formatTickLabel(d.DDATE) : '';
            }),
            tickangle: 9,
            automargin: true
        },
        yaxis: {
            title: {
                text: yTitle,
                show: true,
                font: {
                    size: defAxisFontSize
                }
            },
            tickfont: {
                size: defTickfont
            },
            range: [minY, maxY],
            // range: [minY || Math.min(...dataOrig.map(d => d.YVALUE)), maxY || Math.max(...dataOrig.map(d => d.YVALUE))],
            automargin: true
        }
    };
}

function plotDataLat(dataArr) {

    var RSLat = dataArr.map(function (obj) {
        return {
            DDATE: obj.DDATE,
            SSMM_EUI_SCI_last: obj.SSMM_EUI_SCI_last,
            SSMM_PHI_SCI_last: obj.SSMM_PHI_SCI_last,
            SSMM_SHI_SCI_last: obj.SSMM_SHI_SCI_last,
            SSMM_SPI_SCI_last: obj.SSMM_SPI_SCI_last,
            SSMM_MET_SCI_last: obj.SSMM_MET_SCI_last,
            SSMM_STX_SCI_last: obj.SSMM_STX_SCI_last
        };
    });

    extractDataTracesLatencyRs(RSLat);

    var dataRsLat = [markerSsmmTrace, markerPhiTrace, markerMetTrace, markerSpiTrace, markerShiTrace, markerStxTrace];

    var _getMinMaxY = getMinMaxY(dataRsLat);

    var minY = _getMinMaxY.minY;
    var maxY = _getMinMaxY.maxY;


    var plotTitleRsLat = "Data Latency Remote Sensing Instruments";
    var xTitleRsLat = "Date";
    var yTitleRsLat = "Latency (days)";

    var layoutRS = getLayout(RSLat, plotTitleRsLat, xTitleRsLat, yTitleRsLat, minY, maxY);

    createAndAddToImageList('RSLat', dataRsLat, layoutRS);

    // IS
    var IS = dataArr.map(function (obj) {
        return {
            DDATE: obj.DDATE,
            SSMM_SWA_SCI_last: obj.SSMM_SWA_SCI_last,
            SSMM_RPW_SCI_last: obj.SSMM_RPW_SCI_last,
            SSMM_MAG_SCI_last: obj.SSMM_MAG_SCI_last,
            SSMM_EPD_SCI_last: obj.SSMM_EPD_SCI_last
        };
    });

    extractDataTracesLatencyIs(IS);

    var dataIS = [
        swaLatTrace,
        rpwLatTrace,
        magLatTrace,
        epdLatTrace
    ];

    var __ret = getMinMaxY(dataIS);

    var plotTitleIS = "Data Latency In-Situ Instruments";
    var xTitleIS = "Date";
    var yTitleIS = "Latency (days)";

    var layoutIS = getLayout(IS, plotTitleIS, xTitleIS, yTitleIS, __ret.minY, __ret.maxY);

    createAndAddToImageList('ISLat', dataIS, layoutIS);

    // NonSci
    var NonSci = dataArr.map(function (obj) {
        return {
            DDATE: obj.DDATE,
            SSMM_PYLD_HK_last: obj.SSMM_PYLD_HK_last,
            OMM_last: obj.OMM_last,
            SSMM_PYLD_LL_last: obj.SSMM_PYLD_LL_last
        };
    });
    extractDataTracesLatencyNonSci(NonSci);

    var dataNonSci = [
        pyldHkLatTrace,
        ommLatTrace,
        pyldLlLatTrace
    ];

    __ret = getMinMaxY(dataNonSci);

    var plotTitleNonSci = "Data Latency HK LL and OMM";
    var xTitleNonSci = "Date";
    var yTitleNonSci = "Latency (days)";

    var layoutNonSci = getLayout(NonSci, plotTitleNonSci, xTitleNonSci, yTitleNonSci, __ret.minY, __ret.maxY);
    createAndAddToImageList('NonSciLat', dataNonSci, layoutNonSci);
}

function plotDataEps(dataArrUnd, dataArrRateAvg, storeSizes, sci_sizes) {
    storeSizesGlobal = storeSizes;
    extractDataTraces(dataArrRateAvg);

    // **** PLOT NonSci **** //
    var dataNonSci = [
        ommMemTrace,
        pyldhkMemTrace,
        llMemTrace,
        ssmmTacMemTrace,
        ommMemDashedTrace,
        pyldhkMemDashedTrace,
        llMemDashedTrace,
        ssmmTacMemDashedTrace
    ];
    var __ret = chunkMinMax(dataNonSci);
    var minYNonSci = __ret.minY;
    var maxYNonSci = __ret.maxY;

// plot
    var plotTitleNonSci = "OMM, PAYLOADHK, LowLat Stores, TAC";
    var xTitleNonSci = "Date";
    var yTitleNonSci = "Stored Data Volume (MiBytes)";

    var NonSci = dataArrRateAvg.map(function(item) {
        return {
            DDATE: item.DDATE,
            PYLDHK_Mem: item.PYLDHK_Mem,
            OMM_Mem: item.OMM_Mem,
            LL_Mem: item.LL_Mem,
            SSMM_TAC_Mem: item.SSMM_TAC_Mem
        };
    });

    var layoutNonSci = getLayout(NonSci, plotTitleNonSci, xTitleNonSci, yTitleNonSci, minYNonSci, maxYNonSci);


// Create the chart using Plotly for NonSci
    createAndAddToImageList('NonSci', dataNonSci, layoutNonSci);


    // **** PLOT RS **** //
    extractDataTracesRsNorm(dataArrRateAvg);

    // Create an array of objects for the data
    var dataRs = [
        euiSsmmTrace,
        metSsmmTrace,
        phiSsmmTrace,
        shiSsmmTrace,
        spiSsmmTrace,
        stxSsmmTrace,

        euiSsmmDashedTrace,
        metSsmmDashedTrace,
        phiSsmmDashedTrace,
        shiSsmmDashedTrace,
        spiSsmmDashedTrace,
        stxSsmmDashedTrace
    ];


    __ret = chunkMinMax(dataRs);
    var minYrS = __ret.minY;
    var maxYrS = __ret.maxY;

    var RS = dataArrRateAvg.map(function(item) {
        return {
            DDATE: item.DDATE,
            EUI_SSMM: item.EUI_SSMM,
            MET_SSMM: item.MET_SSMM,
            PHI_SSMM: item.PHI_SSMM,
            SHI_SSMM: item.SHI_SSMM,
            SPI_SSMM: item.SPI_SSMM,
            STX_SSMM: item.STX_SSMM
        };
    });

    // Plot
    var plotTitleRsLat = "Remote Sensing Instruments Fill State";
    var xTitleRsLat = "Date";
    var yTitleRsLat = "Stored Data Volume (MiBytes)";

    var layoutRs = getLayout(RS, plotTitleRsLat, xTitleRsLat, yTitleRsLat, minYrS, maxYrS);


// Create the chart using Plotly
    createAndAddToImageList('Rs', dataRs, layoutRs);


    // **** PLOT IS **** //
    extractDataTracesIsNorm(dataArrRateAvg);
//     // Create an array of objects for the data
    var dataIs = [
        epdSsmmTrace,
        magSsmmTrace,
        rpwSsmmTrace,
        swaSsmmTrace,

        epdSsmmDashedTrace,
        magSsmmDashedTrace,
        rpwSsmmDashedTrace,
        swaSsmmDashedTrace,
        rpwSsmmDottedTrace,
    ];
    __ret = chunkMinMax(dataIs);
    var minYiS = __ret.minY;
    var maxYiS = __ret.maxY;

    var Is = dataArrRateAvg.map(function (item) {
        return {
            DDATE: item.DDATE,
            EUI_SSMM: item.EUI_SSMM,
            MET_SSMM: item.MET_SSMM,
            PHI_SSMM: item.PHI_SSMM,
            SHI_SSMM: item.SHI_SSMM,
            SPI_SSMM: item.SPI_SSMM,
            STX_SSMM: item.STX_SSMM,
        };
    });

// Plotly
// plot
    var plotTitleIs = "IS Fill states; dashed=store limit; dotted=selective limit";
    var xTitleIs = "Date";
    var yTitleIs = "Stored Data Volume (MiBytes)";

    var layoutIs = getLayout(Is, plotTitleIs, xTitleIs, yTitleIs, minYiS, maxYiS);

// Create the chart using Plotly
    createAndAddToImageList('Is', dataIs, layoutIs);

// **** PLOT IS NORM **** //

    var IS_Norm = dataArrRateAvg.map(function (dataObj) {
        return {
            'DDATE': dataObj.DDATE,
            'EPD_SSMM': 100 * dataObj['EPD_SSMM'] / storeSizes['SSMM_EPD_SCI'],
            'MAG_SSMM': 100 * dataObj['MAG_SSMM'] / storeSizes['SSMM_MAG_SCI'],
            'RPW_SSMM': 100 * dataObj['RPW_SSMM'] / storeSizes['SSMM_RPW_SCI'],
            'SWA_SSMM': 100 * dataObj['SWA_SSMM'] / storeSizes['SSMM_SWA_SCI'],
        };
    });

    extractDataTracesIsNorm(IS_Norm);

// Plotly
    var dataIsNorm = [
        epdSsmmTrace,
        magSsmmTrace,
        rpwSsmmTrace,
        swaSsmmTrace
    ];

    __ret = getMinMaxY(dataIsNorm);

// plot
    var plotTitleIsNorm = "In-Situ Instruments Percentage Fill States";
    var xTitleIsNorm = "Date";
    var yTitleIsNorm = "Percentage Fill State";

    var layoutIsNorm = getLayout(IS_Norm, plotTitleIsNorm, xTitleIsNorm, yTitleIsNorm, __ret.minY, __ret.maxY);

// Create the chart using Plotly
    createAndAddToImageList('IsNorm', dataIsNorm, layoutIsNorm);

// **** PLOT RS NORM **** //

    var RS_Norm = dataArrRateAvg.map(function (dataObj) {
        return {
            'DDATE': dataObj.DDATE,
            'STX_SSMM': 100 * dataObj['STX_SSMM'] / storeSizes['SSMM_STX_SCI'],
            'SPI_SSMM': 100 * dataObj['SPI_SSMM'] / storeSizes['SSMM_SPI_SCI'],
            'SHI_SSMM': 100 * dataObj['SHI_SSMM'] / storeSizes['SSMM_SHI_SCI'],
            'PHI_SSMM': 100 * dataObj['PHI_SSMM'] / storeSizes['SSMM_PHI_SCI'],
            'MET_SSMM': 100 * dataObj['MET_SSMM'] / storeSizes['SSMM_MET_SCI'],
            'EUI_SSMM': 100 * dataObj['EUI_SSMM'] / storeSizes['SSMM_EUI_SCI'],
        };
    });

    extractDataTracesRsNorm(RS_Norm);

// Plotly
    var dataRsNorm = [
        euiSsmmTrace,
        metSsmmTrace,
        phiSsmmTrace,
        shiSsmmTrace,
        spiSsmmTrace,
        stxSsmmTrace,
    ];

    __ret = getMinMaxY(dataRsNorm);

// plot
    var plotTitleRsNorm = "Remote Sensing Instruments Percentage Fill State";
    var xTitleRsNorm = "Date";
    var yTitleRsNorm = "Percentage Fill State";

    var layoutRsNorm = getLayout(RS_Norm, plotTitleRsNorm, xTitleRsNorm, yTitleRsNorm, __ret.minY, __ret.maxY);

// Create the chart using Plotly
    createAndAddToImageList('RsNorm', dataRsNorm, layoutRsNorm);


// **** PLOT ratesRs **** //

// Convert data for ratesRs
    var ratesRs = dataArrRateAvg.map(function (dataObj) {
        return {
            DDATE: dataObj.DDATE,
            STX_Downld: dataObj.STX_Downld,
            SPI_Downld: dataObj.SPI_Downld,
            SHI_Downld: dataObj.SHI_Downld,
            MET_Downld: dataObj.MET_Downld,
        };
    });

// Plotly for ratesRs
    var dataratesRs = [
        stxDownldTrace,
        spiDownldTrace,
        shiDownldTrace,
        metDownldTrace,
    ];

    __ret = getMinMaxY(dataratesRs);

// Plot
    var plotTitleratesRs = "Remote Sensing Instruments output rates";
    var xTitleratesRs = "Date";
    var yTitleratesRs = "Rates b/s";

    var layoutratesRs = getLayout(ratesRs, plotTitleratesRs, xTitleratesRs, yTitleratesRs, __ret.minY, __ret.maxY);

// Create the chart using Plotly
    createAndAddToImageList('RatesRs', dataratesRs, layoutratesRs);


// **** PLOT RatesIS **** //

// Convert data for RatesIS
    var ratesIs = dataArrRateAvg.map(function(item) {
        return {
            DDATE: item.DDATE,
            EPD_Downld: item.EPD_Downld,
            MAG_Downld: item.MAG_Downld,
            RPW_Downld: item.RPW_Downld,
            SWA_Downld: item.SWA_Downld,
        };
    });

// Plotly for RatesIS
    var dataRatesIs = [
        epdDownldTrace,
        magDownldTrace,
        rpwDownldTrace,
        swaDownldTrace
    ];

    __ret = getMinMaxY(dataRatesIs);

// Plot
    var plotTitleRatesIs = "In-situ Instruments Output Rates";
    var xTitleRatesIs = "Date";
    var yTitleRatesIs = "Rates (bits/sec)";

    var layoutRatesIs = getLayout(ratesIs, plotTitleRatesIs, xTitleRatesIs, yTitleRatesIs, __ret.minY, __ret.maxY);

// Create the chart using Plotly
    createAndAddToImageList('RatesIs', dataRatesIs, layoutRatesIs);

    // **** PLOT UND **** //

    // Convert data for UND
    var UND = dataArrUnd.map(function(item) {
        return {
            DDATE: item.DDATE,
            Overall_Unused_Capacity: item.Overall_Unused_Capacity,
            Overall_Used_Capacity: item.Overall_Used_Capacity,
            Overall_Pass_Capacity: item.Overall_Pass_Capacity
        };
    });

    extractDataTracesUnd(UND);
    // Plotly for UND
    var dataUND = [
        usedTrace,
        unusedTrace,
        passTrace,
    ];

    __ret = getMinMaxY(dataUND);

    // Plot
    var plotTitleUnd = "Total, Used and Unused volume per pass";
    var xTitleUnd = "Date";
    var yTitleUnd = "Data volume per pass (MiBytes)";

    var layoutUnd = getLayout(UND, plotTitleUnd, xTitleUnd, yTitleUnd, __ret.minY, __ret.maxY);

    // Create the chart using Plotly
    createAndAddToImageList('Und', dataUND, layoutUnd);

// **** PLOT total Accum DL **** //

    var totAccumDL = UND.reduce(function(acc, curr) {
        acc.push({
            DDATE: curr.DDATE,
            Overall_Unused_Capacity: (acc.length > 0 ? parseFloat(acc[acc.length - 1].Overall_Unused_Capacity) : 0) + parseFloat(curr.Overall_Unused_Capacity),
            Overall_Used_Capacity: (acc.length > 0 ? parseFloat(acc[acc.length - 1].Overall_Used_Capacity) : 0) + parseFloat(curr.Overall_Used_Capacity),
            Overall_Pass_Capacity: (acc.length > 0 ? parseFloat(acc[acc.length - 1].Overall_Pass_Capacity) : 0) + parseFloat(curr.Overall_Pass_Capacity),
        });
        return acc;
    }, []);

    extractDataTracesTotAccumDl(totAccumDL);

// Plotly for UND
    var dataTotAccumDL = [
        unusedOverTrace,
        usedOverTrace,
        passOverTrace,
    ];

    __ret = getMinMaxY(dataTotAccumDL);

// Plot
    var plotTitleTotAccDl = "Downlink Potential Volume";
    var xTitleTotAccDl = "Date";
    var yTitleTotAccDl = "Accumulated downlink potential (MiBytes)";

    var layoutTotAccDl = getLayout(totAccumDL, plotTitleTotAccDl, xTitleTotAccDl, yTitleTotAccDl, __ret.minY, __ret.maxY);

// Create the chart using Plotly
    createAndAddToImageList('TotAccumDl', dataTotAccumDL, layoutTotAccDl);

// **** PLOT OutputSSMM_REAL_Tot **** //
// Convert data for OutputSSMM_REAL_Tot

//OMM = AverageData[['OMM_Mem']]
//   Total_HK = np.add(AverageData[['PYLDHK_Mem']],OMM)
    var Total_HK = dataArrRateAvg.map(function (item) {
        return {
            DDATE: item.DDATE,
            Total_HK: parseFloat(item.PYLDHK_Mem) + parseFloat(item.OMM_Mem),
        };
    });

// Total_PromptSci = np.add(AverageData[['LL_Mem']],AverageData[['SSMM_TAC_Mem']])
// Total_NonBulk = np.add(Total_HK,Total_PromptSci)
// Assuming dataArr is an array of objects with properties LL_Mem and SSMM_TAC_Mem
    var Total_PromptSci = dataArrRateAvg.map(function (item) {
        return {
            DDATE: item.DDATE,
            Total_PromptSci: parseFloat(item.LL_Mem) + parseFloat(item.SSMM_TAC_Mem),
        };
    });

// Assuming Total_HK is an array of objects with properties PYLDHK_Mem and OMM_Mem
    var Total_NonBulk = Total_HK.map(function (item, index) {
        return {
            DDATE: item.DDATE,
            Total_NonBulk: parseFloat(item.Total_HK) + parseFloat(Total_PromptSci[index].Total_PromptSci),
        };
    });

// Total = AverageData[['tot_mem']]
// Assuming dataArr is an array of objects with property tot_mem
    var Total = dataArrRateAvg.map(function (item) {
        return {
            DDATE: item.DDATE,
            Total: item.tot_mem,
        };
    });

// Assuming Total and Total_NonBulk are arrays of objects with property Total
    var TotalReal = Total.map(function (item, index) {
        return {
            DDATE: item.DDATE,
            TotalReal: parseFloat(item.Total) + parseFloat(Total_NonBulk[index].Total_NonBulk),
        };
    });

    extractDataTracesTotalReal(TotalReal);

// Plotly
    var sumSciSizes = sci_sizes.reduce(function (accumulator, currentValue) {
        return accumulator + currentValue;
    }, 0);
    var sciDashed = createDashedLineFixedTrace(dataArrRateAvg, 'SCI_size', sumSciSizes, 'green');
    var dataTotalReal = [
        totalRealTrace,
        sciDashed,
    ];

    __ret = getMinMaxY(dataTotalReal);

// Plot
    var plotTitleTotalReal = "Total SSMM fill state";
    var xTitleTotalReal = "Date";
    var yTitleTotalReal = "Stored Data Volume (MiBytes)";

    var layoutTotalReal = getLayout(TotalReal, plotTitleTotalReal, xTitleTotalReal, yTitleTotalReal, __ret.minY, __ret.maxY);

// Create the chart using Plotly
    createAndAddToImageList('TotalReal', dataTotalReal, layoutTotalReal);

// **** PLOT OutputAccumFlsh **** //

// Convert data for OutputAccumFlsh
    var OutputAccumFlsh = dataArrRateAvg.map(function (item) {
        return {
            DDATE: item.DDATE,
            PHI_Accum: item.PHI_Accum,
            EUI_Accum: item.EUI_Accum,
        };
    });

// Plotly for OutputAccumFlsh
    var dataOutputAccumFlsh = [
        phiAccumTrace,
        euiAccumTrace,
    ];

    __ret = getMinMaxY(dataOutputAccumFlsh);

// Plot
    var plotTitleOutputAccumFlsh = "Accumulated Transferred Data Volume (MiBytes) for PHI and EUI";
    var xTitleOutputAccumFlsh = "Date";
    var yTitleOutputAccumFlsh = "Accumulated Transferred Data Volume (MiBytes)";

    var layoutOutputAccumFlsh = getLayout(OutputAccumFlsh, plotTitleOutputAccumFlsh, xTitleOutputAccumFlsh, yTitleOutputAccumFlsh, __ret.minY, __ret.maxY);

// Create the chart using Plotly
    createAndAddToImageList('OutputAccumFlsh', dataOutputAccumFlsh, layoutOutputAccumFlsh);

// **** PLOT Dl **** //

// Convert data for Dl
    var Dl = dataArrRateAvg.map(function (item) {
        return {
            DDATE: item.DDATE,
            DL: item.DL,
        };
    });

// Plotly for Dl
    var dataDl = [
        dlTrace,
    ];

    __ret = getMinMaxY(dataDl);

// Plot
    var plotTitleDl = "Downlink Rate";
    var xTitleDl = "Date";
    var yTitleDl = "rate bps";

    var layoutDl = getLayout(Dl, plotTitleDl, xTitleDl, yTitleDl, __ret.minY, __ret.maxY);

// Create the chart using Plotly
    createAndAddToImageList('Dl', dataDl, layoutDl);



}

function createAndAddToImageList(divId, data, layout) {
    return Plotly.newPlot(divId, data, layout)
        .then(function (plot) {
            return Plotly.toImage(plot, {format: 'png', height: defHeight, width: defWidth});
        })
        .then(function (imgData) {
            imageList.push({data: imgData, filename: divId + '_plot.png'});
        });
}

// Function to launch batch download
function saveImages(images) {
    var zip = new JSZip();
    var promises = imageList.map(function (image) {
        return fetch(image.data)
            .then(function (response) {
                return response.blob();
            })
            .then(function (blob) {
                zip.file(image.filename, blob);
            });
    });

    Promise.all(promises).then(function () {
        zip.generateAsync({ type: 'blob' }).then(function (zipBlob) {
            // Create a link to download the zip file
            var a = document.createElement('a');
            a.href = URL.createObjectURL(zipBlob);
            a.download = 'Plots.zip';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        });
    });
}

function clearImages() {
    imageList = [];
}


(function () {
    'use strict';

    angular.module('soopkitchenApp').controller('PlanningVersionsMaintenanceController', PlanningVersionsMaintenanceController);

    PlanningVersionsMaintenanceController.$inject = ['$window','$sce','$controller', '$uibModalInstance', 'parameters', 'SoopkitchenUtils', 'Planning', 'PlanTypes'];

    function PlanningVersionsMaintenanceController($window, $sce, $controller, $uibModalInstance, parameters, SoopkitchenUtils, Planning, PlanTypes) {

        var title = 'Maintenance of the version list of plan: <span class="label label-info">'+parameters.planLabel+'</span>';
    // , Delete all internal versions from baseline: <span\n' +
    //         'class="label label-info">'+parameters.selectedBaselineToDelete+'</span>
        angular.extend(this, $controller('SoopkitchenDialogController', {
            "title": title, $sce: $sce, $uibModalInstance:$uibModalInstance}));
        var vm = this;

        /**** Properties ****/

        vm.planType = parameters.planType;
        vm.planLabel = parameters.planLabel;
        vm.selectedBaselineToDelete = parameters.selectedBaselineToDelete;
        vm.isMaster = vm.planType === PlanTypes['master'];
        vm.parameters = [];
        vm.parameters.push({'name': 'Label'});
        if (vm.isMaster) {
            vm.parameters.push({'name': 'ID'});
        }
        vm.parameter = {};
        //Overriding Properties from SoopkitchenDialogController:
        vm.saveText = "Clone";
        vm.showDelta = {};

        /**** Methods ****/
        //Override Methods from SoopkitchenDialogController
        vm.deleteVersions = deleteVersions;
        vm.plans = [];
        getPlans();
        vm.downloadFile = downloadFile;

        function successCloning() {
            SoopkitchenUtils.invokeSweetAlert("Nice!", "You have created the plan " + vm.parameter['Label'], "success", vm.clear);
        }

        function failureCloning(response) {
            SoopkitchenUtils.prettyError(response);
        }

        function getPlans() {
            Planning.getAllVersions(
                {
                    planType: vm.planType,
                    id: vm.planLabel,
                },
                function successCallback(response) {
                    vm.totalPlans = response;
                    var baselineFound = false;
                    for (var count = vm.totalPlans.length; count >=0 ; count--) {
                        if (vm.totalPlans.hasOwnProperty(count)) {
                            var plan = vm.totalPlans[count];
                            vm.showDelta[plan.internalVersion] = false;
                            if (plan.baselineVersion === vm.selectedBaselineToDelete) {
                                break;
                            }
                            // console.debug(plan.baselineVersion);
                            // console.debug(plan.baselineVersion);

                            if (plan.baselineVersion ===0 && plan.isBookmarked === false) {
                                vm.plans.push(plan) ;
                            }
                        }
                    }
                },
                function errorCallback(response) {
                }
            )
        }
        function deleteVersions() {
            console.warn(vm.planType);
            Planning.deleteVersions(
                {
                    planType: vm.planType,
                    planLabel: vm.planLabel,
                    baselineVersion: vm.selectedBaselineToDelete
                },
                function successCallback(response) {
                    SoopkitchenUtils.invokeSweetAlert("Nice!", "You deleted versions of the plan " + vm.planLabel + "prior to baseline version: " + vm.selectedBaselineToDelete    , "success");
                    vm.waiting = false;
                    location.reload();
                },
                function errorCallback(response) {
                    SoopkitchenUtils.prettyError(response);
                }
            )

        }
        function downloadFile () {
            $window.open('api/' + vm.planType + '/download-versions/' + window.encodeURIComponent(vm.planLabel) + '/' +  vm.selectedBaselineToDelete);
        }
    }

})();


(function () {
    'use strict';

    angular.module('soopkitchenApp').controller('PlanningVersionsController', PlanningVersionsController);

    PlanningVersionsController.$inject = ['entity', 'previousState', '$window', 'SoopkitchenUtils', 'Planning', '$stateParams', 'PlanTypes', '$uibModal', '$scope', '$cookies', '$http'];

    function PlanningVersionsController(entity, previousState, $window, SoopkitchenUtils, Planning, $stateParams, PlanTypes, $uibModal, $scope, $cookies, $http) {
        var vm = this;

        /** ** Properties *** */

        vm.planType = $stateParams.planType;
        vm.isMaster = vm.planType === PlanTypes['master'];
        vm.isChild = vm.planType === PlanTypes['child'];
        vm.isTemplate = vm.planType === PlanTypes['template'];
        vm.isSoop = vm.planType === PlanTypes['soop'];
        vm.planning = entity;
        vm.previousState = previousState.name;
        vm.previousParams = previousState.params;
        vm.checkedBaselines = true;
        vm.checkedBookmarks = true;
        vm.checkedAll = false;
        vm.checkedInstrument = {};
        vm.showDelta = {};
        vm.checkedAllInstrument = true;
        vm.checkedEvents = true;
        vm.ascending = false;
        vm.predicate = null;
        vm.lastBaselineChecked = false;
        vm.lastBaselineChecked = false;
        vm.selectedToDelete = null;
        vm.versionsToDelete = ['before last baseline', 'all but baselines', 'all but bookmarks'];
        vm.selectedBaselineToDelete = null;
        vm.baselinesToDelete = [];
        vm.isLtp = vm.planning.label.startsWith('LTP');
        /**** Functions ****/

        vm.sortTable = sortTable;
        vm.clone = clone;
        vm.displayVersion = displayVersion;
        vm.checkAllInstruments =checkAllInstruments;
        vm.uncheckAllInstruments = uncheckAllInstruments;
        vm.checkEvents =checkEvents;
        vm.uncheckEvents = uncheckEvents;
        vm.downloadFile = downloadFile;
        vm.downloadComparison = downloadComparison;
        vm.simulatePlan = simulatePlan;
        vm.draftS15TDR = draftS15TDR; // Added this line
        vm.plotPlanEps = plotPlanEps;
        vm.plotPlanLatency = plotPlanLatency;
        vm.donwloadResults = donwloadResults;
        // vm.commitSimulation = commitSimulation;
        vm.plotsGeneration = plotsGeneration;
        vm.editTDR = editTDR;
        vm.commitPush = commitPush;
        vm.rollback = rollback;
        vm.sanityChecks = sanityChecks;
        vm.instrumentChecked = instrumentChecked;
        vm.uncheckInstrument = uncheckInstrument;
        vm.checkInstrument = checkInstrument;
        vm.toggleBaselines = toggleBaselines;
        vm.toggleBookmarks = toggleBookmarks;
        vm.toggleAllVersions = toggleAllVersions;
        vm.deleteVersions = deleteVersions;
        /**** Init ****/

        checklocks(vm.planning.label);
        getPlans();
        vm.instruments = createInstrumentCheckbox();
        vm.checkedAll  = getBooleanFromCookie("checkedAll");
        vm.checkedBookmarks  = getBooleanFromCookie("checkedBookmarks");
        vm.checkedBaselines  = getBooleanFromCookie("checkedBaselines");
        vm.checkedEvents  = getBooleanFromCookie("checkedEvents");

        function getBooleanFromCookie(name) {
            if ($cookies.get(name) == null && name === "checkedAll") return false;
            if ($cookies.get(name) == null) return true;
            return JSON.parse($cookies.get(name));
        }
        function getJSONFromCookie(name) {
            if ($cookies.get(name) == null) return null;
            return JSON.parse($cookies.get(name));
        }
        function toggleAllVersions (){
            vm.checkedAll=!vm.checkedAll;
            if (vm.checkedAll) {
                vm.checkedBookmarks=true;
                vm.checkedBaselines=true;
            }
            storeCookies();
        }

        function deleteVersions() {
            $uibModal.open({
                templateUrl: 'app/entities/planning/planning-versions-maintenance.html',
                controller: 'PlanningVersionsMaintenanceController',
                controllerAs: 'vm',
                size: 'lg',
                backdrop: 'static',
                resolve: {
                    parameters: {
                        planType: vm.planType,
                        planLabel: vm.planning.label,
                        selectedBaselineToDelete: vm.selectedBaselineToDelete,
                    }
                }
            }).result.then(function () {
            }, function () {
            });
        }

        function toggleBookmarks (){
            vm.checkedBookmarks=!vm.checkedBookmarks;
            storeCookies();
        }
        function toggleBaselines (){
            vm.checkedBaselines=!vm.checkedBaselines;
            storeCookies();
        }
        function uncheckInstrument(instrument) {
            vm.checkedInstrument[instrument] = false;
            vm.checkedAllInstrument = false;
            storeCookies();

        }
        function checkInstrument(instrument) {
            vm.checkedInstrument[instrument]=true;
            storeCookies();
        }

        function isInstrumentRelated(delta) {
            for (var i = 0; i < vm.instruments.length; i++) {
                var instrument = vm.instruments[i];
                if (delta.indexOf(instrument)>-1) {
                    return true;
                }
            }
            return false;
        }

        function extractPositions(delta, instrument) {
            var positions = [];
            var pos = delta.prettyString.indexOf(instrument);

            while (pos > -1) {
                positions.push(pos);
                pos = delta.prettyString.indexOf(instrument, pos + 1);
            }
            return positions;
        }

        function instrumentChecked(plan) {
            if (plan.internalVersion === vm.planning.internalVersion ||
                vm.checkedAllInstrument) {
                return true;
            }
            var atLeastOneInstrumet = false;
            for (var count in plan.deltas) {
                var delta = plan.deltas[count];
                if (delta.hasOwnProperty("prettyString")) {
                    for (var instrument in vm.checkedInstrument) {
                        if (vm.checkedInstrument[instrument]) {
                            atLeastOneInstrumet = true;
                            if (delta.prettyString.indexOf(instrument)>-1) {
                                // Positions in the delta where the instrument ID is present:
                                var positions = extractPositions(delta, instrument);
                                for (var position in positions) {
                                    // It should have MAG, but not IMAGE
                                    if (instrument === "MAG") {
                                        var restStringShifted1Char = delta.prettyString.substring(position-1);
                                        var indexImage = restStringShifted1Char.indexOf("IMAGE");
                                        var indexMagTop = restStringShifted1Char.indexOf("_MAGTOP");
                                        if (indexImage < 0 && indexMagTop<0) {
                                            return true;
                                        }
                                    } else {
                                        return true;
                                    }
                                }
                            }
                        }
                    }

                    if (vm.checkedEvents && (delta.prettyString.includes("Event"))) {
                        return true;
                    }

                    if (atLeastOneInstrumet === false &&
                        isInstrumentRelated(delta.prettyString) === false &&
                        delta.prettyString.includes("Event") === false
                    ) {
                        return true;
                    }
                }

            }

            return false;

        }
        function checklocks(label) {
            Planning.getMeta(
                {
                    id: label
                },
                function successCallback(response) {
                    vm.locked = response.locked;
                },
                function errorCallback(response) {
                }
            )
        }

        function getPlans() {
            Planning.getAllVersions(
                {
                    planType: vm.planType,
                    id: vm.planning.label,
                },
                function successCallback(response) {
                    vm.plans = response;
                    for (var count in vm.plans) {
                        if (vm.plans.hasOwnProperty(count)) {
                            var plan = vm.plans[count];
                            vm.showDelta[plan.internalVersion] = false;
                            if (plan.baselineVersion !==0 && plan.baselineVersion !==undefined) {
                                vm.baselinesToDelete.push(plan.baselineVersion) ;
                            }
                        }
                    }
                },
                function errorCallback(response) {
                }
            )
        }

        function downloadFile (plan) {
            $window.open('api/' + vm.planType + '/export/' + window.encodeURIComponent(plan.label) + '/' + plan.internalVersion);
        }

        function downloadComparison (plan) {
            $http({
                method: 'GET',
                url: 'api/' + vm.planType + '/export-comparison/' + window.encodeURIComponent(plan.label) + '/' + plan.internalVersion,
                responseType: 'text'
            }).then(function successCallback(response) {
                var reportContent = response.data;
                var title = 'Event Comparison Report';
                var msg = '<div class="resizable-content">' +
                          '<pre class="log-content">' + reportContent + '</pre>' +
                          '</div>';
                msg += '<h4>Would you like to download the report?</h4>';

                confirmAction(title, msg, 'info', function () {
                    var blob = new Blob([reportContent], {type: 'text/plain'});
                    var downloadLink = document.createElement('a');
                    downloadLink.href = window.URL.createObjectURL(blob);
                    downloadLink.download = plan.label + "_event_comparison.txt";
                    downloadLink.click();
                });
            }, function errorCallback(response) {
                SoopkitchenUtils.prettyError(response);
            });
        }

        // those filenames are needed to identify the Python script to be executed
        function plotPlanLatency(plan) {
            plotPlan(plan, "Latency");
        }

        function plotPlanEps(plan) {
            plotPlan(plan, "Output");
        }

        function plotPlan(plan, filename) {
            $http({
                method: 'GET',
                url: 'api/' + vm.planType + '/plot/' + window.encodeURIComponent(plan.label) + '/' + plan.internalVersion + '/' + filename,
                responseType: 'arraybuffer'
            }).then(function successCallback(response) {
                var title ='Plots Generated Successfully :)';
                var msg = '<h4>Would you like to download results?</h4>';
                confirmAction(title, msg, 'success', function () {
                    donwloadZipFile(response);
                });
            }, function errorCallback(response) {
                SoopkitchenUtils.prettyError(response);
            });
        }

        function simulatePlan(plan) {
            var title = 'Would you like to run the simulation?';

            var tableContainer = document.createElement('div');
            tableContainer.style.textAlign = 'center';

            var label = document.createElement('label');
            label.innerHTML = 'Use Local TDR';
            label.setAttribute('for', 'localTdrCheckbox');
            label.style.fontSize = '20px';
            label.style.display = 'inline-block';


            var checkbox = document.createElement('input');
            checkbox.type = 'checkbox';
            checkbox.id = 'localTdrCheckbox';
            checkbox.style.display = 'inline-block';
            checkbox.style.verticalAlign = 'middle';
            checkbox.style.width = '7%'; // Set the width of the checkbox to 7%
            checkbox.style.boxShadow = 'none'; // Remove the box shadow
            checkbox.style.height = '20px'; // Set the height of the checkbox to 20px



            tableContainer.appendChild(label);
            tableContainer.appendChild(checkbox);

            SoopkitchenUtils.invokeSweetAlertWithParams({
                title: title,
                text:  tableContainer.outerHTML,
                html: true,
                customClass: 'swal-wide',
                type: 'info',
                confirmButtonColor: "#DD6B55",
                animation: 'slide-from-top',
                showCancelButton: true,
                }, function (ok) {
                    if (ok) {
                        var checkboxValue = document.getElementById('localTdrCheckbox').checked;
                        var useLocalTDR = checkboxValue;
                        simulatePlanConfirmation(plan, useLocalTDR);
                    }
                });
        }

        function simulatePlanConfirmation(plan, useLocalTDR) {
            $http({
                method: 'GET',
                url: 'api/' + vm.planType + '/simulate/' + window.encodeURIComponent(plan.label) + '/' + plan.internalVersion + '/' + useLocalTDR,
            }).then(function successCallback(response) {
                var fileContent = response.data;
                var title = 'Simulation Executed Successfully :)';
                var msg = '<h3>' + plan.label + ' - Internal version: ' + plan.internalVersion + ' - Errors from "conflicts.out"' +'</h3>';
                // Filter to show only lines containing "ERROR"
                if (fileContent != "") {
                    var errorLines = fileContent.split('\n').filter(function(line) {
                        return line.includes("ERROR");
                    }).join('\n');
                    if (errorLines === "") {
                        errorLines = "No errors found in simulation.";
                    }
                    msg +=
                        '<div class="resizable-content">' +
                        '<pre class="log-content">' + errorLines + '</pre>' +
                        '</div>';
                }
                //var msg = "<img  height='200' width='200' src='content/images/happy-sun.jpeg'/> <br>"
                msg += '<h4>Would you like to download results?</h4>';

                // Display the message in your modal or UI component here
                confirmAction(title, msg, 'success', function () {
                    donwloadResults(plan, true);
                });
            }, function errorCallback(response) {
                if (response.status === 417) {
                    var fileContent = response.data;

                    var title = "Simulation Failed";
                    var msg = "<img  height='183' width='245' src='content/images/coyote-ouch.jpeg'/> <br>";
                    msg += '<h4>Would you like to download results?</h4>';
                    if (fileContent != "") {
                        msg += '<div class="resizable-content">' +
                            '<pre class="log-content">' + fileContent + '</pre>' +
                            '</div>';
                    }
                    confirmAction(title, msg, 'warning', function () {
                        donwloadResults(plan, true);
                    });
                } else {
                    SoopkitchenUtils.prettyError(response, function () {
                    });
                }
            });
        }

        function draftS15TDR(plan) {
            $http({
                method: 'GET',
                url: 'api/' + vm.planType + '/draftS15TDR/' + window.encodeURIComponent(plan.label) + '/' + plan.internalVersion,
            }).then(function successCallback(response) {
                SoopkitchenUtils.invokeSweetAlert("Nice!", "ADR and EFECS files successfully sent!", "success");
            }, function errorCallback(response) {
                SoopkitchenUtils.prettyError(response);
            });
        }

        function confirmAction(title, message, type,  action) {
            SoopkitchenUtils.prettyHtml(title, message, type, function (ok) {
                if (ok) {
                    action();
                }
            });
        }

        function donwloadResults (plan, simul) {
            $http({
                method: 'GET',
                url: 'api/' + vm.planType + '/downloadresults/' + window.encodeURIComponent(plan.label) + '/' + plan.internalVersion + '/' + simul,
                responseType: 'arraybuffer'
            }).then(function successCallback(response) {
                donwloadZipFile(response);
            }, function errorCallback(response) {
                SoopkitchenUtils.prettyError(response);
            });
        }


        function donwloadZipFile (response) {
            var contentDispositionHeader = response.headers('Content-Disposition');
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(contentDispositionHeader);
            var filename = matches[1].replace(/['"]/g, '');
            // create a blob from the zip file bytes
            var blob = new Blob([response.data], {type: 'application/zip'});
            // create a download link and click it to download the file
            var downloadLink = document.createElement('a');
            downloadLink.href = window.URL.createObjectURL(blob);
            downloadLink.download = filename;
            downloadLink.click();
        }


        function createDivPlot(name) {
            var divPlot = document.createElement('div');
            divPlot.setAttribute('id', name);
            //divPlot.style.border = '1px solid black';
            divPlot.style.width = '1205px';
            return divPlot;
        }

        function plotsGeneration (plan) {
            // table for Plots
            var tableContainer = document.createElement('div');
            tableContainer.style.overflow = 'auto';
            tableContainer.style.height = '75vh';
            tableContainer.style.minHeight = '20px';

            // Create a spinner
            var spinner = document.createElement('div');
            spinner.id = "plotSpinner";
            spinner.setAttribute('class', 'loading-spinner');

            // Append the spinner to the tableContainer
            tableContainer.appendChild(spinner);

            // Define an array of plot identifiers
            var plotIdentifiers = [
                'RsNorm', 'IsNorm', 'Rs', 'Is', 'TotalReal',
                'TotAccumDl', 'Und', 'RatesRs', 'RatesIs', 'OutputAccumFlsh',
                'Dl', 'NonSci', 'ISLat', 'RSLat', 'NonSciLat'
            ];
            // Dynamically create and append plots
            for (var i = 0; i < plotIdentifiers.length; i++) {
                tableContainer.appendChild(createDivPlot(plotIdentifiers[i]));
            }

            SoopkitchenUtils.invokeSweetAlertWithParams({
                title: "Plots",
                text: tableContainer.outerHTML,
                html: true,
                heightAuto: false,
                customClass: 'swal-full-screen',
                animation: 'slide-from-top',
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: 'Save Plots',
                cancelButtonText: 'Cancel',
                closeOnConfirm: false
            }, function (ok) {
                if (ok) {
                    console.log("Saving plots...");
                    saveImages();
                }
            });
            // Execute the code block without waiting for user interaction
            $http({
                method: 'GET',
                url: 'api/' + vm.planType + '/simulationFiles/' + window.encodeURIComponent(plan.label) + '/' + plan.internalVersion,
                responseType: 'arraybuffer'  // Important: Ask for the data as raw binary
            }).then(function successCallback(response) {
                JSZip.loadAsync(response.data).then(function (zipFiles) {
                    var promises = [];
                    var dataArrLat = [];
                    var dataArrRateAvg = [];
                    var dataArrUnd = [];
                    var storeSizes = [];
                    var sci_sizes = [];

                    zipFiles.forEach(function (relativePath, zipEntry) {
                        console.log("File:", relativePath);
                        var promiseData = zipEntry.async('string').then(function (content) {
                            if (relativePath === "cyclic_ds_latency.out") {
                                fetchDataLat(content, dataArrLat);
                            } else if (relativePath === "data_rate_avg.out") {
                                fetchDataEps(content, dataArrRateAvg);
                            } else if (relativePath === "passes.out") {
                                fetchDataEpsPasses(content, dataArrUnd);
                            } else if (relativePath === "sol_memory.edf") {
                                fetchDataEpsMemory(content, storeSizes, sci_sizes);
                            }
                        }).catch(function (error) {
                            console.error("Error in zipEntry.async: ", error);
                        });
                        promises.push(promiseData);
                    });
                    // Wait for all promises to resolve
                    Promise.all(promises).then(function () {
                        // All promises have resolved, now call plotDataLat
                        plotDataLat(dataArrLat);
                        plotDataEps(dataArrUnd, dataArrRateAvg, storeSizes, sci_sizes);
                        // Remove the spinner after plotting the data
                        var docSpinner = document.getElementById("plotSpinner");
                        docSpinner.remove();
                    }).catch(function (error) {
                        console.error("Error in processing zip files: ", error);
                    });
                }).catch(function(error) {
                    console.error("Error in JSZip.loadAsync: ", error);
                });
            }, function errorCallback(response) {
                SoopkitchenUtils.prettyError(response);
            });
        }

        function editTDR (plan) {
            $http({
                method: 'GET',
                url: 'api/' + vm.planType + '/tdredition/' + window.encodeURIComponent(plan.label) + '/' + plan.internalVersion,
            }).then(function successCallback(response) {
                var fileContent = response.data;

                var table = document.createElement('table');
                table.setAttribute('id', 'tdrTable');
                table.setAttribute('border', '3');

                // read row
                var rows = fileContent.split("\n");

                var rowsCount = 0;
                for (var rowIndex in rows) {
                    var row = rows[rowIndex];
                    var dataMain = row.split('=');

                    // date
                    // check if first element of the row is a valid date
                    var td;
                    if (valiDate(dataMain[0].trim())) {
                        var trHeader;
                        if (rowsCount === 0) {
                            trHeader = table.insertRow();
                            td = trHeader.insertCell();
                            td.innerHTML = '<label onclick="sortTableDate(0);" class="label-td">Date</label>';
                            td.style.backgroundColor = "#ADD8E6";
                            td.style.fontWeight = "bold";
                        }
                        var tr2 = table.insertRow();
                        td = tr2.insertCell();
                        td.innerHTML = dataMain[0];
                        td.setAttribute("contenteditable", "true");
                        td.setAttribute("onblur", "editCellDate(this)");
                        td.style.padding = "5px";
                        td.style.fontWeight = "bold";


                        // instruments ratio
                        var data = dataMain[1].trim().split(/\s+/);
                        var cont = 1;
                        var total = 0;
                        // ratio columns
                        for (var colIndex in data) {
                            var col = data[colIndex];
                            if (isWhitespace(col)) break;
                            if (cont % 2 === 0) {
                                td = tr2.insertCell();
                                total += parseFloat(col);
                                td.innerHTML = col;
                                td.setAttribute("contenteditable", "true");
                                td.setAttribute("onblur", "editCell(this)");
                                td.style.padding = "10px";
                            } else {
                                // header
                                if (rowsCount === 0) {
                                    td = trHeader.insertCell();
                                    col = col.replace(/^SSMM_|_SCI$/g, "");
                                    td.innerHTML = col;
                                    td.style.backgroundColor = "#ADD8E6";
                                    td.style.fontWeight = "bold";
                                }
                            }
                            cont++;
                        }
                        // total
                        if (rowsCount === 0) {
                            td = trHeader.insertCell();
                            td.innerHTML = "Total";
                            td.style.backgroundColor = "#ADD8E6";
                            td.style.fontWeight = "bold";
                        }
                        td = tr2.insertCell();
                        updateTotal(td, total);
                        // functions column
                        if (rowsCount === 0) {
                            td = trHeader.insertCell();
                            td.innerHTML = "Functions";
                            td.style.backgroundColor = "#ADD8E6";
                            td.style.fontWeight = "bold";
                        }
                        var comment = "";
                        var extractedComment = rows[rows.indexOf(row) - 1];

                        while (extractedComment && extractedComment.trim().charAt(0) === "#") {
                            if (comment === "")
                                comment = extractedComment.trim().substr(1);
                            else
                                comment = extractedComment.trim().substr(1) + "\n" + comment;
                            extractedComment = rows[rows.indexOf(extractedComment) - 1];
                        }

                        td = tr2.insertCell();
                        td.style.padding = "5px";
                        // Functions buttons
                        // button + to clone the row
                        // button - to remove the row
                        // button 'comment' to modify, add or remove the text for the row comment
                        td.innerHTML = '<label onclick="duplicateRow(this);" class="button-label">+</label> '
                            + '<label onclick="deleteRow(this);" class="button-label">-</label> '
                            + '<label class="button-label" onclick="toggleTextArea(this.parentElement)">Comment</label> '
                            + '<textarea style="display: none;" class="comment-textarea">' + comment + '</textarea>';
                        // increment rows counter
                        rowsCount++;
                    }
                }

                // Create the script element
                var script = document.createElement('script');
                script.setAttribute('src', 'tdr-functions.js');
                var tableBody = document.createElement('tbody');
                tableBody.appendChild(script);

                // Append the table body to the table
                table.appendChild(tableBody);

                var tableContainer = document.createElement('div');
                tableContainer.style.overflow = 'auto';
                tableContainer.style.maxHeight = '500px';
                tableContainer.appendChild(table);

                SoopkitchenUtils.invokeSweetAlertWithParams({
                    title: "TDR Editor",
                    text: tableContainer.outerHTML,
                    html: true,
                    type: 'info',
                    customClass: 'swal-super-wide',
                    animation: 'slide-from-top',
                    showCancelButton: true,
                    confirmButtonColor: "#DD6B55"
                    }, function (ok) {
                        if (ok) {
                            var tdrText = generateTdrText('ltp');
                            saveTDR(plan, tdrText);
                        }
                    }
                );
            }, function errorCallback(response) {
                //console.error(error);
                SoopkitchenUtils.prettyError(response);
            });
        }

        function saveTDR(plan, tdrText) {
            $http({
                method: 'POST',
                url: 'api/' + vm.planType + '/saveTdr/' + encodeURIComponent(plan.label) + '/' + plan.internalVersion,
                data: JSON.stringify(tdrText),
            }).then(function successCallback(response) {
                //console.log(tdrText);
                SoopkitchenUtils.invokeSweetAlert("Nice!", "TDR changes saved", "success");
                //successCallback();
            }, function errorCallback(response) {
                SoopkitchenUtils.prettyError(response);
            });
        }

        function commitPush(plan) {
            var title = 'Commit Plan files';

            var tableContainer = document.createElement('div');
            tableContainer.style.textAlign = 'center';

            var label = document.createElement('label');
            label.innerHTML = 'Would you like the files from the plan to be committed and pushed to the repository?';
            label.style.display = 'block'; // Set display property to block

            var textArea = document.createElement('textarea');
            textArea.id = 'commit-message';
            textArea.style.display = 'block';
            textArea.style.width = '100%';
            textArea.rows = 5;
            textArea.placeholder = 'Enter your commit message here...';

            tableContainer.appendChild(label);
            tableContainer.appendChild(textArea);

            SoopkitchenUtils.invokeSweetAlertWithParams({
                title: title,
                text: tableContainer.outerHTML,
                html: true,
                customClass: 'swal',
                type: 'info',
                confirmButtonColor: "#DD6B55",
                animation: 'slide-from-top',
                showCancelButton: true,
            }, function (ok) {
                if (ok) {
                    $http({
                        method: 'POST',
                        url: 'api/' + vm.planType + '/commitPush/' + encodeURIComponent(plan.label) + '/' + plan.internalVersion,
                        data: angular.toJson(document.getElementById("commit-message").value),
                    }).then(function successCallback(response) {
                        SoopkitchenUtils.invokeSweetAlert("Nice!", "Changes have been committed", "success");
                    }, function errorCallback(response) {
                        SoopkitchenUtils.prettyError(response);
                    });
                }
            });
        }

        function toggleAllInstruments(value) {
            for (var i = 0; i < vm.instruments.length; i++) {
                var instrument = vm.instruments[i];
                vm.checkedInstrument[instrument] = value;
            }
            vm.checkedAllInstrument = value;
            vm.checkedEvents = value;
            storeCookies();
        }

        function checkAllInstruments() {
            toggleAllInstruments(true);
        }
        function uncheckAllInstruments () {
            toggleAllInstruments(false);
        }
        function checkEvents() {
            vm.checkedEvents = true;
        }
        function uncheckEvents () {
            vm.checkedEvents = false;
            vm.checkedAllInstrument = false;
        }
        function createInstrumentCheckbox() {
            var groupsArray = [];
            var obsDef = vm.planning.observationDefinitions.allExperimentsObservationDefinitions;
            var storedCheckedInstrument = getJSONFromCookie("checkedInstrument");
            for (var experiment in obsDef) {
                if (vm.planning.observationDefinitions.allExperimentsObservationDefinitions.hasOwnProperty(experiment)) {
                    groupsArray.push(experiment);
                    if (storedCheckedInstrument != null) {
                        vm.checkedInstrument[experiment] = storedCheckedInstrument[experiment];
                    } else {
                        vm.checkedInstrument[experiment] = true;
                    }
                }
            }
            vm.checkedAllInstrument  = getBooleanFromCookie("checkedAllInstrument");

            return groupsArray;
        }


        function displayVersion(plan) {
            return plan.internalVersion === vm.planning.internalVersion || vm.checkedAll === true
                || (vm.checkedBookmarks === true && plan.isBookmarked === true) || (plan.baselineVersion !== 0 && vm.checkedBaselines === true);
        }


        function rollback (internalVersion) {
            SoopkitchenUtils.prettyConfirm('Rollback', 'Do you really want to rollback to internalversion ' + internalVersion
                + ' ? ', function (ok) {
                if (ok) {
                    doRollBack(internalVersion);
                }
            });
        }

        function sanityChecks(internalVersion) {
            $http({
                method: 'GET',
                url: 'api/plan/checks/' + vm.planning.label + '/' + internalVersion,
            }).then(function successCallback(response) {
                SoopkitchenUtils.sanityChecksResult(response);
            }, function errorCallback(response) {
                SoopkitchenUtils.prettyError(response);
            });
        }


        function doRollBack(internalVersion) {
            Planning.rollback(
                {
                    planType: vm.planType,
                    planLabel: vm.planning.label,
                    internalVersion: internalVersion
                },
                function successCallback(response) {
                    SoopkitchenUtils.invokeSweetAlert("Nice!", "You rolledback the plan " + vm.planning.label + "to version: " + internalVersion, "success");
                    checklocks(vm.planning.label);
                    getPlans();
                    createInstrumentCheckbox();
                },
                function errorCallback(response) {
                }
            )
        }

        function clone(internalVersion) {
            $uibModal.open({
                templateUrl: 'app/entities/planning/clone-plan.html',
                controller: 'ClonePlanController',
                controllerAs: 'vm',
                size: 'md',
                backdrop: 'static',
                resolve: {
                    parameters: {
                        planType: vm.planType,
                        labelToClone: vm.planning.label,
                        internalVersionToClone: internalVersion,
                    }
                }
            }).result.then(function () {
            }, function () {
            });
        }
        function sortTable() {
            vm.plans = SoopkitchenUtils.sort(vm.plans, vm.predicate, !vm.ascending);
            $scope.$apply();
        }

        function storeCookies() {
            $cookies.put("checkedInstrument", JSON.stringify(vm.checkedInstrument));
            $cookies.put("checkedAllInstrument", vm.checkedAllInstrument);
            $cookies.put("checkedAll", vm.checkedAll);
            $cookies.put("checkedBookmarks", vm.checkedBookmarks);
            $cookies.put("checkedBaselines", vm.checkedBaselines);
            $cookies.put("checkedEvents", vm.checkedEvents);

        }
    }

    // TDR
    // date format validator
    function valiDate(dateInput) {
        var regex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/;
        return regex.test(dateInput);
    }

    // check there are no whitespaces
    function isWhitespace(str) {
        return str.trim().length === 0;
    }

    // total color update
    function updateTotal(td, total) {
        td.innerHTML = total.toFixed(3);// round to 3 decimal places
        td.style.color = "white";
        td.style.backgroundColor = "red";
        var oneHandred = 100;
        if (total.toFixed(3) === oneHandred.toFixed(3)) {
            td.style.backgroundColor = "blue";
        }
    }

    // generate tdr
    function generateTdrText(type) {
        if (sortTableDate(0) === "desc"){
            sortTableDate(0);
        }
        var table = document.getElementById("tdrTable");
        var rows = table.rows;
        var headerCells = rows[0].cells;

        // TDR header
        var result = 'VIRTUAL_CHANNEL VC2  # The label of this Virtual Channel\n';
        // particular part of the header depending on ltp or mtp
        if (type === "ltp") {
            result = result + 'EVENT_NAME SSMM_DUMP_1WAY_END SSMM_DUMP_2WAY_END';
        } else if (type === "mlp") {
            result = result + 'EVENT_NAME PASS_END';
        }
        result = result + "\n\nDS_NAMES SSMM_EPD_SCI SSMM_EUI_SCI SSMM_MAG_SCI SSMM_MET_SCI SSMM_PHI_SCI SSMM_RPW_SCI SSMM_SHI_SCI SSMM_SPI_SCI SSMM_STX_SCI SSMM_SWA_SCI\n\n"
            + "LOW_PRIORITY 4 # Big number, low priority\n"
            + "HIGH_PRIORITY 1 # Low number, high priority\n\n";

        // ratios rows generation
        for (var i = 1; i < rows.length; i++) {
            var cells = rows[i].cells;
            //  add comment in case it exists
            var comment = rows[i].getElementsByClassName("comment-textarea")[0].value;
            var fullComment = null;
            if (!isWhitespace(comment)) {
                var lines = comment.split("\n");
                //fullComment = lines.map(line => "#" + line).join("\n") + "\n";
                fullComment = lines.map(function(line) {
                    return "#" + line;
                }).join("\n") + "\n";

            }
            //console.log(fullComment);
            if (fullComment !== null) result += fullComment;

            for (var j = 0; j < cells.length - 2; j++) {
                var cellValue = cells[j].textContent;
                var headerValue = headerCells[j].textContent;
                if (j === 0) {
                    result += cellValue + '= ';
                } else {
                    result += 'SSMM_' + headerValue + '_SCI ' + parseFloat(cellValue).toFixed(3) + ' ';
                }
            }
            result += '\n';
        }

        //console.log(result);
        return result;
    }

})();

(function () {
    'use strict';
    angular
        .module('soopkitchenApp')
        .constant('PlanTypes', {
            master: 'plan',
            child: 'child-plan',
            template: 'template-plan',
            soop: 'soop-plan'
        })
        .factory('PlanTypesUtils', PlanTypesUtils);

    PlanTypesUtils.$inject = ['PlanTypes'];

    function PlanTypesUtils(PlanTypes) {
        
        return {
            getPlanType: getPlanType,
        };

        function getPlanType(type) {
            return PlanTypes[type.toLowerCase()];
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('soopkitchenApp')
        .controller('PlanningRestrictPeriodController', PlanningRestrictPeriodController);

    PlanningRestrictPeriodController.$inject = ['entity', 'AlertService', 'SoopkitchenUtils', 'PlanningEventsService'];

    function PlanningRestrictPeriodController(entity, AlertService, SoopkitchenUtils, PlanningEventsService) {

        var vm = this;

        vm.plan = entity;
        vm.cancel = cancel;
        vm.collectionsStart = vm.plan.eventCollections.validityStartTime;
        vm.collectionsEnd = vm.plan.eventCollections.validityEndTime;
        vm.planStart = vm.plan.validityStartTime;
        vm.planEnd = vm.plan.validityEndTime;
        vm.isValidDate = SoopkitchenUtils.isValidDate;
        vm.picker = {};
        vm.picker2 = {};
        vm.reset = reset;
        vm.apply = apply;
        vm.updateLetters = updateLetters;
        vm.durationLettersInvalid = durationLettersInvalid;
        vm.invalidDateRange = invalidDateRange;
        vm.updateEndDate = updateEndDate;
        vm.updateDuration = updateDuration;
        /**** Main ****/

        vm.picker = {date: vm.plan.validityStartTime.substring(0, 10)};
        vm.picker2 = {date: vm.plan.validityEndTime.substring(0, 10)};

        vm.duration = (Date.parse(vm.picker2.date) - Date.parse(vm.picker.date)) / 1000;
        vm.durationLetters = SoopkitchenUtils.secondsToTime(vm.duration);
        
        updateDuration();

        function cancel() {
            location.reload();
        }

        function reset() {
            vm.picker.date = vm.planStart.substring(0, 10);
            vm.picker2.date = vm.planEnd.substring(0, 10);
            vm.duration = (Date.parse(vm.picker2.date) - Date.parse(vm.picker.date)) / 1000;
            vm.durationLetters = SoopkitchenUtils.secondsToTime(vm.duration);
        }

        function updateLetters() {
            if(SoopkitchenUtils.isValidDate(vm.picker.date) && vm.durationLetters) {
                vm.duration = SoopkitchenUtils.timeToSeconds(vm.durationLetters);
                var newDate = new Date(Date.parse(vm.picker.date).valueOf() + vm.duration * 1000);
                vm.picker2 = {date: SoopkitchenUtils.formattedDate(newDate).substring(0, 10)};
            }
        }

        function updateEndDate() {
            if(SoopkitchenUtils.isValidDate(vm.picker.date)) {
                var newDate = new Date(Date.parse(vm.picker.date).valueOf() + vm.duration * 1000);
                vm.picker2 = {
                    date: SoopkitchenUtils.formattedDate(newDate).substring(0, 10)
                };
            }
        }

        function invalidDateRange() {
            if(SoopkitchenUtils.isValidDate(vm.picker.date) && SoopkitchenUtils.isValidDate(vm.picker2.date)) {
                var endDateMilliseconds = Date.parse(vm.picker2.date).valueOf();
                var startDateMilliseconds = Date.parse(vm.picker.date).valueOf();
                return startDateMilliseconds > endDateMilliseconds;
            } else {
                return false;
            }
        }

        function durationLettersInvalid() {
            if (vm.durationLetters == null) {
                return false;
            } else {
                return (SoopkitchenUtils.timeToSeconds(vm.durationLetters) === 0 || isNaN(SoopkitchenUtils.timeToSeconds(vm.durationLetters)));
            }
        }

        function updateDuration() {
            if(SoopkitchenUtils.isValidDate(vm.picker.date) && SoopkitchenUtils.isValidDate(vm.picker2.date)) {
                vm.duration = (Date.parse(vm.picker2.date) - Date.parse(vm.picker.date)) / 1000;
                vm.durationLetters = SoopkitchenUtils.secondsToTime(vm.duration);
            }
        }

        function apply() {
            PlanningEventsService.setValidityPeriod(
                {
                    planLabel: vm.plan.label,
                    startTime: vm.picker.date,
                    endTime: vm.picker2.date
                },
                function successCallback(response) {
                    SoopkitchenUtils.invokeSweetAlert("Nice!", "You have changed the planning period of " + vm.plan.label, "success");
                    location.reload();
                },
                function errorCallback(response) {
                    SoopkitchenUtils.prettyError(response);
                });
        }
    }
})();

(function() {
  'use strict';

  angular.module('soopkitchenApp').controller('PlanningProfileController', PlanningProfileController);

  PlanningProfileController.$inject = [ '$uibModalInstance', 'entity', 'Planning', 'parameters', 'SoopkitchenUtils' ];

  function PlanningProfileController($uibModalInstance, entity, Planning, parameters, SoopkitchenUtils) {
    var vm = this;
    vm.planning = entity;
    vm.group = parameters.group;
    vm.instrumentProfile = vm.planning.planResourcesProfile.experimentResourcesProfiles[vm.group];
    if (vm.instrumentProfile) {
        vm.powerMaxValue = vm.instrumentProfile.powerProfiles["TOTAL"].maxValue;
    }
    vm.valueRange   = 0;
    vm.startDate = new Date(vm.planning.validityStartTime.replace("Z", ""));
    vm.endDate = new Date(vm.planning.validityEndTime.replace("Z", ""));

    vm.volumeGroups = {};

    vm.clear = clear;
    vm.roundDecimals = roundDecimals;
    vm.calculateVolumes = calculateVolumes;

    init();
    calculateVolumes(vm.startDate, vm.endDate);
      function init() {
        if (!vm.instrumentProfile) {
          vm.currentInstrumentVolumes = Object.keys(vm.planning.planResourcesProfile.volumeProfiles);
        }
        else {
            vm.modulePowers = [];
            for ( var module in vm.instrumentProfile.powerProfiles) {
                if (module !== "TOTAL" || module.indexOf(vm.group) === 0) {
                    vm.modulePowers.push(module);
                }
            }
            vm.currentInstrumentVolumes = [];
            for ( var volume in vm.planning.planResourcesProfile.volumeProfiles) {
                if (volume.indexOf(vm.group) === 0) {
                    vm.currentInstrumentVolumes.push(volume);
                }
            }
        }
        vm.containsVolumes = vm.currentInstrumentVolumes.length > 0;
    }

    function clear() {
      $uibModalInstance.dismiss('cancel');
    }

    function roundDecimals(value) {
          return SoopkitchenUtils.roundDecimals(value, 3);
    }




      function calculateVolumes(startDate, endDate) {
          var specialVolumeNames = ["EUI_TAV_SSMM", "EUI_TAV_FLUSH", "PHI_TAV_SSMM", "PHI_TAV_FLUSH", "STIX_TAV", "RPW_TAV"];
          if (vm.currentInstrumentVolumes.length > 0) {
              for (var volumeName in vm.currentInstrumentVolumes) {
                  if (specialVolumeNames.includes(vm.currentInstrumentVolumes[volumeName])) {
                      var volumeData = {};
                      for (var endDateVol in vm.planning.planResourcesProfile.volumeProfiles[vm.currentInstrumentVolumes[volumeName]]["values"]) {
                          // endDateVol does not include ":ssZ" in some cases and "Z" in the rest. Where the format for the time is in the happenings HH:mm:ssZ
                          if (endDateVol.length === 16){
                              endDateVol = endDateVol + ":00";
                          }
                          endDateVol = endDateVol + "Z";
                          var happenings = vm.planning.observationInstanceTimeline.happenings;
                          var keyVolName = vm.currentInstrumentVolumes[volumeName];
                          var foundValue = 0;
                          for (var obser in happenings) {
                              if (happenings[obser]["endDate"] === (endDateVol)) {
                                  for (var volName in happenings[obser]["volumes"]) {
                                      if (volName === keyVolName) {
                                          foundValue = happenings[obser]["volumes"][volName];
                                          var foundStartDate = happenings[obser]["startDate"].replace("Z", "");
                                          var foundEndDate = happenings[obser]["endDate"].replace("Z", "");
                                          // Check if startDate key exists, if not, create an empty object
                                          if (!volumeData[foundStartDate]) {
                                              volumeData[foundStartDate] = {};
                                          }
                                          // Assign the value to the nested endDate key
                                          volumeData[foundStartDate][foundEndDate] = foundValue;
                                      }
                                  }
                              }
                          }
                      }
                      var totalVolume = 0;
                      totalVolume = generateVolumeGroups(volumeData, startDate, endDate, totalVolume);
              } else {
                  volumeData = vm.planning.planResourcesProfile.volumeProfiles[vm.currentInstrumentVolumes[volumeName]]["dataRatesTimes"];
                  totalVolume = 0;
                  totalVolume = generateVolumeGroups(volumeData, startDate, endDate, totalVolume);
              }
                  vm.volumeGroups[vm.currentInstrumentVolumes[volumeName]] = totalVolume;
              }
          }
      }

      function generateVolumeGroups(volumeData, startDate, endDate, totalVolume) {
          // Iterate over the volume data
          for (var startTime in volumeData) {
              for (var endTime in volumeData[startTime]) {
                  // Convert the date strings to Date objects
                  var startDateTime = new Date(startTime);
                  var endDateTime = new Date(endTime);

                  // Check if the volume falls within the date range
                  if (startDateTime >= startDate && endDateTime <= endDate) {
                      // Get the volume value
                      var volume = volumeData[startTime][endTime];
                      // Increment the total volume
                      totalVolume += volume;
                  } else if (startDateTime <= startDate && endDateTime <= endDate && endDateTime >= startDate) {
                      var overLapVol = calculateOverlapVolume(volumeData[startTime][endTime], startDateTime, endDateTime, startDate, endDateTime);
                      totalVolume += overLapVol;
                  } else if (startDateTime >= startDate && endDateTime >= endDate && startDateTime <= endDate) {
                      overLapVol = calculateOverlapVolume(volumeData[startTime][endTime], startDateTime, endDateTime, startDateTime, endDate);
                      totalVolume += overLapVol;
                  } else if (startDateTime <= startDate && endDateTime >= endDate) {
                      overLapVol = calculateOverlapVolume(volumeData[startTime][endTime], startDateTime, endDateTime, startDate, endDate);
                      totalVolume += overLapVol;
                  }
              }
          }
          return totalVolume;
      }

      function calculateOverlapVolume(volume, startDateTime, endDateTime, startDateOver, endDateOver) {
          var timeDifferenceInMinutes = (endDateTime - startDateTime) / (1000 * 60);
          var averageVolPerMinute = volume / timeDifferenceInMinutes;
          var overlappingMinutes = (endDateOver - startDateOver) / (1000 * 60);
          // Increment the total volume
          return averageVolPerMinute * overlappingMinutes;
      }


  }

})();

(function () {
    'use strict';
    angular
        .module('soopkitchenApp')
        .factory('PlanningEventsService', PlanningEventsService);

    PlanningEventsService.$inject = ['$resource'];

    function PlanningEventsService($resource) {

        var resourceUrl = 'api/plan/';

        return $resource(
            resourceUrl,
            {
                planLabel: '@planLabel',
                startTime: '@startTime',
                endTime: '@endTime',
                minDuration: '@minDuration',
                windowDuration: '@windowDuration',
                eventCollectionsLabel : '@eventCollectionsLabel',
                timeSlot :'@timeSlot',
                backupTimeSlot :'@backupTimeSlot',
                isCoordBurstAutomatic:'@isCoordBurstAutomatic',
            },
            {
                'addEvent': {
                    url: resourceUrl + 'event/add',
                    method: 'PUT',
                },
                'updateEvent': {
                    url: resourceUrl + 'event/update',
                    method: 'PUT',
                },
                'deleteEvent': {
                    url: resourceUrl + 'event/delete',
                    method: 'PUT',
                },
                'generateAttDist': {
                    url: resourceUrl + 'generateAttDist',
                    method: 'PUT',
                },
                'generateAutoEmcPrefNoisy': {
                    url: resourceUrl + 'generateAutoEmcPrefNoisy',
                    method: 'PUT',
                },
                'generateAutoEmcMandQuiet': {
                    url: resourceUrl + 'generateAutoEmcMandQuiet',
                    method: 'PUT',
                },
                'guaranteeEmcPrefNoisy': {
                    url: resourceUrl + 'guaranteeEmcPrefNoisy',
                    method: 'PUT',
                },
                'guaranteeEmcMandQuiet': {
                    url: resourceUrl + 'guaranteeEmcMandQuiet',
                    method: 'PUT',
                },
                'guaranteeEmcMandQuietPrevious': {
                    url: resourceUrl + 'guaranteeEmcMandQuietPrevious',
                    method: 'PUT',
                },
                'guaranteeIsCoordBurst': {
                    url: resourceUrl + 'guaranteeIsCoordBurst',
                    method: 'PUT',
                },
                'finishedEmcPrefNoisy': {
                    url: resourceUrl + 'finishedEmcPrefNoisy',
                    method: 'PUT',
                },
                'finishedIsCoordBurst': {
                    url: resourceUrl + 'finishedIsCoordBurst',
                    method: 'PUT',
                },
                'finishedEmcMandQuiet': {
                    url: resourceUrl + 'finishedEmcMandQuiet',
                    method: 'PUT',
                },
                'updateEventCollection': {
                    url: resourceUrl + 'updateEvents',
                    method: 'PUT'
                },
                'setValidityPeriod': {
                    url: resourceUrl + 'setValidityPeriod',
                    method: 'PUT'
                },
                'getEventSchemas': {
                    url: resourceUrl + 'event-schemas',
                    method: 'GET',
                    isArray: true
                },
                'getProfiles': {
                    url: resourceUrl + 'profiles',
                    method: 'GET',
                    isArray: true
                }, 'getSOCEvents': {
                    method: 'GET',
                    url: resourceUrl + 'soc-events',
                    isArray: true
                }, 'getSOCEventSets': {
                    method: 'GET',
                    url: resourceUrl + 'soc-event-sets'
                },'expandSOCEvents': {
                    method: 'PUT',
                    url:  resourceUrl +'expand-soc-events',
                }
            });
    }
})();

(function () {
    'use strict';

    angular.module('soopkitchenApp').controller('PlanningEventDialogController', PlanningEventDialogController);

    PlanningEventDialogController.$inject = ['$scope', '$uibModalInstance', 'entity', 'AlertService', 'PlanningEventsService',
        'parameters', '$rootScope', 'Principal', 'SoopkitchenUtils', '$cookies', '$timeout', '$uibModal'];

    function PlanningEventDialogController($scope, $uibModalInstance, entity, AlertService, PlanningEventsService, parameters,
                                           $rootScope, Principal, SoopkitchenUtils, $cookies, $timeout, $uibModal) {
        var vm = this;
        var EVENT_DEFAULTS = {
            'SLEW': {
                'comment': { value: 'soc-added', extra: function() { vm.canDeleteEvent = true; } },
                'duration': { value: 300, displayValue: '5m', isDuration: true }
            },
            'HSD_': {
                'duration': { value: 900, displayValue: '15m', isDuration: true }
            },
            'POINT_CENTRE': {
                'boresight': { value: 'SC', isEnum: true },
                'metis_compatible': { value: 'YES', isEnum: true }
            }
        };

        function getEventDefaults(eventName) {
            if (EVENT_DEFAULTS[eventName]) {
                return EVENT_DEFAULTS[eventName];
            }
            for (var key in EVENT_DEFAULTS) {
                if (EVENT_DEFAULTS.hasOwnProperty(key) && key.charAt(key.length - 1) === '_' && eventName.indexOf(key) === 0) {
                    return EVENT_DEFAULTS[key];
                }
            }
            return null;
        }

        vm.containsDuration = false;
        vm.isEditable = false;
        vm.selectedNumber = {};
        vm.repeat = false;

        vm.preserveRatio = getPreserveRatio();
        vm.isDurationDisabled = isDurationDisabled;
        vm.isStartDateDisabled = isStartDateDisabled;
        vm.isEndDateDisabled = isEndDateDisabled;
        vm.onStartDateUpdate = onStartDateUpdate;
        vm.onEndDateUpdate = onEndDateUpdate;
        vm.updateStartDate = updateStartDate;
        vm.updateEndDate = updateEndDate;
        vm.onPreserveRatioClick = onPreserveRatioClick;
        vm.blinkingTimeout = 2000;

        vm.lettersSeparation = 0;
        vm.numberOccurences = 2;
        var events = [];
        vm.dialogTitle = parameters.action;
        Principal.hasAnyAuthority(['ROLE_PLAN_COORDINATOR', 'ROLE_POWER_USER']).then(function (result) {
            if (result) {
                if (parameters.locked != null) {
                    vm.isEditable = parameters.locked === false;
                }
                if ((parameters.occurrence != null) && (vm.isEditable === false)) {
                    vm.dialogTitle = "Visualizing";
                }
            }
        });
        vm.updateDuration = updateDuration;
        vm.takeValuesToUpdate = takeValuesToUpdate;
        vm.parseFloat = function (number) {
            return parseFloat(number);
        };
        vm.nameEventMap = {};
        vm.nameAllEventsMap = {};

        vm.attributeClassMap = {};
        vm.plan = entity;
        vm.clear = clear;
        vm.clearParameters = clearParameters;
        vm.selectedAtt = {};
        vm.selectedEnum = {};
        vm.savedItems = [];
        vm.disableCombobox = false;
        vm.showWarningForSOCEvents = false;
        vm.showWarningForSOCEventSets = false;
        var eventsSet = new Set();
        var allEventsSet = new Set();
        vm.repeatWrong = repeatWrong;
        vm.deleteDisabled = deleteDisabled;
        vm.deleteEvent = deleteEvent;
        vm.eventSetMap = {};

        vm.socEvents = [];

        function updateEventsCombo() {
            for (var index = 0; index < entity.schema.eventDefinitions.length; index++) {
                var eventName = entity.schema.eventDefinitions[index].name;
                if (entity.schema.eventDefinitions[index].canCreate) {
                    eventsSet.add(eventName);
                    vm.nameEventMap[eventName] = entity.schema.eventDefinitions[index];
                }
                allEventsSet.add(eventName);
                vm.nameAllEventsMap[eventName] = entity.schema.eventDefinitions[index];
            }
            vm.canDeleteEvent = true;
            vm.disableSave = false;
            if (parameters.occurrence != null) {

                vm.occurrence = parameters.occurrence;
                vm.startDate = parameters.startDate;
                vm.endDate = parameters.endDate;
                vm.canDeleteEvent = false;

                for (var index = 0; index < entity.schema.eventDefinitions.length; index++) {
                    var eventName = entity.schema.eventDefinitions[index].name;
                    if (entity.schema.eventDefinitions[index].canDelete && vm.occurrence.originalName === eventName) {
                        vm.canDeleteEvent = true;
                    }
                }
                if (vm.socEvents.includes(vm.occurrence.originalName)) {
                    vm.canDeleteEvent = true;
                    vm.showWarningForSOCEvents = true;
                    vm.disableSave = true;
                }

                vm.takeValuesToUpdate();
            } else {
                events = Array.from(eventsSet);
                events.sort();
                vm.events = events;
                // same date to start
                vm.startDate = SoopkitchenUtils.formattedDate(parameters.start);
                vm.endDate = SoopkitchenUtils.formattedDate(parameters.start);
            }
        }

        vm.socEventsSetsFunction = function successCallback(data) {
            // console.warn(data);
            if (data) {
                data = angular.fromJson(data);
                Object.keys(data).forEach(function(key) {
                    // Filter out the special properties added by AngularJS ($promise, $resolved)
                    if (key.charAt(0) !== '$') {
                        var eventSetName = key;          // This will be "RSW_EXT_MULTI"
                        var eventList = data[key];       // This will be the Array(5)
                        createSOCEvent(eventSetName, true);
                        console.log("Processing Event Set:", eventSetName);
                        vm.eventSetMap [eventSetName] = eventList;
                        // Now you can loop through the inner array
                        if (Array.isArray(eventList)) {
                            eventList.forEach(function(eventName, index) {
                                console.log("  - Event " + index + ":", eventName);

                            });
                        }
                    }
                });

            }
            updateEventsCombo();
        }

        function createSOCEvent(eventName, duration) {
            var attributes = [];
            attributes.push({name: 'comment', attributeClassName: 'string', required: false});
            if (duration) {
                attributes.push({name: 'duration', attributeClassName: 'durationType', required: false});
            }
            event = {
                name: eventName,
                canCreate: true,
                canModify: true,
                canDelete: true,
                attributes: attributes

            }

            allEventsSet.add(event.name);
            eventsSet.add(event.name);
            vm.nameEventMap[event.name] = event;
            vm.nameAllEventsMap[event.name] = event
            return event;
        }

        vm.socEventsSuccessFunction = function successCallback(data) {
            // console.warn(data);
            if (data) {
                data = angular.fromJson(data);
                data.forEach(function (eventName, index) {
                    event = createSOCEvent (eventName);
                    vm.socEvents.push(event.name);
                });

            }
            PlanningEventsService.getSOCEventSets(
                {}, vm.socEventsSetsFunction
                ,
                function errorCallback(response) {
                });


        }

        PlanningEventsService.getSOCEvents(
                {}, vm.socEventsSuccessFunction
                ,
                function errorCallback(response) {
                });


        vm.updateCalendar = updateCalendar;

        function repeatWrong() {
            if (vm.repeat === false) {
                return false;
            } else {
                return vm.frequency < vm.duration;
            }
        }

        vm.updateAtributeEnum = function (attributeName) {
            if (! vm.selectedEnum[attributeName]) {
                delete vm.selectedAtt[attributeName];
            } else {
                vm.selectedAtt[attributeName] = vm.selectedEnum[attributeName];
            }
        };
        vm.updateAtributeNumber = function (attributeName) {
            if (vm.selectedNumber[attributeName] != null) {
                vm.selectedAtt[attributeName] = vm.selectedNumber[attributeName].toString();
            }
        };
        vm.update = function () {
            vm.duration = null;
            vm.durationLetters = null;
            vm.selectedAtt = {};
            vm.selectedEnum = {};
            vm.selectedEvent = vm.nameAllEventsMap[vm.selectedEventName];
            // vm.selectedEvent = vm.nameEventMap[vm.selectedEventName];

            console.log(vm.selectedEvent)
            vm.isEditable = vm.selectedEvent.canModify;
            vm.showWarningForSOCEvents = false;


            vm.showWarningForSOCEventSets = false;
            var containsDuration = false;
            var defaults = getEventDefaults(vm.selectedEventName);

            for (var index = 0; index < vm.selectedEvent.attributes.length; index++) {
                var attributeClassName = vm.selectedEvent.attributes[index].attributeClassName;
                var eventName = vm.selectedEvent.name;
                eventsSet.add(eventName);
                var attributeName = vm.selectedEvent.attributes[index].name;
                var attributeClass = entity.schema.attributeClasses[attributeClassName];
                vm.attributeClassMap[attributeClassName] = attributeClass;

                if (attributeClassName === 'durationType') {
                    containsDuration = true;
                }
                if (vm.socEvents.includes(vm.selectedEventName)) {
                    vm.selectedAtt['comment'] = null;
                    vm.canDeleteEvent = true;
                }

                if (defaults && defaults[attributeName]) {
                    var attrDefault = defaults[attributeName];
                    if (attrDefault.isDuration) {
                        vm.selectedAtt[attributeName] = attrDefault.value;
                        vm.duration = attrDefault.value;
                        vm.durationLetters = attrDefault.displayValue;
                        vm.updateCalendar();
                    } else {
                        vm.selectedAtt[attributeName] = attrDefault.value;
                        if (attrDefault.isEnum) {
                            vm.selectedEnum[attributeName] = attrDefault.value;
                        }
                        if (attrDefault.extra) {
                            attrDefault.extra();
                        }
                    }
                }
            }
            vm.containsDuration = containsDuration;
            if (!vm.containsDuration) {
                vm.durationLetters = null;
            }

            if (vm.eventSetMap[vm.selectedEventName] != null) {
                vm.isEditable = true;
                vm.showWarningForSOCEventSets = true;
            }
        };

        vm.invalidParameters = function () {
            if (vm.selectedEvent == null)
                return true;
            for (var index = 0; index < vm.selectedEvent.attributes.length; index++) {
                var attribute = vm.selectedEvent.attributes[index];
                if (attribute.required) {
                    if (vm.selectedEvent.canModify) {
                        // sync ENUM and vm.selectedAtt
                        vm.updateAtributeEnum(attribute.name);
                        vm.updateAtributeNumber(attribute.name);
                    }
                    if (attribute.name !== 'time' && attribute.name !== 'duration' && vm.selectedAtt[attribute.name] == null) {
                        return true;
                    }
                }
            }
            return vm.containsDuration ? vm.duration == null : false;
        };

        vm.parametersWrong = function () {

            if (vm.invalidParameters())
                return true;
            if (vm.invalidateStartDate)
                return true;
            if (vm.invalidateEndDate)
                return true;
            if (vm.durationLettersInvalid())
                return true;
            if (vm.invalidateDateRange())
                return true;
            if (vm.outOfRangeDate())
                return true;
            return vm.repeatWrong();

        };

        vm.invalidateDateRange = function () {
            var endDateMilliseconds = Date.parse(vm.endDate).valueOf();
            var startDateMilliseconds = Date.parse(vm.startDate).valueOf();
            return startDateMilliseconds > endDateMilliseconds;
        };
        vm.outOfRangeDate = function () {
            return vm.startOutOfRangeDate() || vm.endOutOfRangeDate();
        };
        vm.endOutOfRangeDate = function () {
            var validEndDate = Date.parse(vm.plan.validityEndTime);
            var endDateMilliseconds = Date.parse(vm.endDate).valueOf();

            return endDateMilliseconds > validEndDate.valueOf();
        };
        vm.startOutOfRangeDate = function () {
            var validStartDate = Date.parse(vm.plan.validityStartTime);
            var startDateMilliseconds = Date.parse(vm.startDate).valueOf();

            return startDateMilliseconds < validStartDate.valueOf();
        };

        vm.repeatOutOfRangeDate = function () {
            if (vm.repeat === false) {
                return false;
            } else {
                var validEndDate = Date.parse(vm.plan.validityEndTime);
                var endDateMilliseconds = Date.parse(vm.lastEndTime).valueOf();
                return endDateMilliseconds > validEndDate.valueOf();
            }
        };

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        vm.reset = function () {
        };

        vm.save = function () {
            var count = 0;
            if (vm.selectedAtt['count'] != null) {
                count = vm.selectedAtt['count'];
            }
            delete vm.selectedAtt['count']
            delete vm.selectedAtt['duration']
            var event = {
                "count": count,
                "endDate": vm.endDate,
                "name": vm.selectedEventName,
                "parameters": vm.selectedAtt,
                "startDate": vm.startDate
            };
            if ((parameters.occurrence != null) && parameters.cut) {
                updateEventInPlan(event);
            } else if (vm.eventSetMap[vm.selectedEventName] != null) {
                var eventList = [];
                if (Array.isArray(vm.eventSetMap[vm.selectedEventName])) {
                    vm.eventSetMap[vm.selectedEventName].forEach(function(eventName, index) {
                        var event = {

                            "count": count,
                            "endDate": vm.endDate,
                            "name": eventName,
                            "parameters": vm.selectedAtt,
                            "startDate": vm.startDate
                        };
                        eventList.push(event);
                    });
                }
                addEventListInPlan(eventList, event);
            } else {
                saveEventInPlan(event);
            }
        };

        function addEventListInPlan(eventList, event) {
            PlanningEventsService.addEvent(
                {
                    planLabel: entity.label,
                },
                eventList,
                function successCallback(data) {
                    AlertService.success("Added Event " + vm.selectedEventName + " : " + vm.startDate + " --> " + vm.endDate + " to Plan successfully");
                    if (vm.socEvents.includes(vm.selectedEventName)) {
                        PlanningEventsService.expandSOCEvents({
                            planLabel: entity.label
                        }, event, function successCallback(data) {
                            AlertService.success("Expanded SOC Event " + event.name + " : " + event.startDate + " --> " + event.endDate + " to Plan successfully");
                            updateTimeLine(true, data);
                            $uibModalInstance.dismiss('cancel')
                        }, function errorCallback(response) {
                            SoopkitchenUtils.prettyError(response);
                        })
                    } else {
                        updateTimeLine(true, data);

                        $uibModalInstance.dismiss('cancel')
                    }
                },
                function errorCallback(response) {
                    SoopkitchenUtils.prettyError(response);
                });
        }

        function createEventAndAddToList(event, occurrence, eventList) {
            var newEvent = JSON.parse(JSON.stringify(event));
            var newStartDate = new Date(Date.parse(vm.startDate).valueOf() + vm.frequency * (occurrence) * 1000);
            var newEndDate = new Date(Date.parse(vm.endDate).valueOf() + vm.frequency * (occurrence) * 1000);
            newEvent.startDate = newStartDate;
            newEvent.endDate = newEndDate;
            eventList.push(newEvent);
        }

        function saveEventInPlan(event) {

            var eventList = [];
            if (vm.repeat === false) {
                eventList.push(event);
            } else {
                for (var occurrence = 0; occurrence < vm.numberOccurences; occurrence++) {
                    createEventAndAddToList(event, occurrence, eventList);
                }
            }

            addEventListInPlan(eventList, event);
        }

        function updateEventInPlan(event) {
            updateEvent(parameters.occurrence, event);
            if (vm.repeat === true) {
                var eventList = [];

                for (var occurrence = 1; occurrence < vm.numberOccurences; occurrence++) {
                    createEventAndAddToList(event, occurrence, eventList);
                }
                PlanningEventsService.addEvent(
                    {
                        planLabel: entity.label
                    },
                    eventList,
                    function successCallback(data) {
                        AlertService.success("Added Event " + vm.selectedEventName + " : " + vm.startDate + " --> " + vm.endDate + " to Plan successfully");
                        updateTimeLine(true, data);
                        $uibModalInstance.dismiss('cancel');

                    },
                    function errorCallback() {
                        SoopkitchenUtils.prettyError(response);
                    });
            }
        }

        function updateEvent(existingEvent, updatedEvent) {
            var listEvents = [];
            existingEvent.name = existingEvent.originalName;
            listEvents.push(
                {
                    "updatedHappening": updatedEvent,
                    "existingHappening": existingEvent
                }
            );

            PlanningEventsService.updateEvent(
                {
                    planLabel: entity.label,
                },
                { "updateList" : listEvents },
                function successCallback(data) {
                    AlertService.success("Updated Event " + updatedEvent.name + " : " + updatedEvent.startDate + " --> " + updatedEvent.endDate + " to Plan successfully");
                    updateTimeLine(true, data);
                    $uibModalInstance.dismiss('cancel');

                },
                function errorCallback(response) {
                    SoopkitchenUtils.prettyError(response);
                });
        }

        function updateTimeLine(highlightOccurrance, data) {
            if (highlightOccurrance) {
                var count = 0;
                if (vm.selectedAtt['count'] != null) {
                    count = vm.selectedAtt['count'];
                }
                var name = vm.selectedEventName;
                if (vm.eventSetMap[vm.selectedEventName] != null) {
                    name = vm.eventSetMap[vm.selectedEventName][0];
                }
                var event = {
                    "count": count,
                    "endDate": vm.endDate,
                    "name": name,
                    "parameters": vm.selectedAtt,
                    "startDate": vm.startDate
                };
                $rootScope.$broadcast('updateList', {
                    newOccurrance: event,
                    oldOccurrance: parameters.occurrence,
                    data: data
                });
            } else {
                SoopkitchenUtils.updatePlanFromDialog(data);
                $uibModalInstance.dismiss('cancel');

            }
        }

        vm.updateLetters = function () {
            vm.duration = SoopkitchenUtils.timeToSeconds(vm.durationLetters);
            var newDate = new Date(Date.parse(vm.startDate).valueOf() + vm.duration * 1000);
            vm.endDate = SoopkitchenUtils.formattedDate(newDate);
            blinkDuration(false, true);
        };

        vm.updateLettersFrequency = function () {
            vm.durationLettersFrequency = SoopkitchenUtils.secondsToTime(vm.frequency);
            var newDate = new Date(Date.parse(vm.endDate).valueOf() + vm.frequency * (vm.numberOccurences - 1) * 1000);
            vm.lastEndTime = SoopkitchenUtils.formattedDate(newDate);
        };
        vm.updateFrequency = function () {
            vm.frequency = SoopkitchenUtils.timeToSeconds(vm.durationLettersFrequency);
            var newDate = new Date(Date.parse(vm.endDate).valueOf() + vm.frequency * (vm.numberOccurences - 1) * 1000);
            vm.lastEndTime = SoopkitchenUtils.formattedDate(newDate);
        };

        function clearParameters() {
            vm.nameEventMap = {};
            vm.attributeClassMap = {};
            vm.duration = null;
            vm.durationLetters = null;
        }

        function updateCalendar() {
            vm.durationLetters = SoopkitchenUtils.secondsToTime(vm.duration);
            var newDate = new Date(Date.parse(vm.startDate).valueOf() + vm.duration * 1000);
            vm.endDate = SoopkitchenUtils.formattedDate(newDate);
            if (vm.repeat) {
                vm.lastEndTime = SoopkitchenUtils.formattedDate(newDate);
            }
            blinkDuration(true, false);
        }

        function blinkDuration(blinkDurationLetters, blinkDuration) {
            if (blinkDurationLetters) {
                vm.durationLettersStyle = getCssBlinkingStyle();
            }
            if (blinkDuration) {
                vm.durationStyle = getCssBlinkingStyle();
            }
            $timeout(function () {
                vm.durationLettersStyle = null;
                vm.durationStyle = null;
            }, vm.blinkingTimeout);
        }

        function updateDuration(blink) {
            if (SoopkitchenUtils.isValidDate(vm.startDate)) {
                vm.invalidateStartDate = false;
                if (SoopkitchenUtils.isValidDate(vm.endDate)) {
                    vm.invalidateEndDate = false;
                } else {
                    vm.invalidateEndDate = true;
                    return;
                }
                vm.duration = (Date.parse(vm.endDate) - Date.parse(vm.startDate)) / 1000;
                vm.durationLetters = SoopkitchenUtils.secondsToTime(vm.duration);
                if (blink) {
                    blinkDuration(true, true);
                }
            } else {
                vm.invalidateStartDate = true;
            }
        }

        function takeValuesToUpdate() {
            var name = parameters.occurrence.originalName;
            if (belongsToSet(eventsSet, name)) {
                vm.selectedEvent = vm.nameAllEventsMap[name];
                events = Array.from(eventsSet);
                events.sort();
                vm.events = events;
            } else if (belongsToSet(allEventsSet, name)) {
                events = Array.from(allEventsSet);
                events.sort();
                vm.events = events;
                vm.selectedEvent = vm.nameAllEventsMap[name];
                vm.disableCombobox = true;
            } else {
                clear();
                SoopkitchenUtils.invokeSweetAlert("Ooops", "It is not possible to edit that event, sorry!!", "error");
                $uibModalInstance.dismiss('cancel');
            }
            vm.disableCombobox =  (vm.selectedEvent.canModify && vm.selectedEvent.canCreate && vm.selectedEvent.canDelete) === false;
            vm.disableInputs = vm.selectedEvent.canModify === false;

            if (vm.occurrence.originalName === "SLEW") {
                if (!(vm.occurrence.parameters.comment !=null && vm.occurrence.parameters.comment.indexOf('soc-added') !== -1)) {
                    vm.disableCombobox = true;
                    vm.disableInputs = true;
                    vm.canDeleteEvent =false;
                }
            }

            var containsDuration = false;

            vm.selectedEventName = vm.selectedEvent.name;
            for (var index = 0; index < vm.selectedEvent.attributes.length; index++) {

                var attribute = vm.selectedEvent.attributes[index];

                vm.selectedAtt[attribute.name] = parameters.occurrence.parameters[attribute.name];
                var attributeClassName = attribute.attributeClassName;
                var attributeClass = entity.schema.attributeClasses[attributeClassName];
                vm.attributeClassMap[attributeClassName] = attributeClass;

                if (vm.attributeClassMap[attribute.attributeClassName].type === 'ENUM') {
                    if (parameters.occurrence.parameters[attribute.name]) {
                        vm.selectedEnum[attribute.name] = parameters.occurrence.parameters[attribute.name];
                    }
                } else if (vm.attributeClassMap[attribute.attributeClassName].type === 'FLOAT') {
                    vm.selectedAtt[attribute.name] = parseFloat(parameters.occurrence.parameters[attribute.name]);
                    vm.selectedNumber[attribute.name] = parseFloat(parameters.occurrence.parameters[attribute.name]);
                } else if (vm.attributeClassMap[attribute.attributeClassName].type === 'INTEGER') {
                    vm.selectedAtt[attribute.name] = parseInt(parameters.occurrence.parameters[attribute.name]);
                    vm.selectedNumber[attribute.name] = parseInt(parameters.occurrence.parameters[attribute.name]);
                    // for count
                    if (attribute.name === 'count') {
                        if (parseInt(parameters.occurrence.count) > 0) {
                            vm.selectedAtt['count'] = parseInt(parameters.occurrence.count);
                            vm.selectedNumber['count'] = parseInt(parameters.occurrence.count);
                        }
                    }
                }

                if (attributeClassName === 'durationType') {
                    containsDuration = true;
                }
            }
            vm.containsDuration = containsDuration;
            vm.updateDuration(false);
        }

        vm.durationLettersInvalid = function () {
            if (vm.durationLetters == null || vm.containsDuration == false);
                return false;
            return (SoopkitchenUtils.timeToSeconds(vm.durationLetters) === 0 || isNaN(SoopkitchenUtils
                .timeToSeconds(vm.durationLetters)));
        };

        function belongsToSet(thisSet, name) {
            if (thisSet.has(name)) {
                return true;
            } else {
                if (name.indexOf(" ") > 0) {
                    var shortName = name.substring(0, name.indexOf(" "));
                    return thisSet.has(shortName);
                }
                return false;
            }

        }

        function deleteDisabled() {
            return (vm.canDeleteEvent === false || vm.isEditable === false);
        }

        function deleteEvent() {
            var event = null;
            for (var index = 0; index < vm.plan.schema.eventDefinitions.length; index++) {
                var eventName = vm.plan.schema.eventDefinitions[index].name;
                if (vm.occurrence.originalName === eventName) {
                    event = vm.plan.schema.eventDefinitions[index];
                    break;
                }
            }
            if (event != null && event.canDelete === false && vm.socEvents.includes(vm.occurrence.originalName) === false) {
                SoopkitchenUtils.invokeSweetAlert("Ooops", "It is not possible to delete that event", "error");
                return;

            } else if (event == null && vm.socEvents.includes(vm.occurrence.originalName) === false) {
                SoopkitchenUtils.invokeSweetAlert("Ooops", "It is not possible to delete that event (not in the white list)",
                    "error");
                return;
            }
            var message = 'Do you really want to remove item ' + vm.occurrence.name;
            if (vm.socEvents.includes(vm.occurrence.originalName)) {
                message += " (and its expanded events!)";
            }

            message +=' with start date ' + vm.occurrence.startDate + ' ? '
            SoopkitchenUtils.prettyConfirm('Remove item', message, function (ok) {
                if (ok) {
                    var occurrences = [];
                    vm.occurrence.name = vm.occurrence.originalName;
                    occurrences.push(vm.occurrence);
                    PlanningEventsService.deleteEvent(
                        {
                            planLabel: vm.plan.label
                        },
                        occurrences,
                        function successCallback(data) {
                            updateTimeLine(false, data);
                            $uibModalInstance.dismiss('cancel');
                            AlertService.success("Deleted Event successfully");
                        },
                        function (response) {
                            SoopkitchenUtils.prettyError(response);
                        });
                }
            });
        }

        function getPreserveRatio() {
            var defaultValue = "dates";
            if ($cookies.get("preserveRatio") != null) {
                defaultValue = $cookies.get("preserveRatio");
            }
            if (vm.selectedEvent == null) {
                // If event is to be created, return default or cookie value (if exists)
                return defaultValue;
            } else if (isDurationDisabled() || vm.containsDuration === false) {
                // If duration is disabled, return "duration"
                return "duration";
            } else {
                // Any other case, return default or cookie value (if exists)
                return defaultValue;
            }
        }
        function onPreserveRatioClick() {
            $cookies.put("preserveRatio", vm.preserveRatio);
        }

        function isDurationDisabled() {
            if (vm.selectedEvent == null) {
                return vm.disableInputs || vm.isEditable === false;
            } else {
                return vm.disableInputs || vm.isEditable === false || vm.selectedEvent.canModify === false;
            }
        }

        function isStartDateDisabled() {
            return isDurationDisabled();
        }

        function isEndDateDisabled() {
            return vm.disableInputs || vm.containsDuration === false || vm.isEditable === false;
        }

        function onStartDateUpdate() {

            if (vm.containsDuration && vm.preserveRatio === "dates") {
                vm.updateDuration(true);
            } else {
                vm.updateEndDate();
            }
        }

        function onEndDateUpdate() {
            if (vm.preserveRatio === "dates") {
                vm.updateDuration(true);
            } else {
                vm.updateStartDate();
            }
        }

        function updateStartDate() {
            if (SoopkitchenUtils.isValidDate(vm.endDate)) {
                vm.invalidateEndDate = false;
            } else {
                vm.invalidateEndDate = true;
                return;
            }
            var newDate = new Date(Date.parse(vm.endDate).valueOf() - vm.duration * 1000);
            vm.startDate = SoopkitchenUtils.formattedDate(newDate);
            vm.startDateStyle = getCssBlinkingStyle();
            $timeout(function () {
                vm.startDateStyle = null;
            }, vm.blinkingTimeout);
        }

        function updateEndDate() {
            if (SoopkitchenUtils.isValidDate(vm.startDate)) {
                vm.invalidateStartDate = false;
            } else {
                vm.invalidateStartDate = true;
                return;
            }

            if (vm.containsDuration === false){
                vm.duration = 0;
            }

            var newDate = new Date(Date.parse(vm.startDate).valueOf() + vm.duration * 1000);
            vm.endDate = SoopkitchenUtils.formattedDate(newDate);
            if (vm.repeat) {
                var newFinalDate = new Date(Date.parse(vm.endDate).valueOf() + vm.frequency * (vm.numberOccurences - 1) * 1000);
                vm.lastEndTime = SoopkitchenUtils.formattedDate(newFinalDate);
            }
            vm.endDateStyle = getCssBlinkingStyle();
            $timeout(function () {
                vm.endDateStyle = null;
            }, vm.blinkingTimeout);
        }

        function getCssBlinkingStyle() {
            return {
                'animation': 'blinker 1s linear infinite',
                'color': 'blue'
            };
        }

    }
})();

(function () {
    'use strict';

    angular.module('soopkitchenApp').controller('PlanningDialogController', PlanningDialogController);

    PlanningDialogController.$inject = ['$uibModalInstance', 'entity', '$http', 'AlertService', 'parameters',
        '$rootScope', 'Principal', 'SoopkitchenUtils', '$cookies', '$timeout', 'Planning', 'PlanTypes'];

    function PlanningDialogController($uibModalInstance, entity, $http, AlertService, parameters, $rootScope, Principal,
                                      SoopkitchenUtils, $cookies, $timeout, Planning, PlanTypes) {

        var vm = this;
        vm.planType = parameters.planType;
        vm.isMaster = vm.planType == PlanTypes['master'];
        vm.isChild = vm.planType == PlanTypes['child'];
        vm.isTemplate = vm.planType == PlanTypes['template'];
        vm.isSoop = vm.planType == PlanTypes['soop'];
        vm.isTimelineWithNoDates = vm.isTemplate || vm.isSoop;
        vm.cut = parameters.cut;
        vm.waiting = false;

        vm.roundDecimals = SoopkitchenUtils.roundDecimals;

        vm.isEditable = false;
        vm.repeat = false;
        vm.preserveRatio = getPreserveRatio();
        vm.durationLettersFrequency = 0;
        vm.numberOccurences = 2;
        vm.comment = "";
        vm.selectedExperiment = "";
        vm.selectedModule = "";
        vm.selectedObservation = null;
        vm.obsDef = null;
        vm.dialogTitle = parameters.action;
        vm.blinkingTimeout = 2000;
        vm.ids = [];
        vm.isSocUser = false;
        Principal.hasAnyAuthority(['ROLE_PLAN_COORDINATOR', 'ROLE_POWER_USER']).then(
            function (result) {
                if (result) {
                    vm.isSocUser = true;
                }
            }
        );
        vm.userInstruments = [];
        Principal.getUserInstruments().then(
            function (result) {
                if (result) {
                    vm.userInstruments = result;
                }
            }
        );

        function updateSOOPRelations(soopsItBelongs) {
            vm.soopsItBelongs = soopsItBelongs;
            vm.soopBelonging = [];
            vm.soopsItBelongs.forEach(function (item, index) {
                vm.soopBelonging.push(false);
            });
        }

        updateSOOPRelations(getSOOPsItBelongs());

        if (parameters.locked != null) {
            vm.isEditable = parameters.locked === false;
        }
        if (parameters.occurrence != null) {
            if (parameters.occurrence.hasOwnProperty('ids')) {
                for (var i = 0; i < parameters.occurrence.ids.length; i++) {
                    vm.ids.push(parameters.occurrence.ids[i]);
                }
            }
            vm.operation = "Update";
            if (vm.isEditable === false) {
                vm.operation = "Visualizing";
            }
        }

        vm.occurrence = null;
        vm.evaluatedObservation = null;
        vm.isObsUpdate = false;
        vm.plan = entity;
        vm.observationsPerInstrument = vm.plan.observationDefinitions.allExperimentsObservationDefinitions;
        vm.getObsDef = getObsDef;
        vm.clear = clear;
        vm.clearParameters = clearParameters;
        vm.resetEvaluation = resetEvaluation;
        vm.repeatWrong = repeatWrong;
        vm.getValidityRange = getValidityRange;
        vm.belongsToASOOP = belongsToASOOP;
        vm.savedItems = [];
        if (parameters.occurrence != null) {

            vm.evaluatedObservation = null;
            vm.group = parameters.experiment;
            vm.occurrence = parameters.occurrence;
            setStartDate(parameters.start);
            setEndDate(parameters.end);

            vm.availableExperiments = getExperiments();
            vm.availableModules = vm.observationsPerInstrument[parameters.experiment].modules;

            vm.selectedExperiment = parameters.experiment;
            vm.availableModules = vm.observationsPerInstrument[vm.selectedExperiment].modules;

            vm.selectedModule = parameters.module;
            vm.availableObservations = getObservations();

            vm.selectedObservationId = parameters.observation;
            vm.selectedObservation = vm.occurrence;
            vm.obsDef = vm.getObsDef(vm.occurrence);

            vm.isObsUpdate = true;

            updateParametersValues();
        } else {
            vm.operation = "Create";
            vm.group = parameters.group;
            setStartDate(SoopkitchenUtils.formattedDate(parameters.start));
            // same date to start
            setEndDate(getStartDate());

            vm.selectedExperiment = vm.group;
            vm.selectedModule = null;
            vm.selectedObservationId = null;
            vm.numberParameters = null;
            vm.listParameters = null;

            vm.availableExperiments = getExperiments();

            vm.availableModules = vm.observationsPerInstrument[vm.selectedExperiment].modules;
        }

        vm.volumes = volumes;
        vm.updateCalendar = updateCalendar;
        vm.update = update;
        vm.updateModule = updateModule;
        vm.updateSelectedObservation = updateSelectedObservation;
        vm.isDurationDisabled = isDurationDisabled;
        vm.onStartDateUpdate = onStartDateUpdate;
        vm.onEndDateUpdate = onEndDateUpdate;
        vm.updateStartDate = updateStartDate;
        vm.updateDuration = updateDuration;
        vm.updateEndDate = updateEndDate;
        vm.onPreserveRatioClick = onPreserveRatioClick;
        vm.updateLettersFrequency = updateLettersFrequency;

        function getPreserveRatio() {
            var defaultValue = "dates";
            if ($cookies.get("preserveRatio") != null) {
                defaultValue = $cookies.get("preserveRatio");
            }

            if (vm.obsDef == null) {
                // If obs to be created, return default or cookie value (if exists)
                return defaultValue;
            } else if (isDurationDisabled()) {
                // If duration is disabled, return "duration"
                return "duration";
            } else {
                // Any other case, return default or cookie value (if exists)
                return defaultValue;
            }
        }

        function onPreserveRatioClick() {
            $cookies.put("preserveRatio", vm.preserveRatio);
        }

        function onStartDateUpdate() {
            if (vm.preserveRatio === "dates") {
                vm.updateDuration();
            } else {
                vm.updateEndDate();
            }
        }

        function onEndDateUpdate() {
            if (vm.preserveRatio === "dates") {
                vm.updateDuration();
            } else {
                vm.updateStartDate();
            }
        }

        function isDurationDisabled() {
            if (vm.obsDef == null) {
                return true;
            }
            return vm.obsDef.duration.valueType !== 'NUMBER' || vm.isEditable === false;
        }

        function volumes() {
            var volumesList = [];
            if (vm.selectedObservation) {
                for (var volume in vm.selectedObservation.volumes) {
                    if (vm.selectedObservation.flows[volume] == null) {
                        volumesList.push(volume);
                    }
                }
            }
            return volumesList;
        }

        function update() {
            vm.clearParameters();
            vm.numberParameters = [];
            vm.listParameters = [];
            vm.availableModules = vm.observationsPerInstrument[vm.selectedExperiment].modules;
            vm.selectedModule = vm.availableModules[0];
            vm.availableObservations = getObservations();
            vm.evaluatedObservation = null;
            vm.selectedObservation = null;
            vm.obsDef = null;
        }

        function updateModule() {
            vm.clearParameters();
            vm.availableModules = vm.observationsPerInstrument[vm.selectedExperiment].modules;
            vm.availableObservations = getObservations();
            vm.evaluatedObservation = null;
            vm.selectedObservation = null;
            vm.obsDef = null;
        }

        function updateSelectedObservation() {
            vm.availableModules = vm.observationsPerInstrument[vm.selectedExperiment].modules;
            vm.availableObservations = getObservations();
            vm.obsDef = vm.observationsPerInstrument[vm.selectedExperiment].allObservations[vm.selectedModule][vm.selectedObservationId];
            vm.selectedObservation = null;
            updateParametersValues();
            if (false === vm.numberParaMetersWrong()) {
                vm.evaluate();
            }
            if (vm.obsDef.duration.valueType !== 'NUMBER') {
                vm.preserveRatio = "duration";
            }
        }

        vm.numberParaMetersWrong = function () {
            if (vm.obsDef == null)
                return true;
            for (var numberParam in vm.obsDef.numberParameters) {
                if (vm.obsDef.numberParameters.hasOwnProperty(numberParam)) {
                    var min = vm.parameterNumberMin[numberParam];
                    var max = vm.parameterNumberMax[numberParam];
                    var value = vm.numberParameterValue[numberParam];
                    if (value == null)
                        return true;
                    if (isNaN(value))
                        return true;
                    if (value > max || value < min)
                        return true;
                }

            }
            return false;
        };

        vm.parametersWrong = function () {
            if (vm.numberParaMetersWrong())
                return true;
            if (vm.invalidateStartDate)
                return true;
            if (vm.invalidateEndDate)
                return true;
            if (vm.durationLettersInvalid())
                return true;
            if (vm.invalidateDateRange())
                return true;
            if (vm.outOfRangeDate())
                return true;
            if (vm.repeatOutOfRangeDate())
                return true;
            if (vm.repeatWrong())
                return true;
            return false;
        };

        vm.invalidateDateRange = function () {
            var endDateMilliseconds = Date.parse(getEndDate()).valueOf();
            var startDateMilliseconds = Date.parse(getStartDate()).valueOf();
            return startDateMilliseconds > endDateMilliseconds;
        };

        vm.outOfRangeDate = function () {
            return vm.startOutOfRangeDate() || vm.endOutOfRangeDate() || vm.repeatOutOfRangeDate();
        };

        vm.endOutOfRangeDate = function () {
            var validEndDate = Date.parse(vm.plan.validityEndTime);
            var endDateMilliseconds = Date.parse(getEndDate()).valueOf();

            return endDateMilliseconds > validEndDate.valueOf();
        };

        vm.startOutOfRangeDate = function () {
            var validStartDate = Date.parse(vm.plan.validityStartTime);
            var startDateMilliseconds = Date.parse(getStartDate()).valueOf();

            return startDateMilliseconds < validStartDate.valueOf();
        };

        vm.repeatOutOfRangeDate = function () {
            if (vm.repeat === false) {
                return false;
            } else {
                var validEndDate = Date.parse(vm.plan.validityEndTime);
                var endDateMilliseconds = Date.parse(vm.lastEndTime).valueOf();
                return endDateMilliseconds > validEndDate.valueOf();
            }
        };

        function updateEndDate() {
            if (SoopkitchenUtils.isValidDate(getStartDate())) {
                vm.invalidateStartDate = false;
            } else {
                vm.invalidateStartDate = true;
                return;
            }
            vm.resetEvaluation();
            var newDate = new Date(Date.parse(getStartDate()).valueOf() + vm.duration * 1000);
            setEndDate(SoopkitchenUtils.formattedDate(newDate));
            if (vm.repeat) {
                var newDateEnd = new Date(Date.parse(getEndDate()).valueOf() + vm.frequency * (vm.numberOccurences - 1) * 1000);
                vm.lastEndTime = SoopkitchenUtils.formattedDate(newDateEnd);
            }
            vm.endDateStyle = getCssBlinkingStyle();
            $timeout(function () {
                vm.endDateStyle = null;
            }, vm.blinkingTimeout);
        }

        function updateStartDate() {
            if (SoopkitchenUtils.isValidDate(getEndDate())) {
                vm.invalidateEndDate = false;
            } else {
                vm.invalidateEndDate = true;
                return;
            }
            vm.resetEvaluation();
            var newDate = new Date(Date.parse(getEndDate()).valueOf() - vm.duration * 1000);
            setStartDate(SoopkitchenUtils.formattedDate(newDate));
            vm.startDateStyle = getCssBlinkingStyle();
            $timeout(function () {
                vm.startDateStyle = null;
            }, vm.blinkingTimeout);
        }

        function getObsDef(obs) {
            if (obs) {
                return vm.observationsPerInstrument[obs.experiment].allObservations[obs.module][obs.name];
            }
        }

        function repeatWrong() {
            if (vm.repeat === false) {
                return false;
            } else {
                return vm.frequency < vm.duration;
            }
        }

        function getObservations() {
            var observationsSet = new Set();
            var selectedObservations = vm.observationsPerInstrument[vm.selectedExperiment].allObservations[vm.selectedModule];
            for (var obsType in selectedObservations) {
                if (selectedObservations.hasOwnProperty(obsType)) {
                    observationsSet.add(obsType);
                }
            }
            return Array.from(observationsSet);
        }

        function updateParametersValues() {
            vm.clearParameters();
            vm.numberParameters = getNumberParameters();
            vm.listParameters = getListParameters();
            if (vm.obsDef != null) {
                for (var numberParam in vm.obsDef.numberParameters) {
                    if (vm.selectedObservation != null) {
                        vm.numberParameterValue[numberParam] = vm.selectedObservation.numberParameters[numberParam];
                    } else {
                        vm.numberParameterValue[numberParam] = vm.obsDef.numberParameters[numberParam].numberValue;
                    }
                    vm.parameterNumberUnit[numberParam] = vm.obsDef.numberParameters[numberParam].unit;
                    vm.parameterNumberMin[numberParam] = vm.obsDef.numberParameters[numberParam].min;
                    vm.parameterNumberMax[numberParam] = vm.obsDef.numberParameters[numberParam].max;
                }
                for (var listParam in vm.obsDef.listParameters) {
                    if (vm.selectedObservation != null) {
                        vm.listParameterValue[listParam] = vm.selectedObservation.listParameters[listParam];
                    } else {
                        vm.listParameterValue[listParam] = vm.obsDef.listParameters[listParam].value;
                    }
                    vm.listParameterAvailableValues[listParam] = vm.obsDef.listParameters[listParam].values
                }
                if (vm.selectedObservation != null) {
                    vm.duration = vm.selectedObservation.duration;
                    vm.comment = vm.selectedObservation.comment;
                } else {
                    vm.duration = vm.obsDef.duration.numberValue;
                }
                vm.durationLetters = SoopkitchenUtils.secondsToTime(vm.duration);
            }
        }

        function getExperiments() {
            var groupsSet = new Set();

            for (var experiment in vm.observationsPerInstrument) {
                if (vm.observationsPerInstrument.hasOwnProperty(experiment)) {
                    groupsSet.add(experiment);
                }
            }
            return Array.from(groupsSet);
        }

        function getNumberParameters() {
            var parametersSet = new Set();
            if (vm.obsDef == null) {
                return Array.from(parametersSet);
            } else {
                for (var parameters in vm.obsDef.numberParameters) {
                    if (vm.obsDef.numberParameters.hasOwnProperty(parameters)) {
                        parametersSet.add(parameters);
                    }
                }
            }
            return Array.from(parametersSet);
        }

        function getListParameters() {
            var parametersSet = new Set();
            if (vm.obsDef == null) {
                return Array.from(parametersSet);
            } else {
                for (var parameter in vm.obsDef.listParameters) {
                    if (vm.obsDef.listParameters.hasOwnProperty(parameter)) {
                        parametersSet.add(parameter);
                    }
                }
            }
            return Array.from(parametersSet);
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        vm.reset = function () {
            vm.evaluatedObservation = null;
            vm.availableModules = vm.observationsPerInstrument[vm.selectedExperiment].modules;
            vm.availableObservations = getObservations();
            vm.clearParameters();
            vm.numberParameters = getNumberParameters();
            vm.listParameters = getListParameters();
            for (var numberParam in vm.obsDef.numberParameters) {
                vm.numberParameterValue[numberParam] = vm.obsDef.numberParameters[numberParam].numberValue;
                vm.parameterNumberUnit[numberParam] = vm.obsDef.numberParameters[numberParam].unit;
                vm.parameterNumberMin[numberParam] = vm.obsDef.numberParameters[numberParam].min;
                vm.parameterNumberMax[numberParam] = vm.obsDef.numberParameters[numberParam].max;
            }
            for (var listParam in vm.obsDef.listParameters) {
                vm.listParameterValue[listParam] = vm.obsDef.listParameters[listParam].value;
                vm.listParameterAvailableValues[listParam] = vm.obsDef.listParameters[listParam].values
            }
            vm.duration = vm.obsDef.duration.numberValue;
            vm.durationLetters = SoopkitchenUtils.secondsToTime(vm.duration);
            var newDate = new Date(Date.parse(getStartDate()).valueOf() + vm.duration * 1000);
            setEndDate(SoopkitchenUtils.formattedDate(newDate));
            vm.evaluate();
        };

        vm.resetDisabled = function () {
            return vm.isEditable === false || vm.selectedObservation == null;
        };

        vm.evaluateDisabled = function () {
            return (vm.isEditable === false || vm.evaluatedObservation != null || vm.parametersWrong());
        };

        vm.soopsSelectedSOOPToRemove = function () {
            for (var i = 0; i < vm.soopBelonging.length; i++) {
                if (vm.soopBelonging [i] === true) {
                    return true;
                }
            }
            return false;
        };
        var canSave = function () {
            return vm.isEditable === false || vm.evaluatedObservation == null || vm.repeatOutOfRangeDate();
        };

        var canDelete = function () {
            return vm.isEditable === false || vm.operation === 'Create';
        };

        var checkDisabled = function (canPerform) {
            return function () {
                if ((vm.isMaster || vm.isChild) && !vm.isSocUser) {
                    var hasInstrument = vm.userInstruments.indexOf(vm.selectedExperiment) >= 0;
                    if (parameters.occurrence) {
                        hasInstrument = hasInstrument && vm.userInstruments.indexOf(parameters.occurrence.experiment) >= 0;
                    }
                    if (hasInstrument) {
                        return canPerform();
                    } else {
                        return true;
                    }
                } else {
                    return canPerform();
                }
            }
        };

        vm.saveDisabled = checkDisabled(canSave);

        vm.deleteDisabled = checkDisabled(canDelete);

        vm.evaluate = function () {

            var params = {
                "obsDefLabel": vm.plan.observationDefinitions.label,
                "experiment": vm.selectedExperiment,
                "obsModule": vm.selectedModule,
                "obsName": vm.obsDef.name,
                "startTime": getStartDate(),
                "endTime": getEndDate(),
                "overwrittenNumberParams": vm.numberParameterValue,
                "overwrittenListParams": vm.listParameterValue,
                "comment": vm.comment
            };

            if (vm.obsDef.duration.valueType !== 'NUMBER' || getStartDate() === getEndDate()) {
                params = {
                    "obsDefLabel": vm.plan.observationDefinitions.label,
                    "experiment": vm.selectedExperiment,
                    "obsModule": vm.selectedModule,
                    "obsName": vm.obsDef.name,
                    "startTime": getStartDate(),
                    "overwrittenNumberParams": vm.numberParameterValue,
                    "overwrittenListParams": vm.listParameterValue,
                    "comment": vm.comment
                }
            }

            $http({
                method: 'POST',
                url: 'api/obsInstance',
                params: params

            }).then(function successCallback(response) {
                AlertService.success("Evaluation of Observation successful");
                vm.evaluatedObservation = response.data;

                vm.selectedObservationId = vm.evaluatedObservation.name;
                vm.selectedObservation = vm.evaluatedObservation;
                vm.obsDef = vm.getObsDef(vm.evaluatedObservation);
                vm.selectedModule = vm.evaluatedObservation.module;
                setStartDate(vm.evaluatedObservation.startDate);
                setEndDate(vm.evaluatedObservation.endDate);
                updateParametersValues();
                updateLettersFrequency ();

            }, function errorCallback(response) {
                SoopkitchenUtils.prettyError(response);
            });
        };


        vm.save = function () {
            if ((parameters.occurrence != null) && vm.cut) {
                updateObservationInPlan();
            } else {
                saveObservationInPlan();
            }
        };

        function removeFromSOOP(soopInstances) {
            Planning.detatchFromSoop(
                {
                    planType: vm.planType,
                    planLabel: vm.plan.label,
                    soopInstances: soopInstances
                }, [parameters
                    .occurrence],
                function successCallback(data) {
                    AlertService.success("Detached Observation from SOOPS " + JSON.stringify(soopInstances));
                    updateTimeLine(true, data);
                    $uibModalInstance.dismiss('cancel');
                }, function errorCallback(response) {
                    SoopkitchenUtils.prettyError(response);
                });
        }

        vm.detachSOOP = function () {
            var count = 0;
            var selectedSOOPs = [];
            var unselectedSOOPs = [];
            vm.soopsItBelongs.forEach(function (soop) {
                if (vm.soopBelonging[count]) {
                    selectedSOOPs.push(soop)
                } else {
                    unselectedSOOPs.push(soop)
                }
                count++;
            });
            var soopMap = {};
            selectedSOOPs.forEach(function (soop) {
                soopMap[soop.encodedSoopType] = soop.soopInstanceId;
            });
            removeFromSOOP(soopMap);
        };
        
        vm.autonomize = function () {

            Planning.autonomizeFromSoop(
                {
                    planType: vm.planType,
                    planLabel: vm.plan.label,
                }, [parameters.occurrence],
                function successCallback(data) {
                    AlertService.success("Autonomized Observation");
                    updateTimeLine(true);
                    $uibModalInstance.dismiss('cancel');
                }, function errorCallback(data) {
                    AlertService.error("Error autonomizing Observation from SOOPs")
                });
        };

        vm.deautonomize = function () {
            removeFromSOOP({'000': '000'});
        };

        vm.isIndependent = function () {
            for (var i = 0; i < vm.ids.length; i++) {
                var idComponents = vm.ids[i].split('_');
                if (idComponents[2] === "000" && idComponents[3] === "000") {
                    return true;
                }
            }
            return false;
        };

        function saveObservationInPlan() {
            var obsList = [];
            if (vm.repeat === false) {
                var observation = vm.evaluatedObservation;
                obsList.push(observation);
            } else {
                for (var occurrence = 0; occurrence < vm.numberOccurences; occurrence++) {
                    var newObservation = JSON.parse(JSON.stringify(vm.evaluatedObservation));
                    var newStartDate = new Date(Date.parse(getStartDate()).valueOf() + vm.frequency * (occurrence) * 1000);
                    var newEndDate = new Date(Date.parse(getEndDate()).valueOf() + vm.frequency * (occurrence) * 1000);
                    newObservation.startDate = newStartDate;
                    newObservation.endDate = newEndDate;
                    obsList.push(newObservation);
                }
            }
            vm.waiting = true;
            Planning.addObsInstance(
                {
                    planType: vm.planType,
                    planLabel: vm.plan.label,
                },
                obsList,
                function successCallback(data) {
                    vm.waiting = false;
                    var startStr = vm.evaluatedObservation.startDate;
                    var endStr = vm.evaluatedObservation.endDate;
                    if (vm.isTimelineWithNoDates) {
                        startStr = SoopkitchenUtils.timeStringElapsed(vm.plan.validityStartTime, vm.evaluatedObservation.startDate);
                        endStr = SoopkitchenUtils.timeStringElapsed(vm.plan.validityStartTime, vm.evaluatedObservation.endDate);
                    }
                    AlertService.success("Added Observation " + vm.evaluatedObservation.name + " : " + startStr + " --> " + endStr + " to Plan successfully");
                    updateTimeLine(true, data);
                    $uibModalInstance.dismiss('cancel');
                },
                function errorCallback(response) {
                    vm.waiting = false;
                    SoopkitchenUtils.prettyError(response);
                }
            );
        }

        function updateObservationInPlan() {
            var existingObs = parameters.occurrence;
            updateObservation(existingObs, vm.evaluatedObservation, function (data) {
                var startStr = vm.evaluatedObservation.startDate;
                var endStr = vm.evaluatedObservation.endDate;
                if (vm.isTimelineWithNoDates) {
                    startStr = SoopkitchenUtils.timeStringElapsed(vm.plan.validityStartTime, vm.evaluatedObservation.startDate);
                    endStr = SoopkitchenUtils.timeStringElapsed(vm.plan.validityStartTime, vm.evaluatedObservation.endDate);
                }
                AlertService.success("Updated Observation " + vm.evaluatedObservation.name + " : " + startStr + " --> " + endStr + " to Plan successfully");
                updateTimeLine(true, data);
                $uibModalInstance.dismiss('cancel');
            });
        }


        function updateObservation(existingObs, updatedObs, success) {
            var listObservations = [];
            listObservations.push(
                {
                    "updatedHappening": updatedObs,
                    "existingHappening": existingObs
                }
            );
            vm.waiting = true;
            Planning.updateObsInstance(
                {
                    planType: vm.planType,
                    planLabel: vm.plan.label,
                },
                {"updateList": listObservations},
                function successCallback(data) {
                    vm.waiting = false;
                    if (success != null) {
                        success(data);
                    }
                },
                function errorCallback(response) {
                    vm.waiting = false;
                    SoopkitchenUtils.prettyError(response);
                }
            );
        }

        function updateTimeLine(highlightOccurrance, data) {
            
            if (highlightOccurrance) {
                $rootScope.$broadcast('updateList', {
                    newOccurrance: vm.evaluatedObservation,
                    oldOccurrance: parameters.occurrence,
                    data: data
                });

            } else {
                SoopkitchenUtils.updatePlanFromDialog(data);
                $uibModalInstance.dismiss('cancel');

            }
        }

        vm.updateLetters = function () {
            vm.resetEvaluation();
            vm.duration = SoopkitchenUtils.timeToSeconds(vm.durationLetters);
            var newDate = new Date(Date.parse(getStartDate()).valueOf() + vm.duration * 1000);
            setEndDate(SoopkitchenUtils.formattedDate(newDate));
            blinkDuration(false, true);
        };

        function updateLettersFrequency () {
            vm.frequency = SoopkitchenUtils.timeToSeconds(vm.durationLettersFrequency);
            var newDate = new Date(Date.parse(getEndDate()).valueOf() + vm.frequency * (vm.numberOccurences - 1) * 1000);
            vm.lastEndTime = SoopkitchenUtils.formattedDate(newDate);
        }

        
        function clearParameters() {
            vm.parameterNumberUnit = {};
            vm.numberParameterValue = {};
            vm.listParameterValue = {};
            vm.listParameterAvailableValues = {};
            vm.parameterNumberMin = {};
            vm.parameterNumberMax = {};
            vm.numberParameters = [];
            vm.listParameters = [];
            vm.duration = null;
            vm.comment = "";
            vm.durationLetters = null;
        }

        function updateCalendar() {
            vm.resetEvaluation();
            vm.durationLetters = SoopkitchenUtils.secondsToTime(vm.duration);
            var newDate = new Date(Date.parse(getStartDate()).valueOf() + vm.duration * 1000);
            setEndDate(SoopkitchenUtils.formattedDate(newDate));
            if (vm.repeat) {
                vm.lastEndTime = SoopkitchenUtils.formattedDate(newDate);
            }
            blinkDuration(true, false);
        }

        function blinkDuration(blinkDurationLetters, blinkDuration) {
            if (blinkDurationLetters) {
                vm.durationLettersStyle = getCssBlinkingStyle();
            }
            if (blinkDuration) {
                vm.durationStyle = getCssBlinkingStyle();
            }
            $timeout(function () {
                vm.durationLettersStyle = null;
                vm.durationStyle = null;
            }, vm.blinkingTimeout);
        }

        function updateDuration() {
            if (SoopkitchenUtils.isValidDate(getStartDate())) {
                vm.invalidateStartDate = false;
                vm.resetEvaluation();
                if (SoopkitchenUtils.isValidDate(getEndDate())) {
                    vm.invalidateEndDate = false;
                } else {
                    vm.invalidateEndDate = true;
                    return;
                }
                vm.duration = (Date.parse(getEndDate()) - Date.parse(getStartDate())) / 1000;
                vm.durationLetters = SoopkitchenUtils.secondsToTime(vm.duration);
                blinkDuration(true, true);
            } else {
                vm.invalidateStartDate = true;
            }
        }

        function getStartDate() {
            if (vm.isTimelineWithNoDates) {
                return SoopkitchenUtils.addTimeStringToDate(vm.plan.validityStartTime, vm.startDate);
            } else {
                return vm.startDate;
            }
        }

        function setStartDate(date) {
            if (vm.isTimelineWithNoDates) {
                vm.startDate = SoopkitchenUtils.timeStringElapsed(vm.plan.validityStartTime, date);
            } else {
                vm.startDate = date;
            }
        }

        function getEndDate() {
            if (vm.isTimelineWithNoDates) {
                return SoopkitchenUtils.addTimeStringToDate(vm.plan.validityStartTime, vm.endDate);
            } else {
                return vm.endDate;
            }
        }

        function setEndDate(date) {
            if (vm.isTimelineWithNoDates) {
                vm.endDate = SoopkitchenUtils.timeStringElapsed(vm.plan.validityStartTime, date);
            } else {
                vm.endDate = date;
            }
        }

        function belongsToASOOP() {
            if (parameters.occurrence != null && parameters.occurrence.hasOwnProperty('compositeId')) {
                var compositeSoopIds = parameters.occurrence.compositeId.compositeSoopIds;
                for (var i = 0; i < compositeSoopIds.length; i++) {
                    if (compositeSoopIds[i].soopInstanceId !== '000') {
                        return true;
                    }
                }
            }
            return false;
        }

        function getSOOPsItBelongs() {
            var soops = [];
            if (parameters.occurrence != null && parameters.occurrence.hasOwnProperty('compositeId')) {
                var compositeSoopIds = parameters.occurrence.compositeId.compositeSoopIds;
                for (var i = 0; i < compositeSoopIds.length; i++) {
                    if (compositeSoopIds[i].soopInstanceId !== '000') {
                        soops.push(compositeSoopIds[i]);
                    }
                }
            }
            return soops;
        }

        function getCssBlinkingStyle() {
            return {
                'animation': 'blinker 1s linear infinite',
                'color': 'blue'
            };
        }

        function resetEvaluation() {
            vm.evaluatedObservation = null;
        }

        vm.durationLettersInvalid = function () {
            if (vm.durationLetters == null)
                return false;
            return (SoopkitchenUtils.timeToSeconds(vm.durationLetters) === 0 || isNaN(SoopkitchenUtils
                .timeToSeconds(vm.durationLetters)));
        };

        vm.durationLettersInvalidFrequency = function () {
            if (vm.durationLettersFrequency == null)
                return false;
            return (SoopkitchenUtils.timeToSeconds(vm.durationLettersFrequency) === 0 || isNaN(SoopkitchenUtils
                .timeToSeconds(vm.durationLettersFrequency)));
        };

        function getValidityRange() {
            if (vm.isTimelineWithNoDates) {
                return ' -> ' + SoopkitchenUtils.timeStringElapsed(vm.plan.validityStartTime, vm.plan.validityEndTime);
            } else {
                return vm.plan.validityStartTime + ' -> ' + vm.plan.validityEndTime;
            }
        }

        vm.deleteObservation = function () {
            SoopkitchenUtils.prettyConfirm('Remove item', 'Do you really want to remove the observation '
                + vm.occurrence.name + ' with start date ' + vm.occurrence.startDate + ' ? ', function (ok) {
                if (ok) {
                    var occurrences = [];
                    occurrences.push(vm.occurrence);
                    Planning.deleteObsInstance(
                        {
                            planType: vm.planType,
                            planLabel: vm.plan.label
                        },
                        occurrences,
                        function successCallback(data) {
                            updateTimeLine(false, data);
                            $uibModalInstance.dismiss('cancel');
                            AlertService.success("Deleted Observation successfully");
                        }, function (response) {
                            SoopkitchenUtils.prettyError(response);
                        }
                    );
                }
            });
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('soopkitchenApp')
        .factory('PlanningDetailService', PlanningDetailService);

    PlanningDetailService.$inject = ['AutomaticEventService', 'PlanningEventsService','Planning', '$window','$cookies','$http', 'FileUploadService', '$uibModal', 'SoopkitchenUtils'];
    function PlanningDetailService (AutomaticEventService, PlanningEventsService, Planning, $window, $cookies, $http, FileUploadService, $uibModal, SoopkitchenUtils) {
        var vm = null;
        /** ** Constants *** */
        var IN_SITU_INSTRUMENTS = ['EPD', 'MAG', 'RPW', 'SWA'];
        var REMOTE_SENSING_INSTRUMENTS = ['EUI', 'Metis', 'PHI', 'SPICE', 'STIX', 'SoloHI'];
        var soopsGroup = 'SOOPs';

        return {
            submitNewEvCollection: submitNewEvCollection,
            submitNewObsDef : submitNewObsDef,
            soopify : soopify,
            unsoopify : unsoopify,
            openProfile : openProfile,
            updateDuration : updateDuration,
            applyWidth : applyWidth,
            applyPoints : applyPoints,
            updateLetters : updateLetters,
            durationLettersInvalid : durationLettersInvalid,
            panic : panic,
            bookMark : bookMark,
            saveBaseline : saveBaseline,
            updateEndDate : updateEndDate,
            setController: setController,
            getCookiePrefix: getCookiePrefix,
            invalidateDateRange  :  invalidateDateRange,
            unlock :  unlock,
            search :  search,
            openAutomaticEventWindow :  openAutomaticEventWindow,
            showAutomaticButton :  showAutomaticButton,
            canUpdateObsDef :  canUpdateObsDef,
            canUpdateParent :  canUpdateParent,
            canUpdateEvents :  canUpdateEvents,
            toggleCheckAll :  toggleCheckAll,
            resetWidth :  resetWidth,
            setValidityPeriod :  setValidityPeriod,
            resetZoomedDates :  resetZoomedDates,
            resetScroll: resetScroll,
            addVisItem: addVisItem,
            updateVisItem: updateVisItem,
            zoomIn :zoomIn,
            zoomOut :zoomOut,
            movePlanLeft :movePlanLeft,
            movePlanRight :movePlanRight,
            reload :reload,
            goBack :goBack,
            updateParent :updateParent,
            getPickerDate : getPickerDate,
            setPickerDate : setPickerDate,
            getPickerDate2 : getPickerDate2,
            setPickerDate2 : setPickerDate2,
            getPickerPoint1 : getPickerPoint1,
            getPickerPoint2 : getPickerPoint2,
            isEventGroup: isEventGroup,
            createTimeLine: createTimeLine
        };

        function setController(Controller) {
            vm = Controller;
        }

        function panic() {
            SoopkitchenUtils.panicConfirm('Lock Plan', 'Do you really want to lock plan ' + vm.planning.label + "?",
                function (ok) {
                    if (ok) {
                        SoopkitchenUtils.lockPlan(vm.planning.label, vm.planType, function () {
                            location.reload();
                        });
                    }
                });
        }

        function bookMark() {
            SoopkitchenUtils.bookmarkPrompt(function (inputValue) {
                if (inputValue === false)
                    return false;
                bookmarkPlan(inputValue);
            });
        }

        function bookmarkPlan(comment) {
            Planning.bookmark(
                {
                    planType: vm.planType,
                    planLabel: vm.planning.label,
                    internalVersion: vm.planning.internalVersion,
                    comment: comment
                },
                function successCallback(response) {
                    SoopkitchenUtils.invokeSweetAlert("Nice!", "You saved plan " + vm.planning.label + " with the comment: " + comment, "success");
                    location.reload();
                }, function errorCallback(response) {
                    SoopkitchenUtils.prettyError(response);
                }
            );
        }

        function soopify() {
            $uibModal.open({
                templateUrl: 'app/entities/planning/soopify.html',
                controller: 'SoopifyPlanController',
                controllerAs: 'vm',
                size: 'md',
                backdrop: 'static',
                resolve: {
                    entity: vm.planning,
                    parameters: {
                        labelToSoopify: vm.planning.label,
                        internalVersionToSoopify: vm.planning.internalVersion,
                    }
                }
            });
        }


        function unsoopify() {
            $uibModal.open({
                templateUrl: 'app/entities/planning/unsoopify.html',
                controller: 'UnsoopifyPlanController',
                controllerAs: 'vm',
                size: 'md',
                backdrop: 'static',
                resolve: {
                    entity: vm.planning,
                    parameters: {
                        labelToUnsoopify: vm.planning.label,
                        internalVersionToUnsoopify: vm.planning.internalVersion,
                    }
                }
            });
        }

        function openProfile(group) {
            $uibModal.open({
                templateUrl: 'app/entities/planning/planning-profile.html',
                controller: 'PlanningProfileController',
                controllerAs: 'vm',
                size: 'lg',
                backdrop: 'static',
                resolve: {
                    entity: vm.planning,
                    parameters: {
                        group: group
                    }
                }
            });
        }

        function updateDuration() {
            if (false === SoopkitchenUtils.isValidDate(vm.getPickerDate2())) {
                vm.invalidateEndDate = true;
                return;
            } else {
                vm.invalidateEndDate = false;
            }
            vm.duration = (Date.parse(vm.getPickerDate2()) - Date.parse(vm.getPickerDate())) / 1000;
            vm.durationLetters = SoopkitchenUtils.secondsToTime(vm.duration);
            $cookies.put(getCookiePrefix() + "earliestDate", vm.getPickerDate());
            $cookies.put(getCookiePrefix() + "latestDate", vm.getPickerDate2());
        }
        function applyWidth() {
            vm.timeline.setWindow(vm.getPickerDate(), vm.getPickerDate2(), {
                animation: true
            });
            $cookies.put(getCookiePrefix() + "earliestZoomedDate", SoopkitchenUtils.formattedDate(new Date(vm.getPickerDate())));
            $cookies.put(getCookiePrefix() + "latestZoomedDate", SoopkitchenUtils.formattedDate(new Date(vm.getPickerDate2())));
        }

        function applyPoints() {
            SoopkitchenUtils.prettyConfirm('Timeline fill in', 'Do you want to fill in timeline for the period '
                + vm.getPickerPoint1() + ' to ' + vm.getPickerPoint2() + '?',
                function (ok) {
                    if (ok) {
                        console.log("Start: ${vm.getPickerPoint1()} | End: ${vm.getPickerPoint2()}");
                        applyPointsSlewPlan(vm.getPickerPoint1(), vm.getPickerPoint2());
                    }
                });
        }

        function applyPointsSlewPlan(dateStart, dateEnd) {
            Planning.autoSlews(
                {
                    planType: vm.planType,
                    planLabel: vm.planning.label,
                    internalVersion: vm.planning.internalVersion,
                    dateStart: dateStart,
                    dateEnd: dateEnd
                },
                function successCallback(response) {
                    SoopkitchenUtils.showPlanChanges(response, function () {
                        location.reload(); // Reloads page only when user clicks "OK"
                    });
                }, function errorCallback(response) {
                    console.log("Error - Start: ${dateStart} | End: ${dateEnd}");
                    SoopkitchenUtils.prettyError(response);
                }
            );
        }

        function updateLetters() {
            vm.duration = SoopkitchenUtils.timeToSeconds(vm.durationLetters);
            var newDate = new Date(Date.parse(vm.getPickerDate()).valueOf() + vm.duration * 1000);
            setPickerDate2(SoopkitchenUtils.formattedDate(newDate).substring(0, 10));
            $cookies.put(getCookiePrefix() + "earliestDate", vm.getPickerDate());
            $cookies.put(getCookiePrefix() + "latestDate", vm.getPickerDate2());
        }

        function durationLettersInvalid() {
            if (vm.durationLetters == null)
                return false;
            return (SoopkitchenUtils.timeToSeconds(vm.durationLetters) === 0 || isNaN(SoopkitchenUtils
                .timeToSeconds(vm.durationLetters)));
        }

        function submitNewEvCollection() {
            PlanningEventsService.updateEventCollection(
                {
                    planLabel: vm.planning.label,
                    eventCollectionsLabel: vm.selectedNewEventCollections
                },
                function successCallback() {
                    vm.changeEvCollecVisible = false;
                    location.reload();
                },
                function errorCallback(response) {
                    SoopkitchenUtils.prettyError(response);
                })
        }

        function submitNewObsDef() {
            Planning.updateObsDef(
                {
                    planType: vm.planType,
                    planLabel: vm.planning.label,
                    obsDefLabel: vm.selectedNewObservationDefinitions
                },
                function successCallback() {
                    vm.changeObsDefVisible = false;
                    location.reload();
                }, function errorCallback(response) {
                    SoopkitchenUtils.prettyError(response);
                }
            )
        }

        function saveBaseline() {
            SoopkitchenUtils.saveBaselinePrompt(function (inputValue) {
                if (inputValue === false)
                    return false;
                saveBaseLineForPlan(inputValue);
            });
        }
        function updateEndDate() {
            if (false === SoopkitchenUtils.isValidDate(vm.getPickerDate())) {
                vm.invalidateStartDate = true;
                return;
            } else {
                vm.invalidateStartDate = false;
            }

            var newDate = new Date(Date.parse(vm.getPickerDate()).valueOf() + vm.duration * 1000);
            setPickerDate2(SoopkitchenUtils.formattedDate(newDate).substring(0, 10));
            $cookies.put(getCookiePrefix() + "earliestDate", vm.getPickerDate());
            $cookies.put(getCookiePrefix() + "latestDate", vm.getPickerDate2());
        }
        function saveBaseLineForPlan(comment) {
            Planning.baseline(
                {
                    planType: vm.planType,
                    planLabel: vm.planning.label,
                    internalVersion: vm.planning.internalVersion,
                    comment: comment
                },
                function successCallback() {
                    SoopkitchenUtils.invokeSweetAlert("Nice!", "You saved plan " + vm.planning.label + " with the comment: " + comment, "success");
                    location.reload();
                }, function errorCallback(response) {
                    SoopkitchenUtils.prettyError(response);
                }
            );

        }
        function getCookiePrefix() {
            return vm.planning.label + "_";
        }
        function invalidateDateRange() {
            var endDateMilliseconds = Date.parse(vm.getPickerDate2()).valueOf();
            var startDateMilliseconds = Date.parse(vm.getPickerDate()).valueOf();
            return startDateMilliseconds > endDateMilliseconds;
        }

        function unlock(label) {
            SoopkitchenUtils.unlockPrompt('Unlock Plan',
                "<img  height='102' width='102' src='content/images/unlock.png'/> <br>"
                + "Your about to unlock the plan " + label, function (ok) {
                    if (ok) {
                        SoopkitchenUtils.unlockPlan(label, vm.planType, function () {
                            location.reload();
                        });
                    }
                });
        }
        function openAutomaticEventWindow() {
            if (vm.status.hasOwnProperty('selectDates') === false || vm.status.selectDates === false) {
                vm.status.eventService(vm.planning.label);
            } else {
                $uibModal.open({
                    templateUrl: 'app/entities/planning/planning-automatic-event-dialog.html',
                    controller: 'PlanningAutomaticEventDialogController',
                    controllerAs: 'vm',
                    size: 'lg',
                    backdrop: 'static',
                    resolve: {
                        entity: vm.planning,
                        parameters: {
                            id: vm.planning.label,
                            start: vm.dateRange[0],
                            end: vm.dateRange[1],
                            status: vm.status
                        }
                    }
                }).result.then(function () {
                }, function () {
                });
            }

        }

        function showAutomaticButton() {
            return vm.status !== AutomaticEventService.AUTOMATIC_EVENTS_STATUS.FINISHED;
        }

        function toggleCheckAll() {
            vm.checkedAll = vm.checkedAll === false;

            for (var group in vm.groups) {

                if (!isEventGroup(vm.groups[group])) {
                    vm.checkedValue[vm.groups[group]] = vm.checkedAll;
                    $cookies.put(getCookiePrefix() + "checkbox_" + vm.groups[group], vm.checkedAll);
                    vm.groupsTimeLine.forEach(function () {
                        vm.groupsTimeLine.update({
                            'id': vm.groups[group],
                            visible: vm.checkedAll
                        });
                    });
                }

            }
        }

        function isEventGroup(groupName) {
            if (vm.eventGroupSet.has(groupName)) {
                return true;
            }
            return false;
        }

        function addVisItem(visItem) {
            vm.items.add(visItem);
        }

        function updateVisItem(visItem) {
            vm.items.update(visItem);
        }
        function setValidityPeriod() {
            $uibModal.open({
                templateUrl: 'app/entities/planning/planning-restrict-period.html',
                controller: 'PlanningRestrictPeriodController',
                controllerAs: 'vm',
                size: 'lg',
                backdrop: 'static',
                resolve: {
                    entity: vm.planning
                }
            }).result.then(function () {
            }, function () {
            });
        }
        function canUpdateObsDef() {
            return vm.planning.observationDefinitions.label !== vm.selectedNewObservationDefinitions
                && vm.selectedNewObservationDefinitions;
        }

        function canUpdateParent() {
            return vm.planning.parentLabel !== vm.selectedNewParentLabel && vm.selectedNewParentLabel;
        }

        function canUpdateEvents() {
            return vm.planning.eventCollections.label !== vm.selectedNewEventCollections && vm.selectedNewEventCollections;
        }

        function search(text) {
            var occurrences = vm.items.get({
                filter: function (item) {
                    return (item.occurrence.name.indexOf(text) >= 0);
                }
            });
            var ids = [];
            for (var i = 0; i < occurrences.length; i++) {
                ids.push(occurrences[i].id);
            }

            vm.timeline.setSelection(ids, {
                focus: true
            })
        }

        function resetWidth() {
            if (vm.isMaster) {
                setPickerDate(vm.planning.eventCollections.validityStartTime.substring(0, 10));
                setPickerDate2(vm.planning.eventCollections.validityEndTime.substring(0, 10));
            } else {
                setPickerDate(vm.planning.validityStartTime.substring(0, 10));
                setPickerDate2(vm.planning.validityEndTime.substring(0, 10));
            }
            vm.duration = (Date.parse(vm.getPickerDate2()) - Date.parse(vm.getPickerDate())) / 1000;
            vm.durationLetters = SoopkitchenUtils.secondsToTime(vm.duration);

            $cookies.put(getCookiePrefix() + "earliestDate", vm.getPickerDate());
            $cookies.put(getCookiePrefix() + "latestDate", vm.getPickerDate2());
            vm.timeline.setWindow(vm.getPickerDate(), vm.getPickerDate2(), {
                animation: true
            });
            $cookies.put(getCookiePrefix() + "earliestZoomedDate", SoopkitchenUtils.formattedDate(new Date(vm.getPickerDate())));
            $cookies.put(getCookiePrefix() + "latestZoomedDate", SoopkitchenUtils.formattedDate(new Date(vm.getPickerDate2())));
        }

        function resetZoomedDates() {
            $cookies.put(getCookiePrefix() + "earliestZoomedDate", SoopkitchenUtils.formattedDate(new Date(vm.getPickerDate())));
            $cookies.put(getCookiePrefix() + "latestZoomedDate", SoopkitchenUtils.formattedDate(new Date(vm.getPickerDate2())));
        }
        function getPickerDate() {
            if (vm.isTimelineWithNoDates) {
                return SoopkitchenUtils.addTimeStringToDate(vm.planning.validityStartTime, vm.picker.date);
            } else {
                return vm.picker.date;
            }
        }
        function goBack() {
            $state.go(previousState.name, previousState.params);
        }
        function getPickerDate2() {
            if (vm.isTimelineWithNoDates) {
                return SoopkitchenUtils.addTimeStringToDate(vm.planning.validityStartTime, vm.picker2.date);
            } else {
                return vm.picker2.date;
            }
        }
        function getPickerPoint1() {
            if (vm.isTimelineWithNoDates) {
                return SoopkitchenUtils.addTimeStringToDate(vm.planning.validityStartTime, vm.pickerPoint1.date);
            } else {
                return vm.pickerPoint1.date;
            }
        }

        function getPickerPoint2() {
            if (vm.isTimelineWithNoDates) {
                return SoopkitchenUtils.addTimeStringToDate(vm.planning.validityStartTime, vm.pickerPoint2.date);
            } else {
                return vm.pickerPoint2.date;
            }
        }

        function reload() {
            resetZoomedDates();
            resetScroll();
            location.reload();
        }


        function resetScroll() {
            $cookies.put(getCookiePrefix() + "latestYOffset", 0);
        }

        function updateParent() {
            Planning.updateParent(
                {
                    planType: PlanTypes['child'],
                    planLabel: vm.planning.label,
                    parentLabel: vm.selectedNewParentLabel
                },
                function successCallback() {
                    vm.changeParentVisible = false;
                    location.reload();
                }, function errorCallback(response) {
                    SoopkitchenUtils.prettyError(response);
                }
            )
        }
        function zoomIn() {
            vm.timeline.zoomIn(0.2);
        }
        function zoomOut() {
            vm.timeline.zoomOut(0.2);
        }
        function movePlanLeft() {
            movePlan(true);
        }

        function movePlanRight() {
            movePlan(false);
        }

        function movePlan(moveBackwards) {
            var windowTime = vm.timeline.getWindow();
            var millisTotalShown = windowTime.end.getTime() - windowTime.start.getTime();
            var millisCentralDate = windowTime.start.getTime() + millisTotalShown / 2;

            var newMillisCentralDate;
            if (moveBackwards) {
                newMillisCentralDate = millisCentralDate - millisTotalShown / 10;
            } else {
                newMillisCentralDate = millisCentralDate + millisTotalShown / 10;
            }

            vm.timeline.moveTo(new Date(newMillisCentralDate));
        }
        function setPickerDate(date) {
            if (vm.isTimelineWithNoDates) {
                vm.picker.date = SoopkitchenUtils.timeStringElapsed(vm.planning.validityStartTime, date);
                vm.pickerPoint1.date = SoopkitchenUtils.timeStringElapsed(vm.planning.validityStartTime, date);
            } else {
                vm.picker.date = date;
                vm.pickerPoint1.date = date;
            }
        }

        function setPickerDate2(date) {
            if (vm.isTimelineWithNoDates) {
                vm.picker2.date = SoopkitchenUtils.timeStringElapsed(vm.planning.validityStartTime, date);
                vm.pickerPoint2.date = SoopkitchenUtils.timeStringElapsed(vm.planning.validityStartTime, date);
            } else {
                vm.picker2.date = date;
                vm.pickerPoint2.date = date;
            }
        }
        function createTimeLine(updatedPlanning, newOccurrence, checkedValue) {
            var container = document.getElementById('visualization');

            if (updatedPlanning != null) {
                vm.planning = updatedPlanning;
            }
            if (checkedValue != null) {
                vm.checkedValue = checkedValue;
            }

            var eventsSet = new Set();
            var happenings = [];
            if (!vm.isTimelineWithNoDates) {
                happenings = vm.planning.eventsTimeline.happenings;
            }
            happenings = happenings.concat(vm.planning.observationInstanceTimeline.happenings);
            if (vm.planning.hasOwnProperty('soopInstanceTimeline')) {
                happenings = happenings.concat(vm.planning.soopInstanceTimeline.happenings);
            }
            var timeLineOccurrences = [];
            var groupsList = [];
            for (var i = 0; i < happenings.length; i++) {
                var occurrence = happenings[i];
                if (occurrence.hasOwnProperty('visible') && occurrence.visible === false) {
                    continue;
                }

                var group = null;
                var isEvent = occurrence.type === 'event';
                var isObservation = occurrence.type === 'observation';
                var isSoop = occurrence.type === 'soop';
                if (isEvent) {
                    group = occurrence.group.groupName;
                    if (eventsSet.has(group) === false) {
                        eventsSet.add(group);
                    }
                } else if (isObservation) {
                    group = occurrence.experiment;
                } else if (isSoop) {
                    group = soopsGroup;
                }

                var style = 'background-color: ' + occurrence.colour + ';';
                style += 'border-color: ' + occurrence.colour + ';';
                var start = occurrence.startDate;
                var end = occurrence.endDate;
                var startString = start;
                var endString = end;
                if (vm.isTimelineWithNoDates) {
                    startString = SoopkitchenUtils.timeStringElapsed(vm.planning.validityStartTime, start);
                    endString = SoopkitchenUtils.timeStringElapsed(vm.planning.validityStartTime, end);
                } else {
                    startString += ' (' + SoopkitchenUtils.getDayOfYear(occurrence.startDate) + ')';
                    endString += ' (' + SoopkitchenUtils.getDayOfYear(occurrence.endDate) + ')';
                }
                var name = occurrence.name;

                var content = "<span id='timelineOccurrence_" + i + "' style ='" + style + "'>" + name;
                var title = content;
                if (isEvent && occurrence.description) {
                    title += ' (' + occurrence.description + ')'
                }
                if (isSoop) {
                    title += ' (' + occurrence.encodedSoopType + '_' + occurrence.soopInstanceId + ')'
                }
                title += "</span>";
                if (start === end) {
                    title += '<br>' + startString + '<br>';
                    style += "width:10px; \
                    height: 10px;\
                    border: 2px solid\
                    -webkit-transform: rotate(45deg) skew(15deg, 15deg);\
                    -moz-transform: rotate(45deg) skew(15deg, 15deg);\
                    -ms-transform: rotate(45deg) skew(15deg, 15deg);\
                    -o-transform: rotate(45deg) skew(15deg, 15deg);\
                    transform: rotate(45deg) skew(15deg, 15deg);";
                    content = "<span id='timelineOccurrence_" + i + "' style ='visibility: hidden;'>" + name + " </span>";
                } else {
                    title += '<br>' + startString + '->' + endString + '<br>';
                }
                // SPKT-1051: Show SOOP instance volume in the GUI
                if (isSoop) {
                    title += ' Soop Instance Volume = ' + SoopkitchenUtils.roundDecimals(occurrence.soopInstanceVolume, 1) + ' MiB<br>';
                }

                var module = "";
                var subgroup = "";
                var def;
                if (isObservation) {
                    module = occurrence.module;
                    title += "Module: " + module + '<br>';
                    title += "SOC OBS_IDs: " + occurrence.ids + '<br>';
                    // to group by module
                    subgroup = module;
                    def = vm.observationsPerInstrument[occurrence.experiment].allObservations[occurrence.module][occurrence.name];
                } else if (isEvent) {
                    if (occurrence.group.subgroupName) {
                        subgroup = occurrence.group.subgroupName;
                    } else {
                        subgroup = occurrence.originalName;
                    }
                } else if (isSoop) {
                    subgroup = occurrence.soopType;
                }

                if (isEvent) {
                    if (occurrence.hasOwnProperty('count') && occurrence.count) {
                        title += 'count: ' + occurrence.count + '<br>';
                    }
                    if( Object.keys(occurrence.parameters).length > 0) {
                        for (var parameter in occurrence.parameters) {
                            if (occurrence.parameters.hasOwnProperty(parameter)) {
                                title += parameter + ": " + occurrence.parameters[parameter] + '<br>';
                            }
                        }
                    }
                } else {
                    if (occurrence.hasOwnProperty('numberParameters')) {
                        for (var numberParameter in occurrence.numberParameters) {
                            if (occurrence.numberParameters.hasOwnProperty(numberParameter)) {
                                title += numberParameter + ": " + occurrence.numberParameters[numberParameter];
                                if (def.numberParameters[numberParameter].unit != null) {
                                    title += " " + def.numberParameters[numberParameter].unit;
                                }
                                title += '<br>';
                            }
                        }
                    }
                    if (occurrence.hasOwnProperty('listParameters')) {
                        for (var listParameter in occurrence.listParameters) {
                            if (occurrence.listParameters.hasOwnProperty(listParameter)) {
                                title += listParameter + ": " + occurrence.listParameters[listParameter];
                                if (def.listParameters[listParameter].unit != null) {
                                    title += " " + def.listParameters[listParameter].unit;
                                }
                                title += '<br>';
                            }
                        }
                    }
                }
                if (occurrence.hasOwnProperty('flush') && occurrence.flush != null && occurrence.flush !== 0) {
                    title += "FLUSH: " + occurrence.flush;
                    if (def.flush.unit != null) {
                        title += " " + def.flush.unit;
                    }
                    title += " (" + def.flush.flushType + ")<br>";
                }
                if (occurrence.hasOwnProperty('power') && occurrence.power != null && occurrence.power !== 0) {
                    title += "POWER: " + occurrence.power;
                    if (def.power.unit != null) {
                        title += " " + def.power.unit;
                    }

                    title += "<br>";
                }

                var flowsSet = new Set();
                if (occurrence.hasOwnProperty('flows') && occurrence.flows != null) {
                    for (var flowName in occurrence.flows) {
                        if (occurrence.flows.hasOwnProperty(flowName)) {
                            flowsSet.add(flowName);
                            title += flowName + "(" + def.flows[flowName].flowType + "): ";
                            title += SoopkitchenUtils.roundDecimals(occurrence.flows[flowName], 2);
                            if (def.flows[flowName].unit != null) {
                                title += " " + def.flows[flowName].unit;
                            }
                            title += " | " + SoopkitchenUtils.roundDecimals(occurrence.volumes[flowName], 3) + " Mibytes <br>"
                        }
                    }
                }
                if (occurrence.volumes) {
                    var totalDays = (SoopkitchenUtils.dateToSeconds(end) - SoopkitchenUtils.dateToSeconds(start)) / 86400;

                    for (var volume in occurrence.volumes) {
                        if (occurrence.volumes.hasOwnProperty(volume)) {
                            title += volume + ": " + SoopkitchenUtils.roundDecimals(occurrence.volumes[volume], 3) + ' Mibytes';
                            if (volume.includes('_TAV')) {
                                var volumePerDay = occurrence.volumes[volume] / totalDays;
                                title += ' | ' + SoopkitchenUtils.roundDecimals(volumePerDay, 3) + ' Mibytes/Day';
                            }
                            title += '<br>';
                        }
                    }
                }
                if (occurrence.comment) {
                    title = title + "Comment = " + occurrence.comment + ' <br>';
                    //title = title + "Comment = " + occurrence.comment.replace(/\n/g, '<br>') + ' <br>';
                }

                var occurrenceObj = {
                    id: (i + 1),
                    occurrence: occurrence,
                    subgroup: subgroup,
                    module: module,
                    title: title,
                    content: content,
                    start: start,
                    group: group,
                    style: style
                };

                if (start !== end) {
                    occurrenceObj.end = end;
                } else {
                    occurrenceObj.className = 'instantaneous';
                }

                timeLineOccurrences.push(occurrenceObj);
            }

            vm.eventGroupSet = eventsSet;
            vm.groups = createGroups(eventsSet, groupsList, checkedValue != null);
            container.innerHTML = "";

            var groups = new vis.DataSet(groupsList);
            groups.forEach(function (group) {
                vm.checkedValue[group.id] = false === ($cookies.get(getCookiePrefix() + "checkbox_" + group.id) === "false");
                groups.update({
                    'id': group.id,
                    visible: false === ($cookies.get(getCookiePrefix() + "checkbox_" + group.id) === "false")

                });
            });
            vm.groupsTimeLine = groups;
            vm.items = new vis.DataSet(timeLineOccurrences);
            var newOccurrenceItemList = null;
            if (newOccurrence != null) {
                newOccurrenceItemList = vm.items.get({
                    filter: function (item) {
                        return (item.occurrence.startDate === newOccurrence.startDate
                            && item.occurrence.endDate === newOccurrence.endDate && item.occurrence.name
                                .startsWith(newOccurrence.name));
                    }
                });
            }
            if (($cookies.get(getCookiePrefix() + "earliestZoomedDate") != null) && $cookies.get(getCookiePrefix() + "latestZoomedDate")) {
                vm.options.start = $cookies.get(getCookiePrefix() + "earliestZoomedDate");
                vm.options.end = $cookies.get(getCookiePrefix() + "latestZoomedDate");
                setPickerDate(vm.options.start.substring(0,10));
                setPickerDate2(vm.options.end.substring(0,10));
            } else {
                vm.options.start = vm.getPickerDate();
                vm.options.end = vm.getPickerDate2();
            }

            vm.updateDuration();
            vm.selection = [];
            vm.timeline = new vis.Timeline(container, vm.items, groups, vm.options);

            vm.timeline.on('select', function (properties) {
                vm.selected = properties.items.length;
                vm.selection = [];
                vm.isSoopSelected = false;
                if (properties.items.length === 1) {
                    var occurrences = vm.items.get({
                        filter: function (item) {
                            return (item.id === properties.items[0]);
                        }
                    });
                    var soopObservations = extractSelection(occurrences[0]);
                    var soopOccurrenceId = -1;
                    soopObservations.forEach(function (soopObs) {
                        vm.selection.push(soopObs.id);
                        if (soopObs.occurrence.hasOwnProperty('soopInstanceId')) {
                            soopOccurrenceId = soopObs.id;
                        }
                    });
                    if (soopOccurrenceId > -1) {
                        vm.isSoopSelected = true;
                        vm.timeline.setSelection(vm.selection);
                        setIconsToSpoons(document.getElementsByClassName("vis-delete"));
                        vm.timeline.focus(soopOccurrenceId);
                    } else {
                        setIconsToPencils(document.getElementsByClassName("vis-delete"));
                    }
                } else {
                    setIconsToPencils(document.getElementsByClassName("vis-delete"));
                }
            });

            vm.timeline.on('contextmenu', function (props) {
                if (vm.isVersion) {
                    return;
                }
                if (props.what === 'background' || props.what === 'item') {
                    props.event.preventDefault();
                    vm.openContextMenu(props);
                } else {
                    vm.closeContextMenu();
                }
            });
            vm.timeline.on('rangechanged', function (props) {
                $cookies.put(getCookiePrefix() + "earliestZoomedDate", SoopkitchenUtils.formattedDate(props.start));
                $cookies.put(getCookiePrefix() + "latestZoomedDate", SoopkitchenUtils.formattedDate(props.end));
                if (vm.isSoopSelected && vm.selection.length > 1) {
                    vm.timeline.setSelection(vm.selection);
                    setIconsToSpoons(document.getElementsByClassName("vis-delete"));
                } else {
                    setIconsToPencils(document.getElementsByClassName("vis-delete"));
                }
            });

            if (newOccurrenceItemList != null) {
                vm.timeline.setSelection([newOccurrenceItemList[0].id], {
                    focus: true
                })
            }

            vm.groupChange = function groupChange(group) {
                $cookies.put(getCookiePrefix() + "checkbox_" + group, false === vm.checkedValue[group]);
                vm.checkedValue[group] = (false === vm.checkedValue[group]);
                groups.forEach(function () {
                    groups.update({
                        'id': group,
                        visible: vm.checkedValue[group]
                    });
                });

            };

            // Back to previous scroll position... and reset!
            if ($cookies.get(getCookiePrefix() + "latestYOffset") != null) {
                $window.scrollTo(0, $cookies.get(getCookiePrefix() + "latestYOffset"));
                resetScroll();
            }
        }
        function createGroups(eventsSet, groupsList, alreadySelectedGroups) {
            var instruments = REMOTE_SENSING_INSTRUMENTS.concat(IN_SITU_INSTRUMENTS);
            var events = Array.from(eventsSet);

            var groups = events;
            if (vm.hasSoops) {
                groups.push(soopsGroup);
            }
            groups = groups.concat(instruments);
            var instSet = new Set(IN_SITU_INSTRUMENTS);
            var remoteSet = new Set(REMOTE_SENSING_INSTRUMENTS);
            for (var i = 0; i < groups.length; i++) {
                var group = groups[i];
                var style = "";
                if (instSet.has(group)) {
                    style = "background-color: #C0C0C0"
                } else if (remoteSet.has(group)) {
                    style = "background-color: #DCDCDC;"
                } else if (eventsSet.has(group)) {
                    style = "background-color: #F5F5F5;"
                }
                groupsList.push({
                    id: group,
                    value: group,
                    'content': '<span id="group_' + group + '">' + group + '</span>',
                    'style': style,
                    orderId: i

                });

                if (alreadySelectedGroups === false || vm.checkedValue[group] == null) {
                    vm.checkedValue[group] = true;
                }
            }
            return groups;
        }
        function extractSelection(occurrenceSelected) {
            var soopObservations = [];
            if (occurrenceSelected.occurrence.type === 'soop') {
                soopObservations.push(occurrenceSelected);
                soopObservations = soopObservations.concat(vm.items.get({
                    filter: function (item) {
                        if (item.occurrence.hasOwnProperty('compositeId')) {
                            return belongsToSoop(item, occurrenceSelected);
                        }
                        return false;
                    }
                }));
            } else {
                soopObservations.push(occurrenceSelected);
            }

            return soopObservations;
        }


        function belongsToSoop(item, occurrenceSelected) {
            var compositeSoopIds = item.occurrence.compositeId.compositeSoopIds;
            for (var i = 0; i < compositeSoopIds.length; i++) {
                if (compositeSoopIds[i].soopInstanceId === occurrenceSelected.occurrence.soopInstanceId
                    && compositeSoopIds[i].encodedSoopType === occurrenceSelected.occurrence.encodedSoopType
                ) {
                    return true;
                }
            }
            return false;
        }
        function setIconsToPencils (icons) {
            for (var i = 0; i < icons.length; i++) {
                if (icons[i] !== undefined) {
                    icons[i].style ="content:url('content/images/edit.png')";
                    icons[i].title ="Update occurrence";
                }
            }
        }
        function setIconsToSpoons (icons) {
            if (icons.length>1) {
                var soopOccurrence = icons[0];
                soopOccurrence.style = "content:url('content/images/edit.png')";
                soopOccurrence.title = "Update SOOP";
                for (var i = 1; i < icons.length; i++) {
                    if (icons[i] !== undefined) {
                        icons[i].style ="content:url('content/images/spoon.png')";
                        icons[i].title ="Update SOOP component";
                    }
                }
            }
        }
    }

})();

(function() {
    'use strict';
    angular
        .module('soopkitchenApp')
        .factory('PlanningDetailOpenDialogService', PlanningDetailOpenDialogService);

    PlanningDetailOpenDialogService.$inject = ['$uibModal'];
    function PlanningDetailOpenDialogService ($uibModal) {
        var vm = null;

        return {
            setController: setController,
            editSoop:editSoop,
            updateObservationViaDialog:updateObservationViaDialog,
            updateEventViaDialog: updateEventViaDialog,
            manageUsers : manageUsers,
            doInsertPlanTemplateAtTime: doInsertPlanTemplateAtTime,
            doCreateSOOPFromTimeLine: doCreateSOOPFromTimeLine,
            doInsertSoopTemplateAtTime: doInsertSoopTemplateAtTime,
            doChangeMetisCompatibilityAtStartTime: doChangeMetisCompatibilityAtStartTime,
            moveSoop: moveSoop,
            moveObs: moveObs,
            moveEvents: moveEvents,
            addObservation: addObservation,
            addEvent: addEvent,
            insertPlan : insertPlan,
            setEfecsVersion : setEfecsVersion,
            insertSOCEvents: insertSOCEvents
        };

        function setController(Controller) {
            vm = Controller;
        }

        function editSoop(item) {
            $uibModal.open({
                templateUrl: 'app/entities/planning/edit-soop-dialog.html',
                controller: 'EditSoopController',
                controllerAs: 'vm',
                size: 'lg',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    entity: vm.planning,
                    parameters: {
                        planLabel: vm.planning.label,
                        soopInstanceId:  item.occurrence.soopInstanceId,
                        encodedSoopType: item.occurrence.encodedSoopType,
                        anchorDate : item.start,
                        soopType: item.occurrence.soopType,
                        planType: vm.planType,
                    }
                }
            });
        }

        function updateObservationViaDialog(observation, startDate, endDate, cut) {
            $uibModal.open({
                templateUrl: 'app/entities/planning/planning-dialog.html',
                controller: 'PlanningDialogController',
                controllerAs: 'vm',
                size: 'lg',
                backdrop: 'static',
                resolve: {
                    entity: vm.planning,
                    parameters: {
                        planType: vm.planType,
                        action: 'Update',
                        cut: cut,
                        experiment: observation.experiment,
                        module: observation.module,
                        id: vm.planning.label,
                        start: startDate,
                        end: endDate,
                        observation: observation.name,
                        occurrence: observation,
                        locked: (vm.isLocked || vm.isVersion)
                    }

                }
            });
        }

        function updateEventViaDialog(occurrence, startDate, endDate, cut) {
            $uibModal.open({
                templateUrl: 'app/entities/planning/planning-event-dialog.html',
                controller: 'PlanningEventDialogController',
                controllerAs: 'vm',
                size: 'lg',
                backdrop: 'static',
                resolve: {
                    entity: vm.planning,
                    parameters: {
                        action: 'Update',
                        cut: cut,
                        id: vm.planning.label,
                        occurrence: occurrence,
                        startDate: startDate,
                        endDate: endDate,
                        locked: (vm.isLocked || vm.isVersion)
                    }

                }
            });
        }
        function manageUsers() {
            $uibModal.open({
                templateUrl: 'app/entities/planning/manage-users.html',
                controller: 'ManageUsersController',
                controllerAs: 'vm',
                size: 'lg',
                backdrop: 'static',
                resolve: {
                    entity: vm.planning,
                    parameters: {
                        planType: vm.planType,
                    }
                }
            });
        }
        function doInsertPlanTemplateAtTime(time) {
            $uibModal.open({
                templateUrl: 'app/entities/planning/insert-template.html',
                controller: 'InsertTemplateController',
                controllerAs: 'vm',
                size: 'md',
                backdrop: 'static',
                resolve: {
                    entity: vm.planning,
                    parameters: {
                        planType: vm.planType,
                        anchorTime: time,
                    }
                }
            });
        }

        function doCreateSOOPFromTimeLine(occurrences) {
            $uibModal.open({
                templateUrl: 'app/entities/planning/create-soop-from-timeline.html',
                controller: 'CreateSOOPController',
                controllerAs: 'vm',
                size: 'lg',
                backdrop: 'static',
                resolve: {
                    entity: vm.planning,
                    parameters: {
                        planLabel: vm.planning.label,
                        planType: vm.planType,
                        obsDefLabel: vm.planning.observationDefinitions.label,
                        occurrences: occurrences
                    }
                }
            });
        }

        function setEfecsVersion() {
            $uibModal.open({
                templateUrl: 'app/entities/planning/set-efecs-version.html',
                controller: 'SetEfecsVersionController',
                controllerAs: 'vm',
                size: 'md',
                backdrop: 'static',
                resolve: {
                    parameters: {
                        label: vm.planning.label,
                        currentVersion: vm.planning.efecsVersion,
                        prime: vm.planning.prime,
                    }
                }
            });
        }

        function insertPlan() {
            $uibModal.open({
                templateUrl: 'app/entities/planning/insert-plan.html',
                controller: 'InsertPlanController',
                controllerAs: 'vm',
                size: 'md',
                backdrop: 'static',
                resolve: {
                    parameters: {
                        obsDefLabel: vm.planning.observationDefinitions.label,
                        label: vm.planning.label,
                        planType: vm.planType,
                        internalVersion: vm.planning.internalVersion
                    }
                }
            });
        }
        function insertSOCEvents() {
            $uibModal.open({
                templateUrl: 'app/entities/planning/insert-soc-events-in-plan.html',
                controller: 'InsertSOCEventsPlanController',
                controllerAs: 'vm',
                size: 'md',
                backdrop: 'static',
                resolve: {
                    parameters: {
                        obsDefLabel: vm.planning.observationDefinitions.label,
                        label: vm.planning.label,
                        planType: vm.planType,
                        internalVersion: vm.planning.internalVersion
                    }
                }
            });
        }
        function doInsertSoopTemplateAtTime(time) {
            $uibModal.open({
                templateUrl: 'app/entities/planning/insert-soop-template.html',
                controller: 'InsertSoopTemplateController',
                controllerAs: 'vm',
                size: 'md',
                backdrop: 'static',
                resolve: {
                    entity: vm.planning,
                    parameters: {
                        planType: vm.planType,
                        anchorTime: time,
                        obsDefLabel: vm.planning.observationDefinitions.label
                    }
                }
            });
        }
        function doChangeMetisCompatibilityAtStartTime(startTime, endTime) {
            $uibModal.open({
                templateUrl: 'app/entities/planning/change-metis-compatibility.html',
                controller: 'ChangeMetisCompabilityController',
                controllerAs: 'vm',
                size: 'md',
                backdrop: 'static',
                resolve: {
                    entity: vm.planning,
                    parameters: {
                        action: 'Update',
                        planType: vm.planType,
                        id: vm.planning.label,
                        startTime: startTime,
                        endTime: endTime,
                    }

                }
            });
        }

        function moveSoop(occurrence, newStartTime, cut) {
            $uibModal.open({
                templateUrl: 'app/entities/planning/move-soop.html',
                controller: 'MoveSoopController',
                controllerAs: 'vm',
                size: 'lg',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    entity: vm.planning,
                    parameters: {
                        planLabel: vm.planning.label,
                        soopInstanceId:  occurrence.soopInstanceId,
                        encodedSoopType: occurrence.encodedSoopType,
                        soopType: occurrence.soopType,
                        anchorDate : newStartTime,
                        planType: vm.planType,
                        cut: cut
                    }
                }
            });
        }

        function moveObs(observations, newStartTime, cut) {
            $uibModal.open({
                templateUrl: 'app/entities/planning/move-obs.html',
                controller: 'MoveObsController',
                controllerAs: 'vm',
                size: 'lg',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    entity: vm.planning,
                    parameters: {
                        planLabel: vm.planning.label,
                        anchorDate : newStartTime,
                        planType: vm.planType,
                        observations: observations,
                        cut: cut
                    }
                }
            });
        }

        function moveEvents(events, newStartTime, cut) {
            $uibModal.open({
                templateUrl: 'app/entities/planning/move-events.html',
                controller: 'MoveEventsController',
                controllerAs: 'vm',
                size: 'lg',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    entity: vm.planning,
                    parameters: {
                        planLabel: vm.planning.label,
                        anchorDate : newStartTime,
                        planType: vm.planType,
                        events: events,
                        cut: cut
                    }
                }
            });
        }

        function addObservation(item) {
            $uibModal.open({
                templateUrl: 'app/entities/planning/planning-dialog.html',
                controller: 'PlanningDialogController',
                controllerAs: 'vm',
                size: 'lg',
                backdrop: 'static',
                resolve: {
                    entity: vm.planning,
                    parameters: {
                        planType: vm.planType,
                        action: 'Create',
                        group: item.group,
                        start: item.start,
                        version: vm.planning.version,
                        id: vm.planning.label,
                        locked: (vm.isLocked || vm.isVersion)
                    }
                }
            });
        }

        function addEvent(item) {
            $uibModal.open({
                templateUrl: 'app/entities/planning/planning-event-dialog.html',
                controller: 'PlanningEventDialogController',
                controllerAs: 'vm',
                size: 'lg',
                backdrop: 'static',
                resolve: {
                    entity: vm.planning,
                    parameters: {
                        action: 'Create',
                        group: item.group,
                        start: item.start,
                        version: vm.planning.version,
                        id: vm.planning.label,
                        locked: (vm.isLocked || vm.isVersion)
                    }
                }
            });
        }


    }
})();

(function () {
        'use strict';

        angular.module('soopkitchenApp').controller('PlanningDetailController', PlanningDetailController);
        PlanningDetailController.$inject = ['PlanningDetailOpenDialogService', 'ObservationDefinitions', 'EventCollections', 'PlanningDetailService', 'SoopService', 'ObsService', 'EventsService',
            '$scope', '$window', '$stateParams', '$state', 'previousState', 'entity',
            'Planning', '$uibModal', 'AlertService', 'AutomaticEventService', '$cookies',
            'SoopkitchenUtils', '$timeout', '$document', '$sce', 'PlanningEventsService',
            'PlanTypes', '$http', 'Principal'];

        function PlanningDetailController(PlanningDetailOpenDialogService, ObservationDefinitions, EventCollections, PlanningDetailService, SoopService, ObsService, EventsService,
                                          $scope, $window, $stateParams, $state, previousState, entity,
                                          Planning, $uibModal, AlertService, AutomaticEventService, $cookies,
                                          SoopkitchenUtils, $timeout, $document, $sce, PlanningEventsService, PlanTypes, $http, Principal) {

            var vm = this;
            PlanningDetailService.setController(this);
            PlanningDetailOpenDialogService.setController(this);
            vm.planType = $stateParams.planType;

            vm.isMaster = vm.planType == PlanTypes['master'];
            vm.isChild = vm.planType == PlanTypes['child'];
            vm.isTemplate = vm.planType == PlanTypes['template'];
            vm.isSoop = vm.planType == PlanTypes['soop'];
            vm.isTimelineWithNoDates = vm.isTemplate || vm.isSoop;
            vm.hasSoops = vm.isMaster || vm.isChild;

            /** ** Constants *** */
            var IN_SITU_INSTRUMENTS = ['EPD', 'MAG', 'RPW', 'SWA'];
            var REMOTE_SENSING_INSTRUMENTS = ['EUI', 'Metis', 'PHI', 'SPICE', 'STIX', 'SoloHI'];

            /** ** Properties *** */
            vm.changeEvCollecVisible = false;
            vm.changeObsDefVisible = false;
            vm.changeParentVisible = false;
            vm.planning = entity;

            vm.observationsPerInstrument = vm.planning.observationDefinitions.allExperimentsObservationDefinitions;
            vm.status = AutomaticEventService.getStatus(vm.planning.automaticEventStatus);
            if (vm.isMaster) {
                vm.moreInfo = $sce.trustAsHtml('Event Schema: <b><span id="schemaName">' + vm.planning.schemaName
                    + '</span></b><br>' + 'Schema Version: <b><span id="schemaVersion">' + vm.planning.schemaVersion
                    + '</span></b><br>' + 'Plan Profile: <b><span id="planProfile">' + vm.planning.presentationProfile
                    + '</span></b><br>' + 'Plan Limit Start: <b><span id="planLimitStart">' + vm.planning.validityStartTime
                    + '</span></b><br>' + 'Plan Limit End: <b><span id="planLimitEnd">' + vm.planning.validityEndTime
                    + '</span></b><br>' + 'Events Start: <b><span id="eventsStart">'
                    + vm.planning.eventCollections.validityStartTime + '</span></b><br>' + 'Events End: <b><span id="eventsEnd">'
                    + vm.planning.eventCollections.validityEndTime + '</span></b>');
            }

            vm.showPlanToImport = false;
            vm.selectedPlanToImport = "";
            vm.rsInstruments = REMOTE_SENSING_INSTRUMENTS;
            vm.isInstruments = IN_SITU_INSTRUMENTS;
            vm.instruments = REMOTE_SENSING_INSTRUMENTS.concat(IN_SITU_INSTRUMENTS);
            vm.previousState = previousState;
            vm.checkedValue = {};
            vm.isVersion = $stateParams.internalVersion > 0;
            vm.showDelta = {};
            vm.isLockedColor = "white";
            vm.picker = {date: ''};
            vm.picker2 = {date: ''};
            vm.pickerPoint1 = {date: ''};
            vm.pickerPoint2 = {date: ''};
            vm.duration = 0;
            vm.durationLetters = null;
            vm.checkedAll = false;
            vm.isEfecs = vm.planning.schemaName == "e-fecs";

            /* Methods */
            vm.submitNewEvCollection = PlanningDetailService.submitNewEvCollection;
            vm.submitNewObsDef = PlanningDetailService.submitNewObsDef;
            vm.soopify = PlanningDetailService.soopify;
            vm.unsoopify = PlanningDetailService.unsoopify;
            vm.openProfile = PlanningDetailService.openProfile;
            vm.updateDuration = PlanningDetailService.updateDuration;
            vm.applyWidth = PlanningDetailService.applyWidth;
            vm.applyPoints = PlanningDetailService.applyPoints;
            vm.updateLetters = PlanningDetailService.updateLetters;
            vm.durationLettersInvalid = PlanningDetailService.durationLettersInvalid;
            vm.panic = PlanningDetailService.panic;
            vm.bookMark = PlanningDetailService.bookMark;
            vm.saveBaseline = PlanningDetailService.saveBaseline;
            vm.updateEndDate = PlanningDetailService.updateEndDate;
            vm.invalidateDateRange = PlanningDetailService.invalidateDateRange;
            vm.unlock = PlanningDetailService.unlock;
            vm.search = PlanningDetailService.search;
            vm.openAutomaticEventWindow = PlanningDetailService.openAutomaticEventWindow;
            vm.showAutomaticButton = PlanningDetailService.showAutomaticButton;
            vm.canUpdateObsDef = PlanningDetailService.canUpdateObsDef;
            vm.canUpdateParent = PlanningDetailService.canUpdateParent;
            vm.canUpdateEvents = PlanningDetailService.canUpdateEvents;
            vm.toggleCheckAll = PlanningDetailService.toggleCheckAll;
            vm.resetWidth = PlanningDetailService.resetWidth;
            vm.setValidityPeriod = PlanningDetailService.setValidityPeriod;
            vm.resetZoomedDates = PlanningDetailService.resetZoomedDates;
            vm.zoomIn = PlanningDetailService.zoomIn;
            vm.zoomOut = PlanningDetailService.zoomOut;
            vm.movePlanLeft = PlanningDetailService.movePlanLeft;
            vm.movePlanRight = PlanningDetailService.movePlanRight;
            vm.reload = PlanningDetailService.reload;
            vm.goBack = PlanningDetailService.goBack;
            vm.updateParent = PlanningDetailService.updateParent;
            vm.getPickerDate = PlanningDetailService.getPickerDate;
            vm.setPickerDate = PlanningDetailService.setPickerDate;
            vm.getPickerDate2 = PlanningDetailService.getPickerDate2;
            vm.setPickerDate2 = PlanningDetailService.setPickerDate2;
            vm.getPickerPoint1 = PlanningDetailService.getPickerPoint1;
            vm.getPickerPoint2 = PlanningDetailService.getPickerPoint2;

            var soopsGroup = 'SOOPs';

            /** ** Main *** */
            vm.planToImport = [];
            findPlansToImport();
            // var options = null;
            vm.dateRange = getDateRange();
            vm.duration = (Date.parse(vm.getPickerDate2()) - Date.parse(vm.getPickerDate())) / 1000;
            vm.durationLetters = SoopkitchenUtils.secondsToTime(vm.duration);

            vm.isValidDate = SoopkitchenUtils.isValidDate;
            vm.findPlansToImport = findPlansToImport;
            vm.importPlan = importPlan;
            vm.manageUsers = PlanningDetailOpenDialogService.manageUsers;
            vm.insertPlan = PlanningDetailOpenDialogService.insertPlan;
            vm.setEfecsVersion = PlanningDetailOpenDialogService.setEfecsVersion;
            vm.insertSOCEvents = PlanningDetailOpenDialogService.insertSOCEvents;
            vm.expandEvents = expandEvents;
            vm.canImport = canImport;
            vm.openContextMenu = openContextMenu;
            vm.rightClickAction = rightClickAction;

            //Events

            $document.click(function (e) {
                e.stopPropagation();
                closeContextMenu();
            });

            $scope.$on("updateList", function (e, a) {
                PlanningDetailService.resetZoomedDates();
                PlanningDetailService.resetScroll();
                reloadPlan(a.newOccurrance, a.data);
            });

            $scope.$on("cancelMovement", function () {
                reloadPlan();
            });

            generatePage();

            /** ** Auxiliary Functions *** */

            function failure(response) {
                SoopkitchenUtils.prettyError(response);
            }

            function successLoadLatestPlanLabels(data) {
                vm.parentPlans = [];
                vm.parentPlans.push("");
                for (var i = 0; i < data.length; i++) {
                    if (vm.planning.parentLabel !== data[i].label) {
                        vm.parentPlans.push(data[i].label);
                    }
                }
                vm.selectedNewParentLabel = vm.parentPlans[0];
            }

            function successLoadObservationDefinitions(response) {
                if (response.data) {
                    var data = angular.isArray(response.data) ? response.data : angular.fromJson(response.data);
                    var sortedData = SoopkitchenUtils.sort(data, 'timestamp', true);
                    vm.observationDefinitions = [];
                    vm.observationDefinitions.push("");
                    sortedData.forEach(function (item) {
                        if (vm.planning.observationDefinitions.label !== item.label) {
                            vm.observationDefinitions.push(item.label);
                        }
                    });
                    vm.selectedNewObservationDefinitions = vm.observationDefinitions[0];
                }
            }

            function successLoadEventCollections(response) {
                if (response.data) {
                    var data = angular.isArray(response.data) ? response.data : angular.fromJson(response.data);
                    var sortedData = SoopkitchenUtils.sort(data, 'timestamp', true);
                    vm.eventCollections = [];
                    vm.eventCollections.push("");
                    sortedData.forEach(function (item) {
                        if (vm.planning.eventCollections.label !== item.label) {
                            vm.eventCollections.push(item.label);
                        }
                    });
                    vm.selectedNewEventCollections = vm.eventCollections[0];
                }
            }

            function canImport() {
                return vm.planning.label !== vm.selectedPlanToImport && vm.selectedPlanToImport;
            }

            function getDateRange() {
                var earliestDate;
                var latestDate;
                if (vm.isMaster) {
                    earliestDate = vm.planning.eventCollections.validityStartTime.substring(0, 10);
                    latestDate = vm.planning.eventCollections.validityEndTime.substring(0, 10);
                } else {
                    earliestDate = vm.planning.validityStartTime.substring(0, 10);
                    latestDate = vm.planning.validityEndTime.substring(0, 10);
                }

                if ($cookies.get(PlanningDetailService.getCookiePrefix() + "earliestDate") != null && $cookies.get(PlanningDetailService.getCookiePrefix() + "latestDate")) {
                    earliestDate = $cookies.get(PlanningDetailService.getCookiePrefix() + "earliestDate");
                    latestDate = $cookies.get(PlanningDetailService.getCookiePrefix() + "latestDate");
                } else {
                    $cookies.put(PlanningDetailService.getCookiePrefix() + "earliestDate", earliestDate);
                    $cookies.put(PlanningDetailService.getCookiePrefix() + "latestDate", latestDate);
                }

                vm.setPickerDate(earliestDate.substring(0, 10));
                vm.setPickerDate2(latestDate.substring(0, 10));

                return [earliestDate, latestDate];
            }

            function reloadPlan(newOccurrence, data) {
                if (data != null) {
                    PlanningDetailService.createTimeLine(data, newOccurrence, vm.checkedValue);

                } else {
                    Planning.get(
                        {
                            planType: vm.planType,
                            id: vm.planning.label
                        },
                        function successCallback(data) {
                            PlanningDetailService.createTimeLine(data, newOccurrence, vm.checkedValue);
                        },
                        function errorCallback(data) {
                        }
                    )
                }
            }

            function findPlansToImport() {
                vm.planToImport = [];
                vm.planToImport.push("");

                if (vm.isTimelineWithNoDates) {

                    Planning.getAllLatestPlans(
                        {
                            planType: PlanTypes['template']
                        },
                        function onSuccess(data, headers) {
                            for (var i = 0; i < data.length; i++) {
                                if (vm.planning.observationDefinitions.label === data[i].observationDefinitionsLabel && vm.planning.label !== data[i].label) {
                                    vm.planToImport.push(data[i].label);
                                }
                            }
                        },
                        function errorCallback(error) {
                        }
                    );
                }
            }


            function importPlan() {
                Planning.importTemplate(
                    {
                        planType: vm.planType,
                        planLabel: vm.planning.label,
                        importLabel: vm.selectedPlanToImport,
                    },
                    function successCallback(data) {
                        SoopkitchenUtils.invokeSweetAlert("Nice!", "You have imported all observation instances from " + vm.selectedPlanToImport, "success");
                        reloadPlan(null, data);
                    }, function errorCallback(response) {
                        SoopkitchenUtils.prettyError(response);
                    }
                );
            }

            function expandEvents() {
                $http({
                    method: 'PUT',
                    url: 'api/plan/event/expand?planLabel=' + vm.planning.label
                }).then(function success(response) {
                    SoopkitchenUtils.processResponse(
                        response,
                        "Events Expanded!",
                        "All possible events have been expanded",
                        function () {
                            location.reload();
                        });
                }, function error(response) {
                    SoopkitchenUtils.prettyError(response);
                });
            }

            function generatePage() {
                if (vm.isMaster) {
                    EventCollections.getEventCollections(successLoadEventCollections, failure);
                }
                ObservationDefinitions.getObservationDefinitions(successLoadObservationDefinitions, failure, vm.isMaster);
                if (vm.isChild) {
                    Planning.getAllLatestPlans({planType: PlanTypes['master']}, successLoadLatestPlanLabels, failure);
                }
                Planning.getMeta(
                    {
                        id: vm.planning.label,
                    },
                    function successCallback(response) {
                        createOptions(response.locked, vm);
                        vm.isLockedColor = isLockedColor();
                        PlanningDetailService.createTimeLine();
                    }, function errorCallback(response) {
                        SoopkitchenUtils.prettyError(response);
                    }
                )
            }

            function createOptions(isLocked, vm) {

                vm.isLocked = isLocked;
                var minDate;
                var maxDate;
                if (vm.isMaster) {
                    minDate = vm.planning.eventCollections.validityStartTime;
                    maxDate = vm.planning.eventCollections.validityEndTime;
                } else {
                    minDate = vm.planning.validityStartTime;
                    maxDate = vm.planning.validityEndTime;
                }
                vm.options = {

                    orientation: 'both',
                    multiselect: true,
                    multiselectPerGroup: true,
                    editable: true,
                    groupEditable: true,
                    groupOrder: function (a, b) {
                        return a.orderId - b.orderId;
                    },
                    stack: false,
                    stackSubgroups: true,
                    margin: {
                        item: {
                            horizontal: 0
                        }
                    },
                    moment: function (date) {
                        return vis.moment(date).utc();
                    },
                    tooltip: {
                        followMouse: false,
                        overflowMethod: 'cap'
                    },

                    min: minDate,
                    max: maxDate,
                    onMoving: function (item, callback) {
                        return false;
                    },
                    onAdd: function (item) {
                        onAddOccurrence(item);
                    },
                    onUpdate: function (item) {
                        onUpdateOccurrence(item);
                    },

                    onRemove: function (item, callback) {
                        onUpdateOccurrence(item);
                    }

                };
                if (vm.isTimelineWithNoDates) {
                    vm.options['format'] = {
                        minorLabels: {
                            weekday: 'DDD',
                            day: 'DDD',
                            week: 'DDD',
                            month: 'DDD',
                            year: 'DDD'
                        },
                        majorLabels: {
                            millisecond: 'DDD HH:mm:ss',
                            second: 'DDD HH:mm',
                            minute: 'DDD',
                            hour: 'DDD',
                            weekday: '',
                            day: '',
                            week: '',
                            month: '',
                            year: ''
                        }
                    }
                }
                return vm.options;
            }

            function isLockedColor() {
                if (vm.isLocked || vm.isVersion)
                    return "gray";
                return "white";
            }

            function onAddOccurrence(item) {
                if (vm.isLocked === false && vm.isVersion === false) {
                    var adjustedStart = new Date(item.start);
                    adjustedStart.setSeconds(0, 0);
                    item.start = adjustedStart;

                    if (PlanningDetailService.isEventGroup(item.group)) {
                        if (vm.isMaster) {
                            PlanningDetailOpenDialogService.addEvent(item);
                        }
                    } else if (!isSoopGroup(item.group)) {
                        PlanningDetailOpenDialogService.addObservation(item)
                    }
                }
            }

            function onUpdateOccurrence(item) {
                if (vm.isLocked === false && vm.isVersion === false) {
                    if (PlanningDetailService.isEventGroup(item.group)) {
                        if (vm.isMaster) {
                            PlanningDetailOpenDialogService.updateEventViaDialog(item.occurrence, item.occurrence.startDate, item.occurrence.endDate, true);
                        }
                    } else if (!isSoopGroup(item.group)) {
                        PlanningDetailOpenDialogService.updateObservationViaDialog(item.occurrence, item.occurrence.startDate, item.occurrence.endDate, true);
                    } else if (isSoopGroup(item.group)) {
                        PlanningDetailOpenDialogService.editSoop(item);
                    }
                }
            }

            vm.isSocRole = false;
            Principal.hasAnyAuthority(['ROLE_PLAN_COORDINATOR', 'ROLE_POWER_USER']).then(function (result) {
                if (result) {
                    vm.isSocRole = true;
                }
            });

            vm.hasBeenAddedToThePlan = false;
            Principal.isInUsers(vm.planning.planUserInfo.usersWithRights).then(function (result) {
                if (result) {
                    vm.hasBeenAddedToThePlan = true;
                }
            });

            vm.isPlanOwner = false;
            Principal.isUser(vm.planning.planUserInfo.owner).then(function (result) {
                if (result) {
                    vm.isPlanOwner = true;
                }
            });

            vm.isInstrumentCoordinator = false;
            Principal.hasAuthority("ROLE_INSTRUMENT_COORDINATOR").then(function (result) {
                if (result) {
                    vm.isInstrumentCoordinator = true;
                }
            });

            vm.isInstrumentCoordinatorOrMember = true;
            Principal.hasAnyAuthority("ROLE_INSTRUMENT_COORDINATOR", "ROLE_INSTRUMENT_TEAM_MEMBER").then(function (result) {
                if (result) {
                    vm.isInstrumentCoordinatorOrMember = true;
                }
            });
            vm.socEvents = [];
            PlanningEventsService.getSOCEvents(
                {},
                function successCallback(data, status, headers, config) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.forEach(function (eventName, index) {
                            vm.socEvents.push(eventName);
                        });
                    }
                },
                function errorCallback(response) {
                });
            function canDoSoopContextMenu() {
                return (vm.isMaster && (vm.isSocRole || (vm.isInstrumentCoordinator && vm.hasBeenAddedToThePlan))) ||
                    (vm.isChild && (vm.isSocRole || vm.isPlanOwner || (vm.isInstrumentCoordinatorOrMember && vm.hasBeenAddedToThePlan)));
            }

            function canDoEventContextMenu() {
                return vm.isMaster && vm.isSocRole;
            }

            function canDoObsContextMenu() {
                return (vm.isMaster && (vm.isSocRole || (vm.isInstrumentCoordinator && vm.hasBeenAddedToThePlan))) ||
                    ((vm.isSoop || vm.isTemplate || vm.isChild) && (vm.isSocRole || vm.isPlanOwner || (vm.isInstrumentCoordinatorOrMember && vm.hasBeenAddedToThePlan)));
            }

            function always() {
                return true;
            }

            vm.isThereContextMenu = false;
            vm.selectionCount = 0;
            vm.onlyObsSelection = false;
            vm.onlyEventSelection = false;
            vm.onlySoopSelection = false;
            vm.selectedOccurrences = [];
            vm.clickedVisTime = null;

            function whenOnlyEventsSelected() {
                return vm.onlyEventSelection;
            }

            function whenOnlySoopSelected() {
                return vm.onlySoopSelection;
            }

            function whenOnlyObsSelected() {
                return vm.onlyObsSelection;
            }

            function whenSelectionCountIs(nr) {
                return function () {
                    return vm.selectionCount === nr;
                }
            }
            function whenStartEndPointing() {
                return function () {
                    if (vm.selectedOccurrences.length <2){
                        return false;
                    }
                    var first =  vm.selectedOccurrences[0];
                    var last =  vm.selectedOccurrences[vm.selectedOccurrences.length-1];
                    return first.name.startsWith("POINT") && first.name!=="POINT_CENTRE" && last.name.startsWith("POINT")  && last.name!=="POINT_CENTRE" ;
                }
            }
            function whenPreviousActionIsAddToSoopActions() {
                return vm.lastMenuAction === vm.contextMenu.SELECT_OBS_TO_ADD_TO_SOOP;
            }

            function whenPreviousActionIsCopyDate() {
                return vm.lastMenuAction === vm.contextMenu.COPY_START_DATE || vm.lastMenuAction === vm.contextMenu.COPY_END_DATE;
            }

            function whenPreviousActionIsCutOrCopyEvent() {
                return vm.lastMenuAction === vm.contextMenu.CUT_EVENT || vm.lastMenuAction === vm.contextMenu.COPY_EVENT;
            }

            function whenPreviousActionIsCutOrCopySoop() {
                return vm.lastMenuAction === vm.contextMenu.CUT_SOOP || vm.lastMenuAction === vm.contextMenu.COPY_SOOP;
            }

            function whenPreviousActionIsCutOrCopyObs() {
                return vm.lastMenuAction === vm.contextMenu.CUT_OBS || vm.lastMenuAction === vm.contextMenu.COPY_OBS;
            }

            function observationsSelectedAreAttachedToSoop() {
                if (vm.selectedOccurrences.length === 0) {
                    return false;
                }
                return vm.selectedOccurrences.every(function(occ) {
                    if (!occ || !occ.compositeId || !occ.compositeId.compositeSoopIds || occ.compositeId.compositeSoopIds.length === 0) {
                        return false;
                    }
                    var soopIds = occ.compositeId.compositeSoopIds;
                    return !(soopIds.length === 1 && soopIds[0].encodedSoopType === '000');
                });
            }

            function and(f1, f2) {
                return function () {
                    return f1() && f2()
                }
            }

            function or(f1, f2) {
                return function () {
                    return f1() || f2()
                }
            }

            vm.copiedDate = null;
            vm.lastMenuAction = null;
            vm.markedOccurrences = [];

            vm.contextMenu = {
                CUT_SOOP: {
                    text: 'Cut SOOP',
                    action: markOccurrences,
                    userAccessPermitted: canDoSoopContextMenu,
                    contextPermitted: and(whenOnlySoopSelected, whenSelectionCountIs(1))
                },
                CUT_EVENT: {
                    text: 'Cut event(s)',
                    action: markOccurrences,
                    userAccessPermitted: canDoEventContextMenu,
                    contextPermitted: whenOnlyEventsSelected
                },
                CUT_OBS: {
                    text: 'Cut observation(s)',
                    action: markOccurrences,
                    userAccessPermitted: canDoObsContextMenu,
                    contextPermitted: whenOnlyObsSelected
                },
                COPY_SOOP: {
                    text: 'Copy SOOP',
                    action: markOccurrences,
                    userAccessPermitted: canDoSoopContextMenu,
                    contextPermitted: and(whenOnlySoopSelected, whenSelectionCountIs(1))
                },
                COPY_EVENT: {
                    text: 'Copy event(s)',
                    action: markOccurrences,
                    userAccessPermitted: canDoEventContextMenu,
                    contextPermitted: whenOnlyEventsSelected
                },
                COPY_OBS: {
                    text: 'Copy observation(s)',
                    action: markOccurrences,
                    userAccessPermitted: canDoObsContextMenu,
                    contextPermitted: whenOnlyObsSelected
                },
                DELETE_EVENT: {
                    text: 'Delete event(s)',
                    action: deleteEvents,
                    userAccessPermitted: canDoEventContextMenu,
                    contextPermitted: whenOnlyEventsSelected
                },
                DELETE_OBS: {
                    text: 'Delete observation(s)',
                    action: deleteObs,
                    userAccessPermitted: canDoObsContextMenu,
                    contextPermitted: whenOnlyObsSelected
                },
                COPY_START_DATE: {
                    text: 'Copy start date',
                    action: copyStartDate,
                    userAccessPermitted: always,
                    contextPermitted: whenSelectionCountIs(1)
                },
                COPY_END_DATE: {
                    text: 'Copy end date',
                    action: copyEndDate,
                    userAccessPermitted: always,
                    contextPermitted: whenSelectionCountIs(1)
                },
                PASTE_EVENTS: {
                    text: 'Paste events',
                    action: pasteEventAtClickedTime,
                    userAccessPermitted: canDoEventContextMenu,
                    contextPermitted: and(whenSelectionCountIs(0), whenPreviousActionIsCutOrCopyEvent)
                },
                PASTE_EVENT_AND_EDIT: {
                    text: 'Paste event and edit',
                    action: pasteEventAtClickedTimeAndEdit,
                    userAccessPermitted: canDoEventContextMenu,
                    contextPermitted: and(whenSelectionCountIs(0), whenPreviousActionIsCutOrCopyEvent)
                },
                PASTE_EVENT_AT_START_TIME: {
                    text: 'Paste event at start time',
                    action: pasteEventAtStartTime,
                    userAccessPermitted: canDoEventContextMenu,
                    contextPermitted: and(whenSelectionCountIs(1), whenPreviousActionIsCutOrCopyEvent)
                },
                PASTE_EVENT_AT_START_TIME_AND_EDIT: {
                    text: 'Paste event at start time and edit',
                    action: pasteEventAtStartTimeAndEdit,
                    userAccessPermitted: canDoEventContextMenu,
                    contextPermitted: and(whenSelectionCountIs(1), whenPreviousActionIsCutOrCopyEvent)
                },
                PASTE_EVENT_AT_END_TIME: {
                    text: 'Paste event at end time',
                    action: pasteEventAtEndTime,
                    userAccessPermitted: canDoEventContextMenu,
                    contextPermitted: and(whenSelectionCountIs(1), whenPreviousActionIsCutOrCopyEvent)
                },
                PASTE_EVENT_AT_END_TIME_AND_EDIT: {
                    text: 'Paste event at end time and edit',
                    action: pasteEventAtEndTimeAndEdit,
                    userAccessPermitted: canDoEventContextMenu,
                    contextPermitted: and(whenSelectionCountIs(1), whenPreviousActionIsCutOrCopyEvent)
                },
                PASTE_OBS: {
                    text: 'Paste observations',
                    action: pasteObsAtClickedTime,
                    userAccessPermitted: canDoObsContextMenu,
                    contextPermitted: and(whenSelectionCountIs(0), whenPreviousActionIsCutOrCopyObs)
                },
                PASTE_OBS_AND_EDIT: {
                    text: 'Paste observations and edit',
                    action: pasteObsAtClickedTimeAndEdit,
                    userAccessPermitted: canDoObsContextMenu,
                    contextPermitted: and(whenSelectionCountIs(0), whenPreviousActionIsCutOrCopyObs)
                },
                PASTE_OBS_AT_START_TIME: {
                    text: 'Paste observations at start time',
                    action: pasteObsAtStartTime,
                    userAccessPermitted: canDoObsContextMenu,
                    contextPermitted: and(whenSelectionCountIs(1), whenPreviousActionIsCutOrCopyObs)
                },
                PASTE_OBS_AT_START_TIME_AND_EDIT: {
                    text: 'Paste observations at start time and edit',
                    action: pasteObsAtStartTimeAndEdit,
                    userAccessPermitted: canDoObsContextMenu,
                    contextPermitted: and(whenSelectionCountIs(1), whenPreviousActionIsCutOrCopyObs)
                },
                PASTE_OBS_AT_END_TIME: {
                    text: 'Paste observations at end time',
                    action: pasteObsAtEndTime,
                    userAccessPermitted: canDoObsContextMenu,
                    contextPermitted: and(whenSelectionCountIs(1), whenPreviousActionIsCutOrCopyObs)
                },
                PASTE_OBS_AT_END_TIME_AND_EDIT: {
                    text: 'Paste observations at end time and edit',
                    action: pasteObsAtEndTimeAndEdit,
                    userAccessPermitted: canDoObsContextMenu,
                    contextPermitted: and(whenSelectionCountIs(1), whenPreviousActionIsCutOrCopyObs)
                },
                PASTE_SOOP: {
                    text: 'Paste SOOP',
                    action: pasteSoopAtClickedTime,
                    userAccessPermitted: canDoSoopContextMenu,
                    contextPermitted: and(whenSelectionCountIs(0), whenPreviousActionIsCutOrCopySoop)
                },
                PASTE_SOOP_AND_EDIT: {
                    text: 'Paste SOOP and edit',
                    action: pasteSoopAtClickedTimeAndEdit,
                    userAccessPermitted: canDoSoopContextMenu,
                    contextPermitted: and(whenSelectionCountIs(0), whenPreviousActionIsCutOrCopySoop)
                },
                PASTE_SOOP_AT_START_TIME: {
                    text: 'Paste SOOP at start time',
                    action: pasteSoopAtStartTime,
                    userAccessPermitted: canDoSoopContextMenu,
                    contextPermitted: and(whenSelectionCountIs(1), whenPreviousActionIsCutOrCopySoop)
                },
                PASTE_SOOP_AT_START_TIME_AND_EDIT: {
                    text: 'Paste SOOP at start time and edit',
                    action: pasteSoopAtStartTimeAndEdit,
                    userAccessPermitted: canDoSoopContextMenu,
                    contextPermitted: and(whenSelectionCountIs(1), whenPreviousActionIsCutOrCopySoop)
                },
                PASTE_SOOP_AT_END_TIME: {
                    text: 'Paste SOOP at end time',
                    action: pasteSoopAtEndTime,
                    userAccessPermitted: canDoSoopContextMenu,
                    contextPermitted: and(whenSelectionCountIs(1), whenPreviousActionIsCutOrCopySoop)
                },
                PASTE_SOOP_AT_END_TIME_AND_EDIT: {
                    text: 'Paste SOOP at end time and edit',
                    action: pasteSoopAtEndTimeAndEdit,
                    userAccessPermitted: canDoSoopContextMenu,
                    contextPermitted: and(whenSelectionCountIs(1), whenPreviousActionIsCutOrCopySoop)
                },
                PASTE_AS_START_DATE: {
                    text: 'Paste as start date',
                    action: pasteAsStartDate,
                    userAccessPermitted: or(and(canDoEventContextMenu, whenOnlyEventsSelected), and(canDoObsContextMenu, whenOnlyObsSelected)),
                    contextPermitted: and(whenPreviousActionIsCopyDate, whenSelectionCountIs(1))
                },
                PASTE_AS_END_DATE: {
                    text: 'Paste as end date',
                    action: pasteAsEndDate,
                    userAccessPermitted: or(and(canDoEventContextMenu, whenOnlyEventsSelected), and(canDoObsContextMenu, whenOnlyObsSelected)),
                    contextPermitted: and(whenPreviousActionIsCopyDate, whenSelectionCountIs(1))
                },
                EXTEND_UNTIL_NEXT: {
                    text: 'Extend until next',
                    action: extendUntilNext,
                    userAccessPermitted: canDoObsContextMenu,
                    contextPermitted: and(whenSelectionCountIs(1), whenOnlyObsSelected)
                },
                EXTEND_TO_PREVIOUS: {
                    text: 'Extend to previous',
                    action: extendToPrevious,
                    userAccessPermitted: canDoObsContextMenu,
                    contextPermitted: and(whenSelectionCountIs(1), whenOnlyObsSelected)
                },
                INSERT_SOOP_TEMPLATE_AT_TIME: {
                    text: 'Insert SOOP template',
                    action: insertSoopTemplateAtClickedTime,
                    userAccessPermitted: canDoSoopContextMenu,
                    contextPermitted: whenSelectionCountIs(0),
                },
                INSERT_SOOP_TEMPLATE_AT_START_TIME: {
                    text: 'Insert SOOP template at start time',
                    action: insertSoopTemplateAtStartTime,
                    userAccessPermitted: canDoSoopContextMenu,
                    contextPermitted: whenSelectionCountIs(1),
                },
                CHANGE_METIS_COMPABILITY_AT_START_TIME: {
                    text: 'Change METIS Compability for pointings at interval',
                    action: changeMetisCompatibilityAtInterval,
                    userAccessPermitted: canDoEventContextMenu,
                    contextPermitted: whenStartEndPointing(),
                },
                INSERT_SOOP_TEMPLATE_AT_END_TIME: {
                    text: 'Insert SOOP template at end time',
                    action: insertSoopTemplateAtEndTime,
                    userAccessPermitted: canDoSoopContextMenu,
                    contextPermitted: whenSelectionCountIs(1),
                },
                INSERT_PLAN_TEMPLATE_AT_TIME: {
                    text: 'Insert floating timeline',
                    action: insertPlanTemplateAtClickedTime,
                    userAccessPermitted: canDoObsContextMenu,
                    contextPermitted: whenSelectionCountIs(0),
                },
                INSERT_PLAN_TEMPLATE_AT_START_TIME: {
                    text: 'Insert floating timeline at start time',
                    action: insertPlanTemplateAtStartTime,
                    userAccessPermitted: canDoObsContextMenu,
                    contextPermitted: whenSelectionCountIs(1)
                },
                INSERT_PLAN_TEMPLATE_AT_END_TIME: {
                    text: 'Insert floating timeline at end time',
                    action: insertPlanTemplateAtEndTime,
                    userAccessPermitted: canDoObsContextMenu,
                    contextPermitted: whenSelectionCountIs(1)
                },
                SELECT_OBS_TO_ADD_TO_SOOP: {
                    text: 'Select observations for adding them to SOOP',
                    action: markOccurrences,
                    userAccessPermitted: canDoSoopContextMenu,
                    contextPermitted: whenOnlyObsSelected
                },
                CREATE_SOOP_FROM_SELECTED_OBS: {
                    text: 'Create SOOP/Floating Timeline from selection',
                    action: createSOOPFromTimeLine,
                    userAccessPermitted: canDoSoopContextMenu,
                    contextPermitted: whenOnlyObsSelected
                },
                ADD_SELECTED_OBS_TO_SOOP: {
                    text: 'Add selected observations to SOOP',
                    action: addObservationsToSOOP,
                    userAccessPermitted: canDoSoopContextMenu,
                    contextPermitted: and(whenOnlySoopSelected, and(whenSelectionCountIs(1), whenPreviousActionIsAddToSoopActions))
                },
                DETACH_FROM_SOOP: {
                    text: 'Detach selected observations from SOOP',
                    action: detachObservationsFromSOOP,
                    userAccessPermitted: canDoSoopContextMenu,
                    contextPermitted: and(whenOnlyObsSelected, observationsSelectedAreAttachedToSoop)
                },
            };

            function rightClickAction(menuItem) {
                closeContextMenu();
                menuItem.action();
                vm.lastMenuAction = menuItem;
                vm.timeline.setSelection([], {})
            }

            function markOccurrences() {
                vm.markedOccurrences = vm.selectedOccurrences;
            }

            function copyStartDate() {
                vm.copiedDate = vm.selectedOccurrences[0].startDate;
            }

            function copyEndDate() {
                vm.copiedDate = vm.selectedOccurrences[0].endDate;
            }

            function pasteEventAtEndTime() {
                pasteEvent(vm.lastMenuAction === vm.contextMenu.CUT_EVENT, false, vm.selectedOccurrences[0].endDate);
            }

            function pasteEventAtEndTimeAndEdit() {
                pasteEvent(vm.lastMenuAction === vm.contextMenu.CUT_EVENT, true, vm.selectedOccurrences[0].endDate);
            }

            function pasteEventAtStartTime() {
                pasteEvent(vm.lastMenuAction === vm.contextMenu.CUT_EVENT, false, vm.selectedOccurrences[0].startDate);
            }

            function pasteEventAtStartTimeAndEdit() {
                pasteEvent(vm.lastMenuAction === vm.contextMenu.CUT_EVENT, true, vm.selectedOccurrences[0].startDate);
            }

            function pasteEventAtClickedTime() {
                pasteEvent(vm.lastMenuAction === vm.contextMenu.CUT_EVENT, false, SoopkitchenUtils.formattedDate(vm.clickedVisTime));
            }

            function pasteEventAtClickedTimeAndEdit() {
                pasteEvent(vm.lastMenuAction === vm.contextMenu.CUT_EVENT, true, SoopkitchenUtils.formattedDate(vm.clickedVisTime));
            }

            function pasteSoopAtEndTime() {
                pasteSoop(vm.lastMenuAction === vm.contextMenu.CUT_SOOP, false, vm.selectedOccurrences[0].endDate);
            }

            function pasteSoopAtEndTimeAndEdit() {
                pasteSoop(vm.lastMenuAction === vm.contextMenu.CUT_SOOP, true, vm.selectedOccurrences[0].endDate);
            }

            function pasteSoopAtStartTime() {
                pasteSoop(vm.lastMenuAction === vm.contextMenu.CUT_SOOP, false, vm.selectedOccurrences[0].startDate);
            }

            function pasteSoopAtStartTimeAndEdit() {
                pasteSoop(vm.lastMenuAction === vm.contextMenu.CUT_SOOP, true, vm.selectedOccurrences[0].startDate);
            }

            function pasteSoopAtClickedTime() {
                pasteSoop(vm.lastMenuAction === vm.contextMenu.CUT_SOOP, false, SoopkitchenUtils.formattedDate(vm.clickedVisTime));
            }

            function pasteSoopAtClickedTimeAndEdit() {
                pasteSoop(vm.lastMenuAction === vm.contextMenu.CUT_SOOP, true, SoopkitchenUtils.formattedDate(vm.clickedVisTime));
            }

            function pasteObsAtEndTime() {
                pasteObs(vm.lastMenuAction === vm.contextMenu.CUT_OBS, false, vm.selectedOccurrences[0].endDate);
            }

            function pasteObsAtEndTimeAndEdit() {
                pasteObs(vm.lastMenuAction === vm.contextMenu.CUT_OBS, true, vm.selectedOccurrences[0].endDate);
            }

            function pasteObsAtStartTime() {
                pasteObs(vm.lastMenuAction === vm.contextMenu.CUT_OBS, false, vm.selectedOccurrences[0].startDate);
            }

            function pasteObsAtStartTimeAndEdit() {
                pasteObs(vm.lastMenuAction === vm.contextMenu.CUT_OBS, true, vm.selectedOccurrences[0].startDate);
            }

            function pasteObsAtClickedTime() {
                pasteObs(vm.lastMenuAction === vm.contextMenu.CUT_OBS, false, SoopkitchenUtils.formattedDate(vm.clickedVisTime));
            }

            function pasteObsAtClickedTimeAndEdit() {
                pasteObs(vm.lastMenuAction === vm.contextMenu.CUT_OBS, true, SoopkitchenUtils.formattedDate(vm.clickedVisTime));
            }

            function moveEndDate(occurrence, toDate) {
                var originalDurationMillis = Date.parse(occurrence.endDate) - Date.parse(occurrence.startDate);
                var endDate = new Date(new Date(Date.parse(toDate)).getTime() + originalDurationMillis);
                return SoopkitchenUtils.formattedDate(endDate);
            }

            function successCallback(response) {
                return function () {
                    SoopkitchenUtils.updatePlanFromDialog(response.data);
                }
            }

            function confirmAction(title, message, action) {
                SoopkitchenUtils.prettyConfirmHtml(title, message, function (ok) {
                    if (ok) {
                        action();
                    }
                });
            }

            function pasteSoop(cut, openUpdateMenu, date) {
                var soopInstance = vm.markedOccurrences[0];
                if (openUpdateMenu) {
                    PlanningDetailOpenDialogService.moveSoop(soopInstance, date, cut);
                } else {
                    var titlePrefix = "Copy and paste";
                    if (cut) titlePrefix = "Cut and paste";

                    var title = titlePrefix + ' SOOP:' + soopInstance.encodedSoopType + '_' + soopInstance.soopInstanceId;
                    confirmAction(title, 'Are you sure you want to ' + title, function () {
                        SoopService.moveSoop(vm.planType, vm.planning.label, soopInstance.soopInstanceId, soopInstance.encodedSoopType, soopInstance.soopType, date, cut, successCallback);
                    });
                }
            }

            function pasteObs(cut, openUpdateMenu, date) {

                var obsCount = vm.markedOccurrences.length;
                if (obsCount === 1 && openUpdateMenu) {
                    var newEndDate = moveEndDate(vm.markedOccurrences[0], date);
                    PlanningDetailOpenDialogService.updateObservationViaDialog(vm.markedOccurrences[0], date, newEndDate, cut);
                } else if (openUpdateMenu) {
                    PlanningDetailOpenDialogService.moveObs(vm.markedOccurrences, date, cut)
                } else {
                    var titlePrefix = "Copy and paste ";
                    if (cut) titlePrefix = "Cut and paste ";
                    var title = titlePrefix + vm.markedOccurrences.length + ' observations';
                    var msg = '<h4>Are you sure you want to ' + title + '</h4><hr/>';
                    msg += createObsHtmlTable(vm.markedOccurrences);
                    confirmAction(title, msg, function () {
                        ObsService.moveObs(vm.planType, vm.planning.label, vm.markedOccurrences, date, cut, successCallback);
                    });

                }
            }

            function deleteOccurrencesFunction(deleteFunction, occurrences, successMsg) {
                return function () {
                    deleteFunction(
                        {
                            planType: vm.planType,
                            planLabel: vm.planning.label
                        },
                        occurrences,
                        function successCallback(data) {
                            SoopkitchenUtils.updatePlanFromDialog(data);
                            AlertService.success(successMsg);
                        }, function (response) {
                            SoopkitchenUtils.prettyError(response);
                        }
                    );
                }
            }

            // function updateTimeLine(highlightOccurrance, data) {
            //
            //     if (highlightOccurrance) {
            //         $rootScope.$broadcast('updateList', {
            //             newOccurrance: vm.evaluatedObservation,
            //             oldOccurrance: parameters.occurrence,
            //             data: data
            //         });
            //
            //     } else {
            //         SoopkitchenUtils.updatePlanFromDialog(data);
            //         $uibModalInstance.dismiss('cancel');
            //
            //     }
            // }

            function createObsHtmlTable(obsArray) {
                var htmlTxt = '';
                htmlTxt += '<div class="table-wrapper-scroll-x table-wrapper-scroll-y">';
                htmlTxt += '<table class="jh-table table table-striped"><tbody>';
                htmlTxt += '<thead><tr>';
                htmlTxt += '<th>Instrument</th>';
                htmlTxt += '<th>Module</th>';
                htmlTxt += '<th>Name</th>';
                htmlTxt += '<th>SOOP IDs</th>';
                htmlTxt += '<th>Start Date</th>';
                htmlTxt += '</tr></thead>';
                for (var i = 0; i < obsArray.length; i++) {
                    var soopIds = '';
                    for (var j = 0; j < obsArray[i].compositeId.compositeSoopIds.length; j++) {
                        soopIds += obsArray[i].compositeId.compositeSoopIds[j].encodedSoopType + '_' +
                            obsArray[i].compositeId.compositeSoopIds[j].soopInstanceId + ', '
                    }
                    soopIds = soopIds.substring(0, soopIds.length - 2);
                    htmlTxt += '<tr>';
                    htmlTxt += '<td align="left">' + obsArray[i].experiment + '</td>';
                    htmlTxt += '<td align="left">' + obsArray[i].module + '</td>';
                    htmlTxt += '<td align="left">' + obsArray[i].name + '</td>';
                    htmlTxt += '<td align="left">' + soopIds + '</td>';
                    htmlTxt += '<td align="left">' + obsArray[i].startDate + '</td>';
                    htmlTxt += '</tr>';
                }
                htmlTxt += '</tbody></table></div>';
                return htmlTxt;
            }

            function deleteObs() {
                var title = 'Remove observations';
                var msg = '<h4>Are you sure you want to delete ' + vm.selectedOccurrences.length + ' observations</h4><hr/>';
                msg += createObsHtmlTable(vm.selectedOccurrences);
                confirmAction(title, msg, deleteOccurrencesFunction(Planning.deleteObsInstance, vm.selectedOccurrences, "Deleted Observation successfully"));
            }

            function deleteEvents() {
                var title = 'Remove events';
                var msg = '<h4>Are you sure you want to delete ' + vm.selectedOccurrences.length + ' events</h4><hr/>';
                msg += '<div class="table-wrapper-scroll-x table-wrapper-scroll-y">';
                msg += '<table class="jh-table table table-striped"><tbody>';
                msg += '<thead><tr>';
                msg += '<th>Name</th>';
                msg += '<th>Start Date</th>';
                msg += '</tr></thead>';
                for (var i = 0; i < vm.selectedOccurrences.length; i++) {
                    msg += '<tr>';
                    msg += '<td align="left">' + vm.selectedOccurrences[i].name + '</td>';
                    msg += '<td align="left">' + vm.selectedOccurrences[i].startDate + '</td>';
                    msg += '</tr>';
                    if (vm.socEvents.includes(vm.selectedOccurrences[i].name)) {
                        msg += '<tr><td colspan="2" style="color:red;">Warning: '+vm.selectedOccurrences[i].name+' is a SOC event and the expanded events will be also deleted</td></tr>';
                    }
                }
                msg += '</tbody></table></div>';
                confirmAction(title, msg, deleteOccurrencesFunction(PlanningEventsService.deleteEvent, vm.selectedOccurrences, "Deleted Events successfully"));
            }

            function pasteEvent(cut, openUpdateMenu, date) {
                var eventCount = vm.markedOccurrences.length;
                if (eventCount === 1 && openUpdateMenu) {
                    var newEndDate = moveEndDate(vm.markedOccurrences[0], date);
                    PlanningDetailOpenDialogService.updateEventViaDialog(vm.markedOccurrences[0], date, newEndDate, cut);
                } else if (openUpdateMenu) {
                    PlanningDetailOpenDialogService.moveEvents(vm.markedOccurrences, date, cut)
                } else {
                    var titlePrefix = "Copy and paste ";
                    if (cut) titlePrefix = "Cut and paste ";
                    var title = titlePrefix + vm.markedOccurrences.length + ' events';
                    confirmAction(title, 'Are you sure you want to ' + title, function () {
                        EventsService.moveEvents(vm.planType, vm.planning.label, vm.markedOccurrences, date, cut, successCallback);
                    });

                }
            }

            function pasteAsStartDate() {
                pasteDateInsideObject(true);
            }

            function pasteAsEndDate() {
                pasteDateInsideObject(false);
            }

            function pasteDateInsideObject(pasteAsStartDate) {
                var item = vm.selectedOccurrences[0];
                var itemUpdated = angular.copy(item);
                if (pasteAsStartDate) {
                    itemUpdated.startDate = vm.copiedDate;
                } else {
                    itemUpdated.endDate = vm.copiedDate;
                }
                if (SoopkitchenUtils.dateToSeconds(itemUpdated.startDate) > SoopkitchenUtils.dateToSeconds(itemUpdated.endDate)) {
                    AlertService.warning('End date must be greater than the start date. Action canceled.');
                    return;
                }

                if (vm.onlyEventSelection) {
                    // If event...
                    var eventDefinition = findEventDefinitionByName(item.originalName);
                    if (!eventDefinition.canModify) {
                        AlertService.warning('Duration cannot be modified manually. Action canceled.');
                        return;
                    }
                    updateEventInServer([item], [itemUpdated]);
                } else if (vm.onlyObsSelection) {
                    // If observation...
                    var observationDefinition = findObsDef(item.experiment, item.module, item.name);
                    if (canObservationDurationBeModified(observationDefinition)) {
                        AlertService.warning('Duration cannot be modified manually. Action canceled.');
                        return;
                    }
                    evaluateAndUpdateObservation(item, itemUpdated);
                }
            }

            function extendUntilNext() {
                extendObs(true);
            }

            function extendToPrevious() {
                extendObs(false);
            }

            function extendObs(untilNext) {
                var item = vm.selectedOccurrences[0];
                var itemUpdated = angular.copy(item);
                var observationDefinition = findObsDef(item.experiment, item.module, item.name);
                if (canObservationDurationBeModified(observationDefinition)) {
                    AlertService.warning('Duration cannot be modified manually. Action canceled.');
                    return;
                }
                var date = untilNext ? findNextObservationHappeningStartTime(item.experiment, item.module, item.endDate) :
                    findPrevObservationHappeningEndTime(item.experiment, item.module, item.startDate);
                if (date == null) {
                    AlertService.warning('No observation found.');
                } else {
                    if (untilNext) {
                        itemUpdated.endDate = date;
                    } else {
                        itemUpdated.startDate = date;
                    }
                    evaluateAndUpdateObservation(item, itemUpdated);
                }
            }

            // /////////
            // Copy/Paste functionality methods
            function openContextMenu(props) {
                createSelectionItems(props);

                $scope.visContextDropdownStyle = {
                    "z-index": "10000",
                    "position": "absolute",
                    "display": "block",
                    "left": props.pageX,
                    "top": props.pageY
                };

                $scope.visContextDropdownMenuStyle = {
                    "position": "static",
                    "font-size": "12.6px",
                    "display": "block"
                };

                $timeout(function () {
                    $scope.$apply();
                });
            }

            function closeContextMenu() {
                $scope.visContextDropdownStyle = {
                    "z-index": "10000",
                    "position": "absolute",
                    "display": "none"
                };

                $scope.visContextDropdownMenuStyle = {
                    "position": "static",
                    "font-size": "12.6px",
                    "display": "block"
                };

                $timeout(function () {
                    $scope.$apply();
                });
            }

            function createSelectionItems(props) {

                //here set what is selected
                var adjustedTime = new Date(props.time);
                adjustedTime.setSeconds(0, 0);
                vm.clickedVisTime = adjustedTime;
                var clickedVisId = props.item;
                if (clickedVisId != null && vm.timeline.getSelection().length === 0) {
                    vm.timeline.setSelection(clickedVisId, {})
                }
                vm.selectedOccurrences = getSelectedOccurrences();
                vm.selectionCount = vm.selectedOccurrences.length;

                vm.onlyObsSelection = areAllSelectedItemsOfType(vm.selectedOccurrences, 'observation');
                vm.onlyEventSelection = areAllSelectedItemsOfType(vm.selectedOccurrences, 'event');
                vm.onlySoopSelection = areAllSelectedItemsOfType(vm.selectedOccurrences, 'soop');

                vm.isThereContextMenu = false;
                var menuEntries = Object.entries(vm.contextMenu);
                for (var i = 0; i < menuEntries.length; i++) {
                    if (menuEntries[i][1].contextPermitted() && menuEntries[i][1].userAccessPermitted) {
                        vm.isThereContextMenu = true;
                    }
                }
            }

            function findPrevObservationHappeningEndTime(experiment, module, date) {
                var inputSeconds = SoopkitchenUtils.dateToSeconds(date);
                var currentMinimumDistance = Number.MAX_SAFE_INTEGER;
                var currentSelectedObs = null;
                for (var i = 0; i < vm.planning.observationInstanceTimeline.happenings.length; i++) {
                    var obsInstance = vm.planning.observationInstanceTimeline.happenings[i];
                    if ((obsInstance.experiment === experiment) && (obsInstance.module === module)) {
                        var timeDiff = inputSeconds - SoopkitchenUtils.dateToSeconds(obsInstance.endDate);
                        if ((timeDiff > 0) && (timeDiff < currentMinimumDistance)) {
                            currentMinimumDistance = timeDiff;
                            currentSelectedObs = i;
                        }
                    }
                }
                if (currentSelectedObs != null) {
                    return vm.planning.observationInstanceTimeline.happenings[currentSelectedObs].endDate;
                }
                return null;
            }

            function findNextObservationHappeningStartTime(experiment, module, date) {
                var inputSeconds = SoopkitchenUtils.dateToSeconds(date);
                var currentMinimumDistance = Number.MAX_SAFE_INTEGER;
                var currentSelectedObs = null;
                for (var i = 0; i < vm.planning.observationInstanceTimeline.happenings.length; i++) {
                    var obsInstance = vm.planning.observationInstanceTimeline.happenings[i];
                    if ((obsInstance.experiment === experiment) && (obsInstance.module === module)) {
                        var timeDiff = SoopkitchenUtils.dateToSeconds(obsInstance.startDate) - inputSeconds;
                        if ((timeDiff > 0) && (timeDiff < currentMinimumDistance)) {
                            currentMinimumDistance = timeDiff;
                            currentSelectedObs = i;
                        }
                    }
                }
                if (currentSelectedObs != null) {
                    return vm.planning.observationInstanceTimeline.happenings[currentSelectedObs].startDate;
                }
                return null;
            }

            function findObsDef(experiment, module, name) {
                return vm.observationsPerInstrument[experiment].allObservations[module][name];
            }

            function findEventDefinitionByName(eventName) {
                for (var i = 0; i < vm.planning.schema.eventDefinitions.length; i++) {
                    var eventDefinition = vm.planning.schema.eventDefinitions[i];
                    if (eventDefinition.name === eventName) {
                        return eventDefinition;
                    }
                }
                return null;
            }

            function canObservationDurationBeModified(obsDef) {
                return obsDef.duration.valueType !== 'NUMBER';
            }

            function insertSoopTemplateAtClickedTime() {
                PlanningDetailOpenDialogService.doInsertSoopTemplateAtTime(SoopkitchenUtils.formattedDate(vm.clickedVisTime));
            }

            function insertSoopTemplateAtStartTime() {
                PlanningDetailOpenDialogService.doInsertSoopTemplateAtTime(vm.selectedOccurrences[0].startDate);
            }

            function changeMetisCompatibilityAtInterval() {
                vm.selectedOccurrences.sort(function(a, b) {
                    // Assuming startDate is a Date object or a string that can be compared
                    if (a.startDate < b.startDate) {
                        return -1;
                    }
                    if (a.startDate > b.startDate) {
                        return 1;
                    }
                    return 0;
                });
                PlanningDetailOpenDialogService.doChangeMetisCompatibilityAtStartTime(vm.selectedOccurrences[0].startDate, vm.selectedOccurrences[vm.selectedOccurrences.length-1].endDate);
            }


            function insertSoopTemplateAtEndTime() {
                PlanningDetailOpenDialogService.doInsertSoopTemplateAtTime(vm.selectedOccurrences[0].endDate);
            }

            function insertPlanTemplateAtClickedTime() {
                PlanningDetailOpenDialogService.doInsertPlanTemplateAtTime(SoopkitchenUtils.formattedDate(vm.clickedVisTime));
            }

            function insertPlanTemplateAtStartTime() {
                PlanningDetailOpenDialogService.doInsertPlanTemplateAtTime(vm.selectedOccurrences[0].startDate);
            }

            function insertPlanTemplateAtEndTime() {
                PlanningDetailOpenDialogService.doInsertPlanTemplateAtTime(vm.selectedOccurrences[0].endDate);
            }

            function createSOOPFromTimeLine() {
                PlanningDetailOpenDialogService.doCreateSOOPFromTimeLine(vm.selectedOccurrences);
            }

            function doAddObsToSoop() {
                var soopInstances = vm.selectedOccurrences.map(function (soop) {
                    var rObj = {};
                    rObj[soop.encodedSoopType] = soop.soopInstanceId;
                    return rObj;
                });

                Planning.addToSoop(
                    {
                        planType: vm.planType,
                        planLabel: vm.planning.label,
                        soopInstances: soopInstances
                    },
                    vm.markedOccurrences,
                    function successCallback(data) {
                        reloadPlan(null, data);
                    }, function errorCallback(response) {
                        SoopkitchenUtils.prettyError(response);
                    }
                );
            }

            function addObservationsToSOOP() {
                var title = "Add observations to soop";
                var msg = '<h4>Are you sure you want to add the following observations to SOOP</h4><hr/>';
                msg += createObsHtmlTable(vm.markedOccurrences);
                confirmAction(title, msg, doAddObsToSoop);
            }

            function doDetachObsFromSoop() {

                var soopIdSet = new Set();
                vm.selectedOccurrences.forEach(function(obs) {
                    if (obs.compositeId && obs.compositeId.compositeSoopIds) {
                        obs.compositeId.compositeSoopIds.forEach(function(soop) {
                            if (soop.encodedSoopType !== '000') {
                                soopIdSet.add(soop.encodedSoopType + '_' + soop.soopInstanceId);
                            }
                        });
                    }
                });

                var soopInstances = Array.from(soopIdSet).map(function(soopString) {
                    var parts = soopString.split('_');
                    var rObj = {};
                    rObj[parts[0]] = parts[1];
                    return rObj;
                });

                if (soopInstances.length === 0) {
                    AlertService.warning("No SOOPs to detach from were found in the selected observations.");
                    return;
                }

                var observationsToDetach = vm.selectedOccurrences;

                Planning.detatchFromSoop(
                    {
                        planType: vm.planType,
                        planLabel: vm.planning.label,
                        soopInstances: soopInstances
                    },
                    observationsToDetach,
                    function successCallback(data) {
                        AlertService.success("Successfully detached " + observationsToDetach.length + " observation(s).");
                        reloadPlan(null, data);
                    }, function errorCallback(response) {
                        SoopkitchenUtils.prettyError(response);
                    }
                );
            }

            function detachObservationsFromSOOP() {
                var title = "Detach observations from soop";
                var msg = '<h4>Are you sure you want to detach the following observations from the SOOP</h4><hr/>';
                msg += createObsHtmlTable(vm.selectedOccurrences);
                confirmAction(title, msg, doDetachObsFromSoop);
            }

            function getSelectedOccurrences() {
                var selected = [];
                findByIDs(vm.timeline.getSelection()).forEach(function (item) {
                    selected.push(item.occurrence);
                });
                return selected;
            }

            function findByIDs(ids) {
                return vm.items.get({
                    filter: function (item) {
                        for (var i = 0; i < ids.length; i++) {
                            if (item.id === ids[i]) {
                                return true;
                            }
                        }
                        return false;
                    }
                });
            }

            function areAllSelectedItemsOfType(occurrences, type) {
                if (occurrences.length === 0) {
                    return false;
                }
                for (var i = 0; i < occurrences.length; i++) {
                    if (occurrences[i].type !== type) {
                        return false;
                    }
                }
                return true
            }

            function evaluateAndUpdateObservation(prevObservation, observation) {
                var params = {
                    "obsDefLabel": vm.planning.observationDefinitions.label,
                    "experiment": observation.experiment,
                    "obsModule": observation.module,
                    "obsName": observation.name,
                    "startTime": observation.startDate,
                    "endTime": observation.endDate,
                    "overwrittenNumberParams": observation.numberParameters,
                    "comment": observation.comment
                };
                $http({
                    method: 'POST',
                    url: 'api/obsInstance',
                    params: params
                }).then(function successCallback(response) {
                    AlertService.success("Evaluation of Observation successful");
                    updateObservationInServer([prevObservation], [response.data]);
                }, function errorCallback(response) {
                    AlertService.warning("Evaluation of Observation failed; update canceled.");
                });
            }

            function updateEventInServer(existingEvents, updatedEvents) {
                var listEvents = [];
                for (var i = 0; i < existingEvents.length; i++) {
                    listEvents.push(
                        {
                            "updatedHappening": updatedEvents[i],
                            "existingHappening": existingEvents[i]
                        }
                    );
                }

                PlanningEventsService.updateEvent(
                    {
                        planLabel: vm.planning.label
                    },
                    {"updateList": listEvents},
                    function successCallback(data) {
                        if (updatedEvents.length === 1) {
                            reloadPlan(updatedEvents[0], data);
                        } else {
                            reloadPlan(null, data);
                        }
                    }, function errorCallback(response) {
                        SoopkitchenUtils.prettyError(response);
                    });
            }

            function updateObservationInServer(existingObs, updatedObs) {
                var listObservations = [];
                for (var i = 0; i < existingObs.length; i++) {
                    listObservations.push(
                        {
                            "updatedHappening": updatedObs[i],
                            "existingHappening": existingObs[i]
                        }
                    );
                }

                Planning.updateObsInstance(
                    {
                        planType: vm.planType,
                        planLabel: vm.planning.label
                    },
                    {"updateList": listObservations},
                    function successCallback(data) {
                        if (updatedObs.length === 1) {
                            reloadPlan(updatedObs[0], data);
                        } else {
                            reloadPlan(null, data);
                        }
                    }, function errorCallback(response) {
                        SoopkitchenUtils.prettyError(response);
                    }
                );
            }

            function saveEventInServer(eventsToAdd) {
                PlanningEventsService.addEvent(
                    {
                        planType: vm.planType,
                        planLabel: vm.planning.label
                    },
                    eventsToAdd,
                    function successCallback(data) {
                        reloadPlan(eventToAdd, data);
                    }, function errorCallback(response) {
                        SoopkitchenUtils.prettyError(response);
                    }
                );
            }

            function saveObservationInServer(observationToAdd) {
                var obsList = [];
                obsList.push(observationToAdd);
                Planning.addObsInstance(
                    {
                        planType: vm.planType,
                        planLabel: vm.planning.label
                    },
                    obsList,
                    function successCallback(data) {
                        reloadPlan(observationToAdd, data);
                    }, function errorCallback(response) {
                        SoopkitchenUtils.prettyError(response);
                    }
                );
            }

            function getVisLastItemId() {
                var idsArray = vm.items.getIds();
                return idsArray[idsArray.length - 1];
            }

            function isSoopGroup(groupName) {
                if (soopsGroup === groupName) {
                    return true;
                }
                return false;
            }

        }
    }

)
();

(function () {
    'use strict';

    angular
        .module('soopkitchenApp')
        .controller('PlanningDeleteController', PlanningDeleteController);

    PlanningDeleteController.$inject = ['$rootScope', '$sce','$controller', '$uibModalInstance', 'parameters', 'Planning', 'SoopkitchenUtils'];

    function PlanningDeleteController($rootScope, $sce, $controller,$uibModalInstance, parameters, Planning, SoopkitchenUtils) {
        
        var vm = this;

        angular.extend(this, $controller('SoopkitchenDialogController', {
            "title": 'Confirm delete operation', $sce: $sce, $uibModalInstance:$uibModalInstance}));
        
        /**** Properties ****/
        vm.label = parameters.label;
        vm.planType = parameters.planType;
        vm.saveText = "Delete";

        /**** Methods ****/
        vm.save = confirmDelete;

        function confirmDelete() {
            Planning.delete(
                {
                    planType: vm.planType,
                    id: vm.label
                },
                function successCallback() {
                    SoopkitchenUtils.invokeSweetAlert('Plan Deleted', vm.label + ' has been deleted', 'success', function () {
                        $rootScope.$broadcast('deletedPlan');
                        $uibModalInstance.dismiss('cancel');
                    })
                },
                function errorCallback(response) {
                    SoopkitchenUtils.prettyError(response);
                })
        }
    }
})();

/**
 * Created by esalazar on 9/12/17.
 * Service for The Automatic Event Insertion

 */
(function() {
    'use strict';

    angular
        .module('soopkitchenApp')
        .factory('AutomaticEventService', AutomaticEventService);

    AutomaticEventService.$inject = ['PlanningEventsService', 'SoopkitchenUtils'];

    function AutomaticEventService(PlanningEventsService, SoopkitchenUtils) {

        var AUTOMATIC_EVENTS_STATUS = {

            ATT_DIST_TO_BE_APPLIED : {key: 'ATT_DIST_TO_BE_APPLIED', description: 'ATT_DIST Events',
                eventService: generateAttDist},

            EMC_PREF_NOISY_AUTO_TO_BE_APPLIED : {key: 'EMC_PREF_NOISY_AUTO_TO_BE_APPLIED', description: 'Automatic EMC_PREF_NOISY Events',
                eventService: generateAutoEmcPrefNoisy},

            EMC_PREF_NOISY_GUARANTEE_MIN_TO_BE_APPLIED:{key: 'EMC_PREF_NOISY_GUARANTEE_MIN_TO_BE_APPLIED',description: 'EMC_PREF_NOISY Events'
                , selectDates : true, hasMinimumDuration : true,
                apply: guaranteeEmcPrefNoisy, finish: finishedEmcPrefNoisy},

            EMC_MAND_QUIET_AUTO_TO_BE_APPLIED : {key: 'EMC_MAND_QUIET_AUTO_TO_BE_APPLIED',
                description: 'Automatic EMC_MAND_QUIET Events',
                eventService: generateAutoEmcMandQuiet},

            EMC_MAND_QUIET_GUARANTEE_MIN_TO_BE_APPLIED: {key: 'EMC_MAND_QUIET_GUARANTEE_MIN_TO_BE_APPLIED',description: 'EMC_MAND_QUIET Events',
                selectDates : true, hasMinimumDuration : true,  hasTimeSlot : true, hasBackupTimeSlot : true, check: guaranteeEmcMandQuietPrevious,
                apply: guaranteeEmcMandQuiet, finish: finishedEmcMandQuiet},

            IS_COORD_BURST_GUARANTEE_MIN_TO_BE_APPLIED : {key: 'IS_COORD_BURST_GUARANTEE_MIN_TO_BE_APPLIED',description: 'IS_COORD_BURST Events',
                selectDates : true, hasMinimumDuration : false,
                apply: guaranteeIsCoordBurst, finish: finishedIsCoordBurst},

            FINISHED: {key: 'FINISHED',description: 'FINISHED'}

        };

        return {
            getStatus : getStatus,
            AUTOMATIC_EVENTS_STATUS : AUTOMATIC_EVENTS_STATUS
        };

        function getStatus(key) {
            for ( var status in AUTOMATIC_EVENTS_STATUS) {
                if (AUTOMATIC_EVENTS_STATUS[status].hasOwnProperty('key') && AUTOMATIC_EVENTS_STATUS[status].key === key) {
                    return AUTOMATIC_EVENTS_STATUS[status];
                }
            }

        }

        function generateAttDist(planLabel) {
            generateAutoEvent(PlanningEventsService.generateAttDist, planLabel);
        }

        function generateAutoEmcPrefNoisy(planLabel) {
            generateAutoEvent(PlanningEventsService.generateAutoEmcPrefNoisy, planLabel);
        }

        function generateAutoEmcMandQuiet (planLabel) {
            generateAutoEvent(PlanningEventsService.generateAutoEmcMandQuiet, planLabel);

        }
        function guaranteeEmcPrefNoisy (planLabel, startTime, endTime,minDuration, windowDuration) {
            guaranteeEvent (PlanningEventsService.guaranteeEmcPrefNoisy, planLabel, startTime, endTime,minDuration, windowDuration)
        }

        function guaranteeEmcMandQuietPrevious (planLabel, startTime, endTime,minDuration, windowDuration, callback, timeSlot, backupTimeSlot) {
            guaranteeEvent (PlanningEventsService.guaranteeEmcMandQuietPrevious, planLabel, startTime, endTime,minDuration, windowDuration, callback, timeSlot, backupTimeSlot)
        }
        function guaranteeEmcMandQuiet (planLabel, startTime, endTime,minDuration, windowDuration, callback, timeSlot, backupTimeSlot, isCoordBurstAutomatic) {
            guaranteeEvent (PlanningEventsService.guaranteeEmcMandQuiet, planLabel, startTime, endTime,minDuration, windowDuration, callback, timeSlot, backupTimeSlot, isCoordBurstAutomatic)
        }
        function guaranteeIsCoordBurst (planLabel, startTime, endTime,minDuration, windowDuration) {
            guaranteeEvent (PlanningEventsService.guaranteeIsCoordBurst, planLabel, startTime, endTime,minDuration, windowDuration)
        }

        function finishedEmcPrefNoisy (planLabel) {
            finishedEvent(PlanningEventsService.finishedEmcPrefNoisy, planLabel);
        }

        function finishedIsCoordBurst (planLabel) {
            finishedEvent(PlanningEventsService.finishedIsCoordBurst, planLabel)
        }

        function finishedEmcMandQuiet (planLabel) {
            finishedEvent(PlanningEventsService.finishedEmcMandQuiet, planLabel)
        }

        function finishedEmcMandQuietPrevious (planLabel) {
            //TODO

        }
        function reloadCallback() {
            location.reload();
        }

        function errorCallback(response) {
            SoopkitchenUtils.prettyError(response, reloadCallback);
        }

        function generateAutoEvent(resourceFunction, planLabel) {
            resourceFunction(
                {
                    planLabel : planLabel
                },
                function successCallback(response) {
                    SoopkitchenUtils.invokeSweetAlert("Nice!", response.comment, "success", reloadCallback);
                },
                errorCallback);
        }

        function guaranteeEvent (resourceFunction, planLabel, startTime, endTime, minDuration, windowDuration, callback, timeSlot, backupTimeSlot, isCoordBurstAutomatic) {
            console.debug("guaranteeEvent");
            console.debug("timeSlot" + timeSlot);
            console.debug("backupTimeSlot" + backupTimeSlot );

            resourceFunction(
                {
                    planLabel : planLabel,
                    startTime : startTime,
                    endTime : endTime,
                    minDuration : minDuration,
                    windowDuration : windowDuration,
                    timeSlot :timeSlot,
                    backupTimeSlot :backupTimeSlot,
                    isCoordBurstAutomatic:isCoordBurstAutomatic
                },
                function successCallback(response) {
                    if (callback == null) {
                        SoopkitchenUtils.invokeSweetAlert("Nice!", response.comment, "success", reloadCallback);
                    } else {
                        callback(response);
                    }
                },
                errorCallback);
        }

        function finishedEvent(resourceFunction, planLabel) {
            resourceFunction(
                {
                    planLabel: planLabel
                },
                reloadCallback,
                errorCallback);
        }
    }
})();

/**
 * Created by esalazar on 9/11/17.
 * Dialog for The Automatic Event Insertion
 */
(function() {
    'use strict';

    angular
        .module('soopkitchenApp')
        .controller('PlanningAutomaticEventDialogController', PlanningAutomaticEventDialogController);

    PlanningAutomaticEventDialogController.$inject = ['$uibModalInstance', 'parameters', 'SoopkitchenUtils', '$uibModal'];

    function PlanningAutomaticEventDialogController( $uibModalInstance, parameters, SoopkitchenUtils, $uibModal) {
        var vm = this;

        vm.picker = { date: parameters.start};
        vm.picker2 = { date: parameters.end};
        vm.pickerPoint1 = { date: parameters.start};
        vm.pickerPoint2 = { date: parameters.end};
        vm.status = parameters.status;
        vm.planLabel =  parameters.id;
        vm.invalidateStartDate = false;
        vm.invalidateEndDate = false;
        vm.invalidateTimeSlot = true;
        vm.invalidateTimeSlotBackup = true;
        vm.dateField = null;
        vm.timeField = null;
        vm.separation = 24*3600;
        vm.duration = 3600;
        vm.unsuccesfulDates = null;
        vm.timeSlot = null;
        vm.backupTimeSlot = null;
        vm.isCoordBurstAutomatic = true;
        vm.checkLoader = false;

        vm.validateDate = validateDate;
        vm.validateTime = validateTime;
        vm.focusCallback = focusCallback;
        vm.focusCallbackTime = focusCallbackTime;
        vm.invalidateDateRange = invalidateDateRange;
        vm.clear = clear;
        vm.updateSeparationLetters = updateSeparationLetters;
        vm.updateSeparation = updateSeparation;
        vm.updateDurationLetters = updateDurationLetters;
        vm.updateDuration = updateDuration;
        vm.durationLettersInvalid = durationLettersInvalid;
        vm.separationLettersInvalid = separationLettersInvalid;
        vm.apply = apply;
        vm.check = check;
        vm.finish = finish;
        //initiate the date letter fields wit the default values separation = 1d and minimum duration = 1h;
        vm.updateSeparationLetters();
        vm.updateDurationLetters();

        function validateDate() {
            var isNotValid = false === SoopkitchenUtils.isValidDate(vm.dateField.value);
            if (vm.dateField.name === "startDate" ) {
                vm.invalidateStartDate = isNotValid;

            } else {
                vm.invalidateEndDate = isNotValid;
            }
        }

        function validateTime() {
            var isValid = /^([0-1]?[0-9]|2[0-4]):([0-5][0-9])(:[0-5][0-9])?$/.test(vm.timeField.value);
            var isNotValid = false === isValid;
            if (vm.timeField.name === "timeSlot" ) {
                vm.invalidateTimeSlot = isNotValid;
            } else {
                vm.invalidateTimeSlotBackup = isNotValid;
            }
        }

        function clear() {
            location.reload();
        }

        function invalidateDateRange() {
            var endDateMilliseconds = Date.parse(vm.picker2.date).valueOf();
            var startDateMilliseconds = Date.parse(vm.picker.date).valueOf();
            return startDateMilliseconds > endDateMilliseconds;
        }

        function focusCallback($event) {
            if($event.target === null) {
                return;
            }
            vm.dateField = $event.target;
        }

        function focusCallbackTime($event) {
            if($event.target === null) {
                return;
            }
            vm.timeField = $event.target;
        }

        function updateSeparation() {
            vm.separation = SoopkitchenUtils.timeToSeconds (vm.lettersSeparation);
        }

        function updateSeparationLetters() {
            vm.lettersSeparation= SoopkitchenUtils.secondsToTime(vm.separation);
        }

        function updateDuration() {
            vm.duration = SoopkitchenUtils.timeToSeconds (vm.lettersDuration);
        }

        function updateDurationLetters() {
            vm.lettersDuration= SoopkitchenUtils.secondsToTime(vm.duration);
        }

        function durationLettersInvalid  () {
            if (vm.lettersDuration === null || vm.lettersDuration === undefined) return false;
            return (SoopkitchenUtils.timeToSeconds(vm.lettersDuration) === 0 || isNaN(SoopkitchenUtils.timeToSeconds(vm.lettersDuration)));
        }

        function separationLettersInvalid  () {
            if (vm.lettersSeparation === null || vm.lettersSeparation === undefined) return false;
            return (SoopkitchenUtils.timeToSeconds(vm.lettersSeparation) === 0 || isNaN(SoopkitchenUtils.timeToSeconds(vm.lettersSeparation)));
        }

        function getDates (response) {
            vm.checkLoader = false;
            if (response.eventsTimeline.happenings.length > 0) {
                vm.unsuccesfulDates = "Following events, for " + response.eventsTimeline.happenings.length/2 + " day(s), could not be created due to conflicts: \n";
                for (var i = 0; i < response.eventsTimeline.happenings.length ; i++) {
                    vm.unsuccesfulDates += response.eventsTimeline.happenings[i].startDate + " - " + response.eventsTimeline.happenings[i].endDate  + "\n";
                }
            }
            if (vm.unsuccesfulDates != null)
                response.comment  = vm.unsuccesfulDates + response.comment;
            vm.unsuccesfulDates = response.comment;
        }

        function check() {
            console.debug(vm.timeSlot);
            vm.unsuccesfulDates = null;
            vm.checkLoader = true;
            vm.status.check(vm.planLabel, new Date(Date.parse(vm.picker.date).valueOf()), new Date(Date.parse(vm.picker2.date).valueOf()),vm.duration, vm.separation, getDates, vm.timeSlot, vm.backupTimeSlot, vm.isCoordBurstAutomatic);

        }
        function apply() {

            vm.status.apply(vm.planLabel, new Date(Date.parse(vm.picker.date).valueOf()), new Date(Date.parse(vm.picker2.date).valueOf()),vm.duration, vm.separation, null, vm.timeSlot, vm.backupTimeSlot, vm.isCoordBurstAutomatic);
        }

        function finish() {
            vm.status.finish(vm.planLabel);
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('soopkitchenApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('planning', {
            parent: 'entity',
            url: '/planning',
            data: {
                authorities: ['ROLE_INSTRUMENT_COORDINATOR', 'ROLE_INSTRUMENT_TEAM_MEMBER', 'ROLE_USER', 'ROLE_POWER_USER', 'ROLE_PLAN_COORDINATOR', 'ROLE_ADMIN'],
                pageTitle: 'Planning'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/planning/planning.html',
                    controller: 'PlanningController',
                    controllerAs: 'vm'
                }
            }
        })
        .state('planning-detail', {
            parent: 'entity',
            url: '/planning/{planType}/{id}',
            data: {
                authorities: ['ROLE_INSTRUMENT_COORDINATOR', 'ROLE_INSTRUMENT_TEAM_MEMBER', 'ROLE_USER', 'ROLE_POWER_USER', 'ROLE_PLAN_COORDINATOR', 'ROLE_ADMIN'],
                pageTitle: 'Planning Detail'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/planning/planning-detail.html',
                    controller: 'PlanningDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'Planning', function($stateParams, Planning) {
                    return Planning.get({planType: $stateParams.planType, id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'planning',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('planning.versions', {
            parent: 'entity',
            url: '/planning/versions/{planType}/{id}',
            data: {
            	authorities: ['ROLE_INSTRUMENT_COORDINATOR', 'ROLE_INSTRUMENT_TEAM_MEMBER', 'ROLE_USER', 'ROLE_POWER_USER', 'ROLE_PLAN_COORDINATOR', 'ROLE_ADMIN'],
                pageTitle: 'Planning Versions'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/planning/planning-versions.html',
                    controller: 'PlanningVersionsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'Planning', function($stateParams, Planning) {
                    return Planning.get({planType: $stateParams.planType, id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'planning',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('planning-detail-version', {
        	parent: 'entity',
            url: '/planning/{planType}/{id}/{internalVersion}',
            data: {
                authorities: ['ROLE_INSTRUMENT_COORDINATOR', 'ROLE_INSTRUMENT_TEAM_MEMBER', 'ROLE_USER', 'ROLE_POWER_USER', 'ROLE_PLAN_COORDINATOR', 'ROLE_ADMIN'],
                pageTitle: 'Planning details version'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/planning/planning-detail.html',
                    controller: 'PlanningDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'Planning', function($stateParams, Planning) {
                    return Planning.get({planType: $stateParams.planType, id : $stateParams.id, internalVersion : $stateParams.internalVersion}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'planning',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        });
    }

})();

(function () {
    'use strict';
    angular
        .module('soopkitchenApp')
        .factory('Planning', Planning);

    Planning.$inject = ['$resource'];

    function Planning($resource) {

        var baseUrl = 'api/:planType/';
        var id = ':id/';
        var internalVersion = ':internalVersion/';
        var resourceUrl = baseUrl + 'document/' + id + internalVersion;

        return $resource(
            resourceUrl,
            {
                id: '@id',
                planLabel: '@planLabel',
                newPlanLabel: '@newPlanLabel',
                planId: '@planId',
                planType: '@planType',
                parentLabel: '@parentLabel',
                duration: '@duration',
                startTime: '@startTime',
                endTime: '@endTime',
                obsDefLabel: '@obsDefLabel',
                internalVersion: '@internalVersion',
                comment: '@comment',
                eventCollectionsLabel: '@eventCollectionsLabel',
                planProfile: '@planProfile',
                eventSchema: '@eventSchema',
                planLabelToClone : '@planLabelToClone',
                internalVersionToClone : '@internalVersionToClone',
                importLabel : '@importLabel',
                anchorDate : '@anchorDate',
                usernames : '@usernames',
                soopType : '@soopType',
                leadInstrument : '@leadInstrument',
                planLabelToSoopify : '@planLabelToSoopify',
                internalVersionToSoopify : '@internalVersionToSoopify',
                planLabelToUnsoopify : '@planLabelToUnsoopify',
                internalVersionToUnsoopify : '@internalVersionToUnsoopify',
                soopInstanceId : '@soopInstanceId',
                encodedSoopType : '@encodedSoopType',
                soopInstances : '@soopInstances',
                obsInstances : '@obsInstances',
                from: '@from',
                to: '@to',
                efecsVersion: '@efecsVersion',
                prime: '@prime',
                baselineVersion: '@baselineVersion',
                status: '@status',
                dateStart: '@dateStart',
                dateEnd: '@dateEnd'

            },
            {
                'getAllStatusForPlan': {
                    method: 'GET',
                    url: 'api/plan/status-plans',
                    isArray: true
                },
                'getAllLatestPlans': {
                    method: 'GET',
                    isArray: true
                },
                'get': {
                    method: 'GET'
                },
                'delete': {
                    method: 'DELETE'
                },
                'update': {
                    method: 'PUT'
                },
                'create': {
                    method: 'POST',
                    url: baseUrl
                },
                'getAllVersions': {
                    method: 'GET',
                    isArray: true,
                    url: baseUrl + 'all/' + id
                },
                'rename' : {
                    method: 'PUT',
                    url: baseUrl + 'rename'
                },
                'updateObsDef' : {
                    method: 'PUT',
                    url: baseUrl + 'updateObsDef'
                },
                'addObsInstance': {
                    method: 'PUT',
                    url: baseUrl + 'obsInstance/add'
                },
                'deleteObsInstance': {
                    method: 'PUT',
                    url: baseUrl + 'obsInstance/delete'
                },
                'updateObsInstance': {
                    method: 'PUT',
                    url: baseUrl + 'obsInstance/update'
                },
                'bookmark': {
                    method: 'PUT',
                    url: baseUrl + 'bookmark'
                },
                'autoSlews':{
                    method: 'PUT',
                    url: baseUrl + 'autoslews'
                },
                'baseline': {
                    method: 'PUT',
                    url: baseUrl + 'baseline'
                },
                'rollback': {
                    method: 'PUT',
                    url: baseUrl + 'rollback'
                },
                'deleteVersions': {
                    method: 'PUT',
                    url: baseUrl + 'versions-delete'
                },
                'status': {
                    method: 'PUT',
                    url: baseUrl + 'status'
                },
                'lock': {
                    method: 'PUT',
                    url: baseUrl + 'lock'
                },
                'unlock': {
                    method: 'PUT',
                    url: baseUrl + 'unlock'
                },
                'getMeta': {
                    method: 'GET',
                    url: 'api/meta/' + id
                },
                'updateParent': {
                    method: 'PUT',
                    url: baseUrl + 'parent'
                },
                'clone': {
                    method: 'POST',
                    url: baseUrl + 'clone'
                },
                'importPlan': {
                    method: 'PUT',
                    url: baseUrl + 'import-plan'
                },
                'importTemplate': {
                    method: 'PUT',
                    url: baseUrl + 'import-template'
                },
                'importSoop': {
                    method: 'PUT',
                    url: baseUrl + 'import-soop'
                },
                'setUsers': {
                    method: 'PUT',
                    url: baseUrl + 'setUsers'
                },
                'getSoopTypes': {
                    method: 'GET',
                    url: 'api/soop-plan/soop-types',
                    isArray: true
                },
                'soopify' : {
                    method: 'POST',
                    url: 'api/soop-plan/soopify'
                },
                'unsoopify' : {
                    method: 'POST',
                    url: 'api/template-plan/unsoopify'
                },
                'availableSoops' : {
                    method: 'GET',
                    url: 'api/soop-plan/available-soops'
                },
                'soopsInProgress' : {
                    method: 'GET',
                    url: 'api/soop-plan/soops-in-progress'
                },
                'createSoop' : {
                    method: 'PUT',
                    url: baseUrl + 'soop-create'
                },
                'deleteSoop' : {
                    method: 'PUT',
                    url: baseUrl + 'soop-delete'
                },
                'detatchFromSoop' : {
                    method: 'PUT',
                    url: baseUrl + 'remove-soop-instance-ids'
                },
                'autonomizeFromSoop' : {
                    method: 'PUT',
                    url: baseUrl + 'add-dummy-soop-instance-id'
                },
                'addToSoop' : {
                    method: 'PUT',
                    url: baseUrl + 'add-soop-instance-ids'
                },
                'setEfecsVersion' : {
                    method: 'PUT',
                    url: 'api/plan/setEfecsVersion'
                }
            });
    }


})();

(function () {
    'use strict';

    angular
        .module('soopkitchenApp')
        .controller('PlanningController', PlanningController);

    PlanningController.$inject = ['ObservationDefinitions', 'Planning', 'EventCollections', '$scope', 'SoopkitchenUtils', '$sce', 'PlanningEventsService', 'PlanTypes', 'PlanTypesUtils', '$uibModal', 'Principal'];

    function PlanningController(ObservationDefinitions, Planning,  EventCollections, $scope, SoopkitchenUtils, $sce, PlanningEventsService, PlanTypes, PlanTypesUtils, $uibModal, Principal) {
        var vm = this;

        /**** Properties ****/
        vm.plans = [];
        vm.parentPlanLabels = [];
        vm.childPlans = [];
        vm.templatePlansBaselined = [];
        vm.templatePlansInProgress = [];
        vm.soopPlansBaselined = [];
        vm.soopPlansInProgress = [];
        vm.soopTypes = [];
        vm.allPlanStatus = [];
        vm.selectedSoopType = null;
        vm.selectedSoopLeadInstrument = null;
        vm.predicate = 'created';
        vm.reverse = true;
        vm.predicateTemplateInProgress = 'created';
        vm.predicateSoopInProgress = 'created';
        vm.reverseSoopInProgress = true;
        vm.reverseTemplateInProgress = true;
        vm.predicateSoopBaselined = 'created';
        vm.predicateTemplateBaselined = 'created';
        vm.reverseSoopBaselined = true;
        vm.reverseTemplateBaselined = true;
        vm.tabAuthorities = [];
        vm.tabAuthorities.push("ROLE_PLAN_COORDINATOR");
        vm.tabAuthorities.push("ROLE_PLAN_COORDINATOR,ROLE_INSTRUMENT_COORDINATOR,ROLE_POWER_USER");
        vm.tabAuthorities.push("ROLE_PLAN_COORDINATOR,ROLE_INSTRUMENT_TEAM_MEMBER,ROLE_INSTRUMENT_COORDINATOR,ROLE_POWER_USER");
        vm.tabAuthorities.push("ROLE_PLAN_COORDINATOR");

        vm.showDelta = {};
        vm.planStatus = {};
        vm.planStatusLabel = {};
        vm.planValidityRange = {};


        vm.planLabel = "";
        vm.planId = "";
        vm.childPlanLabel = "";
        vm.templatePlanLabel = "";
        vm.soopPlanLabel = "";
        vm.getPlanType = PlanTypesUtils.getPlanType;
        vm.templateDurationString = "";
        vm.soopDurationString = "";
        vm.moreInfo = {};
        vm.showCreateMenu = [false, false, false, false];
        vm.instruments = ['EUI', 'Metis', 'PHI', 'SPICE', 'STIX', 'SoloHI', 'EPD', 'MAG', 'RPW', 'SWA'];
        vm.isPlanCoordinator = false;
        /**** Methods ****/

        vm.createPlan = createPlan;
        vm.createChildPlan = createChildPlan;
        vm.createTemplatePlan = createTemplatePlan;
        vm.createSoopPlan = createSoopPlan;
        vm.sortPlanTable = sortPlanTable;
        vm.sortChildPlanTable = sortChildPlanTable;
        vm.sortTemplatePlanTableInProgress = sortTemplatePlanTableInProgress;
        vm.sortTemplatePlanTableBaselined = sortTemplatePlanTableBaselined;
        vm.sortSoopPlanTableInProgress = sortSoopPlanTableInProgress;
        vm.sortSoopPlanTableBaselined = sortSoopPlanTableBaselined;
        vm.formatIsoZuluDateString = SoopkitchenUtils.formatIsoZuluDateString;
        vm.loadAll = loadAll;
        vm.deletePlan = deletePlan;
        vm.renamePlan = renamePlan;
        vm.setActiveTab = setActiveTab;
        vm.changeStatus = changeStatus;
        vm.isCurrentPlan = isCurrentPlan;
        vm.isCurrentPlanStyle = isCurrentPlanStyle;


        $scope.$on("deletedPlan", function () {
            loadPage();
        });


        /**** Main ****/


        vm.activeTab = 0;
        if (localStorage.getItem('activeTab')) {
            vm.activeTab = parseInt(localStorage.getItem('activeTab'));
        }



        Principal.hasAnyAuthority(['ROLE_PLAN_COORDINATOR']).then(function (result) {
            if (result) {
                vm.isPlanCoordinator = true;
            }
        });

        loadPage();

        vm.masterPlanInfo = $sce.trustAsHtml(
            '<h4>Operational plans</h4>' +
            '<p>Operational plans are timelines of Observations and Events corresponding to an LTP cycle, or a trajectory specific MLP</p>' +
            '<p>Creation of operational plans is restricted to SOC plan coordinators</p>' +
            '<p>Operational plans must comprise an Event Collection and an Operational set of observation definitions</p>'
        );
        vm.templatePlanInfo = $sce.trustAsHtml(
            '<h4>Floating Timelines</h4>' +
            '<p>Floating timelines are draft timelines of observations. Each observation is scheduled relative to the start of the timeline. ' +
            'It can be imported into any other plan and scheduled at any reference point within the plan, as long as the observation definition sets are the same.</p>' +
            '<p>They may be imported multiple times into one plan.</p>'
        );
        vm.soopPlanInfo = $sce.trustAsHtml(
            '<h4>SOOP Templates</h4>' +
            '<p>SOOP templates are blueprints of SOOPs for instantiation into operational plans. Each observation is scheduled relative to the start of the timeline. ' +
            'It can be instantiated into any other plan and scheduled at any reference point within the plan, as long as the observation definition sets are the same.</p>' +
            '<p>They may be instantiated multiple times into one plan.</p>'
        );
        vm.childPlanInfo = $sce.trustAsHtml(
            '<h4>Child plans</h4>' +
            '<p>Child plans are to be used to create draft timelines for importing into Operational Plans</p>' +
            '<p>For the sake of compatibility, child plans inherit the validity range and events (and their respective updates) from the parent plan, however no event set is saved or exported with the child plan.</p>' +
            '<p>A child plan may be imported into other plans if there are no compatibility issues and observation definition sets are the same.</p>' +
            '<p>On import, the absolute time of the planned observation will be maintained.</p>'
        );


        /**** Auxiliary Functions ****/

        function isCurrentPlan (validityRange, status, presentationProfile) {
            var isInRange = false;
            if (validityRange != null) {
                var now = new Date().getTime();
                var start = Date.parse(validityRange[0]);
                var end = Date.parse(validityRange [1]);
                isInRange = start<now && now<end;
            }

            return presentationProfile === "Long Term Planning" && isInRange && status === vm.allPlanStatus[1];
        }

        function isCurrentPlanStyle(validityRange, status, presentationProfile) {
            if (isCurrentPlan(validityRange, status, presentationProfile)) {
                return "background-color:#98FB98";
            }
        }

        function loadPage() {
            loadObservationDefinitions();
            loadEventCollections();
            loadPlanProfiles();
            loadPlanEventSchemas();
            loadSoopTypes();
            var labels = ["label-warning", "label-info", "label-danger"];
            Planning.getAllStatusForPlan(
                {}
                , function onSuccess(data, headers) {
                    for (var i = 0; i < data.length; i++) {
                        var status = data[i];
                        vm.allPlanStatus.push(status);
                        vm.planStatusLabel[status] =  labels[i];
                    }
                    loadAll();
                });

        }

        function setActiveTab(index) {
            localStorage.setItem('activeTab', index);
            vm.activeTab = index;
        }

        function errorCallback(error) {
            SoopkitchenUtils.prettyError(error);
        }

        function deletePlan(label, type) {
            $uibModal.open({
                templateUrl: 'app/entities/planning/planning-delete-dialog.html',
                controller: 'PlanningDeleteController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    parameters: {
                        label: label,
                        planType : type
                    }
                }
            });
        }

        function renamePlan(label, type) {
            $uibModal.open({
                templateUrl: 'app/entities/planning/rename-plan.html',
                controller: 'RenamePlanController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    parameters: {
                        label: label,
                        planType : type
                    }
                }
            }).result.then(
                {},
                function(status) {
                    if (status === 'success') {
                        location.reload();
                    }
                }
            );
        }

        function changeStatus(type, label) {
            var status = vm.planStatus[label];
            Planning.status(
                {
                    planType: type,
                    planLabel: label,
                    status: status
                });
        }

        function addValidityRange(plan) {
            EventCollections.getEventCollection(plan.eventCollectionsLabel, function (response) {
                var eventCollections = response.data;
                vm.planValidityRange[plan.eventCollectionsLabel] = [eventCollections.validityStartTime , eventCollections.validityEndTime];
            }, function () {

            });
        }

        function loadAll() {

            Planning.getAllLatestPlans(
                {
                    planType: PlanTypes['master']
                },
                function onSuccess(data, headers) {
                    vm.plans = [];
                    vm.parentPlanLabels = [];
                    vm.parentPlanLabels.push("");
                    for (var i = 0; i < data.length; i++) {
                        var plan = data[i];
                        vm.plans.push(plan);
                        vm.parentPlanLabels.push(plan.label);
                        vm.showDelta[plan.label] = false;
                        vm.moreInfo[plan.label] = $sce.trustAsHtml('Event Schema: <b><span id="schemaName">' + plan.schemaName + '</span></b><br>' +
                            'Schema Version: <b><span id="schemaVersion">' + plan.schemaVersion + '</span></b><br>' +
                            'Plan Profile: <b><span id="planProfile">' + plan.presentationProfile + '</span></b>');
                        vm.planStatus[plan.label] = plan.status;
                        addValidityRange(plan);

                    }
                    vm.plans = SoopkitchenUtils.sort(vm.plans, vm.predicate, vm.reverse);


                }, errorCallback);
            Planning.getAllLatestPlans(
                {
                    planType: PlanTypes['child']
                },
                function onSuccess(data, headers) {
                    vm.childPlans = [];
                    for (var i = 0; i < data.length; i++) {
                        var plan = data[i];
                        vm.childPlans.push(plan);
                        vm.showDelta[plan.label] = false;
                        vm.planStatus[plan.label] = plan.status;
                    }
                    vm.childPlans = SoopkitchenUtils.sort(vm.childPlans, vm.predicate, vm.reverse);
                }, errorCallback);

            Planning.getAllLatestPlans(
                {
                    planType: PlanTypes['template']
                },
                function onSuccess(data, headers) {
                    vm.templatePlansBaselined = [];
                    vm.templatePlansInProgress = [];
                    for (var i = 0; i < data.length; i++) {
                        var plan = data[i];
                        vm.showDelta[plan.label] = false;
                        if (plan.baselineVersion > 0) {
                            vm.templatePlansBaselined.push(plan);
                        } else {
                            vm.templatePlansInProgress.push(plan);
                        }
                        vm.planStatus[plan.label] = plan.status;
                    }
                    vm.templatePlansBaselined = SoopkitchenUtils.sort(vm.templatePlansBaselined, vm.predicateTemplateBaselined, vm.reverseTemplateBaselined);
                    vm.templatePlansInProgress = SoopkitchenUtils.sort(vm.templatePlansInProgress, vm.predicateTemplateInProgress, vm.reverseTemplateInProgress);
                }, errorCallback);

            Planning.getAllLatestPlans(
                {
                    planType: PlanTypes['soop']
                },
                function onSuccess(data, headers) {
                    vm.soopPlansBaselined = [];
                    vm.soopPlansInProgress = [];

                    for (var i = 0; i < data.length; i++) {
                        var plan = data[i];
                        vm.showDelta[plan.label] = false;
                        if (plan.baselineVersion > 0) {
                            vm.soopPlansBaselined.push(plan);
                        } else {
                            vm.soopPlansInProgress.push(plan);
                        }
                        vm.planStatus[plan.label] = plan.status;
                    }
                    vm.soopPlansBaselined = SoopkitchenUtils.sort(vm.soopPlansBaselined, vm.predicateSoopBaselined, vm.reverseSoopBaselined);
                    vm.soopPlansInProgress = SoopkitchenUtils.sort(vm.soopPlansInProgress, vm.predicateSoopInProgress, vm.reverseSoopInProgress);
                }, errorCallback
            );
        }

        function successLoadObservationDefinitionsOperational(response) {

            if (response.data) {
                var data = angular.isArray(response.data) ? response.data : angular.fromJson(response.data);
                var sortedData = SoopkitchenUtils.sort(data, 'timestamp', true);
                vm.observationDefinitions = [];
                vm.observationDefinitions.push("");
                vm.soopObservationDefinitions = [];
                vm.soopObservationDefinitions.push("");
                sortedData.forEach(function (item) {
                    vm.observationDefinitions.push(item.label);
                    vm.soopObservationDefinitions.push(item.label);
                });
                vm.selectedObservationDefinitions = vm.observationDefinitions[0];
                vm.selectedSoopObservationDefinitions = vm.soopObservationDefinitions[0];
            }
        }

        function failure(response) {
            SoopkitchenUtils.prettyError(response);
        }

        function successLoadObservationDefinitions(response) {
            if (response.data) {
                var data = angular.isArray(response.data) ? response.data : angular.fromJson(response.data);
                var sortedData = SoopkitchenUtils.sort(data, 'timestamp', true);
                vm.templateObservationDefinitions = [];
                vm.templateObservationDefinitions.push("");
                sortedData.forEach(function (item) {
                    vm.templateObservationDefinitions.push(item.label);
                });
                vm.selectedTemplateObservationDefinitions = vm.templateObservationDefinitions[0];
            }
        }

        function loadObservationDefinitions() {
            ObservationDefinitions.getObservationDefinitions(successLoadObservationDefinitionsOperational, failure, true);
            ObservationDefinitions.getObservationDefinitions(successLoadObservationDefinitions, failure, false);
        }

        function successLoadEventCollectionLabels(response) {
            if (response.data) {
                var data = angular.isArray(response.data) ? response.data : angular.fromJson(response.data);
                var sortedData = SoopkitchenUtils.sort(data, 'timestamp', true);
                vm.eventCollections = [];
                vm.eventCollections.push("");
                sortedData.forEach(function (item) {
                    vm.eventCollections.push(item.label);
                });
                vm.selectedEventCollections = vm.eventCollections[0];
            }
        }

        function loadEventCollections() {
            EventCollections.getEventCollections(successLoadEventCollectionLabels, failure);
        }

        function loadPlanProfiles() {
            PlanningEventsService.getProfiles(
                {},
                function successCallback(data) {
                    if (data) {
                        data = angular.fromJson(data);
                        vm.planProfiles = [];
                        vm.planProfiles.push("");
                        data.forEach(function (item) {
                            vm.planProfiles.push(item);
                        });
                        vm.selectedPlanProfile = vm.planProfiles[0];
                    }
                },errorCallback)
        }

        function loadSoopTypes() {
            Planning.getSoopTypes(
                {},
                function successCallback(data) {
                    if (data) {
                        data = angular.fromJson(data);
                        vm.soopTypes = [];
                        vm.soopTypes.push("");
                        data.forEach(function (item) {
                            vm.soopTypes.push(item);
                        });
                        vm.selectedSoopType = vm.soopTypes[0];
                    }
                },errorCallback)
        }

        function loadPlanEventSchemas() {
            PlanningEventsService.getEventSchemas(
                {},
                function successCallback(data) {
                    if (data) {
                        data = angular.fromJson(data);
                        vm.eventSchemas = [];
                        vm.eventSchemas.push("");
                        data.forEach(function (item) {
                            vm.eventSchemas.push(item);
                        });
                        vm.selectedEventSchema = vm.eventSchemas[0];
                    }
                },errorCallback)
        }

        function resetPlanForm() {
            vm.showCreateMenu[0] = false;
            vm.selectedObservationDefinitions = null;
            vm.selectedEventCollections = null;
            vm.selectedPlanProfile = null;
            vm.selectedEventSchema = null;
            vm.planLabel = null;
            vm.planId = null;
        }

        function createPlan() {
            Planning.create(
                {
                    planType: PlanTypes['master'],
                    obsDefLabel: vm.selectedObservationDefinitions,
                    eventCollectionsLabel: vm.selectedEventCollections,
                    planProfile: vm.selectedPlanProfile,
                    eventSchema: vm.selectedEventSchema,
                    planLabel: vm.planLabel,
                    planId: vm.planId
                },
                function successCallback() {
                    resetPlanForm();
                    loadAll();
                },errorCallback
            );
        }

        function resetChildPlanForm() {
            vm.showCreateMenu[1] = false;
            vm.childPlanLabel = null;
            vm.selectedParentLabel = null;
        }

        function createChildPlan() {
            Planning.create(
                {
                    planType: PlanTypes['child'],
                    planLabel: vm.childPlanLabel,
                    parentLabel: vm.selectedParentLabel
                },
                function successCallback(response) {
                    resetChildPlanForm();
                    loadAll();
                }, errorCallback);
        }

        function resetTemplatePlanForm() {
            vm.showCreateMenu[2] = false;
            vm.selectedTemplateObservationDefinitions = null;
            vm.templateDurationString = null;
            vm.templatePlanLabel = null;
        }

        function createTemplatePlan() {
            Planning.create(
                {
                    planType: PlanTypes['template'],
                    obsDefLabel: vm.selectedTemplateObservationDefinitions,
                    duration: SoopkitchenUtils.timeToSeconds(vm.templateDurationString),
                    planLabel: vm.templatePlanLabel
                },
                [],
                function successCallback(response) {
                    resetTemplatePlanForm();
                    loadAll();
                }, errorCallback);
        }

        function resetSoopPlanForm() {
            vm.showCreateMenu[3] = false;
            vm.selectedSoopObservationDefinitions = null;
            vm.soopDurationString = null;
            vm.soopPlanLabel = null;
            vm.selectedSoopType = null;
            vm.selectedSoopLeadInstrument = null;
        }

        function createSoopPlan() {
            Planning.create(
                {
                    planType: PlanTypes['soop'],
                    obsDefLabel: vm.selectedSoopObservationDefinitions,
                    duration: SoopkitchenUtils.timeToSeconds(vm.soopDurationString),
                    planLabel: vm.soopPlanLabel,
                    leadInstrument: vm.selectedSoopLeadInstrument,
                    soopType: vm.selectedSoopType,
                },
                [],
                function successCallback(response) {
                    resetSoopPlanForm();
                    loadAll();
                }, errorCallback);
        }
        function sortPlanTable() {
            vm.plans = SoopkitchenUtils.sort(vm.plans, vm.predicate, vm.reverse);
            $scope.$apply();
        }

        function sortChildPlanTable() {
            vm.childPlans = SoopkitchenUtils.sort(vm.childPlans, vm.predicate, vm.reverse);
            $scope.$apply();
        }

        function sortTemplatePlanTableInProgress() {
            vm.templatePlansInProgress = SoopkitchenUtils.sort(vm.templatePlansInProgress, vm.predicateTemplateInProgress, vm.reverseTemplateInProgress);
            $scope.$apply();
        }

        function sortTemplatePlanTableBaselined() {
            vm.templatePlansBaselined = SoopkitchenUtils.sort(vm.templatePlansBaselined, vm.predicateTemplateBaselined, vm.reverseTemplateBaselined);
            $scope.$apply();
        }

        function sortSoopPlanTableInProgress() {
            vm.soopPlans = SoopkitchenUtils.sort(vm.soopPlansInProgress, vm.predicateSoopInProgress, vm.reverseSoopInProgress);
            $scope.$apply();
        }
        function sortSoopPlanTableBaselined() {
            vm.soopPlans = SoopkitchenUtils.sort(vm.soopPlansBaselined, vm.predicateSoopBaselined, vm.reverseSoopBaselined);
            $scope.$apply();
        }
    }
})();

(function () {
    'use strict';
    angular
        .module('soopkitchenApp')
        .factory('ObsService', ObsService);

    ObsService.$inject = ['SoopkitchenUtils', '$http'];

    function ObsService(SoopkitchenUtils, $http) {

        return {
            moveObs: moveObs,
        };

        function successMoveObs(observations, time, cut, extraCallback) {
            return function (response) {
                var verb = 'copied';
                if (cut) verb = 'moved';
                var title = "Observations have been " + verb;
                var msg = observations.length + " have been " + verb + " to " + time;
                SoopkitchenUtils.processResponse(
                    response,
                    title,
                    msg,
                    extraCallback(response)
                );
            }
        }

        function failureMoveObs(response) {
            SoopkitchenUtils.prettyError(response);
        }

        function moveObs(planType, planLabel, observations, anchorTime, cut, successCallback) {
            $http({
                method: 'PUT',
                url: 'api/' + planType + '/obsInstance/copy',
                params: {
                    'planLabel': planLabel,
                    'anchorDate': anchorTime,
                    'cut': cut
                },
                data: observations 
            }).then(successMoveObs(observations, anchorTime, cut, successCallback), failureMoveObs);
        }

    }
})();

(function () {
    'use strict';

    angular.module('soopkitchenApp').controller('MoveSoopController', MoveSoopController);

    MoveSoopController.$inject = ['SoopService', '$rootScope', '$controller', '$sce', '$uibModalInstance', 'entity', 'AlertService', 'parameters', 'SoopkitchenUtils'];

    function MoveSoopController(SoopService, $rootScope, $controller, $sce, $uibModalInstance, entity, AlertService, parameters, SoopkitchenUtils) {

        var vm = this;

        vm.planLabel = parameters.planLabel;
        vm.soopInstanceId = parameters.soopInstanceId;
        vm.encodedSoopType = parameters.encodedSoopType;
        vm.soopType = parameters.soopType;
        vm.anchorTime = parameters.anchorDate;
        vm.planType = parameters.planType;
        vm.cut = parameters.cut;
        
        var titlePrefix = "Copy and paste";
        if (vm.cut) titlePrefix = "Cut and paste";

        var title = titlePrefix + ' SOOP ' + vm.soopType + ': <span class="label label-info">' + vm.encodedSoopType + '_' + vm.soopInstanceId + '</span>';
        angular.extend(this, $controller('SoopkitchenDialogController',
            {"title": title, $sce: $sce, $uibModalInstance: $uibModalInstance}));

        //Overriding Properties from SoopkitchenDialogController:
        vm.saveDisabled = false;
        vm.saveText = "Apply";

        /**** Methods ****/
        vm.isValidDate = isValidDate;

        //Override Methods from SoopkitchenDialogController
        vm.save = moveSoop;
        vm.clear = clear;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function isValidDate(date) {
            if (date == null || date === '') {
                vm.saveDisabled = true;
                return false;
            }
            vm.saveDisabled = false === SoopkitchenUtils.isValidDate(date);
            return SoopkitchenUtils.isValidDate(date);
        }

        function successCallback(response) {
            return function() {
                vm.waiting = false;
                SoopkitchenUtils.updatePlanFromDialog(response.data);
                $uibModalInstance.dismiss('cancel');
            }
        }

        function extraErrorCallback() {
            vm.waiting = false;
        }

        function moveSoop() {
            vm.waiting = true;
            SoopService.moveSoop(vm.planType, vm.planLabel, vm.soopInstanceId, vm.encodedSoopType, vm.soopType, vm.anchorTime, vm.cut, successCallback, extraErrorCallback);
        }

    }
})();

(function () {
    'use strict';

    angular.module('soopkitchenApp').controller('MoveObsController', MoveObsController);

    MoveObsController.$inject = ['ObsService', '$rootScope', '$controller','$sce', '$uibModalInstance', 'entity', 'AlertService', 'parameters', 'SoopkitchenUtils'];
    
    function MoveObsController(ObsService, $rootScope, $controller, $sce, $uibModalInstance, entity, AlertService, parameters, SoopkitchenUtils) {

        var vm = this;

        /**** Properties ****/

        vm.planLabel =  parameters.planLabel;
        vm.observations =  parameters.observations;
        vm.anchorTime =  parameters.anchorDate;
        vm.planType =  parameters.planType;
        vm.cut =  parameters.cut;

        var titlePrefix = "Copy and paste ";
        if (vm.cut) titlePrefix = "Cut and paste "; 
        
        var title = titlePrefix + vm.observations.length + ' observations';
        angular.extend(this, $controller('SoopkitchenDialogController',
            {"title": title, $sce: $sce, $uibModalInstance: $uibModalInstance}));

        //Overriding Properties from SoopkitchenDialogController:
        vm.saveDisabled = false;
        vm.saveText = "Apply";

        /**** Methods ****/
        vm.isValidDate = isValidDate;

        //Override Methods from SoopkitchenDialogController
        vm.save = moveObs;
        vm.clear = clear;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function isValidDate(date) {
            if (date == null || date === '') {
                vm.saveDisabled = true;
                return false;
            }
            vm.saveDisabled = false === SoopkitchenUtils.isValidDate(date);
            return SoopkitchenUtils.isValidDate(date);
        }

        function successCallback(response) {
            return function() {
                SoopkitchenUtils.updatePlanFromDialog(response.data);
                $uibModalInstance.dismiss('cancel');
            }
        }
        
        function moveObs() {
            ObsService.moveObs(vm.planType, vm.planLabel, vm.observations, vm.anchorTime, vm.cut, successCallback);
        }    
        
    }
})();

(function () {
    'use strict';

    angular.module('soopkitchenApp').controller('MoveEventsController', MoveEventsController);

    MoveEventsController.$inject = ['EventsService', '$rootScope', '$controller','$sce', '$uibModalInstance', 'entity', 'AlertService', 'parameters', 'SoopkitchenUtils'];
    
    function MoveEventsController(EventsService, $rootScope, $controller, $sce, $uibModalInstance, entity, AlertService, parameters, SoopkitchenUtils) {

        var vm = this;

        /**** Properties ****/

        vm.planLabel =  parameters.planLabel;
        vm.events =  parameters.events;
        vm.anchorTime =  parameters.anchorDate;
        vm.planType =  parameters.planType;
        vm.cut =  parameters.cut;

        var titlePrefix = "Copy and paste ";
        if (vm.cut) titlePrefix = "Cut and paste "; 
        
        var title = titlePrefix + vm.events.length + ' events';
        angular.extend(this, $controller('SoopkitchenDialogController',
            {"title": title, $sce: $sce, $uibModalInstance: $uibModalInstance}));

        //Overriding Properties from SoopkitchenDialogController:
        vm.saveDisabled = false;
        vm.saveText = "Apply";

        /**** Methods ****/
        vm.isValidDate = isValidDate;

        //Override Methods from SoopkitchenDialogController
        vm.save = moveEvents;
        vm.clear = clear;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function isValidDate(date) {
            if (date == null || date === '') {
                vm.saveDisabled = true;
                return false;
            }
            vm.saveDisabled = false === SoopkitchenUtils.isValidDate(date);
            return SoopkitchenUtils.isValidDate(date);
        }

        function successCallback(response) {
            return function() {
                SoopkitchenUtils.updatePlanFromDialog(response.data);
                $uibModalInstance.dismiss('cancel');
            }
        }
        
        function moveEvents() {
            EventsService.moveEvents(vm.planType, vm.planLabel, vm.events, vm.anchorTime, vm.cut, successCallback);
        }    
        
    }
})();

(function () {
    'use strict';

    angular.module('soopkitchenApp').controller('ManageUsersController', ManageUsersController);

    ManageUsersController.$inject = ['$controller','$sce','$uibModalInstance', 'entity', 'parameters', 'SoopkitchenUtils', 'Planning', 'AuthServerProvider', 'PlanTypes'];

    function ManageUsersController($controller, $sce, $uibModalInstance, entity, parameters, SoopkitchenUtils, Planning, AuthServerProvider, PlanTypes) {

        var vm = this;

        var title = 'Set Users with Editing Rights for <span class="label label-info">'+entity.label+'</span>';
        angular.extend(this, $controller('SoopkitchenDialogController',
            {"title": title, $sce: $sce, $uibModalInstance:$uibModalInstance}));

        /**** Properties ****/


        vm.plan = entity;
        vm.planType = parameters.planType;
        vm.allUsers = [];

        vm.selectedUsers = vm.plan.planUserInfo.usersWithRights.sort();

        vm.isMaster = vm.planType === PlanTypes['master'];
        //Overriding Properties from SoopkitchenDialogController:
        vm.saveText = "Set";

        vm.toggleSelection = function toggleSelection(user) {
            var idx = vm.selectedUsers.indexOf(user);

            // Is currently selected
            if (idx > -1) {
                vm.selectedUsers.splice(idx, 1);
            }

            // Is newly selected
            else {
                vm.selectedUsers.push(user);
            }
        };

        vm.checkAllUsers = function checkAllUsers(planUsers, checkAllValue) {
            vm.selectedUsers = [];
            if (checkAllValue) {
                for (var i = 0; i < planUsers.length; i++) {
                    vm.selectedUsers.push(planUsers[i]);
                }
            }
        };

        /**** Methods ****/
        //Override Methods from SoopkitchenDialogController
        vm.save = setUsers;

        var authoritiesToAdd = 'ROLE_INSTRUMENT_COORDINATOR,ROLE_INSTRUMENT_TEAM_MEMBER';
        if (vm.isMaster) {
            authoritiesToAdd = 'ROLE_INSTRUMENT_COORDINATOR';
        }

        function successGetUsers(response) {
            var i;
            for (i = 0; i < response.data.length; i++) {
                vm.allUsers.push(response.data[i].login);
            }
            vm.allUsers.sort();
        }
        function failure(response) {
            SoopkitchenUtils.prettyError(response);
        }

        AuthServerProvider.getUsersByAuthority(successGetUsers,failure, authoritiesToAdd);


        function setUsers() {
            var usernames = '';
            if (vm.selectedUsers.length > 0) {
                usernames = vm.selectedUsers;
            }
            Planning.setUsers(
                {
                    planType: vm.planType,
                    usernames: usernames,
                    planLabel: vm.plan.label,
                },
                function successCallback() {
                    location.reload();
                    $uibModalInstance.dismiss('cancel');
                }, failure
            );
        }
    }
})();

(function () {
    'use strict';

    angular.module('soopkitchenApp').controller('InsertTemplateController', InsertTemplateController);

    InsertTemplateController.$inject = ['$controller','$sce','$uibModalInstance', 'entity', 'AlertService', 'parameters', 'SoopkitchenUtils', 'Planning', 'PlanTypes'];
    
    function InsertTemplateController($controller, $sce, $uibModalInstance, entity, AlertService, parameters, SoopkitchenUtils, Planning, PlanTypes) {

        var vm = this;
        var title = 'Insert a Template into Plan <span class="label label-info">'+entity.label+'</span>, Version <span\n' +
            'class="label label-info">'+entity.internalVersion+'</span>';
        angular.extend(this, $controller('SoopkitchenDialogController',
            {"title": title, $sce: $sce, $uibModalInstance:$uibModalInstance}));
        
        /**** Properties ****/

        vm.plan = entity;
        vm.planType = parameters.planType;
        vm.isTemplate = vm.planType === PlanTypes['template'];
        vm.isSoop = vm.planType === PlanTypes['soop'];
        vm.isTimelineWithNoDates = vm.isTemplate || vm.isSoop;
        if (vm.isTimelineWithNoDates) {
            vm.datePattern = null;
            vm.anchorTime = SoopkitchenUtils.timeStringElapsed(vm.plan.validityStartTime, parameters.anchorTime);
        } else {
            vm.anchorTime = parameters.anchorTime;
            vm.datePattern = "/^(\\d+d)?(\\d+h)?(\\d+m)?(\\d+s)?$/";
        }
        vm.templates = [];
        vm.selectedTemplate = null;
        
        //Overriding Properties from SoopkitchenDialogController:
        vm.saveDisabled = true;
    
        /**** Methods ****/
        //Override Methods from SoopkitchenDialogController
        vm.save = importTemplate;
        vm.isValidDate = isValidDate;
        
        Planning.getAllLatestPlans(
            {
                planType: PlanTypes['template']
            },
            function onSuccess(data) {
                for (var i = 0; i < data.length; i++) {
                    if (vm.plan.observationDefinitions.label === data[i].observationDefinitionsLabel) {
                        var baselined = true;
                        var label = data[i].label;
                        if (data[i].baselineVersion === 0) {
                            baselined = false;
                            label += ' (not baselined)'
                        } 
                        vm.templates.push({
                            label: label,
                            disabled: !baselined
                        });
                    }
                }
            });

       
        function isValidDate(date) {
            
            if (date === null || date === '') {
                vm.saveDisabled = true;
                return false;
            }

            if (vm.isTimelineWithNoDates) {
                if (isNaN(SoopkitchenUtils.timeToSeconds(date)) || SoopkitchenUtils.timeToSeconds(date) === 0) {
                    vm.saveDisabled = true;
                    return false;
                }
                date = SoopkitchenUtils.addTimeStringToDate(vm.plan.validityStartTime, date);
            }
            
            vm.saveDisabled = vm.selectedTemplate === null || (false === SoopkitchenUtils.isValidDate(date));
            return SoopkitchenUtils.isValidDate(date) ;
        }
        
        function importTemplate() {
            var time;
            if (vm.isTimelineWithNoDates) {
                time = SoopkitchenUtils.addTimeStringToDate(vm.plan.validityStartTime, vm.anchorTime);
            } else {
                time = vm.anchorTime;
            }
            Planning.importTemplate(
                {
                    planType: vm.planType,
                    planLabel: vm.plan.label,
                    importLabel: vm.selectedTemplate.label,
                    anchorDate: time
                },
                function successCallback(data) {
                    SoopkitchenUtils.updatePlanFromDialog(data);
                    $uibModalInstance.dismiss('cancel');

                }, function errorCallback(response) {
                    SoopkitchenUtils.prettyError(response);
                }
            );
        }
    }
})();

(function () {
    'use strict';

    angular.module('soopkitchenApp').controller('InsertSoopTemplateController', InsertSoopTemplateController);

    InsertSoopTemplateController.$inject = ['$controller','$sce', '$uibModalInstance', 'entity', 'AlertService', 'parameters', 'SoopkitchenUtils', 'Planning', 'PlanTypes'];

    function InsertSoopTemplateController($controller, $sce, $uibModalInstance, entity, AlertService, parameters, SoopkitchenUtils, Planning, PlanTypes) {

        var vm = this;
        var title = 'Insert a SOOP Template into Plan <span class="label label-info">'+entity.label+'</span>, Version <span\n' +
            'class="label label-info">'+entity.internalVersion+'</span>';
        angular.extend(this, $controller('SoopkitchenDialogController',
            {"title": title, $sce: $sce, $uibModalInstance:$uibModalInstance}));
        
        /**** Properties ****/
        vm.plan = entity;
        vm.planType = parameters.planType;
        vm.anchorTime = parameters.anchorTime;
        vm.obsDefLabel = parameters.obsDefLabel;
        vm.soops = {
            "ALL" : []
        };
        vm.soopTypes = [];
        vm.selectedSoop = "";
        vm.selectedType = "ALL";
        
        //Overriding Properties from SoopkitchenDialogController:
        vm.saveDisabled = true;

        /**** Methods ****/
        //Override Methods from SoopkitchenDialogController
        vm.save = importSoopTemplate;
        vm.isValidDate = isValidDate;
        
        Planning.availableSoops(
            {
                obsDefLabel: vm.obsDefLabel
            },
            function onSuccess(data) {
                extractSoops(data, false);
            },
            {}
        );
        
        Planning.soopsInProgress(
            {
                obsDefLabel: vm.obsDefLabel
            },
            function onSuccess(data) {
                extractSoops(data, true);
            },{}
        );

        vm.soops.ALL.sort();
        vm.soopTypes.splice(0, 0, "ALL");
        
        function extractSoops(data, inProgress) {
            var cleanData = angular.fromJson(angular.toJson(data));
            for (var type in cleanData) {
                if (!vm.soops.hasOwnProperty(type)) {
                    vm.soops[type] = [];
                }
                for (var i = 0; i < cleanData[type].length; i++) {
                    var soop = cleanData[type][i];
                    if (inProgress) {
                        soop += " (not baselined)";
                    }
                    var soopObject = {
                        label: soop,
                        disabled: inProgress
                    };
                    if (!vm.soopTypes.includes(type)) {
                        vm.soopTypes.push(type);
                    }
                    vm.soops[type].push(soopObject);
                    vm.soops.ALL.push(soopObject);
                }
            }
        }
        
        
        function isValidDate(date) {
            if (date === null || date === '') {
                vm.saveDisabled = true;
                return false;
            }
            vm.saveDisabled = vm.selectedSoop ==='' || (false === SoopkitchenUtils.isValidDate(date));
            return SoopkitchenUtils.isValidDate(date);
        }
        
        function importSoopTemplate() {
            var time = vm.anchorTime;
            Planning.importSoop(
                {
                    planType: vm.planType,
                    planLabel: vm.plan.label,
                    importLabel: vm.selectedSoop.label,
                    anchorDate: time
                },
                function successCallback(data) {
                    SoopkitchenUtils.updatePlanFromDialog(data);
                    $uibModalInstance.dismiss('cancel');

                }, function errorCallback(response) {
                    SoopkitchenUtils.prettyError(response);
                }
            );
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('soopkitchenApp')
        .controller('InsertSOCEventsPlanController', InsertSOCEventsPlanController);

    InsertSOCEventsPlanController.$inject = ['parameters', 'FileUploadService', 'SoopkitchenUtils',  '$scope', '$uibModalInstance', '$window'];

    function InsertSOCEventsPlanController (parameters, FileUploadService, SoopkitchenUtils, $scope, $uibModalInstance, $window) {

        var vm = this;

        /**** Properties ****/
        vm.formatIsoZuluDateString = SoopkitchenUtils.formatIsoZuluDateString;
        vm.isUploading = false;
        vm.ascending = true;
        vm.predicate = null;
        vm.uploadStrategy = 'conflicts';

        /**** Methods ****/
        vm.uploadFiles = uploadFiles;
        vm.upload = upload;
        vm.downloadPointings = downloadPointings;
        vm.close = close;

        function uploadFiles(files) {
            vm.files = files;
        }

        function successUpload(response) {
            var listPointings = [];
            response.data.eventsTimeline.happenings.forEach(function(h) {
                if (h.name.startsWith("POINT")) listPointings.push(h)});
            var text = '<div class="table-wrapper-scroll-x table-wrapper-scroll-y">';
            text += '<table class="jh-table table table-striped"><tbody>';
            listPointings.forEach(function(pointing) {

                text += '<tr>';
                text += '<td nowrap style="text-align:left;vertical-align:top">' + pointing.name + " " + pointing.startDate + "->" + pointing.endDate + "</br>"; + '</td>';
                text += '</tr>';
            })
            text += '</table></div>';
            SoopkitchenUtils.prettyConfirmHtml("Pointings in Plan (total: " +listPointings.length+ ")", text,  reloadCallback);

        }

        function failureUpload(response) {
            SoopkitchenUtils.prettyError(response, function () {
                vm.isUploading = false;
                $scope.$apply();
            });
        }

        function reloadCallback() {
            location.reload();
        }


        function upload () {
            if (vm.files && vm.files.length) {
                vm.isUploading = true;
                FileUploadService.uploadFiles(vm.files, 'api/'+ parameters.planType +'/event/add-soc-events-file?strategy=' + vm.uploadStrategy, parameters.label, successUpload,
                    failureUpload, FileUploadService.progressCallback,
                    parameters.label);
            }
        }
        function downloadPointings () {
            var url = 'api/' + parameters.planType + '/export-pointings/' + window.encodeURIComponent(parameters.label) + '/' + parameters.internalVersion;
            $window.open(url);
            $uibModalInstance.dismiss('cancel');
        }

        function close() {
            $uibModalInstance.dismiss('cancel');
        }

    }
})();

(function () {
    'use strict';

    angular.module('soopkitchenApp').controller('InsertPlanController', InsertPlanController);

    InsertPlanController.$inject = ['$controller', '$sce', '$uibModalInstance', 'AlertService', 'parameters', 'SoopkitchenUtils', 'Planning', 'PlanTypes', '$http'];

    function InsertPlanController($controller, $sce, $uibModalInstance, AlertService, parameters, SoopkitchenUtils, Planning, PlanTypes, $http) {

        var vm = this;
        var title = 'Insert a Child or <b>Operational Plan</b> into Plan <span class="label label-info">' + parameters.label + '</span>, Version <span\n' +
            'class="label label-info">' + parameters.internalVersion + '</span>';
        angular.extend(this, $controller('SoopkitchenDialogController',
            {"title": title, $sce: $sce, $uibModalInstance: $uibModalInstance}));
        /** ** Constants *** */
        var IN_SITU_INSTRUMENTS = ['EPD', 'MAG', 'RPW', 'SWA'];
        var REMOTE_SENSING_INSTRUMENTS = ['EUI', 'Metis', 'PHI', 'SPICE', 'STIX', 'SoloHI'];
        /**** Properties ****/
        vm.checkedAll = true;
        vm.planType = parameters.planType;
        vm.operationalPlanToImport = [];
        vm.childPlanToImport = [];
        vm.nonSelectedPlan = {label: '', internalVersion: 0};
        vm.operationalPlanToImport.push(vm.nonSelectedPlan);
        vm.childPlanToImport.push(vm.nonSelectedPlan);
        vm.selectedOperationalPlan = vm.nonSelectedPlan;
        vm.selectedChildPlan = vm.nonSelectedPlan;
        vm.selected = vm.nonSelectedPlan;
        vm.toTime = null;
        vm.fromTime = null;
        vm.selectedInternalVersion = 0;
        vm.maxInternalVersion = 0;
        vm.saveDisabled = true;
        vm.rsInstruments = REMOTE_SENSING_INSTRUMENTS;
        vm.isInstruments = IN_SITU_INSTRUMENTS;

        vm.calculateSaveDisabled = calculateSaveDisabled;
        vm.toggleCheckAll = toggleCheckAll;
        vm.instrumentsSelected = instrumentsSelected;
        vm.groupChange = groupChange;

        vm.checkedValue ={};
        vm.groups = createGroups();
        vm.onSelectChildPlan = function () {
            vm.selectedInternalVersion = 0;
            vm.selectedOperationalPlan = vm.nonSelectedPlan;
            vm.maxInternalVersion = vm.selectedChildPlan.internalVersion;
            vm.selected = vm.selectedChildPlan;
            calculateSaveDisabled();
        };

        vm.onSelectOperationalPlan = function () {
            vm.selectedInternalVersion = 0;
            vm.selectedChildPlan = vm.nonSelectedPlan;
            vm.maxInternalVersion = vm.selectedOperationalPlan.internalVersion;
            vm.selected = vm.selectedOperationalPlan;
            calculateSaveDisabled();
        };

        /**** Methods ****/
        //Override Methods from SoopkitchenDialogController
        vm.save = importPlan;
        vm.isValidDate = isValidDate;

        Planning.getAllLatestPlans(
            {
                planType: PlanTypes['master']
            },
            function onSuccess(data, headers) {
                for (var i = 0; i < data.length; i++) {
                    if (parameters.obsDefLabel === data[i].observationDefinitionsLabel && parameters.label !== data[i].label) {
                        vm.operationalPlanToImport.push({label: data[i].label, internalVersion: data[i].internalVersion});
                    }
                }
            },
            function errorCallback(error) {
            }
        );

        Planning.getAllLatestPlans(
            {
                planType: PlanTypes['child']
            },
            function onSuccess(data, headers) {
                for (var i = 0; i < data.length; i++) {
                    if (parameters.obsDefLabel === data[i].observationDefinitionsLabel && parameters.label !== data[i].label) {
                        vm.childPlanToImport.push({label: data[i].label, internalVersion: data[i].internalVersion});
                    }
                }
            },
            function errorCallback(error) {
            }
        );

        function isValidDate(date) {
            var isValid = true;
            if (date !== null && date !== '') {
                isValid = SoopkitchenUtils.isValidDate(date);
            }
            return isValid;
        }

        function calculateSaveDisabled() {
            vm.saveDisabled = vm.selectedOperationalPlan === vm.nonSelectedPlan && vm.selectedChildPlan === vm.nonSelectedPlan;
        }

        function successImportPlan(response) {
            SoopkitchenUtils.processResponse(
                response,
                "Plan has been imported",
                vm.selected.label + " has been imported into " + parameters.label,
                function () {
                    SoopkitchenUtils.updatePlanFromDialog(response.data);
                    $uibModalInstance.dismiss('cancel');
                }
            );
        }

        function failureImportPlan(response) {
            SoopkitchenUtils.prettyError(response);
        }



        function instrumentsSelected() {
            var listInstruments = [];
            for (var group in vm.groups) {
                if (vm.checkedValue[vm.groups[group]] === true){
                    listInstruments.push(vm.groups[group]);
                }
            }
            return listInstruments.join(',');
        }

        function importPlan() {
            if (vm.fromTime !== null && vm.fromTime.trim() === '') {
                vm.fromTime = null;
            }
            if (vm.toTime !== null && vm.toTime.trim() === '') {
                vm.toTime = null;
            }

            $http({
                method: 'PUT',
                url: 'api/' + vm.planType + '/import-plan',
                params: {
                    'planLabel': parameters.label,
                    'importLabel': vm.selected.label,
                    'from': vm.fromTime,
                    'to': vm.toTime,
                    'internalVersion': vm.selectedInternalVersion,
                    'instruments': vm.instrumentsSelected()
                }
            }).then(successImportPlan, failureImportPlan);
        }
        function toggleCheckAll() {
            vm.checkedAll = vm.checkedAll === false;
            for (var group in vm.groups) {
                 vm.checkedValue[vm.groups[group]] = vm.checkedAll;
            }
        }
        function createGroups() {
            var instruments = Array.from(REMOTE_SENSING_INSTRUMENTS.concat(IN_SITU_INSTRUMENTS));
            var groupsList = [];
            for (var i = 0; i < instruments.length; i++) {
                var group = instruments[i];
                if (vm.checkedValue[group] == null) {
                    vm.checkedValue[group] = true;
                }
            }
            return instruments;
        }
        function groupChange(group) {
            vm.checkedValue[group] = (false === vm.checkedValue[group]);
        }

    }
})();

(function () {
    'use strict';
    angular
        .module('soopkitchenApp')
        .factory('EventsService', EventsService);

    EventsService.$inject = ['SoopkitchenUtils', '$http'];

    function EventsService(SoopkitchenUtils, $http) {

        return {
            moveEvents: moveEvents,
            updateMetisCompatibility: updateMetisCompatibility
        };

        function successMoveEvents(events, time, cut, extraCallback) {
            return function (response) {
                var verb = 'copied';
                if (cut) verb = 'moved';
                var title = "Events have been " + verb;
                var msg = events.length + " have been " + verb + " to " + time;
                SoopkitchenUtils.processResponse(
                    response,
                    title,
                    msg,
                    extraCallback(response)
                );
            }
        }

        function failure(response) {
            SoopkitchenUtils.prettyError(response);
        }

        function moveEvents(planType, planLabel, events, anchorTime, cut, successCallback) {
            $http({
                method: 'PUT',
                url: 'api/' + planType + '/event/copy',
                params: {
                    'planLabel': planLabel,
                    'anchorDate': anchorTime,
                    'cut': cut
                },
                data: events
            }).then(successMoveEvents(events, anchorTime, cut, successCallback), failure);
        }

        function updateMetisCompatibility(planType, planLabel, startTime, endTime, compatibility, successCallback) {
            console.warn("updateMetisCompatibility");
            $http({
                method: 'PUT',
                url: 'api/' + planType + '/event/metis-compatibility',
                params: {
                    'planLabel': planLabel,
                    'startTime': startTime,
                    'endTime': endTime,
                    'compatibility': compatibility
                }
            }).then(successCallback, failure);
        }
    }
})();

(function () {
    'use strict';

    angular.module('soopkitchenApp').controller('EditSoopController', EditSoopController);

    EditSoopController.$inject = ['$rootScope','$sce','$controller', '$uibModalInstance', 'entity', 'parameters', 'SoopkitchenUtils', 'Planning', 'SoopService'];

    function EditSoopController($rootScope, $sce, $controller, $uibModalInstance, entity, parameters, SoopkitchenUtils, Planning, SoopService) {

        var vm = this;
        var title = 'Update SOOP' + parameters.soopType + ': <span class="label label-info">' + parameters.encodedSoopType + '_' + parameters.soopInstanceId + '</span>';
        angular.extend(this, $controller('SoopkitchenDialogController',
            {"title": title, $sce: $sce, $uibModalInstance:$uibModalInstance}));
        
        /**** Properties ****/
        vm.plan = entity;
        vm.planLabel =  parameters.planLabel;
        vm.soopInstanceId=  parameters.soopInstanceId;
        vm.encodedSoopType=  parameters.encodedSoopType;
        vm.anchorTime =  parameters.anchorDate;
        vm.planType =  parameters.planType;
        vm.soopType =  parameters.soopType;
        
        //Overriding Properties from SoopkitchenDialogController:
        vm.deleteText = "Delete";
        vm.saveDisabled = false;

        /**** Methods ****/
        vm.isValidDate = isValidDate;
        
        //Override Methods from SoopkitchenDialogController
        vm.delete = deleteSoop;
        vm.save = moveSoop;
        vm.clear = clear;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function isValidDate(date) {
            if (date === null || date    === '') {
                vm.saveDisabled = true;
                return false;
            }
            vm.saveDisabled = SoopkitchenUtils.isValidDate(date) === false;
            return SoopkitchenUtils.isValidDate(date);
        }

        function successCallback(response) {
            return function() {
                vm.waiting = false;
                SoopkitchenUtils.updatePlanFromDialog(response.data);
                $uibModalInstance.dismiss('cancel');
            }
        }

        function extraErrorCallback() {
            vm.waiting = false;
        }
        
        function moveSoop() {
            vm.waiting = true;
            SoopService.moveSoop(vm.planType, vm.planLabel, vm.soopInstanceId, vm.encodedSoopType, vm.soopType, vm.anchorTime, true, successCallback, extraErrorCallback)
        }
        
        function deleteSoop() {
            var title = "Delete SOOP";
            var text = "Do you really want to delete the SOOP of type "+ vm.encodedSoopType +  " and soopInstanceId "+vm.soopInstanceId
                +"?";
            vm.waiting = true;
            var callback = function() {
                Planning.deleteSoop(
                    {
                        planType: vm.planType,
                        planLabel: vm.planLabel,
                        soopInstanceId:  vm.soopInstanceId,
                        encodedSoopType: vm.encodedSoopType
                    },
                    function successCallback(data) {
                        SoopkitchenUtils.updatePlanFromDialog(data);
                        vm.waiting = false;
                        $uibModalInstance.dismiss('cancel');

                    }, function errorCallback(response) {
                        SoopkitchenUtils.prettyError(response);
                        vm.waiting = false;
                    });
            };

            SoopkitchenUtils.prettyConfirm(title, text, callback);
        }

    }
})();

(function () {
    'use strict';

    angular.module('soopkitchenApp').controller('CreateSOOPController', CreateSOOPController);

    CreateSOOPController.$inject = ['$rootScope', '$sce', '$controller', '$uibModalInstance', 'entity', 'parameters', 'SoopkitchenUtils', 'Planning', 'PlanTypes'];

    function CreateSOOPController($rootScope, $sce, $controller, $uibModalInstance, entity, parameters, SoopkitchenUtils, Planning, PlanTypes) {
        angular.extend(this, $controller('SoopkitchenDialogController',
            {"title": "Create SOOP/Floating Timeline", $sce: $sce, $uibModalInstance: $uibModalInstance}));

        var vm = this;

        /**** Properties ****/
        vm.plan = entity;
        vm.planType = parameters.planType;
        vm.obsDefLabel = parameters.obsDefLabel;
        vm.observations = parameters.occurrences;
        vm.planLabel = parameters.planLabel;
        vm.soops = {
            "ALL": ['']
        };
        vm.soopTypes = [];
        vm.selectedSoop = "";
        vm.selectedType = "ALL";
        //Overriding Properties from SoopkitchenDialogController:
        vm.saveText = "Save";
        vm.saveSoopInPlan = true;
        vm.saveSoopTemplate = false;
        vm.savePlanTemplate = false;
        vm.soopDurationString = null;
        vm.soopPlanLabel = null;
        vm.instruments = ['EUI', 'Metis', 'PHI', 'SPICE', 'STIX', 'SoloHI', 'EPD', 'MAG', 'RPW', 'SWA'];
        vm.selectedSoopLeadInstrument = null;
        vm.templateDurationString = null;
        vm.templatePlanLabel = null;
        
        var earliestDate = Date.parse(vm.observations[0].startDate);
        var latestDate = Date.parse(vm.observations[0].endDate);
        for (var i = 1; i < vm.observations.length; i++) {
            var start = Date.parse(vm.observations[i].startDate);
            var end = Date.parse(vm.observations[i].endDate);
            if (start < earliestDate) {
                earliestDate = start;
            }
            if (end > latestDate) {
                latestDate = end;
            }
        } 
        vm.duration = (latestDate - earliestDate) / 1000;
        vm.durationLetters = SoopkitchenUtils.secondsToTime(vm.duration);
                
        /**** Methods ****/
        //Override Methods from SoopkitchenDialogController
        vm.save = save;

        //load combobox
        Planning.getSoopTypes({}, successLoadingSoopTypes, failureLoadingSoopTypes);

        function successLoadingSoopTypes(data) {
            if (data) {
                data = angular.fromJson(data);
                vm.soopTypes = [];
                vm.soopTypes.push("");
                data.forEach(function (item) {
                    vm.soopTypes.push(item);
                });
                vm.selectedSoopType = vm.soopTypes[0];
            }
            vm.waiting = false;

        }

        function failureLoadingSoopTypes(response) {
            SoopkitchenUtils.prettyError(response);
            vm.waiting = false;
        }

        function successCallback() {
            if (vm.callbackMsg.length > 0) {
                SoopkitchenUtils.invokeSweetAlert("Nice!", vm.callbackMsg, "success", function () {
                    SoopkitchenUtils.updatePlanFromDialog(vm.data);
                    $uibModalInstance.dismiss('cancel');
                });
            }
        }

        function failureCallback(response) {
            SoopkitchenUtils.processResponse(response, vm.callbackMsg, vm.callbackMsgError, function () {
                location.reload();
                $uibModalInstance.dismiss('cancel');
            });
        }
        
        function processErrorResponseCallback(response) {
            return function () {
                SoopkitchenUtils.processResponse(response, '', vm.callbackMsgError, function () {
                    location.reload();
                    $uibModalInstance.dismiss('cancel');
                });
            }
        }

        function getCreateSoopPlanFunction(success) {
            if (vm.saveSoopTemplate) {
                return function () {
                    Planning.create(
                        {
                            planType: PlanTypes['soop'],
                            obsDefLabel: vm.obsDefLabel,
                            duration: SoopkitchenUtils.timeToSeconds(vm.soopDurationString),
                            planLabel: vm.soopPlanLabel,
                            leadInstrument: vm.selectedSoopLeadInstrument,
                            soopType: vm.selectedSoopType,
                        },
                        vm.observations,
                        function () {
                            vm.callbackMsg += 'Successfully Saved SOOP template\n';
                            success();
                        },
                        function (response) {
                            vm.callbackMsgError += 'Failed to save the SOOP template';
                            failureCallback(response);
                        }
                    );
                }
            } else {
                return function() {
                    success();
                }
            }
        }

        function getCreateTemplatePlanFunction(success) {
            if (vm.savePlanTemplate) {
                return function () {
                    Planning.create(
                        {
                            planType: PlanTypes['template'],
                            obsDefLabel: vm.obsDefLabel,
                            duration: SoopkitchenUtils.timeToSeconds(vm.templateDurationString),
                            planLabel: vm.templatePlanLabel
                        },
                        vm.observations,
                        function () {
                            vm.callbackMsg += 'Successfully saved Floating Timeline\n';
                            success();
                        },
                        function (response) {
                            vm.callbackMsgError += 'Failed to save the Floating Timeline';
                            failureCallback(response);
                        }
                    );
                }
            } else {
                return function() {
                    success();
                }
            }
        }

        function getSaveSoopInPlanFunction(success) {
            if (vm.saveSoopInPlan) {
                return function () {
                    Planning.createSoop(
                        {
                            planLabel: vm.planLabel,
                            soopType: vm.selectedSoopType,
                            planType: vm.planType
                        },
                        vm.observations,
                        function (data) {
                            vm.data = data;
                            vm.callbackMsg += 'Successfully created SOOP instance in Plan\n';
                            success();
                        },
                        function (response) {
                            vm.callbackMsgError += 'Failed to create the SOOP instance in the Plan';
                            failureCallback(response);
                        }
                    );
                } 
            } else {
                return function() {
                    success();
                }
            }
        }

        function save() {
            vm.data = null;
            vm.callbackMsg = '';
            vm.callbackMsgError = '';
            vm.failedToCreateSoop = '';
            vm.waiting = true;
            getSaveSoopInPlanFunction(getCreateSoopPlanFunction(getCreateTemplatePlanFunction(successCallback)))();
        }
    }
})();

(function () {
    'use strict';

    angular.module('soopkitchenApp').controller('ClonePlanController', ClonePlanController);

    ClonePlanController.$inject = ['$sce','$controller', '$uibModalInstance', 'parameters', 'SoopkitchenUtils', 'Planning', 'PlanTypes'];
    
    function ClonePlanController($sce, $controller, $uibModalInstance, parameters, SoopkitchenUtils, Planning, PlanTypes) {
        
        var title = 'Clone Plan <span class="label label-info">'+parameters.labelToClone+'</span>, Version <span\n' +
            'class="label label-info">'+parameters.internalVersionToClone+'</span>';

        angular.extend(this, $controller('SoopkitchenDialogController', {
            "title": title, $sce: $sce, $uibModalInstance:$uibModalInstance}));
        var vm = this;

        /**** Properties ****/

        vm.planType = parameters.planType;
        vm.labelToClone = parameters.labelToClone;
        vm.internalVersionToClone = parameters.internalVersionToClone;
        vm.isMaster = vm.planType === PlanTypes['master'];
        vm.parameters = [];
        vm.parameters.push({'name': 'Label'});
        if (vm.isMaster) {
            vm.parameters.push({'name': 'ID'});
        }
        vm.parameter = {};
        //Overriding Properties from SoopkitchenDialogController:
        vm.saveText = "Clone";

        /**** Methods ****/
        //Override Methods from SoopkitchenDialogController
        vm.save = clone;
        
        function successCloning() {
            SoopkitchenUtils.invokeSweetAlert("Nice!", "You have created the plan " + vm.parameter['Label'], "success", vm.clear);
        }
        
        function failureCloning(response) {
            SoopkitchenUtils.prettyError(response);
        }
        
        function clone() {
            var planningParameters ={
                planType: vm.planType,
                planLabel: vm.parameter['Label'],
                planLabelToClone : vm.labelToClone,
                internalVersionToClone : vm.internalVersionToClone
            };
                
            if (vm.isMaster) {
                planningParameters.planId = vm.parameter['ID'];
            }
            
            Planning.clone(
                planningParameters,
                successCloning,
                failureCloning
            )
        }
    }
})();

(function () {
    'use strict';

    angular.module('soopkitchenApp').controller('ChangeMetisCompabilityController', ChangeMetisCompatibilityController);

    ChangeMetisCompatibilityController.$inject = ['$scope', '$uibModalInstance', 'entity', 'AlertService', 'PlanningEventsService', 'EventsService',
        'parameters', '$rootScope', 'Principal', 'SoopkitchenUtils', '$cookies', '$timeout', '$uibModal', '$controller', '$sce'];

    function ChangeMetisCompatibilityController
        ($scope, $uibModalInstance, entity, AlertService, PlanningEventsService, EventsService, parameters,
            $rootScope, Principal, SoopkitchenUtils, $cookies, $timeout, $uibModal,$controller,$sce) {
            var vm = this;
            vm.isEditable = false;
            vm.selectedMetisCompability = "YES";
            vm.blinkingTimeout = 2000;
            vm.isValidDate = SoopkitchenUtils.isValidDate;
            vm.nameEventMap = {};
            vm.nameAllEventsMap = {};
            vm.attributeClassMap = {};
            vm.plan = entity;
            vm.schema = entity.schema;
            vm.startTime = parameters.startTime;
            vm.endTime = parameters.endTime;

            // vm.selectedEvent = vm.nameEventMap['POINT_FEATURE'];
            var title = 'Change Metis compatibility to all POINT events in an interval into Plan <span class="label label-info">'+entity.label+'</span>, Version <span\n' +
                'class="label label-info">'+entity.internalVersion+'</span>';
            angular.extend(this, $controller('SoopkitchenDialogController',
            {"title": title, $sce: $sce, $uibModalInstance:$uibModalInstance}));
            // vm.headerTitle = ";
            vm.cancelText = "Cancel";
            vm.saveText= "Apply";
            vm.deleteText='None';
            vm.save = changeMetisCompatibility;
            vm.clear = clear;
            vm.planLabel =  entity.label;
            vm.planType =  parameters.planType;
            function clear() {
                $uibModalInstance.dismiss('cancel');
            }
            function successCallback(response) {
                var msg = "POINT Events in the interval ("+vm.startTime + " - " + vm.endTime + ") have been updated its METIS compatibility to " + vm.selectedMetisCompability;
                SoopkitchenUtils.processResponse(
                            response,
                            "Changed METIS compatibility",
                            msg,
                            vm.clear
                        );
                SoopkitchenUtils.updatePlanFromDialog(response.data);
            }
            function changeMetisCompatibility() {
                EventsService.updateMetisCompatibility(vm.planType, vm.planLabel , vm.startTime , vm.endTime, vm.selectedMetisCompability, successCallback);
            }
        }
    })();

(function () {
    'use strict';
    angular
        .module('soopkitchenApp')
        .controller('ObservationDefinitionsNexusController', ObservationDefinitionsNexusController);
    
    ObservationDefinitionsNexusController.$inject = ['ObservationDefinitions', 'SoopkitchenUtils', '$uibModalInstance', '$state'];
    
    function ObservationDefinitionsNexusController(ObservationDefinitions, SoopkitchenUtils, $uibModalInstance, $state) {
        var vm = this;

        /**** Properties ****/
        vm.versions = null;
        vm.checked = {};
        vm.descriptions = {};

        /**** Methods ****/
        vm.clear = clear;
        vm.isValid = isValid;
        vm.importObsDef = importObsDef;


        ObservationDefinitions.loadNexusVersions(successLoadNexusVersions, failureLoadNexusVersions);
        
        function successLoadNexusVersions(response) {
            vm.versions = response.data;
        }
        
        function failureLoadNexusVersions(response) {
            clear();
            SoopkitchenUtils.prettyError(response);
        }
        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function isValid() {
            for (var version in vm.checked) {
                if (vm.checked[version]) {
                    return true;
                }
            }
            return false;
        }

        function extractVersions() {
            var versionsToImport = {};
            for (var version in vm.checked) {
                if (vm.checked[version]) {
                    if (vm.descriptions.hasOwnProperty(version)) {
                        versionsToImport[version] = vm.descriptions[version];
                    } else {
                        versionsToImport[version] = '';
                    }
                }
            }
            return versionsToImport;
        }

        function successImportFromNexus(response) {
            SoopkitchenUtils.processResponse(
                response,
                "Observation Definitions Imported",
                "New Observation Definitions have been creatd in SoopKitchen",
                function () {
                    $state.go('observation-definitions');
                    $uibModalInstance.dismiss('cancel');
                }
            );
        }
        
        function failureImportFromNexus(response) {
            SoopkitchenUtils.prettyError(response);
        }
        
        function importObsDef() {
            var versionsToImport = extractVersions();
            ObservationDefinitions.importVersionsFromNexus(versionsToImport, successImportFromNexus, failureImportFromNexus);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('soopkitchenApp')
        .controller('ObservationDefinitionsDetailController', ObservationDefinitionsDetailController);

    ObservationDefinitionsDetailController.$inject = [ 'ObservationDefinitions', 'previousState',  'SoopkitchenUtils','$stateParams'];

    function ObservationDefinitionsDetailController(ObservationDefinitions, previousState,  SoopkitchenUtils,$stateParams) {
        var vm = this;

        /**** Properties ****/

        vm.waiting = true;
        vm.observationDefinitions = null;
        vm.previousState = null;
        vm.flows = [];
        vm.flushes = [];
        vm.volumes = [];
        vm.flowMappings = [];
        vm.flushMappings = [];
        vm.observationsPerInstrument = null;
        vm.previousState = previousState.name;
        
        /**** Methods ****/

        vm.formatExpression = formatExpression;
        vm.getMapLength = getMapLength;
        vm.sortTable = sortTable;


        ObservationDefinitions.getObservationDefinition($stateParams.id, init, showError);

        function init(response) {
            
            vm.observationDefinitions = response.data;

            vm.flows = createSortedArray(vm.observationDefinitions.derivedFlows.flows, 'id');
            vm.flushes = createSortedArray(vm.observationDefinitions.derivedFlows.flushes, 'id');
            vm.volumes = createSortedArray(vm.observationDefinitions.derivedFlows.volumes, 'id');

            vm.flowMappings = createSortedArray(vm.observationDefinitions.epsActionMappings.flowMappings, 'flowName');
            vm.flushMappings = createSortedArray(vm.observationDefinitions.epsActionMappings.flushMappings, 'flushName');

            vm.observationsPerInstrument = vm.observationDefinitions.allExperimentsObservationDefinitions;
            vm.waiting = false;

        }

        function showError(response) {
            SoopkitchenUtils.prettyError(response, function () {
                vm.waiting = false;
                $scope.$apply();
            });
        }

        function getMapLength(obj) {
            return Object.keys(obj).length;
        }
        
        function formatExpression(str) {
            if (str) {
                return str.replace(/&&/g, ' && ').replace(/\|\|/g, ' || ').replace(/==/g, ' == ').replace(/\+/g, ' + ').replace(/-/g, ' - ').replace(/\*/g, ' * ').replace(/\//g, ' / ');
            }
        }

        function sortTable(table, columnName, reverse) {
            return SoopkitchenUtils.sort(table, columnName, reverse);
        }
        
        function createSortedArray(map, sortKey) {
            return sortTable(SoopkitchenUtils.extractArrayFromMap(map, sortKey), sortKey, false);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('soopkitchenApp')
        .controller('ObservationDefinitionsDeleteController',ObservationDefinitionsDeleteController);

    ObservationDefinitionsDeleteController.$inject = ['ObservationDefinitions', '$uibModalInstance', 'parameters', 'SoopkitchenUtils'];

    function ObservationDefinitionsDeleteController(ObservationDefinitions, $uibModalInstance, parameters, SoopkitchenUtils) {
        var vm = this;
        
        /**** Properties ****/
        vm.label = parameters.label;
        vm.waiting = false;
        
        /**** Methods ****/
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function successDelete() {
            SoopkitchenUtils.invokeSweetAlert('Observation Definitions Deleted', vm.label + ' has been deleted', 'success', function () {
                location.reload();
            });
            $uibModalInstance.dismiss('cancel');
            vm.waiting = false;
        }
        
        function failureDelete(response) {
            SoopkitchenUtils.prettyError(response);
            $uibModalInstance.dismiss('cancel');
            vm.waiting = false;
        }
        
        function confirmDelete() {
            vm.waiting = true;
            ObservationDefinitions.confirmDelete(vm.label, successDelete, failureDelete)
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('soopkitchenApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('observation-definitions', {
            parent: 'entity',
            url: '/observation-definitions',
            data: {
                authorities: ['ROLE_INSTRUMENT_COORDINATOR', 'ROLE_INSTRUMENT_TEAM_MEMBER', 'ROLE_USER', 'ROLE_POWER_USER', 'ROLE_PLAN_COORDINATOR', 'ROLE_ADMIN'],
                pageTitle: 'Observation Definitions'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/observation-definitions/observation-definitions.html',
                    controller: 'ObservationDefinitionsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        }).state('observation-definitions-detail', {
            parent: 'entity',
            url: '/observation-definitions/{id}',
            data: {
                authorities: ['ROLE_INSTRUMENT_COORDINATOR', 'ROLE_INSTRUMENT_TEAM_MEMBER', 'ROLE_USER', 'ROLE_POWER_USER', 'ROLE_PLAN_COORDINATOR', 'ROLE_ADMIN'],
                pageTitle: 'Observation Definitions detail'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/observation-definitions/observation-definitions-detail.html',
                    controller: 'ObservationDefinitionsDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'observation-definitions',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        }).state('observation-definitions.nexus', {
            parent: 'observation-definitions',
            url: '/nexus',
            data: {
                authorities: ['ROLE_PLAN_COORDINATOR']
            },
            onEnter: ['$state', '$uibModal', function ($state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/observation-definitions/observation-definitions-nexus.html',
                    controller: 'ObservationDefinitionsNexusController',
                    controllerAs: 'vm',
                    size: 'lg',
                    backdrop: 'static'
                }).result.then(function () {
                    $state.go('observation-definitions', null, {reload: true});
                }, function () {
                    $state.go('observation-definitions', null, {reload: true});
                });
            }]
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('soopkitchenApp')
        .factory('ObservationDefinitions', ObservationDefinitions);

    ObservationDefinitions.$inject = ['$http', 'FileUploadService', '$uibModal'];
    function ObservationDefinitions ($http, FileUploadService, $uibModal) {
        return {
            getObservationDefinitions:getObservationDefinitions,
            getObservationDefinition:getObservationDefinition,
            uploadObservationDefinition: uploadObservationDefinition,
            openDeleteDialog : openDeleteDialog,
            confirmDelete: confirmDelete,
            loadNexusVersions: loadNexusVersions,
            importVersionsFromNexus: importVersionsFromNexus
        };

        function getObservationDefinitions(success, failure, operational) {
            var url = 'api/observation-definitions/';
            if (operational) {
                url += '?operational=true';
            }
            $http({
                method: 'GET',
                url: url
            }).then(success, failure);
        }

        function getObservationDefinition(label, success, failure) {
            $http({
                method: 'GET',
                url: 'api/observation-definitions/' + label
            }).then(success, failure);

        }

        function uploadObservationDefinition(label, files, description, success, failure) {
            FileUploadService.uploadFiles(files, 'api/observation-definitions/multi-files-upload', label, success,
                failure,
                FileUploadService.progressCallback,
                description);
        }

        function openDeleteDialog(label) {
            $uibModal.open({
                templateUrl: 'app/entities/observation-definitions/observation-definitions-delete-dialog.html',
                controller: 'ObservationDefinitionsDeleteController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    parameters: {
                        label: label
                    }
                }
            });
        }

        function confirmDelete(label, success, failure) {
            $http({
                method: 'DELETE',
                url: 'api/observation-definitions/' + label
            }).then(success, failure);
        }

        function loadNexusVersions(success, failure) {
            $http({
                method: 'GET',
                url: 'api/observation-definitions/nexus'
            }).then(success, failure);
        }

        function importVersionsFromNexus(versionsToImport, success, failure) {
            $http({
                method: 'POST',
                url: 'api/observation-definitions/nexus',
                params: {
                    "versions" : versionsToImport
                }
            }).then(success, failure);
        }
        function loadObsDefinitionsLabels(success, failure, operational) {
            var url = 'api/observation-definitions/labels';
            if (operational) {
                url += '?operational=true'
            }
            $http({
                method: 'GET',
                url: url
            }).then(success, failure);
        }


    }
})();

(function () {
    'use strict';

    angular
        .module('soopkitchenApp')
        .controller('ObservationDefinitionsController', ObservationDefinitionsController);

    ObservationDefinitionsController.$inject = ['ObservationDefinitions', 'FileUploadService', 'SoopkitchenUtils', '$scope'];

    function ObservationDefinitionsController(ObservationDefinitions, FileUploadService, SoopkitchenUtils, $scope) {
        var vm = this;

        /**** Properties ****/

        vm.isUploading = false;
        vm.ascending = false;
        vm.predicate = "timestamp";

        /**** Methods ****/

        vm.sortTable = sortTable;
        vm.uploadFiles = uploadFiles;
        vm.save = save;
        vm.formatIsoZuluDateString = SoopkitchenUtils.formatIsoZuluDateString;
        vm.openDeleteDialog = ObservationDefinitions.openDeleteDialog;

        // Load all Observation definitions.
        ObservationDefinitions.getObservationDefinitions(init, showError);

        function init(response) {
            vm.observationDefinitions = response.data;
            sortTable();
            // By default, sort by timestamp desc (SPKT-517)
        }
        
        function showError(response) {
            SoopkitchenUtils.prettyError(response, function () {
                $scope.$apply();
            });
        }
        
        function sortTable() {
            vm.observationDefinitions = SoopkitchenUtils.sort(vm.observationDefinitions, vm.predicate, !vm.ascending);
            $scope.$applyAsync();
        }
        
        function uploadFiles(files) {
            vm.files = files;
        }
        
        function successUpload(response) {
            SoopkitchenUtils.processResponse(
                response,
                "Observation Definitions Created", "An Observation Definitions  with name '"
                + vm.labelVal + "' has been created",
                function () {
                    location.reload();
                }
            );
        }

        function failureUpload(response) {
            SoopkitchenUtils.prettyError(response, function () {
                vm.isUploading = false;
                $scope.$apply();
            });
        }
        
        function save() {
            if (vm.files && vm.files.length) {
                vm.isUploading = true;
                ObservationDefinitions.uploadObservationDefinition(vm.labelVal, vm.files, vm.description, successUpload, failureUpload)
            }
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('soopkitchenApp')
        .controller('EventCollectionsUpdateValidityController', EventCollectionsUpdateValidityController);

    EventCollectionsUpdateValidityController.$inject = ['EventCollections', 'parameters','$stateParams',  '$scope', 'SoopkitchenUtils', '$uibModalInstance'];

    function EventCollectionsUpdateValidityController(EventCollections, parameters, $stateParams, $scope, SoopkitchenUtils,$uibModalInstance) {
        var vm = this;

        /**** Properties ****/
        vm.waiting = false;
        vm.label = parameters.label;
        vm.validityStartTime = parameters.validityStartTime;
        vm.validityEndTime = parameters.validityEndTime;
        vm.invalidateStartDate = false;
        vm.invalidateEndDate = false;
        vm.duration = 0;
        vm.validateDates = validateDates;
        vm.clear = clear;
        vm.save = save;

        function validateDates() {
            if (SoopkitchenUtils.isValidDate(vm.validityStartTime)) {
                vm.invalidateStartDate = false;
                if (SoopkitchenUtils.isValidDate(vm.validityEndTime)) {
                    vm.invalidateEndDate = false;
                } else {
                    vm.invalidateEndDate = true;
                    return;
                }
                vm.duration = (Date.parse(vm.validityEndTime) - Date.parse(vm.validityStartTime)) / 1000;
            } else {
                vm.invalidateStartDate = true;
            }
        }

        function successDeleting() {
            $uibModalInstance.dismiss('cancel');
            location.reload();
        }

        function failureDeleting() {
           SoopkitchenUtils.invokeSweetAlert('Unknown problem with Event Collection ', vm.label, 'error', function () {
                           location.reload();
                       })
        }

        function clear() {
            EventCollections.deleteEventCollection(vm.label, successDeleting, failureDeleting);
        }

        function success () {
            SoopkitchenUtils.invokeSweetAlert('Event Collection with label ', vm.label + ' has been successfully stored ', 'success', function () {
                location.reload();
            })
        }
        function failure (response) {
            SoopkitchenUtils.prettyError(response, function () {
            })
        }
        function save() {
            EventCollections.setValidityEventCollection(vm.label,  new Date(Date.parse(vm.validityStartTime).valueOf()), new Date(Date.parse(vm.validityEndTime).valueOf()), success, failure);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('soopkitchenApp')
        .controller('EventCollectionsDetailController', EventCollectionsDetailController);

    EventCollectionsDetailController.$inject = ['previousState', 'EventCollections','$stateParams',  '$scope', 'SoopkitchenUtils'];

    function EventCollectionsDetailController(previousState, EventCollections, $stateParams, $scope, SoopkitchenUtils) {
        var vm = this;
        var container;

        /**** Properties ****/

        vm.previousState = previousState.name;
        vm.events = [];
        vm.reverse = false;
        vm.predicate = 'name';
        vm.showLog = false;
        vm.waiting = true;

        /**** Methods ****/

        vm.sortTable = sortTable;
        vm.showError = showError;
        vm.createparameters = EventCollections.createparameters;

        EventCollections.getEventCollection($stateParams.id, init, showError);

        function showError(response) {
            SoopkitchenUtils.prettyError(response, function () {
                vm.isUploading = false;
                vm.waiting = false;
                $scope.$apply();
            });
        }

        function init(response) {
            vm.eventCollections= response.data;
            vm.logs = vm.eventCollections.logs;

            for (var eventFile in vm.eventCollections.eventsByFile) {
                if (vm.eventCollections.eventsByFile.hasOwnProperty(eventFile)) {
                    var happenings = vm.eventCollections.eventsByFile[eventFile].happenings;
                    var arrayLength = happenings.length;
                    for (var i = 0; i < arrayLength; i++) {
                        vm.events.push({
                            name: happenings[i].originalName,
                            startDate: happenings[i].startDate,
                            endDate: happenings[i].endDate,
                            parameters: happenings[i].parameters,
                            count: happenings[i].count,
                            source: eventFile,
                            happening: happenings[i]
                        })
                    }
                }
            }
            container = document.getElementById('timeline-view');
            EventCollections.createTimeline(container, vm.eventCollections, vm.events);
            vm.waiting = false;

        }

        function sortTable() {
            vm.events = SoopkitchenUtils.sort(vm.events, vm.predicate, vm.reverse);
            $scope.$apply();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('soopkitchenApp')
        .controller('EventCollectionsDeleteController',EventCollectionsDeleteController);

    EventCollectionsDeleteController.$inject = ['$uibModalInstance', 'parameters', 'SoopkitchenUtils', 'EventCollections'];

    function EventCollectionsDeleteController($uibModalInstance, parameters, SoopkitchenUtils, EventCollections) {
        
        var vm = this;
        
        /**** Properties ****/
        vm.waiting = false;
        vm.label = parameters.label;
        
        /**** Methods ****/
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function successDeleting () {
            vm.waiting = false;
            $uibModalInstance.dismiss('cancel');
            SoopkitchenUtils.invokeSweetAlert('Event Collection Deleted', vm.label + ' has been deleted', 'success', function () {
                location.reload();
            })
        }
        
        function failureDeleting (response) {
            vm.waiting = false;
            $uibModalInstance.dismiss('cancel');
            SoopkitchenUtils.prettyError(response);
        }
        
        function confirmDelete(label) {
            EventCollections.deleteEventCollection(label, successDeleting, failureDeleting);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('soopkitchenApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('event-collections', {
                parent: 'entity',
                url: '/event-collections',
                data: {
                    authorities: ['ROLE_INSTRUMENT_COORDINATOR', 'ROLE_INSTRUMENT_TEAM_MEMBER', 'ROLE_USER', 'ROLE_POWER_USER', 'ROLE_PLAN_COORDINATOR', 'ROLE_ADMIN'],
                    pageTitle: 'Event Collections'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/event-collections/event-collections.html',
                        controller: 'EventCollectionsController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {}
            })
            .state('event-collections-detail', {
                parent: 'entity',
                url: '/event-collections/{id}',
                data: {
                    authorities: ['ROLE_INSTRUMENT_COORDINATOR', 'ROLE_INSTRUMENT_TEAM_MEMBER', 'ROLE_USER', 'ROLE_POWER_USER', 'ROLE_PLAN_COORDINATOR', 'ROLE_ADMIN'],
                    pageTitle: 'Event Collections detail'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/event-collections/event-collections-detail.html',
                        controller: 'EventCollectionsDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    previousState: ["$state", function ($state) {
                        return {
                            name: $state.current.name || 'event-collections',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                    }]
                }
            })
            .state('event-collections.delete', {
                parent: 'event-collections',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_PLAN_COORDINATOR']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/event-collections/event-collections-delete-dialog.html',
                        controller: 'EventCollectionsDeleteController',
                        controllerAs: 'vm',
                        size: 'md'
                    }).result.then(function () {
                        $state.go('event-collections', null, {reload: 'event-collections'});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('event-collections.egs', {
                parent: 'event-collections',
                url: '/egs',
                data: {
                    authorities: ['ROLE_PLAN_COORDINATOR']
                },
                onEnter: ['$state', '$uibModal', function ($state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/event-collections/egs-form.html',
                        controller: 'EgsFormController',
                        controllerAs: 'vm',
                        size: 'lg',
                        backdrop: 'static'
                    }).result.then(function () {
                        $state.go('event-collections', null, {reload: 'event-collections'});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('egs-job-details', {
                parent: 'event-collections',
                url: '/egs/{id}',
                data: {
                    authorities: ['ROLE_PLAN_COORDINATOR'],
                    pageTitle: 'EGS Job detail'
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/event-collections/egs-details.html',
                        controller: 'EgsDetailController',
                        controllerAs: 'vm',
                        size: 'lg',
                        backdrop: 'static'
                    }).result.then(function () {
                        $state.go('event-collections', null, {reload: 'event-collections'});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
    }

})();

(function() {
    'use strict';

    angular
        .module('soopkitchenApp')
        .factory('EventCollections', EventCollections);

    EventCollections.$inject = ['$http', 'SoopkitchenUtils', 'FileUploadService', '$uibModal'];

    function EventCollections ($http, SoopkitchenUtils, FileUploadService, $uibModal) {
        return {
            getEventCollections:getEventCollections,
            getEventCollection:getEventCollection,
            createTimeline: createTimeline,
            merge: merge,
            createparameters: createparameters,
            openDeleteDialog: openDeleteDialog,
            deleteEventCollection : deleteEventCollection,
            uploadEventCollection:uploadEventCollection,
            getEventCollectionsLabels: getEventCollectionsLabels,
            setValidityEventCollection: setValidityEventCollection,
            pickValidityDialog: pickValidityDialog
        };

        function getEventCollections(success, failure) {
            $http({
                method: 'GET',
                url: 'api/event-collections/'
            }).then(success, failure);
        }

        function getEventCollectionsLabels(success, failure) {
            $http({
                method: 'GET',
                url: 'api/event-collections/labels'
            }).then(success, failure);
        }

        function setValidityEventCollection(label, startDateTime, endDateTime, success, failure) {
            $http({
            method: 'PUT',
            url: 'api/event-collections/update-validity/' + label,
                params: { startDateTime: startDateTime ,
                    endDateTime: endDateTime}

            }).then(success, failure);
        }
        function getEventCollection(label, success, failure) {
            $http({
                method: 'GET',
                url: 'api/event-collections/' + label
            }).then(success, failure);
        }
        function createOptions(eventCollections) {
            var options = {
                orientation: 'both',
                multiselect: false,
                editable: false,
                groupEditable: false,
                groupOrder: function (a, b) {
                    return a.orderId > b.orderId;
                },
                stack: false,
                stackSubgroups: true,
                margin: {
                    item: {
                        horizontal: 0
                    }
                },
                moment: function (date) {
                    return vis.moment(date).utc();
                },
                tooltip: {
                    followMouse: false,
                    overflowMethod: 'cap'
                },

                min: eventCollections.validityStartTime,
                max: eventCollections.validityEndTime,

                onMoving: function () {
                    return false;
                },
                onAdd: function () {
                    return false;
                },
                onUpdate: function () {
                    return false;
                },

                onRemove: function () {
                    return false;
                }
            };
            return options;
        }


        function createEventObject(i, title, content, occurrence, group, subgroup, style) {
            var eventObj = {
                id: (i + 1),
                title: title,
                content: content,
                start: occurrence.startDate,
                group: group,
                subgroup: subgroup,
                style: style
            };

            if (occurrence.startDate !== occurrence.endDate) {
                eventObj.end = occurrence.endDate;
            } else {
                eventObj.className = 'instantaneous';

            }
            return eventObj;
        }

        function extractParametersDescription(occurrence, title) {
            if (Object.keys(occurrence.parameters).length) {
                for (var parameter in occurrence.parameters) {
                    if (occurrence.parameters.hasOwnProperty(parameter)) {
                        title += parameter + ": " + occurrence.parameters[parameter] + '<br>';
                    }
                }
            }
            return title;
        }

        function createTimeline(container, eventCollections, events) {
            var timelineObjects = [];
            var groupsSet = new Set();
            var options = createOptions(eventCollections);
            for (var i = 0; i < events.length; i++) {
                var occurrence = events[i].happening;
                var group = occurrence.group.groupName;
                var style = 'background-color: ' + occurrence.colour + ';' + 'border-color: ' + occurrence.colour + ';';
                var startString = occurrence.startDate + ' (' + SoopkitchenUtils.getDayOfYear(occurrence.startDate) + ')';
                var endString = occurrence.endDate + ' (' + SoopkitchenUtils.getDayOfYear(occurrence.endDate) + ')';
                var content = "<span id='timelineOccurrence_" + i + "' style ='" + style + "'>" + occurrence.name;
                var title = content;

                if (groupsSet.has(group) === false) {
                    groupsSet.add(group);
                }

                if (occurrence.description) {
                    title += ' (' + occurrence.description + ')'
                }

                title += "</span>";
                if (occurrence.startDate === occurrence.endDate) {
                    title += '<br>' + startString + '<br>';
                    style = SoopkitchenUtils.styleForInstantEvent(style);
                    content = "<span id='timelineOccurrence_" + i + "' style ='visibility: hidden;'>" + occurrence.name + " </span>";
                } else {
                    title += '<br>' + startString + '->' + endString + '<br>';
                }

                var subgroup = "";
                if (occurrence.group.subgroupName) {
                    subgroup = occurrence.group.subgroupName;
                } else {
                    subgroup = occurrence.originalName;
                }
                if (occurrence.count) {
                    title += 'count: ' + occurrence.count + '<br>';
                }
                title = extractParametersDescription(occurrence, title);
                title += '<hr style="display: block; margin: 6px"/>Source: ' + events[i].source + '<br>';
                timelineObjects.push(createEventObject(i, title, content, occurrence, group, subgroup, style));
            }

            container.innerHTML = "";

            var timelineGroups = new vis.DataSet(createGroups(groupsSet));
            var timelineItems = new vis.DataSet(timelineObjects);
            return new vis.Timeline(container, timelineItems, timelineGroups, options);
        }

        function createGroups(groupSet) {
            var groups = Array.from(groupSet);
            var timelineGroups = [];
            for (var i = 0; i < groups.length; i++) {
                var group = groups[i];
                var style = "background-color: #F5F5F5;";
                timelineGroups.push({
                    id: group,
                    value: group,
                    'content': '<span id="group_' + group + '">' + group + '</span>',
                    'style': style,
                    orderId: group
                });
            }
            return timelineGroups;
        }

        function createparameters(event) {
            var str = '';
            var parameters = event.parameters;
            var count = event.count;
            if (Object.keys(parameters).length > 0 || count > 0) {
                str = '{';
                if (count > 0) {
                    str += '"count" : ' + count + ', ';
                }
                for (var key in parameters) {
                    // check if the property/key is defined in the object itself, not in parent
                    if (parameters.hasOwnProperty(key)) {
                        str += '"' + key + '" : "' + parameters[key] + '", ';
                    }
                }
                str = str.substring(0, str.length - 2);
                str += '}';
            }
            return str;
        }
        function merge(checked,labelVal,description,  success, failure) {
            var collections = [];
            for (var collectionLabel in checked) {
                if (checked.hasOwnProperty(collectionLabel) && checked[collectionLabel]) {
                    collections.push(collectionLabel)
                }
            }
            $http({
                method: 'POST',
                url: 'api//event-collections/merge',
                params: {
                    "eventCollections" : collections,
                    "label": labelVal,
                    "description" : description
                }

            }).then(success, failure);

        }
        function deleteEventCollection(label, success, failure) {
            $http({
                method: 'DELETE',
                url: 'api/event-collections/' + label
            }).then(function successCallback(response) {
                success (response);
            }, function errorCallback(response) {
                failure(response);
            })
        }
        function openDeleteDialog(label) {
            $uibModal.open({
                templateUrl: 'app/entities/event-collections/event-collections-delete-dialog.html',
                controller: 'EventCollectionsDeleteController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    parameters: {
                        label: label
                    }
                }
            });
        }

        function uploadEventCollection(label, files, description, success, failure) {
            FileUploadService.uploadFiles(files, 'api/event-collections/multi-files-upload', label, success,
                failure,
                FileUploadService.progressCallback,
                description);
        }

        function pickValidityDialog(label, validityStartTime, validityEndTime) {
            $uibModal.open({
                templateUrl: 'app/entities/event-collections/event-collections-update.html',
                controller: 'EventCollectionsUpdateValidityController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    parameters: {
                        label: label,
                        validityStartTime: validityStartTime,
                        validityEndTime: validityEndTime
                    }
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('soopkitchenApp')
        .controller('EventCollectionsController', EventCollectionsController);

    EventCollectionsController.$inject = ['EventCollections','EGSService',  'FileUploadService', 'SoopkitchenUtils',  '$scope'];

    function EventCollectionsController (EventCollections, EGSService,  FileUploadService, SoopkitchenUtils, $scope) {

    	var vm = this;

        /**** Properties ****/
        vm.eventCollections = [];
        vm.checked = {};
        vm.formatIsoZuluDateString = SoopkitchenUtils.formatIsoZuluDateString;
        vm.isUploading = false;
        vm.ascending = false;
        vm.predicate = 'timestamp';
        vm.egsParameters = [];

        /**** Methods ****/
        vm.uploadFiles = uploadFiles;
        vm.areChecked = areChecked;
        vm.merge = merge;
        vm.save = save;
        vm.abort = abort;
        vm.sortTable = sortTable;
        vm.isProcessFinished = isProcessFinished;
        vm.jobsStatusClass = EGSService.jobsStatusClass;
        vm.deleteCollection = EventCollections.openDeleteDialog;

        //Load Event Collections
        EventCollections.getEventCollections(
            successLoadingEventCollections,
            showError);

        function showError(response) {
            SoopkitchenUtils.prettyError(response, function () {
                $scope.$apply();
            });
        }

        function successLoadingEventCollections(response) {
            var data = response.data;
            for (var i = 0; i < data.length; i++) {
                var eventCollection = data[i];
                if (eventCollection.egsJob !== null) {
                    eventCollection.description = "Generated by EGS";
                    eventCollection.processStatus =eventCollection.egsJob.processStatus;
                } else {
                    eventCollection.processStatus = "N/A";
                }
                vm.eventCollections.push(eventCollection);
            }
            vm.eventCollections = SoopkitchenUtils.sort(vm.eventCollections, vm.predicate, !vm.ascending);
        }

        function sortTable() {
            vm.eventCollections = SoopkitchenUtils.sort(vm.eventCollections, vm.predicate, !vm.ascending);
            $scope.$apply();
        }

        function uploadFiles(files) {
            vm.files = files;
        }

        function successUpload(response) {
            const label = response.data.label;
            const validityStart = response.data.validityStartTime;
            const validityEndTime = response.data.validityEndTime;
            EventCollections.pickValidityDialog(label,  validityStart, validityEndTime);
        }

        function failureUpload(response) {
            SoopkitchenUtils.prettyError(response, function () {
                vm.isUploading = false;
                $scope.$apply();
            });
        }

        function reloadCallback() {
            location.reload();
        }

        function abort(jobId) {
            EGSService.abort(jobId,
                function (response) {
                    SoopkitchenUtils.processResponse(
                        response,
                        "Job aborted",
                        "The EGS Job " + jobId + " has been aborted",
                        reloadCallback
                    );
                },
                function (response) {
                    SoopkitchenUtils.prettyError(response, reloadCallback);
                }
            );
        }

        function save () {
            if (vm.files && vm.files.length) {
                vm.isUploading = true;
                EventCollections.uploadEventCollection(vm.labelVal, vm.files, vm.description, successUpload, failureUpload)
            }
        }

        function areChecked() {
            var count = 0;
            for (var label in vm.checked) {
                if (vm.checked[label]) {
                    count++;
                }
            }
            return count;
        }

        function successMerge(response) {
            const label = response.data.label;
            const validityStart = response.data.validityStartTime;
            const validityEndTime = response.data.validityEndTime;
            EventCollections.pickValidityDialog(label,  validityStart, validityEndTime);
        }

        function failureMerge(response) {
            SoopkitchenUtils.prettyError(response);
        }

        function merge() {
            EventCollections.merge(vm.checked, vm.labelVal,vm.description,  successMerge, failureMerge);
        }

        function isProcessFinished(eventCollection) {
            return eventCollection.egsJob===null || eventCollection.egsJob.processStatus==='COMPLETED';
        }
    }
})();

(function () {
    'use strict';
    angular
        .module('soopkitchenApp')
        .factory('EGSService', EGSService);

    EGSService.$inject = ['$http'];

    function EGSService($http) {
        var prototypeRange = {
            startDate: null,
            endDate: null
        };
        return {
            runEGS: runEGS,
            loadOrbitFileNames: loadOrbitFileNames,
            abort: abort,
            jobsStatusClass: jobsStatusClass,
            createEGSParameters: createEGSParameters,
            resetParamsInArray: resetParamsInArray,
            getDateRangesFromObj: getDateRangesFromObj,
            getDateRangesFromString: getDateRangesFromString,
            getPickerOpts: getPickerOpts
        };

        function runEGS(egsJOB, success, failure) {
            $http({
                method: 'POST',
                url: 'api/run-egs?label=' + egsJOB.label,
                data: JSON.stringify(egsJOB)
            }).then(success, failure);
        }

        function loadOrbitFileNames(success, failure) {
            $http({
                method: 'GET',
                url: 'api/egs-orbit-files'
            }).then(success, failure);
        }

        function abort(jobId, success, failure) {
            $http({
                method: 'PUT',
                url: 'api/abort?jobId=' + jobId
            }).then(success, failure);
        }

        function jobsStatusClass(jobStatus) {
            if (jobStatus === 'COMPLETED') {
                return 'label-success';
            } else if (jobStatus === 'FAILED' || jobStatus === 'FAILED_BAD_EXIT' || jobStatus === 'FAILED_SERVER_ERROR' || jobStatus === 'ABORTED') {
                return 'label-danger';
            } else if (jobStatus === 'N/A') {
                return 'label-default';
            } else {
                return ' label-warning';
            }
        }

        function createCruisePhaseParams() {
            var cruisePhaseParams = [];

            var checkoutWindows = {
                id: 'checkoutWindows',
                text: 'Cruise checkout windows',
                dateRanges: true,
                value: [],
                opts: []
            };
            cruisePhaseParams.push(checkoutWindows);

            var cruisePassPrimaryDuration = {
                id: 'cruisePassPrimaryDuration',
                text: 'Normal cruise pass length (hours)',
                default: 8,
                min: -1,
                max: 24,
                required: true,
                scalar: true
            };
            cruisePhaseParams.push(cruisePassPrimaryDuration);

            var checkoutPassWindows = {
                id: 'checkoutPassWindows',
                text: 'Cruise checkout pass periods',
                dateRanges: true,
                value: [],
                opts: []
            };
            cruisePhaseParams.push(checkoutPassWindows);

            var cruisePassSecondaryDurWindows = {
                id: 'cruisePassSecondaryDurWindows',
                text: 'Specific cruise pass length periods',
                dateRanges: true,
                value: [],
                opts: []
            };
            cruisePhaseParams.push(cruisePassSecondaryDurWindows);

            var cruisePassSecondaryDuration = {
                id: 'cruisePassSecondaryDuration',
                text: 'Specific cruise pass length (hours)',
                default: -1,
                min: -1,
                max: 24,
                required: true,
                scalar: true
            };
            cruisePhaseParams.push(cruisePassSecondaryDuration);

            var cruiseExtraPassPeriodDays = {
                id: 'cruiseExtraPassPeriodDays',
                text: 'Extra cruise passes frequency (days)',
                default: -1,
                min: -1,
                max: 30,
                required: true,
                scalar: true
            };
            cruisePhaseParams.push(cruiseExtraPassPeriodDays);

            var cruiseExtraPassWindows = {
                id: 'cruiseExtraPassWindows',
                text: 'Additional cruise pass periods',
                dateRanges: true,
                value: [],
                opts: []
            };
            cruisePhaseParams.push(cruiseExtraPassWindows);
            return cruisePhaseParams;
        }

        function createNominalPhaseParams() {
            var nominalPhaseParams = [];

            var periRSWindows = {
                id: 'periRSWindows',
                text: 'Perihelion remote sensing windows dates',
                dateRanges: true,
                textarea: true,
                placeholder: 'Leave blank to for EGS to automatically schedule the windows as close as possible to perihelion; note the existence of any perihelion window date here will overwrite all automatically generated perihelion windows',
                showText: false,
                value: [],
                valueText: { value: ''},
                opts: []
            };
            nominalPhaseParams.push(periRSWindows);

            var maxRSWindows = {
                id: 'maxRSWindows',
                text: 'Maximum latitude remote sensing windows dates',
                dateRanges: true,
                textarea: true,
                placeholder: 'leave blank to for EGS to automatically schedule the windows as close as possible to the maximum latitude event; note the existence of any max latitude window date here will overwrite all automatically generated max latitude windows',
                showText: false,
                value: [],
                valueText: { value: ''},
                opts: []
            };
            nominalPhaseParams.push(maxRSWindows);

            var minRSWindows = {
                id: 'minRSWindows',
                text: 'Minimum latitude remote sensing windows dates',
                dateRanges: true,
                textarea: true,
                placeholder: 'leave blank to for EGS to automatically schedule the windows as close as possible to the minimum latitude event; note the existence of any minimum latitude window date here will overwrite all automatically generated minimum latitude windows',
                showText: false,
                value: [],
                valueText: { value: ''},
                opts: []
            };
            nominalPhaseParams.push(minRSWindows);

            var minPassLengthHours = {
                id: 'minPassLengthHours',
                text: 'Target pass length (hours)',
                default: 7,
                min: -1,
                max: 24,
                required: true,
                scalar: true
            };
            nominalPhaseParams.push(minPassLengthHours);

            var dailyPassAllocationHours = {
                id: 'dailyPassAllocationHours',
                text: 'Daily pass allocation (hours)',
                default: 9,
                min: -1,
                max: 24,
                required: true,
                scalar: true
            };
            nominalPhaseParams.push(dailyPassAllocationHours);

            var minExtraPassLengthHours = {
                id: 'minExtraPassLengthHours',
                text: 'Minimum length of extra passes (hours)',
                default: 2,
                min: -1,
                max: 24,
                required: true,
                scalar: true
            };
            nominalPhaseParams.push(minExtraPassLengthHours);

            var secondaryGSPassLimitHours = {
                id: 'secondaryGSPassLimitHours',
                text: 'Extra pass length (hours)',
                default: 9,
                min: -1,
                max: 24,
                required: true,
                scalar: true
            };
            nominalPhaseParams.push(secondaryGSPassLimitHours);

            var secondaryPassBoundSequence = {
                id: 'secondaryPassBoundSequence',
                text: 'Extra pass periods',
                dateRanges: true,
                value: [],
                opts: []
            };
            nominalPhaseParams.push(secondaryPassBoundSequence);
            return nominalPhaseParams;
        }

        function createGenericParams() {
            var genericParams = [];

            var spiceSearchStepSize = {
                id: 'spiceSearchStepSize',
                text: 'Simulation step size',
                default: 60,
                min: 1,
                max: 3600,
                required: true,
                scalar: true
            };
            genericParams.push(spiceSearchStepSize);

            var gsHandoverHours = {
                id: 'gsHandoverHours',
                text: 'Ground station handover (hours)',
                default: 1,
                min: -1,
                max: 24,
                required: true,
                scalar: true
            };
            genericParams.push(gsHandoverHours);

            var scReservedPerPrimaryPassHours = {
                id: 'scReservedPerPrimaryPassHours',
                text: 'Spacecraft reserved primary pass time (hours)',
                default: 1,
                min: -1,
                max: 24,
                required: true,
                scalar: true
            };
            genericParams.push(scReservedPerPrimaryPassHours);

            var scReservedPerExtraPassHours = {
                id: 'scReservedPerExtraPassHours',
                text: 'Spacecraft reserved extra pass time (hours)',
                default: 1,
                min: -1,
                max: 24,
                required: true,
                scalar: true
            };
            genericParams.push(scReservedPerExtraPassHours);

            var passFailurePeriod = {
                id: 'passFailurePeriod',
                text: 'Pass failure period (passes)',
                default: 20,
                min: -1,
                max: 365,
                required: true,
                scalar: true
            };
            genericParams.push(passFailurePeriod);
            var maxRedistributedAllocationHours = {
                id: 'maxRedistributedAllocationHours',
                text: 'Max redistributed allocation (hours)',
                default: 0,
                min: 0,
                max: 999999999,
                required: true,
                scalar: true
            };
            genericParams.push(maxRedistributedAllocationHours);
            return genericParams;
        }

        function createEGSParameters() {
            // cruise phase params
            var cruisePhaseParams = createCruisePhaseParams();

            // nominal phase params
            var nominalPhaseParams = createNominalPhaseParams();

            // generic params
            var genericParams = createGenericParams();

            var params = [];
            params.push(cruisePhaseParams);
            params.push(nominalPhaseParams);
            params.push(genericParams);
            return params;
        }

        function getPickerOpts(dateRangeParam, valueIndex, startDate, endDate, overlappingDates) {
            var optsObj = {
                locale: {
                    applyClass: 'btn-green',
                    applyLabel: "Apply",
                    fromLabel: "From",
                    format: "YYYY-MM-DD",
                    toLabel: "To",
                    cancelLabel: 'Cancel'
                },
                startDate: startDate,
                endDate: endDate,
                autoApply: true,
                index: valueIndex,
                datesOverlap: overlappingDates
            };

            var resetDates = function (index, newStartDate, newEndDate, newOverlappingDates) {
                dateRangeParam.opts[index] = getPickerOpts(dateRangeParam, index, newStartDate, newEndDate, newOverlappingDates);
                dateRangeParam.value[index] = createTimeRangeObj(prototypeRange);
            };

            var onApply = function () {
                var length = dateRangeParam.value.length;
                if (dateRangeParam.value[optsObj.index].startDate && dateRangeParam.value[optsObj.index].endDate) {
                    var newStartDate = dateRangeParam.value[optsObj.index].startDate.startOf('day');
                    var newEndDate = dateRangeParam.value[optsObj.index].endDate.startOf('day');
                    if (!datesOverlap(dateRangeParam.value, optsObj.index)) {
                        dateRangeParam.opts[optsObj.index] = getPickerOpts(dateRangeParam, optsObj.index, newStartDate, newEndDate);
                        dateRangeParam.value[optsObj.index].startDate = newStartDate;
                        dateRangeParam.value[optsObj.index].endDate = newEndDate;
                        if (optsObj.index === length - 1) {
                            dateRangeParam.opts.push(getPickerOpts(dateRangeParam, length, newEndDate, newEndDate));
                            dateRangeParam.value.push(createTimeRangeObj(prototypeRange));
                        }
                    } else {
                        resetDates(optsObj.index, newStartDate, newEndDate, true);
                    }
                } else {
                    resetDates(optsObj.index, startDate, endDate);
                }
            };


            optsObj.eventHandlers = {
                // 'apply.daterangepicker': onApply,
                'hide.daterangepicker': onApply
            };
            return optsObj;
        }

        function resetParamsInArray(array) {
            for (var i = 0; i < array.length; i++) {
                if (array[i].scalar) {
                    array[i].value = array[i].default;
                }
                if (array[i].dateRanges) {
                    array[i].opts = [];
                    array[i].opts.push(getPickerOpts(array[i], 0, moment().startOf('day'), moment().startOf('day')));
                    array[i].value = [];
                    array[i].value.push(createTimeRangeObj(prototypeRange));
                    if (array[i].textarea) {
                        array[i].showText = false;
                        array[i].valueText = { value: ''};
                    }
                }
            }
        }

        function createTimeRangeObj(proto) {
            return Object.assign({}, proto);
        }

        function datesOverlap(ranges, index) {
            for (var i = 0; i < ranges.length; i++) {
                if (i !== index && ranges[index].startDate && ranges[i].startDate) {
                    var startDateA = ranges[index].startDate.startOf('day');
                    var endDateA = ranges[index].endDate.startOf('day');
                    var startDateB = ranges[i].startDate.startOf('day');
                    var endDateB = ranges[i].endDate.startOf('day');
                    if ((startDateA < endDateB) && (endDateA > startDateB)) {
                        return true;
                    }
                }
            }
            return false;
        }

        function getDateRangesFromString(value) {
            var dateRanges = [];
            var dates = value.replace(/'/g, '').replace(/\s*/g, '').split(',');
            for (var i = 0; i < dates.length -1; i = i+2) {
                var startDate = moment.utc(dates[i]).format('YYYY-MM-DDTHH:mm:ss[Z]')
                var endDate = moment.utc(dates[i+1]).format('YYYY-MM-DDTHH:mm:ss[Z]')
                dateRanges.push({startDate: startDate, endDate: endDate});
            }

            return dateRanges;
        }

        function getDateRangesFromObj(value) {
            var dateRanges = [];
            for (var dateRangeCount in value) {
                if (value[dateRangeCount].startDate !== null && value[dateRangeCount].endDate !== null) {
                    var startDateNoTimeZone = value[dateRangeCount].startDate.format('YYYY-MM-DDTHH:mm:ss[Z]');
                    var endDateNoTimeZone = value[dateRangeCount].endDate.format('YYYY-MM-DDTHH:mm:ss[Z]');
                    dateRanges.push({startDate: startDateNoTimeZone, endDate: endDateNoTimeZone});
                }
            }
            return dateRanges;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('soopkitchenApp')
        .controller('EgsFormController', EgsFormController);

    EgsFormController.$inject = ['AlertService',  'SoopkitchenUtils', 'EGSService', '$uibModalInstance'];

    function EgsFormController(AlertService, SoopkitchenUtils, EGSService, $uibModalInstance) {

        var vm = this;

        /**** Properties ****/
        vm.labelVal = "";
        vm.params = EGSService.createEGSParameters();
        vm.orbitFileNames = [];
        vm.nominalStartSpecifier = "";

        /**** Methods ****/
        vm.reset = reset;
        vm.clear = clear;
        vm.runEgs = runEgs;
        vm.removeDateRange = removeDateRange;
        vm.intervalsWrong = intervalsWrong;

        EGSService.loadOrbitFileNames(successLoadOrbitFiles, failureLoadOrbitFiles);


        function intervalsWrong() {
            var oneHasWrongInterval = false;

            for (var paramSection in vm.params) {
                if (vm.params.hasOwnProperty(paramSection)) {
                    for (var paramCounter in vm.params[paramSection]) {
                        if (vm.params[paramSection].hasOwnProperty(paramCounter)) {
                            var parameter = vm.params[paramSection][paramCounter];
                            if (parameter.dateRanges === true) {
                                for (var interval in parameter.value) {
                                    if (parameter.value[interval].endDate<parameter.value[interval].startDate) {
                                        parameter.opts[interval].wrongInterval = true;
                                        oneHasWrongInterval = true;
                                    }
                                }
                            }
                        }
                    }
                }
            }
            return oneHasWrongInterval;
        }

        function reset() {
            vm.labelVal = "";
            for (var i = 0; i < vm.params.length; i++) {
                EGSService.resetParamsInArray(vm.params[i]);
            }
            vm.selectedOrbitFileName = null;
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function jobSubmittedSuccessfully(response) {
            SoopkitchenUtils.processResponse(response, "EGS Job submitted", "EGS Job submitted successfully with ID: " + response.data.id, function () {
                location.reload();
            });
        }

        function jobSubmittedFailure(response) {
            SoopkitchenUtils.prettyError(response);
        }

        function extractParameter(paramSection, egsParameters) {
            for (var paramCounter in vm.params[paramSection]) {
                if (vm.params[paramSection].hasOwnProperty(paramCounter)) {
                    var parameter = vm.params[paramSection][paramCounter];
                    if (parameter.dateRanges === true && parameter.valueText == null) {
                        egsParameters[parameter.id] = EGSService.getDateRangesFromObj(parameter.value);
                    } else if (parameter.dateRanges === true && parameter.valueText != null) {
                        egsParameters[parameter.id] = EGSService.getDateRangesFromString(parameter.valueText.value);
                    } else {
                        egsParameters[parameter.id] = parameter.value;
                    }
                }
            }
        }

        function runEgs() {
            var egsJob = {};
            var egsParameters = {};
            for (var paramSection in vm.params) {
                if (vm.params.hasOwnProperty(paramSection)) {
                    extractParameter(paramSection, egsParameters);
                }
            }
            egsJob.egsParameters = egsParameters;
            egsJob.orbitFilename = vm.selectedOrbitFileName ;
            egsJob.label = vm.labelVal;
            egsJob.nominalStartSpecifier =  vm.nominalStartSpecifier;
            egsJob.successURL = '<<to be filled in server>>';
            egsJob.failureURL = '<<to be filled in server>>';
            EGSService.runEGS(egsJob, jobSubmittedSuccessfully, jobSubmittedFailure);
            $uibModalInstance.dismiss('cancel');
        }

        function removeDateRange(dateRangeParam, valueIndex) {
            var length = dateRangeParam.value.length;
            if (valueIndex < length - 1) {
                for (var i = valueIndex + 1; i < length; i++) {
                    dateRangeParam.opts[i] = EGSService.getPickerOpts(dateRangeParam, i - 1, dateRangeParam.opts[i].startDate, dateRangeParam.opts[i].endDate);
                }
                SoopkitchenUtils.removeIndexFromArray(dateRangeParam.opts, valueIndex);
                SoopkitchenUtils.removeIndexFromArray(dateRangeParam.value, valueIndex);
            }
        }

        function successLoadOrbitFiles(response) {
            vm.orbitFileNames = response.data;
            if (vm.orbitFileNames.length === 0) {
                SoopkitchenUtils.prettyError(response);
            } else {
                reset();
            }

        }

        function failureLoadOrbitFiles(response) {
            if (response.status !== 500) {
                SoopkitchenUtils.prettyError(response, function () {
                    $scope.$apply();
                });
            } else {
                AlertService.error("Unable to retrieve the Orbit Files.");
            }

        }

    }
})();

(function () {
    'use strict';

    angular
        .module('soopkitchenApp')
        .controller('EgsDetailController', EgsDetailController);

    EgsDetailController.$inject = ['$stateParams', 'EventCollections',  'EGSService', '$uibModalInstance'];

    function EgsDetailController($stateParams, EventCollections,  EGSService, $uibModalInstance) {

        var vm = this;


        /**** Properties ****/
        vm.waiting = true;
        vm.showLog = false;
        vm.egsJob = null;
        vm.spec = null;
        vm.egsParameters = null;

        /**** Methods ****/
        vm.clear = clear;
        vm.displayDate = displayDate;
        vm.jobsStatusClass = EGSService.jobsStatusClass;

        //Load the EventCollection
        EventCollections.getEventCollection($stateParams.id, init, showError);

        function init(response) {
            vm.eventCollection= response.data;
            vm.egsJob = vm.eventCollection.egsJob;
            vm.spec = vm.eventCollection.egsJob.spec;
            vm.egsParameters = vm.spec.egsParameters;
            vm.waiting = false;
        }

        function showError(response) {
            SoopkitchenUtils.prettyError(response, function () {
                $scope.$apply();
            });
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function displayDate(date) {
            var display = date.startDate + " - ";
            display += date.endDate ;
            return display;
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('soopkitchenApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('entity', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function () {
    'use strict';

    angular.module('soopkitchenApp').controller('SoopkitchenDialogController', SoopkitchenDialogController);

    SoopkitchenDialogController.$inject = ['title', '$sce', '$uibModalInstance'];

    function SoopkitchenDialogController(title, $sce, $uibModalInstance) {
        var vm = this;
        /**** Properties ****/
        vm.headerTitle = $sce.trustAsHtml(title);
        vm.saveText = "Save";
        vm.cancelText = "Cancel";
        vm.deleteText = "None";
        vm.delete = null;
        vm.waiting = false;
        vm.saveDisabled = false;
        vm.clear = clear;
        function clear() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('soopkitchenApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('cookiepolicy', {
                parent: 'app',
                url: '/cookiepolicy',
                data: {
                    authorities: [],
                    pageTitle: 'Cookie Policy'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/cookiepolicy/cookiepolicy.html'
                    }
                }
            });
    }
})();

(function() {
    'use strict';

    angular
        .module('soopkitchenApp')
        .filter('words', words);

    function words() {
        return wordsFilter;

        function wordsFilter(input, words) {
            if (isNaN(words)) {
                return input;
            }
            if (words <= 0) {
                return '';
            }
            if (input) {
                var inputWords = input.split(/\s+/);
                if (inputWords.length > words) {
                    input = inputWords.slice(0, words).join(' ') + '...';
                }
            }
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('soopkitchenApp')
        .filter('characters', characters);

    function characters () {
        return charactersFilter;

        function charactersFilter(input, chars, breakOnWord) {
            if (isNaN(chars)) {
                return input;
            }
            if (chars <= 0) {
                return '';
            }
            if (input && input.length > chars) {
                input = input.substring(0, chars);

                if (!breakOnWord) {
                    var lastspace = input.lastIndexOf(' ');
                    // Get last space
                    if (lastspace !== -1) {
                        input = input.substr(0, lastspace);
                    }
                } else {
                    while (input.charAt(input.length-1) === ' ') {
                        input = input.substr(0, input.length - 1);
                    }
                }
                return input + '...';
            }
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('soopkitchenApp')
        .directive('jhSortBy', jhSortBy);

    function jhSortBy() {
        var directive = {
            restrict: 'A',
            scope: false,
            require: '^jhSort',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs, parentCtrl) {
            element.bind('click', function () {
                parentCtrl.sort(attrs.jhSortBy);
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('soopkitchenApp')
        .directive('jhSort', jhSort);

    function jhSort () {
        var directive = {
            restrict: 'A',
            scope: {
                predicate: '=jhSort',
                ascending: '=',
                callback: '&'
            },
            controller: SortController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;
    }

    SortController.$inject = ['$scope', '$element'];

    function SortController ($scope, $element) {
        var vm = this;

        vm.applyClass = applyClass;
        vm.resetClasses = resetClasses;
        vm.sort = sort;
        vm.triggerApply = triggerApply;

        $scope.$watchGroup(['vm.predicate', 'vm.ascending'], vm.triggerApply);
        vm.triggerApply();

        function applyClass (element) {
            var thisIcon = element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt',
                remove = sortIcon + ' ' + sortDesc,
                add = sortAsc;
            if (!vm.ascending) {
                remove = sortIcon + ' ' + sortAsc;
                add = sortDesc;
            }
            vm.resetClasses();
            thisIcon.removeClass(remove);
            thisIcon.addClass(add);
        }

        function resetClasses () {
            var allThIcons = $element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt';
            allThIcons.removeClass(sortAsc + ' ' + sortDesc);
            allThIcons.addClass(sortIcon);
        }

        function sort (field) {
            if (field !== vm.predicate) {
                vm.ascending = true;
            } else {
                vm.ascending = !vm.ascending;
            }
            vm.predicate = field;
            $scope.$apply();
            vm.callback();
        }

        function triggerApply (values)  {
            vm.resetClasses();
            if (values && values[0] !== '_score') {
                vm.applyClass($element.find('th[jh-sort-by=\'' + values[0] + '\']'));
            }
        }
    }
})();

(function(){
    'use strict';

    angular
        .module('soopkitchenApp')
        .factory('ParseLinks', ParseLinks);

    function ParseLinks () {

        var service = {
            parse : parse
        };

        return service;

        function parse(header) {
            if (header.length === 0) {
                throw new Error('input must not be of zero length');
            }

            // Split parts by comma
            var parts = header.split(',');
            var links = {};
            // Parse each part into a named link
            angular.forEach(parts, function(p) {
                var section = p.split('>;');
                if (section.length !== 2) {
                    throw new Error('section could not be split on ">;"');
                }
                var url = section[0].replace(/<(.*)/, '$1').trim();
                var queryString = {};
                url.replace(
                    new RegExp('([^?=&]+)(=([^&]*))?', 'g'),
                    function($0, $1, $2, $3) { queryString[$1] = $3; }
                );
                var page = queryString.page;
                if (angular.isString(page)) {
                    page = parseInt(page);
                }
                var name = section[1].replace(/rel="(.*)"/, '$1').trim();
                links[name] = page;
            });
            return links;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('soopkitchenApp')
        .factory('PaginationUtil', PaginationUtil);

    function PaginationUtil () {

        var service = {
            parseAscending : parseAscending,
            parsePage : parsePage,
            parsePredicate : parsePredicate
        };

        return service;

        function parseAscending (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                return sort.split(',').slice(-1)[0] === 'asc';
            } else {
                // default to true if no sort defined
                return true;
            }
        }

        // query params are strings, and need to be parsed
        function parsePage (page) {
            return parseInt(page);
        }

        // sort can be in the format `id,asc` or `id`
        function parsePredicate (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                sortArray.pop();
            }
            return sortArray.join(',');
        }
    }
})();

(function() {
    'use strict';

    var jhiItemCount = {
        template: '<div class="info">' +
                    'Showing {{(($ctrl.page - 1) * $ctrl.itemsPerPage) == 0 ? 1 : (($ctrl.page - 1) * $ctrl.itemsPerPage + 1)}} - ' +
                    '{{($ctrl.page * $ctrl.itemsPerPage) < $ctrl.queryCount ? ($ctrl.page * $ctrl.itemsPerPage) : $ctrl.queryCount}} ' +
                    'of {{$ctrl.queryCount}} items.' +
                '</div>',
        bindings: {
            page: '<',
            queryCount: '<total',
            itemsPerPage: '<'
        }
    };

    angular
        .module('soopkitchenApp')
        .component('jhiItemCount', jhiItemCount);
})();

(function() {
    'use strict';

    angular
        .module('soopkitchenApp')
        .factory('DateUtils', DateUtils);

    DateUtils.$inject = ['$filter'];

    function DateUtils ($filter) {

        var service = {
            convertDateTimeFromServer : convertDateTimeFromServer,
            convertLocalDateFromServer : convertLocalDateFromServer,
            convertLocalDateToServer : convertLocalDateToServer,
            dateformat : dateformat
        };

        return service;

        function convertDateTimeFromServer (date) {
            if (date) {
                return new Date(date);
            } else {
                return null;
            }
        }

        function convertLocalDateFromServer (date) {
            if (date) {
                var dateString = date.split('-');
                return new Date(dateString[0], dateString[1] - 1, dateString[2]);
            }
            return null;
        }

        function convertLocalDateToServer (date) {
            if (date) {
                return $filter('date')(date, 'yyyy-MM-dd');
            } else {
                return null;
            }
        }

        function dateformat () {
            return 'yyyy-MM-dd';
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('soopkitchenApp')
        .factory('DataUtils', DataUtils);

    DataUtils.$inject = ['$window'];

    function DataUtils ($window) {

        var service = {
            abbreviate: abbreviate,
            byteSize: byteSize,
            openFile: openFile,
            toBase64: toBase64
        };

        return service;

        function abbreviate (text) {
            if (!angular.isString(text)) {
                return '';
            }
            if (text.length < 30) {
                return text;
            }
            return text ? (text.substring(0, 15) + '...' + text.slice(-10)) : '';
        }

        function byteSize (base64String) {
            if (!angular.isString(base64String)) {
                return '';
            }

            function endsWith(suffix, str) {
                return str.indexOf(suffix, str.length - suffix.length) !== -1;
            }

            function paddingSize(base64String) {
                if (endsWith('==', base64String)) {
                    return 2;
                }
                if (endsWith('=', base64String)) {
                    return 1;
                }
                return 0;
            }

            function size(base64String) {
                return base64String.length / 4 * 3 - paddingSize(base64String);
            }

            function formatAsBytes(size) {
                return size.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' bytes';
            }

            return formatAsBytes(size(base64String));
        }

        function openFile (type, data) {
            $window.open('data:' + type + ';base64,' + data, '_blank', 'height=300,width=400');
        }

        function toBase64 (file, cb) {
            var fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = function (e) {
                var base64Data = e.target.result.substr(e.target.result.indexOf('base64,') + 'base64,'.length);
                cb(base64Data);
            };
        }
    }
})();

/*
 * ---license-start---
 * Solar Orbiter Science Operations software
 * ----
 * Copyright (C) 2012 - 2018 European Space Agency - Solar Orbiter SOC
 * ----
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Lesser General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Lesser Public License for more details.
 *
 * You should have received a copy of the GNU General Lesser Public
 * License along with this program.  If not, see
 * <http://www.gnu.org/licenses/lgpl-3.0.html>.
 * ---license-end---
 */
(function () {
    'use strict';

    angular
        .module('soopkitchenApp')
        .directive('closedRegistration', closedRegistration);

    closedRegistration.$inject = [];

    function closedRegistration() {
        return  {
            template : '<p class="alert-link" >The user registration is currently closed. \n' +
                '                    <a href="mailto:solarorbiter_sciops@esa.int"> Please send an email to request it.</p>'
        };

    }

})();

(function() {
    'use strict';

    angular
        .module('soopkitchenApp')
        .filter('capitalize', capitalize);

    function capitalize() {
        return capitalizeFilter;

        function capitalizeFilter (input) {
            if (input !== null) {
                input = input.toLowerCase();
                input = input.substring(0, 1).toUpperCase() + input.substring(1);
            }
            return input;
        }
    }
})();

(function() {
    /*jshint bitwise: false*/
    'use strict';

    angular
        .module('soopkitchenApp')
        .factory('Base64', Base64);

    function Base64 () {
        var keyStr = 'ABCDEFGHIJKLMNOP' +
            'QRSTUVWXYZabcdef' +
            'ghijklmnopqrstuv' +
            'wxyz0123456789+/' +
            '=';

        var service = {
            decode : decode,
            encode : encode
        };

        return service;

        function encode (input) {
            var output = '',
                chr1, chr2, chr3,
                enc1, enc2, enc3, enc4,
                i = 0;

            while (i < input.length) {
                chr1 = input.charCodeAt(i++);
                chr2 = input.charCodeAt(i++);
                chr3 = input.charCodeAt(i++);

                enc1 = chr1 >> 2;
                enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                enc4 = chr3 & 63;

                if (isNaN(chr2)) {
                    enc3 = enc4 = 64;
                } else if (isNaN(chr3)) {
                    enc4 = 64;
                }

                output = output +
                    keyStr.charAt(enc1) +
                    keyStr.charAt(enc2) +
                    keyStr.charAt(enc3) +
                    keyStr.charAt(enc4);
            }

            return output;
        }

        function decode (input) {
            var output = '',
                chr1, chr2, chr3,
                enc1, enc2, enc3, enc4,
                i = 0;

            // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
            input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');

            while (i < input.length) {
                enc1 = keyStr.indexOf(input.charAt(i++));
                enc2 = keyStr.indexOf(input.charAt(i++));
                enc3 = keyStr.indexOf(input.charAt(i++));
                enc4 = keyStr.indexOf(input.charAt(i++));

                chr1 = (enc1 << 2) | (enc2 >> 4);
                chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
                chr3 = ((enc3 & 3) << 6) | enc4;

                output = output + String.fromCharCode(chr1);

                if (enc3 !== 64) {
                    output = output + String.fromCharCode(chr2);
                }
                if (enc4 !== 64) {
                    output = output + String.fromCharCode(chr3);
                }
            }

            return output;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('soopkitchenApp')
        .factory('LoginService', LoginService);

    LoginService.$inject = ['$uibModal'];

    function LoginService ($uibModal) {
        var service = {
            open: open
        };

        var modalInstance = null;
        var resetModal = function () {
            modalInstance = null;
        };

        return service;

        function open () {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/components/login/login.html',
                controller: 'LoginController',
                controllerAs: 'vm'
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('soopkitchenApp')
        .controller('LoginController', LoginController);

    LoginController.$inject = ['$rootScope', '$state', '$timeout', 'Auth', '$uibModalInstance', 'Administration'];

    function LoginController ($rootScope, $state, $timeout, Auth, $uibModalInstance, Administration) {
        var vm = this;

        vm.authenticationError = false;
        vm.cancel = cancel;
        vm.credentials = {};
        vm.login = login;
        vm.password = null;
        vm.register = register;
        vm.rememberMe = true;
        vm.requestResetPassword = requestResetPassword;
        vm.username = null;
        vm.userRegistrationEnabled = false;



        $timeout(function (){angular.element('#username').focus();Administration.get({}, function(result) {
            vm.userRegistrationEnabled = result.userRegistrationEnabled;
        });});

        function cancel () {
            vm.credentials = {
                username: null,
                password: null,
                rememberMe: true
            };
            vm.authenticationError = false;
            $uibModalInstance.dismiss('cancel');
        }

        function login (event) {
            event.preventDefault();
            Auth.login({
                username: vm.username,
                password: vm.password,
                rememberMe: vm.rememberMe
            }).then(function () {
                vm.authenticationError = false;
                $uibModalInstance.close();
                if ($state.current.name === 'register' || $state.current.name === 'activate' ||
                    $state.current.name === 'finishReset' || $state.current.name === 'requestReset') {
                    $state.go('home');
                }

                $rootScope.$broadcast('authenticationSuccess');

                // previousState was set in the authExpiredInterceptor before being redirected to login modal.
                // since login is successful, go to stored previousState and clear previousState
                if (Auth.getPreviousState()) {
                    var previousState = Auth.getPreviousState();
                    Auth.resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }
            }).catch(function () {
                vm.authenticationError = true;
            });
        }

        function register () {
            $uibModalInstance.dismiss('cancel');
            $state.go('register');
        }

        function requestResetPassword () {
            $uibModalInstance.dismiss('cancel');
            $state.go('requestReset');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('soopkitchenApp')
        .directive('showValidation', showValidation);

    function showValidation () {
        var directive = {
            restrict: 'A',
            require: 'form',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, formCtrl) {
            element.find('.form-group').each(function() {
                var $formGroup = angular.element(this);
                var $inputs = $formGroup.find('input[ng-model],textarea[ng-model],select[ng-model]');

                if ($inputs.length > 0) {
                    $inputs.each(function() {
                        var $input = angular.element(this);
                        var inputName = $input.attr('name');
                        scope.$watch(function() {
                            if (formCtrl[inputName] === undefined) {
                                return false; // Input not found in form controller
                            }
                            return formCtrl[inputName].$invalid && formCtrl[inputName].$dirty;
                        }, function(isInvalid) {
                            $formGroup.toggleClass('has-error', isInvalid);
                        });
                    });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('soopkitchenApp')
        .constant('paginationConstants', {
            'itemsPerPage': 20
        });
})();

(function() {
    'use strict';

    angular
        .module('soopkitchenApp')
        .directive('minbytes', minbytes);

    function minbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.minbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) >= attrs.minbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('soopkitchenApp')
        .directive('maxbytes', maxbytes);

    function maxbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.maxbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) <= attrs.maxbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }

})();

(function() {
    'use strict';

    var jhiAlertError = {
        template: '<div class="alerts" ng-cloak="">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre>{{ alert.msg }}</pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertErrorController
    };

    angular
        .module('soopkitchenApp')
        .component('jhiAlertError', jhiAlertError);

    jhiAlertErrorController.$inject = ['$scope', 'AlertService', '$rootScope'];

    function jhiAlertErrorController ($scope, AlertService, $rootScope) {
        var vm = this;

        vm.alerts = [];

        function addErrorAlert (message, key, data) {
            vm.alerts.push(
                AlertService.add(
                    {
                        type: 'danger',
                        msg: message,
                        timeout: 8000,
                        toast: AlertService.isToast(),
                        scoped: true
                    },
                    vm.alerts
                )
            );
        }

        var cleanHttpErrorListener = $rootScope.$on('soopkitchenApp.httpError', function (event, httpResponse) {
            var i;
            event.stopPropagation();
            switch (httpResponse.status) {
            // connection refused, server not reachable
            case 0:
                addErrorAlert('Server not reachable','error.server.not.reachable');
                break;

            case 404:
                addErrorAlert('Not found','error.url.not.found');
                break;

            case 403:
                addErrorAlert('Access denied');
                break;

            default:
                var headers = Object.keys(httpResponse.headers()).filter(function (header) {
                    return header.indexOf('app-error', header.length - 'app-error'.length) !== -1 || header.indexOf('app-params', header.length - 'app-params'.length) !== -1;
                }).sort();
                var errorHeader = httpResponse.headers(headers[0]);
                var entityKey = httpResponse.headers(headers[1]);
                if (errorHeader) {
                    var entityName = entityKey;
                    addErrorAlert(errorHeader, errorHeader, {entityName: entityName});
                } else if (httpResponse.data && httpResponse.data.fieldErrors) {
                    for (i = 0; i < httpResponse.data.fieldErrors.length; i++) {
                        var fieldError = httpResponse.data.fieldErrors[i];
                        // convert 'something[14].other[4].id' to 'something[].other[].id' so translations can be written to it
                        var convertedField = fieldError.field.replace(/\[\d*\]/g, '[]');
                        var fieldName = convertedField.charAt(0).toUpperCase() + convertedField.slice(1);
                        addErrorAlert('Field ' + fieldName + ' cannot be empty', 'error.' + fieldError.message, {fieldName: fieldName});
                    }
                } else if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message, httpResponse.data.message, httpResponse.data);
                }
                break;
            }
        });

        $scope.$on('$destroy', function () {
            if(angular.isDefined(cleanHttpErrorListener) && cleanHttpErrorListener !== null){
                cleanHttpErrorListener();
                vm.alerts = [];
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('soopkitchenApp')
        .provider('AlertService', AlertService);

    function AlertService () {
        this.toast = false;
        /*jshint validthis: true */
        this.$get = getService;

        this.showAsToast = function(isToast) {
            this.toast = isToast;
        };

        getService.$inject = ['$timeout', '$sce'];

        function getService ($timeout, $sce) {
            var toast = this.toast,
                alertId = 0, // unique id for each alert. Starts from 0.
                alerts = [],
                timeout = 5000; // default timeout

            return {
                factory: factory,
                isToast: isToast,
                add: addAlert,
                closeAlert: closeAlert,
                closeAlertByIndex: closeAlertByIndex,
                clear: clear,
                get: get,
                success: success,
                error: error,
                info: info,
                warning : warning
            };

            function isToast() {
                return toast;
            }

            function clear() {
                alerts = [];
            }

            function get() {
                return alerts;
            }

            function success(msg, params, position) {
                return this.add({
                    type: 'success',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function error(msg, params, position) {
                return this.add({
                    type: 'danger',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function warning(msg, params, position) {
                return this.add({
                    type: 'warning',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function info(msg, params, position) {
                return this.add({
                    type: 'info',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function factory(alertOptions) {
                var alert = {
                    type: alertOptions.type,
                    msg: $sce.trustAsHtml(alertOptions.msg),
                    id: alertOptions.alertId,
                    timeout: alertOptions.timeout,
                    toast: alertOptions.toast,
                    position: alertOptions.position ? alertOptions.position : 'top right',
                    scoped: alertOptions.scoped,
                    close: function (alerts) {
                        return closeAlert(this.id, alerts);
                    }
                };
                if(!alert.scoped) {
                    alerts.push(alert);
                }
                return alert;
            }

            function addAlert(alertOptions, extAlerts) {
                alertOptions.alertId = alertId++;
                var that = this;
                var alert = this.factory(alertOptions);
                if (alertOptions.timeout && alertOptions.timeout > 0) {
                    $timeout(function () {
                        that.closeAlert(alertOptions.alertId, extAlerts);
                    }, alertOptions.timeout);
                }
                return alert;
            }

            function closeAlert(id, extAlerts) {
                var thisAlerts = extAlerts ? extAlerts : alerts;
                return closeAlertByIndex(thisAlerts.map(function(e) { return e.id; }).indexOf(id), thisAlerts);
            }

            function closeAlertByIndex(index, thisAlerts) {
                return thisAlerts.splice(index, 1);
            }
        }
    }
})();

(function() {
    'use strict';

    var jhiAlert = {
        template: '<div class="alerts" ng-cloak="">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre ng-bind-html="alert.msg"></pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertController
    };

    angular
        .module('soopkitchenApp')
        .component('jhiAlert', jhiAlert);

    jhiAlertController.$inject = ['$scope', 'AlertService'];

    function jhiAlertController($scope, AlertService) {
        var vm = this;

        vm.alerts = AlertService.get();
        $scope.$on('$destroy', function () {
            vm.alerts = [];
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('soopkitchenApp')
        .factory('notificationInterceptor', notificationInterceptor);

    notificationInterceptor.$inject = ['$q', 'AlertService'];

    function notificationInterceptor ($q, AlertService) {
        var service = {
            response: response
        };

        return service;

        function response (response) {
            var headers = Object.keys(response.headers()).filter(function (header) {
                return header.indexOf('app-alert', header.length - 'app-alert'.length) !== -1 || header.indexOf('app-params', header.length - 'app-params'.length) !== -1;
            }).sort();
            var alertKey = response.headers(headers[0]);
            if (angular.isString(alertKey)) {
                AlertService.success(alertKey, { param : response.headers(headers[1])});
            }
            return response;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('soopkitchenApp')
        .factory('errorHandlerInterceptor', errorHandlerInterceptor);

    errorHandlerInterceptor.$inject = ['$q', '$rootScope'];

    function errorHandlerInterceptor ($q, $rootScope) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError (response) {
            if (!(response.status === 401 && (response.data === '' || (response.data.path && response.data.path.indexOf('/api/account') === 0 )))) {
                $rootScope.$emit('soopkitchenApp.httpError', response);
            }
            return $q.reject(response);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('soopkitchenApp')
        .factory('authExpiredInterceptor', authExpiredInterceptor);

    authExpiredInterceptor.$inject = ['$rootScope', '$q', '$injector'];

    function authExpiredInterceptor($rootScope, $q, $injector) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError(response) {
            // If we have an unauthorized request we redirect to the login page
            // Don't do this check on the account API to avoid infinite loop
            if (response.status === 401 && angular.isDefined(response.data.path) && response.data.path.indexOf('/api/account') === -1) {
                var Auth = $injector.get('Auth');
                var to = $rootScope.toState;
                var params = $rootScope.toStateParams;
                Auth.logout();
                if (to.name !== 'accessdenied') {
                    Auth.storePreviousState(to.name, params);
                }
                var LoginService = $injector.get('LoginService');
                LoginService.open();
            }
            return $q.reject(response);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('soopkitchenApp')
        .factory('stateHandler', stateHandler);

    stateHandler.$inject = ['$rootScope', '$state', '$sessionStorage',  '$window',
        'Auth', 'Principal', 'VERSION'];

    function stateHandler($rootScope, $state, $sessionStorage,  $window,
        Auth, Principal, VERSION) {
        return {
            initialize: initialize
        };

        function initialize() {
            $rootScope.VERSION = VERSION;

            var stateChangeStart = $rootScope.$on('$stateChangeStart', function (event, toState, toStateParams, fromState) {
                $rootScope.toState = toState;
                $rootScope.toStateParams = toStateParams;
                $rootScope.fromState = fromState;

                // Redirect to a state with an external URL (http://stackoverflow.com/a/30221248/1098564)
                if (toState.external) {
                    event.preventDefault();
                    $window.open(toState.url, '_self');
                }

                if (Principal.isIdentityResolved()) {
                    Auth.authorize();
                }

            });

            var stateChangeSuccess = $rootScope.$on('$stateChangeSuccess',  function(event, toState, toParams, fromState, fromParams) {
                var titleKey = 'Soopkitchen' ;

                // Set the page title key to the one configured in state or use default one
                if (toState.data.pageTitle) {
                    titleKey = toState.data.pageTitle;
                }
                $window.document.title = titleKey;
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(stateChangeStart) && stateChangeStart !== null){
                    stateChangeStart();
                }
                if(angular.isDefined(stateChangeSuccess) && stateChangeSuccess !== null){
                    stateChangeSuccess();
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('soopkitchenApp')
        .config(paginationConfig);

    paginationConfig.$inject = ['uibPaginationConfig', 'paginationConstants'];

    function paginationConfig(uibPaginationConfig, paginationConstants) {
        uibPaginationConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPaginationConfig.maxSize = 5;
        uibPaginationConfig.boundaryLinks = true;
        uibPaginationConfig.firstText = '«';
        uibPaginationConfig.previousText = '‹';
        uibPaginationConfig.nextText = '›';
        uibPaginationConfig.lastText = '»';
    }
})();

(function () {
    'use strict';

    angular
        .module('soopkitchenApp')
        .config(pagerConfig);

    pagerConfig.$inject = ['uibPagerConfig', 'paginationConstants'];

    function pagerConfig(uibPagerConfig, paginationConstants) {
        uibPagerConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPagerConfig.previousText = '«';
        uibPagerConfig.nextText = '»';
    }
})();

(function() {
    'use strict';

    angular
        .module('soopkitchenApp')
        .config(localStorageConfig);

    localStorageConfig.$inject = ['$localStorageProvider', '$sessionStorageProvider'];

    function localStorageConfig($localStorageProvider, $sessionStorageProvider) {
        $localStorageProvider.setKeyPrefix('jhi-');
        $sessionStorageProvider.setKeyPrefix('jhi-');
    }
})();

(function() {
    'use strict';

    angular
        .module('soopkitchenApp')
        .config(httpConfig);

    httpConfig.$inject = ['$urlRouterProvider', '$httpProvider', 'httpRequestInterceptorCacheBusterProvider', '$urlMatcherFactoryProvider'];

    function httpConfig($urlRouterProvider, $httpProvider, httpRequestInterceptorCacheBusterProvider, $urlMatcherFactoryProvider) {
        //Cache everything except rest api requests
        httpRequestInterceptorCacheBusterProvider.setMatchlist([/.*api.*/, /.*protected.*/], true);

        $urlRouterProvider.otherwise('/');

        $httpProvider.interceptors.push('errorHandlerInterceptor');
        $httpProvider.interceptors.push('authExpiredInterceptor');
        $httpProvider.interceptors.push('notificationInterceptor');
        // jhipster-needle-angularjs-add-interceptor JHipster will add new application http interceptor here

        $urlMatcherFactoryProvider.type('boolean', {
            name : 'boolean',
            decode: function(val) { return val === true || val === 'true'; },
            encode: function(val) { return val ? 1 : 0; },
            equals: function(a, b) { return this.is(a) && a === b; },
            is: function(val) { return [true,false,0,1].indexOf(val) >= 0; },
            pattern: /bool|true|0|1/
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('soopkitchenApp')
        .config(compileServiceConfig);

    compileServiceConfig.$inject = ['$compileProvider','DEBUG_INFO_ENABLED'];

    function compileServiceConfig($compileProvider,DEBUG_INFO_ENABLED) {
        // disable debug data on prod profile to improve performance
        $compileProvider.debugInfoEnabled(DEBUG_INFO_ENABLED);

        /*
        If you wish to debug an application with this information
        then you should open up a debug console in the browser
        then call this method directly in this console:

		angular.reloadWithDebugInfo();
		*/
    }
})();

(function() {
    'use strict';

    angular
        .module('soopkitchenApp')
        .config(alertServiceConfig);

    alertServiceConfig.$inject = ['AlertServiceProvider'];

    function alertServiceConfig(AlertServiceProvider) {
        // set below to true to make alerts look like toast
        AlertServiceProvider.showAsToast(false);
    }
})();

(function() {
    'use strict';

    angular
        .module('soopkitchenApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('app', {
            abstract: true,
            views: {
                'navbar@': {
                    templateUrl: 'app/layouts/navbar/navbar.html',
                    controller: 'NavbarController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                authorize: ['Auth',
                    function (Auth) {
                        return Auth.authorize();
                    }
                ]
            }
        });
    }
})();

(function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('soopkitchenApp')
        .constant('VERSION', "10.8.0")
        .constant('DEBUG_INFO_ENABLED', false)
;
})();

(function() {
    'use strict';

    angular
        .module('soopkitchenApp')
        .controller('UserManagementDialogController',UserManagementDialogController);

    UserManagementDialogController.$inject = ['$stateParams', '$uibModalInstance', 'entity', 'User'];

    function UserManagementDialogController ($stateParams, $uibModalInstance, entity, User) {
        var vm = this;

        vm.authorities = ['ROLE_USER', 'ROLE_INSTRUMENT_TEAM_MEMBER', 'ROLE_INSTRUMENT_COORDINATOR', 'ROLE_POWER_USER', 'ROLE_PLAN_COORDINATOR', 'ROLE_ADMIN'];
        vm.instruments = ['EUI', 'Metis', 'PHI', 'SPICE', 'STIX', 'SoloHI', 'EPD', 'MAG', 'RPW', 'SWA'];
        vm.clear = clear;
        vm.languages = null;
        vm.save = save;
        vm.user = entity;



        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function onSaveSuccess (result) {
            vm.isSaving = false;
            $uibModalInstance.close(result);
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function save () {
            vm.isSaving = true;
            if (vm.user.id !== null) {
                User.update(vm.user, onSaveSuccess, onSaveError);
            } else {
                vm.user.langKey = 'en';
                User.save(vm.user, onSaveSuccess, onSaveError);
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('soopkitchenApp')
        .controller('UserManagementDetailController', UserManagementDetailController);

    UserManagementDetailController.$inject = ['$stateParams', 'User'];

    function UserManagementDetailController ($stateParams, User) {
        var vm = this;

        vm.load = load;
        vm.user = {};

        vm.load($stateParams.login);

        function load (login) {
            User.get({login: login}, function(result) {
                vm.user = result;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('soopkitchenApp')
        .controller('UserManagementDeleteController', UserManagementDeleteController);

    UserManagementDeleteController.$inject = ['$uibModalInstance', 'entity', 'User'];

    function UserManagementDeleteController ($uibModalInstance, entity, User) {
        var vm = this;

        vm.user = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (login) {
            User.delete({login: login},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('soopkitchenApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('user-management', {
            parent: 'admin',
            url: '/user-management?page&sort',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Users'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/user-management/user-management.html',
                    controller: 'UserManagementController',
                    controllerAs: 'vm'
                }
            },            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort)
                    };
                }]
            }        })
        .state('user-management-detail', {
            parent: 'admin',
            url: '/user/:login',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'soopkitchen'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/user-management/user-management-detail.html',
                    controller: 'UserManagementDetailController',
                    controllerAs: 'vm'
                }
            }
        })
        .state('user-management.new', {
            parent: 'user-management',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null, login: null, firstName: null, lastName: null, email: null,
                                activated: true, langKey: null, createdBy: null, createdDate: null,
                                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                                resetKey: null, authorities: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('user-management');
                });
            }]
        })
        .state('user-management.edit', {
            parent: 'user-management',
            url: '/{login}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({login : $stateParams.login});
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('user-management.delete', {
            parent: 'user-management',
            url: '/{login}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-delete-dialog.html',
                    controller: 'UserManagementDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({login : $stateParams.login});
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('soopkitchenApp')
        .controller('UserManagementController', UserManagementController);

    UserManagementController.$inject = ['Principal', 'User', 'ParseLinks', 'AlertService', '$scope', 'SoopkitchenUtils', 'Administration'];

    function UserManagementController(Principal, User, ParseLinks, AlertService, $scope, SoopkitchenUtils, Administration) {
        var vm = this;

        vm.authorities = ['ROLE_INSTRUMENT_COORDINATOR', 'ROLE_INSTRUMENT_TEAM_MEMBER', 'ROLE_USER', 'ROLE_POWER_USER', 'ROLE_PLAN_COORDINATOR', 'ROLE_ADMIN'];
        vm.currentAccount = null;
        vm.languages = null;
        vm.loadAll = loadAll;
        vm.setActive = setActive;
        vm.users = [];
        vm.totalItems = null;
        vm.clear = clear;
        vm.links = null;
        vm.sort = sort;
        vm.userRegistrationEnabled = false;
        vm.enableRegistration = enableRegistration;
        vm.disableRegistration = disableRegistration;

        vm.loadAll();
        Principal.identity().then(function(account) {
            vm.currentAccount = account;
        });

        function setActive (user, isActivated) {
            user.activated = isActivated;
            User.update(user, function () {
                vm.loadAll();
                vm.clear();
            });
        }

        function loadAll () {
            User.query(
            onSuccess, onError);
            Administration.get({}, function(result) {
                    vm.userRegistrationEnabled = result.userRegistrationEnabled;
            });
        }

        function onSuccess(data) {
            //hide anonymous user from user management: it's a required user for Spring Security
            var hiddenUsersSize = 0;
            for (var i in data) {
                if (data[i]['login'] === 'anonymoususer') {
                    data.splice(i, 1);
                    hiddenUsersSize++;
                }
            }
            vm.users = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function clear () {
            vm.user = {
                id: null, login: null, firstName: null, lastName: null, email: null,
                activated: null, langKey: null, createdBy: null, createdDate: null,
                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                resetKey: null, authorities: null
            };
        }

        function sort () {
            vm.users = SoopkitchenUtils.sort(vm.users, vm.predicate, !vm.ascending);
            $scope.$apply();
        }
        function enableRegistration () {
            Administration.update({userRegistrationEnabled: true}, function(result) {
                vm.userRegistrationEnabled = result.userRegistrationEnabled;
                $scope.$apply();
            });
        }
        function disableRegistration () {
            Administration.update({userRegistrationEnabled: false}, function(result) {
                vm.userRegistrationEnabled = result.userRegistrationEnabled;
                $scope.$apply();
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('soopkitchenApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-tracker', {
            parent: 'admin',
            url: '/tracker',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Real-time user activities'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/tracker/tracker.html',
                    controller: 'JhiTrackerController',
                    controllerAs: 'vm'
                }
            },
            onEnter: ['JhiTrackerService', function(JhiTrackerService) {
                JhiTrackerService.subscribe();
            }],
            onExit: ['JhiTrackerService', function(JhiTrackerService) {
                JhiTrackerService.unsubscribe();
            }]
        });
    }
})();

(function() {
    'use strict';
    /* globals SockJS, Stomp */

    angular
        .module('soopkitchenApp')
        .factory('JhiTrackerService', JhiTrackerService);

    JhiTrackerService.$inject = ['$rootScope', '$window', '$cookies', '$http', '$q'];

    function JhiTrackerService ($rootScope, $window, $cookies, $http, $q) {
        var stompClient = null;
        var subscriber = null;
        var listener = $q.defer();
        var connected = $q.defer();
        var alreadyConnectedOnce = false;

        var service = {
            connect: connect,
            disconnect: disconnect,
            receive: receive,
            sendActivity: sendActivity,
            subscribe: subscribe,
            unsubscribe: unsubscribe
        };

        return service;

        function connect () {
            //building absolute path so that websocket doesnt fail when deploying with a context path
            var loc = $window.location;
            var url = '//' + loc.host + loc.pathname + 'websocket/tracker';
            var socket = new SockJS(url);
            stompClient = Stomp.over(socket);
            var stateChangeStart;
            var headers = {};
            headers[$http.defaults.xsrfHeaderName] = $cookies.get($http.defaults.xsrfCookieName);
            stompClient.connect(headers, function() {
                connected.resolve('success');
                sendActivity();
                if (!alreadyConnectedOnce) {
                    stateChangeStart = $rootScope.$on('$stateChangeStart', function () {
                        sendActivity();
                    });
                    alreadyConnectedOnce = true;
                }
            });
            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(stateChangeStart) && stateChangeStart !== null){
                    stateChangeStart();
                }
            });
        }

        function disconnect () {
            if (stompClient !== null) {
                stompClient.disconnect();
                stompClient = null;
            }
        }

        function receive () {
            return listener.promise;
        }

        function sendActivity() {
            if (stompClient !== null && stompClient.connected) {
                stompClient
                    .send('/topic/activity',
                    {},
                    angular.toJson({'page': $rootScope.toState.name}));
            }
        }

        function subscribe () {
            connected.promise.then(function() {
                subscriber = stompClient.subscribe('/topic/tracker', function(data) {
                    listener.notify(angular.fromJson(data.body));
                });
            }, null, null);
        }

        function unsubscribe () {
            if (subscriber !== null) {
                subscriber.unsubscribe();
            }
            listener = $q.defer();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('soopkitchenApp')
        .controller('JhiTrackerController', JhiTrackerController);

    JhiTrackerController.$inject = ['$cookies', '$http', 'JhiTrackerService'];

    function JhiTrackerController ($cookies, $http, JhiTrackerService) {
        // This controller uses a Websocket connection to receive user activities in real-time.
        var vm = this;

        vm.activities = [];

        JhiTrackerService.receive().then(null, null, function(activity) {
            showActivity(activity);
        });

        function showActivity(activity) {
            var existingActivity = false;
            for (var index = 0; index < vm.activities.length; index++) {
                if(vm.activities[index].sessionId === activity.sessionId) {
                    existingActivity = true;
                    if (activity.page === 'logout') {
                        vm.activities.splice(index, 1);
                    } else {
                        vm.activities[index] = activity;
                    }
                }
            }
            if (!existingActivity && (activity.page !== 'logout')) {
                vm.activities.push(activity);
            }
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('soopkitchenApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-metrics', {
            parent: 'admin',
            url: '/metrics',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Application Metrics'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/metrics/metrics.html',
                    controller: 'JhiMetricsMonitoringController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('soopkitchenApp')
        .factory('JhiMetricsService', JhiMetricsService);

    JhiMetricsService.$inject = ['$rootScope', '$http'];

    function JhiMetricsService ($rootScope, $http) {
        var service = {
            getMetrics: getMetrics,
            threadDump: threadDump
        };

        return service;

        function getMetrics () {
            return $http.get('management/metrics').then(function (response) {
                return response.data;
            });
        }

        function threadDump () {
            return $http.get('management/dump').then(function (response) {
                return response.data;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('soopkitchenApp')
        .controller('JhiMetricsMonitoringModalController', JhiMetricsMonitoringModalController);

    JhiMetricsMonitoringModalController.$inject = ['$uibModalInstance', 'threadDump'];

    function JhiMetricsMonitoringModalController ($uibModalInstance, threadDump) {
        var vm = this;

        vm.cancel = cancel;
        vm.getLabelClass = getLabelClass;
        vm.threadDump = threadDump;
        vm.threadDumpAll = 0;
        vm.threadDumpBlocked = 0;
        vm.threadDumpRunnable = 0;
        vm.threadDumpTimedWaiting = 0;
        vm.threadDumpWaiting = 0;

        angular.forEach(threadDump, function(value) {
            if (value.threadState === 'RUNNABLE') {
                vm.threadDumpRunnable += 1;
            } else if (value.threadState === 'WAITING') {
                vm.threadDumpWaiting += 1;
            } else if (value.threadState === 'TIMED_WAITING') {
                vm.threadDumpTimedWaiting += 1;
            } else if (value.threadState === 'BLOCKED') {
                vm.threadDumpBlocked += 1;
            }
        });

        vm.threadDumpAll = vm.threadDumpRunnable + vm.threadDumpWaiting +
            vm.threadDumpTimedWaiting + vm.threadDumpBlocked;

        function cancel () {
            $uibModalInstance.dismiss('cancel');
        }

        function getLabelClass (threadState) {
            if (threadState === 'RUNNABLE') {
                return 'label-success';
            } else if (threadState === 'WAITING') {
                return 'label-info';
            } else if (threadState === 'TIMED_WAITING') {
                return 'label-warning';
            } else if (threadState === 'BLOCKED') {
                return 'label-danger';
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('soopkitchenApp')
        .controller('JhiMetricsMonitoringController', JhiMetricsMonitoringController);

    JhiMetricsMonitoringController.$inject = ['$scope','JhiMetricsService', '$uibModal'];

    function JhiMetricsMonitoringController ($scope, JhiMetricsService, $uibModal) {
        var vm = this;

        vm.metrics = {};
        vm.refresh = refresh;
        vm.refreshThreadDumpData = refreshThreadDumpData;
        vm.servicesStats = {};
        vm.updatingMetrics = true;

        vm.refresh();

        $scope.$watch('vm.metrics', function (newValue) {
            vm.servicesStats = {};
            angular.forEach(newValue.timers, function (value, key) {
                if (key.indexOf('web.rest') !== -1 || key.indexOf('service') !== -1) {
                    vm.servicesStats[key] = value;
                }
            });

        });

        function refresh () {
            vm.updatingMetrics = true;
            JhiMetricsService.getMetrics().then(function (promise) {
                vm.metrics = promise;
                vm.updatingMetrics = false;
            }, function (promise) {
                vm.metrics = promise.data;
                vm.updatingMetrics = false;
            });
        }

        function refreshThreadDumpData () {
            JhiMetricsService.threadDump().then(function(data) {
                $uibModal.open({
                    templateUrl: 'app/admin/metrics/metrics.modal.html',
                    controller: 'JhiMetricsMonitoringModalController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        threadDump: function() {
                            return data;
                        }

                    }
                });
            });
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('soopkitchenApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('logs', {
            parent: 'admin',
            url: '/logs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Logs'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/logs/logs.html',
                    controller: 'LogsController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('soopkitchenApp')
        .factory('LogsService', LogsService);

    LogsService.$inject = ['$resource'];

    function LogsService ($resource) {
        var service = $resource('management/logs', {}, {
            'findAll': { method: 'GET', isArray: true},
            'changeLevel': { method: 'PUT'}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('soopkitchenApp')
        .controller('LogsController', LogsController);

    LogsController.$inject = ['LogsService'];

    function LogsController (LogsService) {
        var vm = this;

        vm.changeLevel = changeLevel;
        vm.loggers = LogsService.findAll();

        function changeLevel (name, level) {
            LogsService.changeLevel({name: name, level: level}, function () {
                vm.loggers = LogsService.findAll();
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('soopkitchenApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-health', {
            parent: 'admin',
            url: '/health',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Health Checks'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/health/health.html',
                    controller: 'JhiHealthCheckController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('soopkitchenApp')
        .factory('JhiHealthService', JhiHealthService);

    JhiHealthService.$inject = ['$rootScope', '$http'];

    function JhiHealthService ($rootScope, $http) {
        var separator = '.';
        var service = {
            checkHealth: checkHealth,
            transformHealthData: transformHealthData,
            getBaseName: getBaseName,
            getSubSystemName: getSubSystemName
        };

        return service;

        function checkHealth () {
            return $http.get('management/health').then(function (response) {
                return response.data;
            });
        }

        function transformHealthData (data) {
            var response = [];
            flattenHealthData(response, null, data);
            return response;
        }

        function getBaseName (name) {
            if (name) {
                var split = name.split('.');
                return split[0];
            }
        }

        function getSubSystemName (name) {
            if (name) {
                var split = name.split('.');
                split.splice(0, 1);
                var remainder = split.join('.');
                return remainder ? ' - ' + remainder : '';
            }
        }

        /* private methods */
        function flattenHealthData (result, path, data) {
            angular.forEach(data, function (value, key) {
                if (isHealthObject(value)) {
                    if (hasSubSystem(value)) {
                        addHealthObject(result, false, value, getModuleName(path, key));
                        flattenHealthData(result, getModuleName(path, key), value);
                    } else {
                        addHealthObject(result, true, value, getModuleName(path, key));
                    }
                }
            });
            return result;
        }

        function addHealthObject (result, isLeaf, healthObject, name) {

            var healthData = {
                'name': name
            };
            var details = {};
            var hasDetails = false;

            angular.forEach(healthObject, function (value, key) {
                if (key === 'status' || key === 'error') {
                    healthData[key] = value;
                } else {
                    if (!isHealthObject(value)) {
                        details[key] = value;
                        hasDetails = true;
                    }
                }
            });

            // Add the of the details
            if (hasDetails) {
                angular.extend(healthData, { 'details': details});
            }

            // Only add nodes if they provide additional information
            if (isLeaf || hasDetails || healthData.error) {
                result.push(healthData);
            }
            return healthData;
        }

        function getModuleName (path, name) {
            var result;
            if (path && name) {
                result = path + separator + name;
            }  else if (path) {
                result = path;
            } else if (name) {
                result = name;
            } else {
                result = '';
            }
            return result;
        }

        function hasSubSystem (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value) {
                if (value && value.status) {
                    result = true;
                }
            });
            return result;
        }

        function isHealthObject (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value, key) {
                if (key === 'status') {
                    result = true;
                }
            });
            return result;
        }

    }
})();

(function() {
    'use strict';

    angular.module('soopkitchenApp')
        .controller('HealthModalController', HealthModalController);

    HealthModalController.$inject = ['$uibModalInstance', 'currentHealth', 'baseName', 'subSystemName'];

    function HealthModalController ($uibModalInstance, currentHealth, baseName, subSystemName) {
        var vm = this;

        vm.cancel = cancel;
        vm.currentHealth = currentHealth;
        vm.baseName = baseName;
        vm.subSystemName = subSystemName;

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('soopkitchenApp')
        .controller('JhiHealthCheckController', JhiHealthCheckController);

    JhiHealthCheckController.$inject = ['JhiHealthService', '$uibModal'];

    function JhiHealthCheckController (JhiHealthService, $uibModal) {
        var vm = this;

        vm.updatingHealth = true;
        vm.getLabelClass = getLabelClass;
        vm.refresh = refresh;
        vm.showHealth = showHealth;
        vm.baseName = JhiHealthService.getBaseName;
        vm.subSystemName = JhiHealthService.getSubSystemName;

        vm.refresh();

        function getLabelClass (statusState) {
            if (statusState === 'UP') {
                return 'label-success';
            } else {
                return 'label-danger';
            }
        }

        function refresh () {
            vm.updatingHealth = true;
            JhiHealthService.checkHealth().then(function (response) {
                vm.healthData = JhiHealthService.transformHealthData(response);
                vm.updatingHealth = false;
            }, function (response) {
                vm.healthData =  JhiHealthService.transformHealthData(response.data);
                vm.updatingHealth = false;
            });
        }

        function showHealth (health) {
            $uibModal.open({
                templateUrl: 'app/admin/health/health.modal.html',
                controller: 'HealthModalController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    currentHealth: function() {
                        return health;
                    },
                    baseName: function() {
                        return vm.baseName;
                    },
                    subSystemName: function() {
                        return vm.subSystemName;
                    }

                }
            });
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('soopkitchenApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('docs', {
            parent: 'admin',
            url: '/docs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'API'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/docs/docs.html'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('soopkitchenApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-configuration', {
            parent: 'admin',
            url: '/configuration',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Configuration'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/configuration/configuration.html',
                    controller: 'JhiConfigurationController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('soopkitchenApp')
        .factory('JhiConfigurationService', JhiConfigurationService);

    JhiConfigurationService.$inject = ['$filter', '$http'];

    function JhiConfigurationService ($filter, $http) {
        var service = {
            get: get,
            getEnv: getEnv
        };

        return service;

        function get () {
            return $http.get('management/configprops').then(getConfigPropsComplete);

            function getConfigPropsComplete (response) {
                var properties = [];
                angular.forEach(response.data, function (data) {
                    properties.push(data);
                });
                var orderBy = $filter('orderBy');
                return orderBy(properties, 'prefix');
            }
        }

        function getEnv () {
            return $http.get('management/env').then(getEnvComplete);

            function getEnvComplete (response) {
                var properties = {};
                angular.forEach(response.data, function (val,key) {
                    var vals = [];
                    angular.forEach(val, function (v,k) {
                        vals.push({ key:k, val:v });
                    });
                    properties[key] = vals;
                });
                return properties;
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('soopkitchenApp')
        .controller('JhiConfigurationController', JhiConfigurationController);

    JhiConfigurationController.$inject = ['$filter','JhiConfigurationService'];

    function JhiConfigurationController (filter,JhiConfigurationService) {
        var vm = this;

        vm.allConfiguration = null;
        vm.configuration = null;

        JhiConfigurationService.get().then(function(configuration) {
            vm.configuration = configuration;
        });
        JhiConfigurationService.getEnv().then(function (configuration) {
            vm.allConfiguration = configuration;
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('soopkitchenApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('audits', {
            parent: 'admin',
            url: '/audits',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Audits'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/audits/audits.html',
                    controller: 'AuditsController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('soopkitchenApp')
        .factory('AuditsService', AuditsService);

    AuditsService.$inject = ['$resource'];

    function AuditsService ($resource) {
        var service = $resource('management/audits/:id', {}, {
            'get': {
                method: 'GET',
                isArray: true
            },
            'query': {
                method: 'GET',
                isArray: true,
                params: {fromDate: null, toDate: null}
            }
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('soopkitchenApp')
        .controller('AuditsController', AuditsController);

    AuditsController.$inject = ['$filter', 'AuditsService', 'ParseLinks'];

    function AuditsController ($filter, AuditsService, ParseLinks) {
        var vm = this;

        vm.audits = null;
        vm.fromDate = null;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.onChangeDate = onChangeDate;
        vm.page = 1;
        vm.previousMonth = previousMonth;
        vm.toDate = null;
        vm.today = today;
        vm.totalItems = null;

        vm.today();
        vm.previousMonth();
        vm.onChangeDate();

        function onChangeDate () {
            var dateFormat = 'yyyy-MM-dd';
            var fromDate = $filter('date')(vm.fromDate, dateFormat);
            var toDate = $filter('date')(vm.toDate, dateFormat);

            AuditsService.query({page: vm.page -1, size: 20, fromDate: fromDate, toDate: toDate}, function(result, headers){
                vm.audits = result;
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
            });
        }

        // Date picker configuration
        function today () {
            // Today + 1 day - needed if the current day must be included
            var today = new Date();
            vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);
        }

        function previousMonth () {
            var fromDate = new Date();
            if (fromDate.getMonth() === 0) {
                fromDate = new Date(fromDate.getFullYear() - 1, 11, fromDate.getDate());
            } else {
                fromDate = new Date(fromDate.getFullYear(), fromDate.getMonth() - 1, fromDate.getDate());
            }

            vm.fromDate = fromDate;
        }

        function loadPage (page) {
            vm.page = page;
            vm.onChangeDate();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('soopkitchenApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('admin', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('soopkitchenApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('settings', {
            parent: 'account',
            url: '/settings',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Settings'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/settings/settings.html',
                    controller: 'SettingsController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('soopkitchenApp')
        .controller('SettingsController', SettingsController);

    SettingsController.$inject = ['Principal', 'Auth'];

    function SettingsController (Principal, Auth) {
        var vm = this;

        vm.error = null;
        vm.save = save;
        vm.settingsAccount = null;
        vm.success = null;

        /**
         * Store the "settings account" in a separate variable, and not in the shared "account" variable.
         */
        var copyAccount = function (account) {
            return {
                activated: account.activated,
                email: account.email,
                firstName: account.firstName,
                langKey: account.langKey,
                lastName: account.lastName,
                login: account.login,
                authorities: account.authorities,
                instruments: account.instruments,
            };
        };

        Principal.identity().then(function(account) {
            vm.settingsAccount = copyAccount(account);
        });

        function save () {
            Auth.updateAccount(vm.settingsAccount).then(function() {
                vm.error = null;
                vm.success = 'OK';
                Principal.identity(true).then(function(account) {
                    vm.settingsAccount = copyAccount(account);
                });
            }).catch(function() {
                vm.success = null;
                vm.error = 'ERROR';
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('soopkitchenApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('sessions', {
            parent: 'account',
            url: '/sessions',
            data: {
                authorities: ['ROLE_INSTRUMENT_COORDINATOR', 'ROLE_INSTRUMENT_TEAM_MEMBER', 'ROLE_USER', 'ROLE_POWER_USER', 'ROLE_PLAN_COORDINATOR', 'ROLE_ADMIN'],
                pageTitle: 'Sessions'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/sessions/sessions.html',
                    controller: 'SessionsController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('soopkitchenApp')
        .controller('SessionsController', SessionsController);

    SessionsController.$inject = ['Sessions', 'Principal'];

    function SessionsController (Sessions, Principal) {
        var vm = this;

        vm.account = null;
        vm.error = null;
        vm.invalidate = invalidate;
        vm.sessions = Sessions.getAll();
        vm.success = null;


        Principal.identity().then(function(account) {
            vm.account = account;
        });

        function invalidate (series) {
            Sessions.delete({series: encodeURIComponent(series)},
                function () {
                    vm.error = null;
                    vm.success = 'OK';
                    vm.sessions = Sessions.getAll();
                },
                function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('soopkitchenApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('requestReset', {
            parent: 'account',
            url: '/reset/request',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/request/reset.request.html',
                    controller: 'RequestResetController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('soopkitchenApp')
        .controller('RequestResetController', RequestResetController);

    RequestResetController.$inject = ['$timeout', 'Auth'];

    function RequestResetController ($timeout, Auth) {
        var vm = this;

        vm.error = null;
        vm.errorEmailNotExists = null;
        vm.requestReset = requestReset;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#email').focus();});

        function requestReset () {

            vm.error = null;
            vm.errorEmailNotExists = null;

            Auth.resetPasswordInit(vm.resetAccount.email).then(function () {
                vm.success = 'OK';
            }).catch(function (response) {
                vm.success = null;
                if (response.status === 400 && response.data === 'e-mail address not registered') {
                    vm.errorEmailNotExists = 'ERROR';
                } else {
                    vm.error = 'ERROR';
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('soopkitchenApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('finishReset', {
            parent: 'account',
            url: '/reset/finish?key',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/finish/reset.finish.html',
                    controller: 'ResetFinishController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('soopkitchenApp')
        .controller('ResetFinishController', ResetFinishController);

    ResetFinishController.$inject = ['$stateParams', '$timeout', 'Auth', 'LoginService'];

    function ResetFinishController ($stateParams, $timeout, Auth, LoginService) {
        var vm = this;

        vm.keyMissing = angular.isUndefined($stateParams.key);
        vm.confirmPassword = null;
        vm.doNotMatch = null;
        vm.error = null;
        vm.finishReset = finishReset;
        vm.login = LoginService.open;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#password').focus();});

        function finishReset() {
            vm.doNotMatch = null;
            vm.error = null;
            if (vm.resetAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                Auth.resetPasswordFinish({key: $stateParams.key, newPassword: vm.resetAccount.password}).then(function () {
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('soopkitchenApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('register', {
            parent: 'account',
            url: '/register',
            data: {
                authorities: [],
                pageTitle: 'Registration'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/register/register.html',
                    controller: 'RegisterController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('soopkitchenApp')
        .controller('RegisterController', RegisterController);


    RegisterController.$inject = [ '$timeout', 'Auth', 'LoginService', 'Administration'];

    function RegisterController ($timeout, Auth, LoginService, Administration) {
        var vm = this;

        vm.doNotMatch = null;
        vm.error = null;
        vm.errorUserExists = null;
        vm.login = LoginService.open;
        vm.register = register;
        vm.registerAccount = {};
        vm.success = null;
        vm.userRegistrationEnabled = false;

        Administration.get({}, function(result) {
            vm.userRegistrationEnabled = result.userRegistrationEnabled;
        });


        $timeout(function (){angular.element('#login').focus();});

        function register () {
            if (vm.registerAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                vm.registerAccount.langKey =  'en' ;
                vm.doNotMatch = null;
                vm.error = null;
                vm.errorUserExists = null;
                vm.errorEmailExists = null;

                Auth.createAccount(vm.registerAccount).then(function () {
                    vm.success = 'OK';
                }).catch(function (response) {
                    vm.success = null;
                    if (response.status === 400 && response.data === 'login already in use') {
                        vm.errorUserExists = 'ERROR';
                    } else if (response.status === 400 && response.data === 'e-mail address already in use') {
                        vm.errorEmailExists = 'ERROR';
                    } else {
                        vm.error = 'ERROR';
                    }
                });
            }
        }
    }
})();

/* globals $ */
(function() {
    'use strict';

    angular
        .module('soopkitchenApp')
        .directive('passwordStrengthBar', passwordStrengthBar);

    function passwordStrengthBar () {
        var directive = {
            replace: true,
            restrict: 'E',
            template: '<div id="strength">' +
                '<small>Password strength:</small>' +
                '<ul id="strengthBar">' +
                '<li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li>' +
                '</ul>' +
                '</div>',
            scope: {
                passwordToCheck: '='
            },
            link: linkFunc
        };

        return directive;

        /* private helper methods*/

        function linkFunc(scope, iElement) {
            var strength = {
                colors: ['#F00', '#F90', '#FF0', '#9F0', '#0F0'],
                mesureStrength: function (p) {

                    var _force = 0;
                    var _regex = /[$-/:-?{-~!"^_`\[\]]/g; // "

                    var _lowerLetters = /[a-z]+/.test(p);
                    var _upperLetters = /[A-Z]+/.test(p);
                    var _numbers = /[0-9]+/.test(p);
                    var _symbols = _regex.test(p);

                    var _flags = [_lowerLetters, _upperLetters, _numbers, _symbols];
                    var _passedMatches = $.grep(_flags, function (el) {
                        return el === true;
                    }).length;

                    _force += 2 * p.length + ((p.length >= 10) ? 1 : 0);
                    _force += _passedMatches * 10;

                    // penalty (short password)
                    _force = (p.length <= 6) ? Math.min(_force, 10) : _force;

                    // penalty (poor variety of characters)
                    _force = (_passedMatches === 1) ? Math.min(_force, 10) : _force;
                    _force = (_passedMatches === 2) ? Math.min(_force, 20) : _force;
                    _force = (_passedMatches === 3) ? Math.min(_force, 40) : _force;

                    return _force;

                },
                getColor: function (s) {

                    var idx;
                    if (s <= 10) {
                        idx = 0;
                    }
                    else if (s <= 20) {
                        idx = 1;
                    }
                    else if (s <= 30) {
                        idx = 2;
                    }
                    else if (s <= 40) {
                        idx = 3;
                    }
                    else {
                        idx = 4;
                    }

                    return { idx: idx + 1, col: this.colors[idx] };
                }
            };
            scope.$watch('passwordToCheck', function (password) {
                if (password) {
                    var c = strength.getColor(strength.mesureStrength(password));
                    iElement.removeClass('ng-hide');
                    iElement.find('ul').children('li')
                        .css({ 'background-color': '#DDD' })
                        .slice(0, c.idx)
                        .css({ 'background-color': c.col });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('soopkitchenApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('password', {
            parent: 'account',
            url: '/password',
            data: {
                authorities: ['ROLE_INSTRUMENT_COORDINATOR', 'ROLE_INSTRUMENT_TEAM_MEMBER', 'ROLE_USER', 'ROLE_POWER_USER', 'ROLE_PLAN_COORDINATOR', 'ROLE_ADMIN'],
                pageTitle: 'Password'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/password/password.html',
                    controller: 'PasswordController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('soopkitchenApp')
        .controller('PasswordController', PasswordController);

    PasswordController.$inject = ['Auth', 'Principal'];

    function PasswordController (Auth, Principal) {
        var vm = this;

        vm.changePassword = changePassword;
        vm.doNotMatch = null;
        vm.error = null;
        vm.success = null;

        Principal.identity().then(function(account) {
            vm.account = account;
        });

        function changePassword () {
            if (vm.password !== vm.confirmPassword) {
                vm.error = null;
                vm.success = null;
                vm.doNotMatch = 'ERROR';
            } else {
                vm.doNotMatch = null;
                Auth.changePassword(vm.password).then(function () {
                    vm.error = null;
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('soopkitchenApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('activate', {
            parent: 'account',
            url: '/activate?key',
            data: {
                authorities: [],
                pageTitle: 'Activation'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/activate/activate.html',
                    controller: 'ActivationController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('soopkitchenApp')
        .controller('ActivationController', ActivationController);

    ActivationController.$inject = ['$stateParams', 'Auth', 'LoginService'];

    function ActivationController ($stateParams, Auth, LoginService) {
        var vm = this;

        Auth.activateAccount({key: $stateParams.key}).then(function () {
            vm.error = null;
            vm.success = 'OK';
        }).catch(function () {
            vm.success = null;
            vm.error = 'ERROR';
        });

        vm.login = LoginService.open;
    }
})();

(function() {
    'use strict';

    angular
        .module('soopkitchenApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('account', {
            abstract: true,
            parent: 'app'
        });
    }
})();
(function(){angular.module('soopkitchenApp').run(['$templateCache', function($templateCache) {$templateCache.put('app/cookiepolicy/cookiepolicy.html','<div ng-cloak><div class="row"><div class="col-md-3"><span class="hipster img-responsive img-rounded"></span></div><div class="col-md-7"><div class="row"><div class="col-md-12"><h1 class="page-header">Cookies policy</h1></div><div class="col-md-12"><p>We use cookies to facilitate the use of our website. Cookies are small text files stored by your browser on the hard drive of your computer when you use our site.</p><p>We use them to:</p><ul><li>Save the User Session once identified</li><li>Remember your planning duration preferences</li><li>Remember your planning zoom preferences</li></ul><p>The cookies we use do not store any personal data beyond your Soopkitchen user name.</p><p>If you do not want to receive cookies, please configure your Internet browser to delete them from the hard drive of your computer, block them or warn you in case of installation of the same.</p></div></div></div></div></div>');
$templateCache.put('app/entities/dialog-footer.html','<div class="modal-footer"><button id="cancelButton" type="button" class="btn btn-info" data-dismiss="modal" ng-click="vm.clear()" ng-disabled="vm.waiting"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>{{vm.cancelText}}</span></button> <button id="saveButton" type="button" class="btn btn-success" ng-click="vm.save()" ng-disabled="vm.saveDisabled || dialogForm.$invalid || vm.waiting"><span class="glyphicon glyphicon-duplicate"></span>&nbsp;<span>{{vm.saveText}}</span></button> <button class="btn btn-danger" ng-show="vm.deleteText!==\'None\'" ng-click="vm.delete()" ng-disabled="vm.waiting"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div><jhi-alert-error></jhi-alert-error><jhi-alert></jhi-alert>');
$templateCache.put('app/entities/dialog-header.html','<wait ng-show="vm.waiting"></wait><div class="modal-header" ng-show="vm.waiting===false"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h3 class="modal-title"><span ng-bind-html="vm.headerTitle"></span></h3></div>');
$templateCache.put('app/home/home.html','<div ng-cloak><div class="row"><div class="col-md-3"><span class="hipster img-responsive img-rounded"></span></div><div class="col-md-7"><div ng-switch="vm.isAuthenticated()"><div ng-switch-when="false"><h1 class="page-header">Welcome, Soopkitchen User!</h1></div><div ng-switch-when="true"><h1 class="page-header" id="welcome-login-message">Welcome, {{vm.account.login}}!</h1></div><div class="alert alert-info" ng-switch-when="true"><strong><a ui-sref="observation-definitions">Observation definitions</a></strong>: Add, Delete and Inspect Observation Definitions</div><div class="alert alert-info" ng-switch-when="true"><strong><a ui-sref="event-collections">Event collections</a></strong>: Create, Upload, Delete and Inspect Event Collections</div><div class="alert alert-info" ng-switch-when="true"><strong><a ui-sref="planning">Planning</a></strong>: Create, Modify, View, Manage and Export Science Operation Plans</div><div class="alert alert-warning" ng-switch-when="false">You are not signed in, please do so: <a class="alert-link" href="" ng-click="vm.login()">Sign in</a></div><div class="alert alert-warning" ng-switch-when="false">You don\'t have an account yet? <span ng-show="vm.userRegistrationEnabled"><a class="alert-link" ui-sref="register">Register a new account</a></span><closed-registration ng-show="!vm.userRegistrationEnabled"></closed-registration></div></div></div></div></div>');
$templateCache.put('app/account/activate/activate.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1>Activation</h1><div class="alert alert-success" ng-show="vm.success"><strong>Your user has been activated.</strong> Please <a class="alert-link" href="" ng-click="vm.login()">sign in</a>.</div><div class="alert alert-danger" ng-show="vm.error"><strong>Your user could not be activated.</strong> Please use the registration form to sign up.</div></div></div></div>');
$templateCache.put('app/account/password/password.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h2>Password for [<strong>{{vm.account.login}}</strong>]</h2><div class="alert alert-success" ng-show="vm.success"><strong>Password changed!</strong></div><div class="alert alert-danger" ng-show="vm.error"><strong>An error has occurred!</strong> The password could not be changed.</div><div class="alert alert-danger" ng-show="vm.doNotMatch">The password and its confirmation do not match!</div><form name="form" role="form" novalidate ng-submit="vm.changePassword()" show-validation><div class="form-group"><label class="control-label" for="password">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="New password" ng-model="vm.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="Confirm the new password" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required">Your confirmation password is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength">Your confirmation password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength">Your confirmation password cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary">Save</button></form></div></div></div>');
$templateCache.put('app/account/register/register.html','<div><div class="row" ng-show="vm.userRegistrationEnabled"><div class="col-md-8 col-md-offset-2"><h1>Registration</h1><div class="alert alert-success" ng-show="vm.success"><strong>Registration saved!</strong> Please check your email for confirmation.</div><div class="alert alert-danger" ng-show="vm.error"><strong>Registration failed!</strong> Please try again later.</div><div class="alert alert-danger" ng-show="vm.errorUserExists"><strong>Login name already registered!</strong> Please choose another one.</div><div class="alert alert-danger" ng-show="vm.errorEmailExists"><strong>E-mail is already in use!</strong> Please choose another one.</div><div class="alert alert-danger" ng-show="vm.doNotMatch">The password and its confirmation do not match!</div></div><div class="col-md-8 col-md-offset-2"><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.register()" show-validation><div class="form-group"><label class="control-label" for="login">Username</label><input type="text" class="form-control" id="login" name="login" placeholder="Your username" ng-model="vm.registerAccount.login" ng-minlength="1" ng-maxlength="50" ng-pattern="/^[_\'.@A-Za-z0-9-]*$/" required><div ng-show="form.login.$dirty && form.login.$invalid"><p class="help-block" ng-show="form.login.$error.required">Your username is required.</p><p class="help-block" ng-show="form.login.$error.minlength">Your username is required to be at least 1 character.</p><p class="help-block" ng-show="form.login.$error.maxlength">Your username cannot be longer than 50 characters.</p><p class="help-block" ng-show="form.login.$error.pattern">Your username can only contain lower-case letters and digits.</p></div></div><div class="form-group"><label class="control-label" for="email">E-mail</label><input type="email" class="form-control" id="email" name="email" placeholder="Your e-mail" ng-model="vm.registerAccount.email" ng-minlength="5" ng-maxlength="100" required><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required">Your e-mail is required.</p><p class="help-block" ng-show="form.email.$error.email">Your e-mail is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength">Your e-mail is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength">Your e-mail cannot be longer than 100 characters.</p></div></div><div class="form-group"><label class="control-label" for="password">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="New password" ng-model="vm.registerAccount.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.registerAccount.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="Confirm the new password" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required">Your confirmation password is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength">Your confirmation password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength">Your confirmation password cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary">Register</button></form><p></p></div></div><div class="row" ng-show="!vm.userRegistrationEnabled"><div class="col-md-8 col-md-offset-2"><h1>Registration</h1><closed-registration ng-show="!vm.userRegistrationEnabled"></closed-registration></div></div></div>');
$templateCache.put('app/account/sessions/sessions.html','<div><h2>Active sessions for [<strong>{{vm.account.login}}</strong>]</h2><div class="alert alert-success" ng-show="vm.success"><strong>Session invalidated!</strong></div><div class="alert alert-danger" ng-show="vm.error"><strong>An error has occured!</strong> The session could not be invalidated.</div><div class="table-responsive"><table class="table table-striped"><thead><tr><th>IP Address</th><th>User agent</th><th>Date</th><th></th></tr></thead><tbody><tr ng-repeat="session in vm.sessions"><td>{{session.ipAddress}}</td><td>{{session.userAgent}}</td><td>{{session.tokenDate | date:\'longDate\'}}</td><td><button ng-show="false" type="submit" class="btn btn-primary" ng-click="vm.invalidate(session.series)">Invalidate</button></td></tr></tbody></table></div></div>');
$templateCache.put('app/account/settings/settings.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h2>User settings for [<strong>{{vm.settingsAccount.login}}</strong>]</h2><div class="alert alert-success" ng-show="vm.success"><strong>Settings saved!</strong></div><jhi-alert-error></jhi-alert-error><form name="form" role="form" novalidate ng-submit="vm.save()" show-validation><div class="form-group"><label class="control-label" for="firstName">First Name</label><input type="text" class="form-control" id="firstName" name="firstName" placeholder="Your first name" ng-model="vm.settingsAccount.firstName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.firstName.$dirty && form.firstName.$invalid"><p class="help-block" ng-show="form.firstName.$error.required">Your first name is required.</p><p class="help-block" ng-show="form.firstName.$error.minlength">Your first name is required to be at least 1 character.</p><p class="help-block" ng-show="form.firstName.$error.maxlength">Your first name cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" for="lastName">Last Name</label><input type="text" class="form-control" id="lastName" name="lastName" placeholder="Your last name" ng-model="vm.settingsAccount.lastName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.lastName.$dirty && form.lastName.$invalid"><p class="help-block" ng-show="form.lastName.$error.required">Your last name is required.</p><p class="help-block" ng-show="form.lastName.$error.minlength">Your last name is required to be at least 1 character.</p><p class="help-block" ng-show="form.lastName.$error.maxlength">Your last name cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" for="email">E-mail</label><input type="email" class="form-control" id="email" name="email" placeholder="Your e-mail" ng-model="vm.settingsAccount.email" ng-minlength="5" ng-maxlength="100" required maxlength="100"><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required">Your e-mail is required.</p><p class="help-block" ng-show="form.email.$error.email">Your e-mail is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength">Your e-mail is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength">Your e-mail cannot be longer than 100 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary">Save</button></form></div></div><hr><div><h4>Roles</h4><ul><li ng-repeat="role in vm.settingsAccount.authorities">{{role.substring(role.indexOf(\'ROLE_\') + \'ROLE_\'.length)}}</li></ul></div><hr><div><h4>Instruments</h4><ul><li ng-repeat="instrument in vm.settingsAccount.instruments">{{instrument}}</li></ul></div></div>');
$templateCache.put('app/admin/audits/audits.html','<div><h2>Audits</h2><div class="row"><div class="col-md-5"><h4>Filter by date</h4><p class="input-group"><span class="input-group-addon">from</span> <input type="date" class="input-sm form-control" name="start" ng-model="vm.fromDate" ng-change="vm.onChangeDate()" required> <span class="input-group-addon">to</span> <input type="date" class="input-sm form-control" name="end" ng-model="vm.toDate" ng-change="vm.onChangeDate()" required></p></div></div><table class="table table-condensed table-striped table-bordered table-responsive"><thead><tr><th ng-click="predicate = \'timestamp\'; reverse=!reverse"><span>Date</span></th><th ng-click="predicate = \'principal\'; reverse=!reverse"><span>User</span></th><th ng-click="predicate = \'type\'; reverse=!reverse"><span>State</span></th><th ng-click="predicate = \'data.message\'; reverse=!reverse"><span>Extra data</span></th></tr></thead><tr ng-repeat="audit in vm.audits | filter:filter | orderBy:predicate:reverse" ng-hide="audit.filtered"><td><span>{{audit.timestamp| date:\'medium\'}}</span></td><td><small>{{audit.principal}}</small></td><td>{{audit.type}}</td><td><span ng-show="audit.data.message">{{audit.data.message}}</span> <span ng-show="audit.data.remoteAddress"><span>Remote Address</span> {{audit.data.remoteAddress}}</span></td></tr></table><div class="text-center"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.loadPage(vm.page)"></uib-pagination></div></div>');
$templateCache.put('app/admin/configuration/configuration.html','<div><h2>Configuration</h2><span>Filter (by prefix)</span> <input type="text" ng-model="filter" class="form-control"><label ng-hide="filteredConfig.length == 0">Spring configuration</label><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filteredConfig.length == 0"><thead><tr><th ng-click="predicate = \'prefix\'; reverse=!reverse" class="col-sm-4"><span>Prefix</span></th><th class="col-sm-8">Properties</th></tr></thead><tr ng-repeat="entry in filtered = (vm.configuration | filter:filter | orderBy:predicate:reverse)"><td><span>{{entry.prefix}}</span></td><td><div class="row" ng-repeat="(key, value) in entry.properties"><div class="col-md-4">{{key}}</div><div class="col-md-8"><span class="pull-right label label-default break">{{value}}</span></div></div></td></tr></table><div ng-repeat="(key, value) in vm.allConfiguration"><label ng-hide="filtered.length == 0"><span>{{key}}</span></label><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filtered.length == 0"><thead><tr><th class="col-sm-4">Property</th><th class="col-sm-8">Value</th></tr></thead><tbody><tr ng-repeat="item in filtered = (value | filter:filter)"><td class="break">{{item.key}}</td><td class="break"><span class="pull-right label label-default break">{{item.val}}</span></td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/docs/docs.html','<iframe src="swagger-ui/index.html" frameborder="0" marginheight="0" marginwidth="0" width="100%" height="900" scrolling="auto" target="_top" title="Swagger UI"></iframe>');
$templateCache.put('app/admin/health/health.html','<div><h2>Health Checks</h2><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span>Refresh</span></button></p><table id="healthCheck" class="table table-striped"><thead><tr><th class="col-md-7">Service Name</th><th class="col-md-2 text-center">Status</th><th class="col-md-2 text-center">Details</th></tr></thead><tbody><tr ng-repeat="health in vm.healthData"><td><span class="text-capitalize">{{ vm.baseName(health.name) }}</span> {{vm.subSystemName(health.name)}}</td><td class="text-center"><span class="label" ng-class="vm.getLabelClass(health.status)">{{ health.status }}</span></td><td class="text-center"><a class="hand" ng-click="vm.showHealth(health)" ng-show="health.details || health.error"><em class="glyphicon glyphicon-eye-open"></em></a></td></tr></tbody></table></div>');
$templateCache.put('app/admin/health/health.modal.html','<div class="modal-header"><button aria-label="Close" data-dismiss="modal" class="close" type="button" ng-click="vm.cancel()"><span aria-hidden="true">&times;</span></button><h4 class="modal-title" id="showHealthLabel"><span class="text-capitalize">{{ vm.baseName(vm.currentHealth.name) }}</span> {{vm.subSystemName(vm.currentHealth.name)}}</h4></div><div class="modal-body pad"><div ng-show="vm.currentHealth.details"><h4>Properties</h4><table class="table table-striped"><thead><tr><th class="col-md-6 text-left">Name</th><th class="col-md-6 text-left">Value</th></tr></thead><tbody><tr ng-repeat="(k,v) in vm.currentHealth.details"><td class="col-md-6 text-left">{{k}}</td><td class="col-md-6 text-left">{{v}}</td></tr></tbody></table></div><div ng-show="vm.currentHealth.error"><h4>Error</h4><pre>{{vm.currentHealth.error}}</pre></div></div><div class="modal-footer"><button data-dismiss="modal" class="btn btn-default pull-left" type="button" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/logs/logs.html','<div class="table-responsive"><h2>Logs</h2><p>There are {{ vm.loggers.length }} loggers.</p><span>Filter</span> <input type="text" ng-model="filter" class="form-control"><table class="table table-condensed table-striped table-bordered"><thead><tr title="click to order"><th ng-click="predicate = \'name\'; reverse=!reverse"><span>Name</span></th><th ng-click="predicate = \'level\'; reverse=!reverse"><span>Level</span></th></tr></thead><tr ng-repeat="logger in vm.loggers | filter:filter | orderBy:predicate:reverse"><td><small>{{logger.name | characters:140}}</small></td><td><button ng-click="vm.changeLevel(logger.name, \'TRACE\')" ng-class="(logger.level==\'TRACE\') ? \'btn-danger\' : \'btn-default\'" class="btn btn-default btn-xs">TRACE</button> <button ng-click="vm.changeLevel(logger.name, \'DEBUG\')" ng-class="(logger.level==\'DEBUG\') ? \'btn-warning\' : \'btn-default\'" class="btn btn-default btn-xs">DEBUG</button> <button ng-click="vm.changeLevel(logger.name, \'INFO\')" ng-class="(logger.level==\'INFO\') ? \'btn-info\' : \'btn-default\'" class="btn btn-default btn-xs">INFO</button> <button ng-click="vm.changeLevel(logger.name, \'WARN\')" ng-class="(logger.level==\'WARN\') ? \'btn-success\' : \'btn-default\'" class="btn btn-default btn-xs">WARN</button> <button ng-click="vm.changeLevel(logger.name, \'ERROR\')" ng-class="(logger.level==\'ERROR\') ? \'btn-primary\' : \'btn-default\'" class="btn btn-default btn-xs">ERROR</button></td></tr></table></div>');
$templateCache.put('app/admin/tracker/tracker.html','<div><h2>Real-time user activities</h2><div class="table-responsive"><table class="table table-striped"><thead><tr><th>User</th><th>IP Address</th><th>Current page</th><th>Time</th><th></th></tr></thead><tbody><tr ng-repeat="activity in vm.activities"><td>{{activity.userLogin}}</td><td>{{activity.ipAddress}}</td><td>{{activity.page}}</td><td>{{activity.time}}</td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/metrics/metrics.html','<div><h2>Application Metrics</h2><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span>Refresh</span></button></p><h3>JVM Metrics</h3><div class="row" ng-hide="vm.updatingMetrics"><div class="col-md-4"><strong>Memory</strong><p><span>Total Memory</span> ({{vm.metrics.gauges[\'jvm.memory.total.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.total.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.total.max\'].value" value="vm.metrics.gauges[\'jvm.memory.total.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.total.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.total.max\'].value | number:0}}%</span></uib-progressbar><p><span>Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.heap.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.heap.max\'].value" value="vm.metrics.gauges[\'jvm.memory.heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.heap.max\'].value | number:0}}%</span></uib-progressbar><p><span>Non-Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value" value="vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><strong>Threads</strong> (Total: {{vm.metrics.gauges[\'jvm.threads.count\'].value}}) <a class="hand" ng-click="vm.refreshThreadDumpData()" data-toggle="modal" data-target="#threadDump"><em class="glyphicon glyphicon-eye-open"></em></a><p><span>Runnable</span> {{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value}}</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.runnable.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span>Timed Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span>Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span>Blocked</span> ({{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.blocked.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><strong>Garbage collections</strong><div class="row"><div class="col-md-9">Mark Sweep count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.count\'].value}}</div></div><div class="row"><div class="col-md-9">Mark Sweep time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.time\'].value}}ms</div></div><div class="row"><div class="col-md-9">Scavenge count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.count\'].value}}</div></div><div class="row"><div class="col-md-9">Scavenge time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.time\'].value}}ms</div></div></div></div><div class="well well-lg" ng-show="vm.updatingMetrics">Updating...</div><h3>HTTP requests (events per second)</h3><p><span>Active requests</span> <strong>{{vm.metrics.counters[\'com.codahale.metrics.servlet.InstrumentedFilter.activeRequests\'].count | number:0}}</strong> - <span>Total requests</span> <strong>{{vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count | number:0}}</strong></p><div class="table-responsive"><table class="table table-striped"><thead><tr><th>Code</th><th>Count</th><th class="text-right">Mean</th><th class="text-right"><span>Average</span> (1 min)</th><th class="text-right"><span>Average</span> (5 min)</th><th class="text-right"><span>Average</span> (15 min)</th></tr></thead><tbody><tr><td>OK</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m15_rate | number:2}}</td></tr><tr><td>Not Found</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m15_rate | number:2}}</td></tr><tr><td>Server error</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m15_rate | number:2}}</td></tr></tbody></table></div><h3>Services statistics (time in millisecond)</h3><div class="table-responsive"><table class="table table-striped"><thead><tr><th>Service name</th><th class="text-right">Count</th><th class="text-right">Mean</th><th class="text-right">Min</th><th class="text-right">p50</th><th class="text-right">p75</th><th class="text-right">p95</th><th class="text-right">p99</th><th class="text-right">Max</th></tr></thead><tbody><tr ng-repeat="(k, v) in vm.servicesStats"><td>{{k}}</td><td class="text-right">{{v.count}}</td><td class="text-right">{{v.mean * 1000 | number:0}}</td><td class="text-right">{{v.min * 1000 | number:0}}</td><td class="text-right">{{v.p50 * 1000 | number:0}}</td><td class="text-right">{{v.p75 * 1000 | number:0}}</td><td class="text-right">{{v.p95 * 1000 | number:0}}</td><td class="text-right">{{v.p99 * 1000 | number:0}}</td><td class="text-right">{{v.max * 1000 | number:0}}</td></tr></tbody></table></div><h3 ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0">DataSource statistics (time in millisecond)</h3><div class="table-responsive" ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0"><table class="table table-striped"><thead><tr><th><span>Usage</span> ({{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value}} / {{vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value}})</th><th class="text-right">Count</th><th class="text-right">Mean</th><th class="text-right">Min</th><th class="text-right">p50</th><th class="text-right">p75</th><th class="text-right">p95</th><th class="text-right">p99</th><th class="text-right">Max</th></tr></thead><tbody><tr><td><div class="progress progress-striped"><uib-progressbar min="0" max="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value" value="vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value * 100 / vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value | number:0}}%</span></uib-progressbar></div></td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].count}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].mean | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].min | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p50 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p75 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p95 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p99 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].max | number:2}}</td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/metrics/metrics.modal.html','<!-- Modal used to display the threads dump --><div class="modal-header"><button type="button" class="close" ng-click="vm.cancel()">&times;</button><h4 class="modal-title">Threads dump</h4></div><div class="modal-body pad"><span class="label label-primary" ng-click="threadDumpFilter = {}">All&nbsp;<span class="badge">{{vm.threadDumpAll}}</span></span>&nbsp; <span class="label label-success" ng-click="threadDumpFilter = {threadState: \'RUNNABLE\'}">Runnable&nbsp;<span class="badge">{{vm.threadDumpRunnable}}</span></span>&nbsp; <span class="label label-info" ng-click="threadDumpFilter = {threadState: \'WAITING\'}">Waiting&nbsp;<span class="badge">{{vm.threadDumpWaiting}}</span></span>&nbsp; <span class="label label-warning" ng-click="threadDumpFilter = {threadState: \'TIMED_WAITING\'}">Timed Waiting&nbsp;<span class="badge">{{vm.threadDumpTimedWaiting}}</span></span>&nbsp; <span class="label label-danger" ng-click="threadDumpFilter = {threadState: \'BLOCKED\'}">Blocked&nbsp;<span class="badge">{{vm.threadDumpBlocked}}</span></span>&nbsp;<div class="voffset2">&nbsp;</div>Filter <input type="text" ng-model="threadDumpFilter" class="form-control"><div class="row pad" ng-repeat="(k, v) in vm.threadDump | filter:threadDumpFilter"><h5><span class="label" ng-class="vm.getLabelClass(v.threadState)">{{v.threadState}}</span>&nbsp;{{v.threadName}} (ID {{v.threadId}}) <a ng-click="show = !show"><span ng-show="!show">Show StackTrace</span> <span ng-show="show">Hide StackTrace</span></a></h5><div class="well" ng-show="show"><div ng-repeat="(stK, stV) in v.stackTrace">{{stV.className}}.{{stV.methodName}}({{stV.fileName}}:{{stV.lineNumber}}) <span class="voffset1"></span></div></div><table class="table table-condensed"><thead><tr><th class="text-right">Blocked Time</th><th class="text-right">Blocked Count</th><th class="text-right">Waited Time</th><th class="text-right">Waited Count</th><th>Lock Name</th></tr></thead><tbody><tr><td>{{v.blockedTime}}</td><td>{{v.blockedCount}}</td><td>{{v.waitedTime}}</td><td>{{v.waitedCount}}</td><td>{{v.lockName}}</td></tr></tbody></table></div></div><div class="modal-footer"><button type="button" class="btn btn-default pull-left" data-dismiss="modal" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/user-management/user-management-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.user.login)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this User?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/admin/user-management/user-management-detail.html','<div><h2><span>User</span> "{{vm.user.login}}"</h2><dl class="dl-horizontal"><dt><span>Login</span></dt><dd><span>{{vm.user.login}}</span></dd><dt><span>First Name</span></dt><dd>{{vm.user.firstName}}</dd><dt><span>Last Name</span></dt><dd>{{vm.user.lastName}}</dd><dt><span>Email</span></dt><dd>{{vm.user.email}}</dd><dt><span>Activated</span></dt><dd>{{vm.user.activated}}</dd><dt><span>Created By</span></dt><dd>{{vm.user.createdBy}}</dd><dt><span>Created Date</span></dt><dd>{{vm.user.createdDate | date:\'dd/MM/yy HH:mm\' }}</dd><dt><span>Last Modified By</span></dt><dd>{{vm.user.lastModifiedBy}}</dd><dt><span>Last Modified Date</span></dt><dd>{{vm.user.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}</dd><dt><span>Profiles</span></dt><dd><ul class="list-unstyled"><li ng-repeat="authority in vm.user.authorities"><span>{{authority}}</span></li></ul></dd><dt><span>Instruments</span></dt><dd><ul class="list-unstyled"><li ng-repeat="instrument in vm.user.instruments"><span>{{instrument}}</span></li></ul></dd></dl><button type="submit" ui-sref="user-management" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button></div>');
$templateCache.put('app/admin/user-management/user-management-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myUserLabel">Create or edit a User</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label>ID</label><input type="text" class="form-control" name="id" ng-model="vm.user.id" readonly="readonly"></div><div class="form-group"><label class="control-label">Login</label><input type="text" class="form-control" name="login" ng-model="vm.user.login" ng-required="vm.user.id == null" ng-minlength="1" ng-maxlength="50" ng-pattern="/^[_\'.@A-Za-z0-9-]*$/"><div ng-show="editForm.login.$invalid"><p class="help-block" ng-show="editForm.login.$error.required">This field is required.</p><p class="help-block" ng-show="editForm.login.$error.maxlength">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label">First Name</label><input type="text" class="form-control" name="firstName" ng-model="vm.user.firstName" ng-maxlength="50"><div ng-show="editForm.firstName.$invalid"><p class="help-block" ng-show="editForm.firstName.$error.maxlength">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label>Last Name</label><input type="text" class="form-control" name="lastName" ng-model="vm.user.lastName" ng-maxlength="50"><div ng-show="editForm.lastName.$invalid"><p class="help-block" ng-show="editForm.lastName.$error.maxlength">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label">Email</label><input type="email" class="form-control" name="email" ng-model="vm.user.email" required ng-maxlength="100"><div ng-show="editForm.email.$invalid"><p class="help-block" ng-show="editForm.email.$error.required">This field is required.</p><p class="help-block" ng-show="editForm.email.$error.maxlength">This field cannot be longer than 100 characters.</p><p class="help-block" ng-show="editForm.email.$error.email">Your e-mail is invalid.</p></div></div><div class="form-group"><label for="activated"><input ng-disabled="vm.user.id === null" type="checkbox" id="activated" name="activated" ng-model="vm.user.activated"> <span>Activated</span></label></div><div class="form-group"><label>Profiles</label><select class="form-control" multiple="multiple" name="authority" ng-model="vm.user.authorities" ng-options="authority for authority in vm.authorities"></select></div><div class="form-group"><label>Instruments</label><select class="form-control" multiple="multiple" name="instrument" ng-model="vm.user.instruments" ng-options="instrument for instrument in vm.instruments"></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/admin/user-management/user-management.html','<div><h2>Users</h2><jhi-alert></jhi-alert><div class="row"><div class="col-md-12"><button class="btn btn-primary" ui-sref="user-management.new"><span class="glyphicon glyphicon-flash"></span> <span>Create a new User</span></button> <button class="btn btn-primary" ng-click="vm.enableRegistration()" ng-show="!vm.userRegistrationEnabled"><span class="glyphicon glyphicon-eye-close"></span> <span>Open User Registration</span></button> <button class="btn btn-primary" ng-click="vm.disableRegistration()" ng-show="vm.userRegistrationEnabled"><span class="glyphicon glyphicon-user"></span> <span>Close User Registration</span></button> <span class="label label-danger" ng-show="!vm.userRegistrationEnabled" style="cursor: pointer">User Registration Closed</span> <span class="label label-success" ng-show="vm.userRegistrationEnabled" style="cursor: pointer">User Registration Open</span><div class="form-group pull-right"><label for="search">Total {{results.length}} row(s)</label><input id="search" placeholder="Search text" type="text" ng-model="vm.searchText"></div></div></div><div class="table-wrapper-scroll-y"><table class="table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.ascending" callback="vm.sort()"><th jh-sort-by="id"><span>ID</span><span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="login"><span>Login</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="email"><span>Email</span> <span class="glyphicon glyphicon-sort"></span></th><th></th><th><span>Profiles</span></th><th><span>Instruments</span></th><th jh-sort-by="createdDate"><span>Created Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastModifiedBy"><span>Last Modified By</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastModifiedDate"><span>Last Modified Date</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="user in vm.users| filter:vm.searchText as results track by user.id"><td><a ui-sref="user-management-detail({login:user.login})">{{user.id}}</a></td><td>{{user.login}}</td><td>{{user.email}}</td><td><span class="label label-danger" ng-click="vm.setActive(user, true)" ng-show="!user.activated" style="cursor: pointer">Deactivated</span> <span class="label label-success" ng-click="vm.setActive(user, false)" ng-show="user.activated" style="cursor: pointer">Activated</span></td><td><div ng-repeat="authority in user.authorities"><span class="label label-info">{{ authority }}</span></div></td><td><div ng-repeat="instrument in user.instruments"><span class="label label-info">{{ instrument }}</span></div></td><td>{{user.createdDate | date:\'dd/MM/yy HH:mm\'}}</td><td>{{user.lastModifiedBy}}</td><td>{{user.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="user-management-detail({login:user.login})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="user-management.edit({login:user.login})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="user-management.delete({login:user.login})" class="btn btn-danger btn-sm" ng-disabled="vm.currentAccount.login==user.login"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/components/login/login.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.cancel()">&times;</button><h4 class="modal-title">Sign in</h4></div><div class="modal-body"><div class="row"><div class="col-md-4 col-md-offset-4"><h1>Sign in</h1></div><div class="col-md-8 col-md-offset-2"><div class="alert alert-danger" ng-show="vm.authenticationError"><strong>Failed to sign in!</strong> Please check your credentials and try again.</div></div><div class="col-md-8 col-md-offset-2"><form class="form" role="form" ng-submit="vm.login($event)"><div class="form-group"><label for="username">Login</label><input type="text" class="form-control" id="username" placeholder="Your username" ng-model="vm.username"></div><div class="form-group"><label for="password">Password</label><input type="password" class="form-control" id="password" placeholder="Your password" ng-model="vm.password"></div><div class="form-group"><label for="rememberMe"><input type="checkbox" id="rememberMe" ng-model="vm.rememberMe" checked="checked"> <span>Remember me</span></label></div><button type="submit" class="btn btn-primary">Sign in</button></form><p></p><div class="alert alert-warning"><a class="alert-link" href="" ng-click="vm.requestResetPassword()">Did you forget your password?</a></div><div class="alert alert-warning">You don\'t have an account yet? <a ng-show="vm.userRegistrationEnabled" class="alert-link" href="" ng-click="vm.register()">Register a new account</a><closed-registration ng-show="!vm.userRegistrationEnabled"></closed-registration></div></div></div></div>');
$templateCache.put('app/entities/event-collections/egs-details.html','<wait ng-show="vm.waiting"></wait><div ng-show="!vm.waiting"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h3 class="modal-title">Job <span class="label label-info">{{vm.egsJob.id}}</span>, Status <span class="label {{vm.jobsStatusClass(vm.egsJob.processStatus)}}">{{vm.egsJob.processStatus}}</span></h3></div><div class="modal-body"><div class="form-group"><br><div class="row"><label class="col-sm-4 control-label">Orbit file name</label><span class="label label-info label-xs">{{vm.spec.orbitFilename}}</span></div><div class="row"><label class="col-sm-4 control-label">Nominal start specifier</label><span class="label label-info label-xs">{{vm.spec.nominalStartSpecifier}}</span></div></div><br><table class="table table-striped table-condensed"><thead><th>EGS Parameter</th><th>Value</th></thead><tbody><tr><td width="50%">checkoutWindows</td><td><p ng-repeat="date in vm.egsParameters.checkoutWindows track by $index ">{{vm.displayDate(date)}}</p></td></tr><tr><td width="50%">checkoutPassWindows</td><td><p ng-repeat="date in vm.egsParameters.checkoutPassWindows track by $index ">{{vm.displayDate(date)}}</p></td></tr><tr><td>cruiseExtraPassPeriodDays</td><td>{{vm.egsParameters.cruiseExtraPassPeriodDays}}</td></tr><tr><td>cruiseExtraPassWindows</td><td><p ng-repeat="date in vm.egsParameters.cruiseExtraPassWindows track by $index ">{{vm.displayDate(date)}}</p></td></tr><tr><td>cruisePassPrimaryDuration</td><td>{{vm.egsParameters.cruisePassPrimaryDuration}}</td></tr><tr><td>cruisePassSecondaryDurWindows</td><td><p ng-repeat="date in vm.egsParameters.cruisePassSecondaryDurWindows track by $index ">{{vm.displayDate(date)}}</p></td></tr><tr><td>cruisePassSecondaryDuration</td><td>{{vm.egsParameters.cruisePassSecondaryDuration}}</td></tr><tr><td>dailyPassAllocationHours</td><td>{{vm.egsParameters.dailyPassAllocationHours}}</td></tr><tr><td>gsHandoverHours</td><td>{{vm.egsParameters.gsHandoverHours}}</td></tr><tr><td>maxRSWindows</td><td><p ng-repeat="date in vm.egsParameters.maxRSWindows track by $index ">{{vm.displayDate(date)}}</p></td></tr><tr><td>minExtraPassLengthHours</td><td>{{vm.egsParameters.minExtraPassLengthHours}}</td></tr><tr><td>minPassLengthHours</td><td>{{vm.egsParameters.minPassLengthHours}}</td></tr><tr><td>minRSWindows</td><td><p ng-repeat="date in vm.egsParameters.minRSWindows track by $index ">{{vm.displayDate(date)}}</p></td></tr><tr><td>passFailurePeriod</td><td>{{vm.egsParameters.passFailurePeriod}}</td></tr><tr><td>periRSWindows</td><td><p ng-repeat="date in vm.egsParameters.periRSWindows track by $index ">{{vm.displayDate(date)}}</p></td></tr><tr><td>scReservedPerExtraPassHours</td><td>{{vm.egsParameters.scReservedPerExtraPassHours}}</td></tr><tr><td>scReservedPerPrimaryPassHours</td><td>{{vm.egsParameters.scReservedPerPrimaryPassHours}}</td></tr><tr><td>secondaryGSPassLimitHours</td><td>{{vm.egsParameters.secondaryGSPassLimitHours}}</td></tr><tr><td>maxRedistributedAllocationHours</td><td>{{vm.egsParameters.maxRedistributedAllocationHours}}</td></tr><tr><td>secondaryPassBoundSequence</td><td><p ng-repeat="date in vm.egsParameters.secondaryPassBoundSequence track by $index ">{{vm.displayDate(date)}}</p></td></tr><tr><td>spiceSearchStepSize</td><td>{{vm.egsParameters.spiceSearchStepSize}}</td></tr></tbody></table><div class="panel panel-default"><div class="panel-heading"><span ng-click="vm.showLog=!vm.showLog" ng-show="vm.showLog === false" class="glyphicon glyphicon-plus-sign text-info"></span> <span class="glyphicon glyphicon-minus-sign text-info" ng-click="vm.showLog=!vm.showLog" ng-show="vm.showLog"></span> Logs</div><div class="panel-body" ng-show="vm.showLog"><span ng-repeat="log in vm.eventCollection.logs track by $index ">{{log}}<br></span></div></div></div></div>');
$templateCache.put('app/entities/event-collections/egs-form.html','<form name="egsForm" role="form" novalidate><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Create a new Event Collection from EGS</h4></div><div class="modal-body form-group form-group-sm"><jhi-alert-error></jhi-alert-error><jhi-alert></jhi-alert><div class="row"><div class="col-sm-4"><label class="col-form-label">Filename (Event Collection Label):</label></div><div class="col-sm-8"><input type="text" name="label" ng-model="vm.labelVal" required id="label" placeholder="Type a name for the generated file and the event collection to be created" class="form-control" ng-pattern="/^[0-9a-zA-Z\\.\\:\\<\\>\\ \\_\\@\\!\\(\\)\\{\\}\\,\\-\\[\\]]+$/"> <span id="errorRequired_label" class="label label-danger" ng-show="egsForm.label.$error.required">Required value! </span><span id="errorWrongCharacter" class="label label-danger" ng-show="egsForm.label.$invalid && (egsForm.label.$viewValue.length > 0)">Character not allowed!</span></div></div><div ng-repeat="paramSet in vm.params track by $index" ng-init="parentIndex = $index"><hr class="hr-small"><div ng-repeat="param in paramSet track by $index"><div ng-if="param.scalar"><div class="row"><div class="col-sm-6"><label class="col-form-label">{{param.text}}:</label></div><div class="col-sm-4"><input type="number" class="form-control" id="paramName_{{parentIndex}}_{{$index}}" name="paramName_{{parentIndex}}_{{$index}}" min="{{param.min}}" max="{{param.max}}" ng-model="param.value" ng-required="param.required" ng-trim="false"> <span id="errorRequired_param_{{parentIndex}}_{{$index}}" class="label label-danger" ng-show="!egsForm[\'paramName_\' + parentIndex + \'_\' + $index].$valid">Required or not valid value!</span></div><div class="col-sm-2"><label class="col-form-label">[&nbsp;{{param.min}}&nbsp;-&nbsp;{{param.max}}&nbsp;]</label></div></div></div><div ng-if="param.dateRanges && (!param.textarea || !param.showText)"><div class="row" ng-repeat="range in param.value track by $index" ng-init="name = paramName + \'_\' + parentIndex + \'_\' + $index"><div class="col-sm-6"><label ng-show="$index == 0" class="col-form-label">{{param.text}}:</label></div><div class="col-sm-4"><input date-range-picker options="param.opts[$index]" id="{{name}}" name="{{name}}" class="form-control date-picker" type="text" ng-model="param.value[$index]" clearable="false"> <span id="{{name}}_overlap_error" class="label label-danger" ng-show="param.opts[$index].datesOverlap">Dates Overlap!</span> <span id="{{name}}_interval_error" class="label label-danger" ng-show="param.opts[$index].wrongInterval">Interval is not correct!</span></div><div class="col-sm-2"><button ng-show="$index == param.value.length - 1 && param.textarea" class="btn btn-default btn-xs" ng-click="param.showText=true"><em class="glyphicon glyphicon-transfer"></em></button> <button ng-show="$index < param.value.length - 1" has-authority="ROLE_PLAN_COORDINATOR" id="remove_date_{{name}}" name="remove_date_{{name}}" class="btn btn-default btn-xs" ng-click="vm.removeDateRange(param, $index)"><em class="glyphicon glyphicon-remove"></em></button></div></div></div><div ng-if="param.dateRanges && param.textarea && param.showText"><div class="row"><div class="col-sm-6"><label class="col-form-label">{{param.text}}:</label></div><div class="col-sm-4"><textarea id="{{paramName}}_textarea" name="textarea_{{parentIndex}}_{{$index}}" class="form-control" rows="6" placeholder="{{param.placeholder}}" ng-pattern="/^(\\s*(\'\\d{4}-\\d{2}-\\d{2}(T\\d{2}:\\d{2}:\\d{2}(\\.\\d{3})?)?\')\\s*,\\s*(\'\\d{4}-\\d{2}-\\d{2}(T\\d{2}:\\d{2}:\\d{2}(\\.\\d{3})?)?\'))(\\s*,\\s*(\'\\d{4}-\\d{2}-\\d{2}(T\\d{2}:\\d{2}:\\d{2}(\\.\\d{3})?)?\')\\s*,\\s*(\'\\d{4}-\\d{2}-\\d{2}(T\\d{2}:\\d{2}:\\d{2}(\\.\\d{3})?)?\')\\s*)*$/" ng-model="param.valueText.value"></textarea><span id="areaValid_{{parentIndex}}_{{$index}}" class="label label-danger" ng-show="!egsForm[\'textarea_\' + parentIndex + \'_\' + $index].$valid">Not valid value!</span></div><div class="col-sm-2"><button class="btn btn-default btn-xs" ng-click="param.showText=false"><em class="glyphicon glyphicon-transfer"></em></button></div></div></div></div></div><hr class="hr-small"><hr class="hr-small hr-invisible"><div class="row"><div class="col-sm-6"><label class="col-form-label">Orbit File:</label></div><div class="col-sm-4"><select id="selectedOrbitFileName" required name="selectedOrbitFileName" ng-model="vm.selectedOrbitFileName" class="form-control" ng-class="{\'red-border\': egsForm.selectedOrbitFileName.$error.required}" ng-options="a as a for a in vm.orbitFileNames"><option selected="selected"></option></select><span id="selectedOrbitFileName_error" class="label label-danger" ng-show="egsForm.selectedOrbitFileName.$error.required">Required value!</span></div><div class="col-sm-2">&nbsp;</div></div><div class="row"><div class="col-sm-6"><label class="col-form-label">Nominal Start Specifier:</label></div><div class="col-sm-4"><input type="string" id="nominalStartSpecifier" name="nominalStartSpecifier" class="form-control" ng-model="vm.nominalStartSpecifier" required> <span id="nominalStartSpecifier_error" class="label label-danger" ng-show="egsForm.nominalStartSpecifier.$error.required">Required value!</span></div><div class="col-sm-2">&nbsp;</div></div><br><div class="modal-footer"><button id="cancelButton" type="button" class="btn btn-info" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button id="resetButton" type="button" class="btn btn-primary" ng-click="vm.reset()"><span class="glyphicon"></span>&nbsp;<span>Reset</span></button> <button id="saveButton" type="button" class="btn btn-success" ng-click="vm.runEgs()" ng-disabled="vm.intervalsWrong() || !egsForm.$valid"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Run EGS</span></button></div></div></form>');
$templateCache.put('app/entities/event-collections/event-collections-delete-dialog.html','<wait ng-show="vm.waiting"></wait><form ng-show="vm.waiting===false" name="deleteForm" ng-submit="vm.confirmDelete(vm.label)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete the Event Collections labelled {{vm.label}}?</p></div><div class="modal-footer"><button type="button" id="cancelButton" class="btn btn-info" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" id="deleteButton" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/event-collections/event-collections-detail.html','<wait ng-show="vm.waiting"></wait><div ng-show="vm.waiting===false"><h2>Event Collections <em>\'{{vm.eventCollections.label}}\'</em></h2><hr><div class="row"><div class="col-sm-12"><h4>Event files</h4><ul><li ng-repeat="(file, contents) in vm.eventCollections.contentsByFile">{{file}}</li></ul></div></div><hr><uib-tabset><uib-tab heading="Timeline View" id="timeline-view-tab"><div id="timeline-view"><wait></wait></div></uib-tab><uib-tab heading="Table View" id="table-view-tab"><div class="table-responsive"><h4>Events in Collection</h4><table class="jh-table table table-striped table-condensed" id="events"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.sortTable()"><th jh-sort-by="name"><span>Name</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="startDate"><span>Start Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="endDate"><span>End Date</span> <span class="glyphicon glyphicon-sort"></span></th><th><span>Parameters</span></th><th jh-sort-by="source"><span>Source</span> <span class="glyphicon glyphicon-sort"></span></th></tr><tr ng-repeat="event in vm.events"><td>{{event.name}}</td><td>{{event.startDate}}</td><td>{{event.endDate}}</td><td>{{vm.createparameters(event)}}</td><td>{{event.source}}</td></tr></table></div></uib-tab></uib-tabset><hr ng-show="vm.logs.length > 0"><div class="panel panel-default" ng-show="vm.logs.length > 0"><div class="panel-heading"><span ng-click="vm.showLog=!vm.showLog" ng-show="vm.showLog === false" class="glyphicon glyphicon-collapse-down"></span> <span class="glyphicon glyphicon-collapse-up" ng-click="vm.showLog=!vm.showLog" ng-show="vm.showLog"></span> Ingestion Logs:</div><div class="panel-body" ng-show="vm.showLog"><span ng-repeat="log in vm.logs track by $index ">{{log}}<br></span></div></div><hr><button type="submit" id="backButton" ui-sref="{{ vm.previousState }}" class="btn btn-primary"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button></div>');
$templateCache.put('app/entities/event-collections/event-collections-update.html','<div><div class="modal-body"><form name="editForm" role="form" class="form-horizontal" novalidate show-validation><div class="form-group"><div class="col-sm-10"><h2>Event Collection:<em>\'{{vm.label}}\'</em></h2></div></div><div class="alert-fixed"><jhi-alert-error></jhi-alert-error><jhi-alert></jhi-alert></div><div class="form-group"><div class="col-sm-2">Validity Start / End</div><div class="col-sm-8"><div class="input-group"><input placeholder="YYYY-MM-DDThh:mm:ssZ" name="startDate" id="startDate" maxlength="20" ng-change="vm.validateDates()" size="20" type="text" class="form-control" ng-model="vm.validityStartTime"> <span class="input-group-addon">/</span> <input id="endDate" name="endDate" placeholder="YYYY-MM-DDThh:mm:ssZ" ng-change="vm.validateDates()" maxlength="20" size="20" type="text" class="form-control" ng-model="vm.validityEndTime"></div></div><div class="col-sm-10"><span id="erroStart" class="label label-danger" ng-show="vm.invalidateStartDate">Wrong Valid Start date </span><span id="erroEnd" class="label label-danger" ng-show="vm.invalidateEndDate">Wrong Valid End date </span><span id="erroDuratuib" class="label label-danger" ng-show="vm.duration<0">End date is earlier than start data</span></div></div></form><div class="modal-footer"><button id="cancelButton" type="button" class="btn btn-info" data-dismiss="modal" ng-click="vm.clear()" ng-disabled="vm.notValidValidity"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button ng-disabled="vm.invalidateStartDate || vm.invalidateEndDate || vm.duration < 0" id="saveButton" has-any-authority="ROLE_PLAN_COORDINATOR" type="button" class="btn btn-success" ng-click="vm.save()"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></div></div>');
$templateCache.put('app/entities/event-collections/event-collections.html','<div class="row"><div class="col-sm-12"><h2 class="h-inline">Event Collections</h2><div class="pull-right" style="margin-top: 20px"><button has-authority="ROLE_PLAN_COORDINATOR" id="createEventColButton" class="btn btn-primary btn-sm h2-btn-margin" ng-click="showCreateMenu = ! showCreateMenu"><span ng-switch="showCreateMenu"><span ng-switch-when="false" class="glyphicon glyphicon-plus-sign"></span> <span ng-switch-when="true" class="glyphicon glyphicon-minus-sign"></span> <span ng-switch-default class="glyphicon glyphicon-plus-sign"></span> </span>&nbsp;&nbsp;<span>Create new</span></button> <button has-authority="ROLE_PLAN_COORDINATOR" id="egsButton" class="btn btn-primary btn-sm h2-btn-margin" ui-sref="event-collections.egs"><em class="glyphicon glyphicon-plus"></em>&nbsp;&nbsp;<span>Create From EGS</span></button></div></div></div><div class="create-entity" ng-show="showCreateMenu"><br><form name="createForm" class="form-horizontal" has-authority="ROLE_PLAN_COORDINATOR"><div class="form-group"><label for="eventColLabel" class="col-sm-2 control-label">Label</label><div class="col-sm-10"><input type="text" name="label" ng-model="vm.labelVal" required class="form-control" id="eventColLabel" ng-pattern="/^[0-9a-zA-Z\\.\\:\\<\\>\\ \\_\\@\\!\\(\\)\\{\\}\\,\\-\\[\\]]+$/"><div ng-show="createForm.label.$invalid && (createForm.label.$viewValue.length > 0)"><p class="help-block">Character not allowed</p></div><div ng-show="createForm.label.$error.required"><p class="help-block" ng-show="createForm.label.$error.required">This field is required.</p></div></div></div><div class="form-group"><label for="eventColDescription" class="col-sm-2 control-label">Description</label><div class="col-sm-10"><input type="text" name="description" ng-model="vm.description" class="form-control" id="eventColDescription"></div></div><div class="form-group"><label class="col-sm-2 control-label">Files</label><div class="col-sm-6"><input id="field_file" type="hidden" name="files" ng-model="vm.files" required> <span class="help-block" ng-show="createForm.files.$error.required">Please load file(s) (*.xml)</span><ul style="padding: 6px 0 0 10px"><li ng-repeat="f in vm.files" style="font-size: smaller">{{f.name}}</li></ul></div><div class="col-sm-4"><button id="uploadButton" class="btn btn-primary pull-right" ngf-select="vm.uploadFiles($files)" multiple="multiple"><span class="glyphicon glyphicon-folder-open"></span>&nbsp;&nbsp;<span>Load Files</span></button></div></div><div class="form-group"><div class="col-sm-2"></div><div class="col-sm-10"><div class="pull-right"><button id="saveButton" class="btn btn-success" ng-disabled="!createForm.$valid" ng-click="vm.save()"><span class="glyphicon glyphicon-save"></span>&nbsp;&nbsp;<span>Create</span></button> <button id="mergeButton" class="btn btn-success" ng-disabled="!createForm.label.$valid || vm.areChecked() < 2" ng-click="vm.merge()"><span class="glyphicon glyphicon-resize-small"></span>&nbsp;&nbsp;<span>Merge Selected Event Collections</span></button></div></div></div></form></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.ascending" callback="vm.sortTable()"><th></th><th jh-sort-by="label"><span>Label</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="processStatus"><span>Status</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="validityStartTime"><span>Validity Start Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="validityEndTime"><span>Validity End Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="timestamp"><span>Creation Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="description"><span>Description</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="username"><span>Username</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="eventCollection in vm.eventCollections"><td><input class="form-check-input" type="checkbox" id="checkBox_{{$index}}" ng-model="vm.checked[eventCollection.label]" ng-click="vm.checkEventCollection()"></td><td>{{eventCollection.label}}</td><td><span class="label {{vm.jobsStatusClass(eventCollection.processStatus)}} label-xs">{{eventCollection.processStatus}}</span></td><td><span ng-show="vm.isProcessFinished(eventCollection)">{{vm.formatIsoZuluDateString(eventCollection.validityStartTime)}}</span></td><td><span ng-show="vm.isProcessFinished(eventCollection)">{{vm.formatIsoZuluDateString(eventCollection.validityEndTime)}}</span></td><td>{{vm.formatIsoZuluDateString(eventCollection.timestamp)}}</td><td>{{eventCollection.description}}</td><td>{{eventCollection.username}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button ng-show="eventCollection.egsJob!==null" type="submit" class="btn btn-info btn-sm" ui-sref="egs-job-details({id:eventCollection.label})" title="Show EGS Parameters"><span class="glyphicon glyphicon-cog"></span></button> <button ng-if="eventCollection.egsJob != null && (eventCollection.egsJob.processStatus == \'PENDING\' || eventCollection.egsJob.processStatus == \'SUBMITTED\' || eventCollection.egsJob.processStatus == \'RUNNING\')" id="buttonAbort_{{eventCollection.label}}" ng-click="vm.abort(eventCollection.egsJob.id)" class="btn btn-danger btn-sm" has-authority="ROLE_PLAN_COORDINATOR" data-toggle="tooltip" data-placement="bottom" title="Abort EGS run" delay="1000"><span class="glyphicon glyphicon-stop"></span></button> <button ng-disabled="{{!(eventCollection.egsJob===null || eventCollection.egsJob.processStatus == \'COMPLETED\')}}" type="submit" ui-sref="event-collections-detail({id:eventCollection.label})" class="btn btn-primary btn-sm" data-toggle="tooltip" data-placement="bottom" title="View" delay="1000"><span class="glyphicon glyphicon-eye-open"></span></button> <button type="submit" id="buttonDelete_{{eventCollection.label}}" ng-click="vm.deleteCollection(eventCollection.label)" class="btn btn-danger btn-sm" has-authority="ROLE_PLAN_COORDINATOR" data-toggle="tooltip" data-placement="bottom" title="Delete" delay="1000"><span class="glyphicon glyphicon-remove-circle"></span></button></div></td></tr></tbody></table></div><div class="alert-fixed"><jhi-alert-error></jhi-alert-error><jhi-alert></jhi-alert></div>');
$templateCache.put('app/entities/observation-definitions/observation-definitions-delete-dialog.html','<wait ng-show="vm.waiting"></wait><form ng-show="vm.waiting===false" name="deleteForm" ng-submit="vm.confirmDelete(vm.label)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete the Observation Definitions with the label <strong>{{vm.label}}</strong></p></div><div class="modal-footer"><button type="button" id="cancelButton" class="btn btn-info" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" id="deleteButton" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/observation-definitions/observation-definitions-detail-action-mappings.html','<uib-tabset><uib-tab heading="Flows"><table class="table table-striped table-condensed jh-table"><thead><tr><th>Multiplier</th><th>SoopKitchen Value</th><th>EPS Experiment</th><th>EPS Action</th><th>Action Parameter</th><th>Default Value</th><th>Filename</th></tr></thead><tbody><tr ng-repeat="flowMappingValue in vm.flowMappings"><td>{{flowMappingValue.multiplier}}</td><td>{{flowMappingValue.flowName}}</td><td>{{flowMappingValue.epsExperiment}}</td><td>{{flowMappingValue.epsAction}}</td><td>{{flowMappingValue.epsActionParameter}}</td><td>{{flowMappingValue.defaultValue}}</td><td>{{flowMappingValue.filename}}</td></tr></tbody></table></uib-tab><uib-tab heading="Flushes"><table class="table table-striped table-condensed jh-table"><thead><tr><th>Multiplier</th><th>SoopKitchen Value</th><th>EPS Experiment</th><th>EPS Action</th><th>Action Parameter</th><th>Filename</th></tr></thead><tbody><tr ng-repeat="flushMappingValue in vm.flushMappings"><td>{{flushMappingValue.multiplier}}</td><td>{{flushMappingValue.flushName}}</td><td>{{flushMappingValue.epsExperiment}}</td><td>{{flushMappingValue.epsAction}}</td><td>{{flushMappingValue.epsActionParameter}}</td><td>{{flushMappingValue.filename}}</td></tr></tbody></table></uib-tab></uib-tabset>');
$templateCache.put('app/entities/observation-definitions/observation-definitions-detail-derived-values.html','<uib-tabset><uib-tab heading="Flows"><table class="table table-striped table-condensed jh-table"><thead><tr><th>Name</th><th>Expression</th></tr></thead><tbody><tr ng-repeat="flow in vm.flows"><td>{{flow.id}}</td><td>{{vm.formatExpression(flow.expression)}}</td></tr></tbody></table></uib-tab><uib-tab heading="Flushes"><table class="table table-striped table-condensed jh-table"><thead><tr><th>Name</th><th>Expression</th></tr></thead><tbody><tr ng-repeat="flush in vm.flushes"><td>{{flush.id}}</td><td>{{vm.formatExpression(flush.expression)}}</td></tr></tbody></table></uib-tab><uib-tab heading="Volumes"><table class="table table-striped table-condensed jh-table"><thead><tr><th>Name</th><th>Expression</th></tr></thead><tbody><tr ng-repeat="volume in vm.volumes"><td>{{volume.id}}</td><td>{{vm.formatExpression(volume.expression)}}</td></tr></tbody></table></uib-tab></uib-tabset>');
$templateCache.put('app/entities/observation-definitions/observation-definitions-detail-instruments.html','<uib-tabset><uib-tab ng-repeat="(instrument, instrumentObsDef) in vm.observationsPerInstrument" heading="{{instrument}}"><uib-tabset><uib-tab ng-repeat="module in instrumentObsDef.modules" heading="{{module}}"><uib-tabset><uib-tab ng-repeat="(obsName, obsDef) in instrumentObsDef.allObservations[module]" heading="{{obsName}}"><table class="table table-striped table-condensed jh-table"><thead><tr><th>Name</th><th>Type</th><th>Value</th><th>Range</th><th>Unit</th></tr></thead><tr ng-show="vm.getMapLength(instrumentObsDef.rootEnvironment.constants) + vm.getMapLength(instrumentObsDef.rootEnvironment.variables) > 0"><td colspan="100" class="jhi-table-group">Instrument Global Context</td></tr><tr ng-show="vm.getMapLength(instrumentObsDef.rootEnvironment.constants) > 0"><td colspan="100" class="jhi-table-sub-group">Constants</td></tr><tr ng-repeat="(constantName, constant) in instrumentObsDef.rootEnvironment.constants"><td>{{constant.name}}</td><td></td><td>{{constant.numberValue}}</td><td></td><td>{{constant.unit}}</td></tr><tr ng-show="vm.getMapLength(instrumentObsDef.rootEnvironment.variables) > 0"><td colspan="100" class="jhi-table-sub-group">Variables</td></tr><tr ng-repeat="(variableName, variable) in instrumentObsDef.rootEnvironment.variables"><td>{{variable.name}}</td><td></td><td>{{vm.formatExpression(variable.expression)}}</td><td></td><td>{{variable.unit}}</td></tr><tr ng-show="vm.getMapLength(obsDef.groupEnvironment.constants) + vm.getMapLength(obsDef.groupEnvironment.variables) > 0"><td colspan="100" class="jhi-table-group">Group Context</td></tr><tr ng-show="vm.getMapLength(obsDef.groupEnvironment.constants) > 0"><td colspan="100" class="jhi-table-sub-group">Constants</td></tr><tr ng-repeat="(constantName, constant) in obsDef.groupEnvironment.constants"><td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{constant.name}}</td><td></td><td>{{constant.numberValue}}</td><td></td><td>{{constant.unit}}</td></tr><tr ng-show="vm.getMapLength(obsDef.groupEnvironment.variables) > 0"><td colspan="100" class="jhi-table-sub-group">Variables</td></tr><tr ng-repeat="(variableName, variable) in obsDef.groupEnvironment.variables"><td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{variable.name}}</td><td></td><td>{{vm.formatExpression(variable.expression)}}</td><td></td><td>{{variable.unit}}</td></tr><tr style="border-bottom: 2px solid #000"><td colspan="100"></td></tr><tr ng-show="vm.getMapLength(obsDef.constants) + vm.getMapLength(obsDef.variables) > 0"><td colspan="100" class="jhi-table-group">Observation Context</td></tr><tr ng-show="vm.getMapLength(obsDef.constants) > 0"><td colspan="100" class="jhi-table-sub-group">Constants</td></tr><tr ng-repeat="(constantName, constant) in obsDef.constants"><td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{constant.name}}</td><td></td><td>{{constant.numberValue}}</td><td></td><td>{{constant.unit}}</td></tr><tr ng-show="vm.getMapLength(obsDef.variables) > 0"><td colspan="100" class="jhi-table-sub-group">Variables</td></tr><tr ng-repeat="(variableName, variable) in obsDef.variables"><td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{variable.name}}</td><td></td><td>{{vm.formatExpression(variable.expression)}}</td><td></td><td>{{variable.unit}}</td></tr><tr ng-show="vm.getMapLength(obsDef.numberParameters)"><td colspan="100" class="jhi-table-group">Number Parameters</td></tr><tr ng-repeat="(paramName, param) in obsDef.numberParameters"><td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{paramName}}</td><td></td><td>{{param.numberValue}}</td><td>[<span ng-show="param.min>-1.7E308">{{param.min}}</span><span ng-show="param.min<-1.7E308">-&infin;</span>, <span ng-show="param.max<1.7E308">{{param.max}}</span><span ng-show="param.max>1.7E308">&infin;</span>]</td><td>{{param.unit}}</td></tr><tr ng-show="vm.getMapLength(obsDef.listParameters)"><td colspan="100" class="jhi-table-group">List Parameters</td></tr><tr ng-repeat="(paramName, param) in obsDef.listParameters"><td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{paramName}}</td><td></td><td>{{param.value}}</td><td>{{param.values}}</td><td></td></tr><tr ng-show="obsDef.duration"><td colspan="100" class="jhi-table-group">Duration</td></tr><tr ng-show="obsDef.duration"><td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Duration</td><td></td><td>{{obsDef.duration.numberValue}}{{obsDef.duration.reference}}{{vm.formatExpression(obsDef.duration.expression)}}</td><td>[<span ng-show="obsDef.duration.min>-1.7E308">{{obsDef.duration.min}}</span><span ng-show="obsDef.duration.min<-1.7E308">-&infin;</span>, <span ng-show="obsDef.duration.max<1.7E308">{{obsDef.duration.max}}</span><span ng-show="obsDef.duration.max>1.7E308">&infin;</span>]</td><td>{{obsDef.duration.unit}}</td></tr><tr ng-show="obsDef.power"><td colspan="100" class="jhi-table-group">Power</td></tr><tr ng-show="obsDef.power"><td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Power</td><td></td><td>{{obsDef.power.numberValue}}{{obsDef.power.reference}}{{vm.formatExpression(obsDef.power.expression)}}</td><td>[<span ng-show="obsDef.power.min>-1.7E308">{{obsDef.power.min}}</span><span ng-show="obsDef.power.min<-1.7E308">-&infin;</span>, <span ng-show="obsDef.power.max<1.7E308">{{obsDef.power.max}}</span><span ng-show="obsDef.power.max>1.7E308">&infin;</span>]</td><td>{{obsDef.power.unit}}</td></tr><tr ng-show="obsDef.flush"><td colspan="100" class="jhi-table-group">Flush</td></tr><tr ng-show="obsDef.flush"><td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Flush</td><td>{{obsDef.flush.flushType}}</td><td>{{obsDef.flush.numberValue}}{{obsDef.flush.reference}}{{vm.formatExpression(obsDef.flush.expression)}}</td><td>[<span ng-show="obsDef.flush.min>-1.7E308">{{obsDef.flush.min}}</span><span ng-show="obsDef.flush.min<-1.7E308">-&infin;</span>, <span ng-show="obsDef.flush.max<1.7E308">{{obsDef.flush.max}}</span><span ng-show="obsDef.flush.max>1.7E308">&infin;</span>]</td><td>{{obsDef.flush.unit}}</td></tr><tr ng-show="vm.getMapLength(obsDef.flows) > 0"><td colspan="100" class="jhi-table-group">Flows</td></tr><tr ng-repeat="(flowName, flow) in obsDef.flows"><td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{flowName}}</td><td>{{flow.flowType}}</td><td>{{flow.numberValue}}{{flow.reference}}{{vm.formatExpression(flow.expression)}}</td><td>[<span ng-show="flow.min>-1.7E308">{{flow.min}}</span><span ng-show="flow.min<-1.7E308">-&infin;</span>, <span ng-show="flow.max<1.7E308">{{flow.max}}</span><span ng-show="flow.max>1.7E308">&infin;</span>]</td><td>{{flow.unit}}</td></tr></table></uib-tab></uib-tabset></uib-tab></uib-tabset></uib-tab></uib-tabset>');
$templateCache.put('app/entities/observation-definitions/observation-definitions-detail.html','<wait ng-show="vm.waiting"></wait><div ng-show="vm.waiting===false"><h2>Observation Definitions <em>\'{{vm.observationDefinitions.label}}\'</em></h2><div><uib-tabset><uib-tab heading="Instruments"><div ng-include="\'app/entities/observation-definitions/observation-definitions-detail-instruments.html\'"></div></uib-tab><uib-tab heading="Derived Values"><div ng-include="\'app/entities/observation-definitions/observation-definitions-detail-derived-values.html\'"></div></uib-tab><uib-tab heading="Action Mappings"><div ng-include="\'app/entities/observation-definitions/observation-definitions-detail-action-mappings.html\'"></div></uib-tab></uib-tabset></div><br><div><button type="submit" id="backButton" ui-sref="{{ vm.previousState }}" class="btn btn-primary"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button></div></div>');
$templateCache.put('app/entities/observation-definitions/observation-definitions-nexus.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Import Observation Definitions from Nexus</h4></div><div class="modal-body form-group form-group-sm"><div class="row"><div class="col-sm-2"><label class="col-form-label">Nexus Version</label></div><div class="col-sm-10"><label class="col-form-label">Description</label></div></div><div ng-repeat="version in vm.versions"><div class="row"><div class="col-sm-2"><input class="form-check-input" type="checkbox" id="checkBox_{{version}}" ng-model="vm.checked[version]"><label class="col-form-label">{{version}}</label></div><div class="col-sm-10"><input type="text" name="desc_{{version}}" ng-model="vm.descriptions[version]" id="desc_{{version}}" class="form-control"></div></div></div><hr class="hr-small hr-invisible"><div class="modal-footer"><button id="cancelButton" type="button" class="btn btn-info" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button id="saveButton" type="button" class="btn btn-success" ng-click="vm.importObsDef()" ng-disabled="!vm.isValid()"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Import</span></button></div></div><jhi-alert-error></jhi-alert-error><jhi-alert></jhi-alert>');
$templateCache.put('app/entities/observation-definitions/observation-definitions.html','<div class="row"><div class="col-sm-12"><h2 class="h-inline">Observation Definitions</h2><div class="pull-right" style="margin-top: 20px"><button has-authority="ROLE_PLAN_COORDINATOR" id="createObsDefButton" class="btn btn-primary btn-sm h2-btn-margin" ng-click="showCreateMenu = ! showCreateMenu"><span ng-switch="showCreateMenu"><span ng-switch-when="false" class="glyphicon glyphicon-plus-sign"></span> <span ng-switch-when="true" class="glyphicon glyphicon-minus-sign"></span> <span ng-switch-default class="glyphicon glyphicon-plus-sign"></span> </span>&nbsp;&nbsp;<span>Create new</span></button> <button has-authority="ROLE_PLAN_COORDINATOR" id="nexusButton" class="btn btn-primary btn-sm h2-btn-margin" ui-sref="observation-definitions.nexus"><em class="glyphicon glyphicon-plus"></em>&nbsp;&nbsp;<span>Import From Nexus</span></button></div></div></div><div class="create-entity" ng-show="showCreateMenu"><br><form name="createForm" class="form-horizontal" has-authority="ROLE_PLAN_COORDINATOR"><div class="form-group"><label for="obsDefLabel" class="col-sm-2 control-label">Label</label><div class="col-sm-10"><input type="text" name="label" ng-model="vm.labelVal" required class="form-control" id="obsDefLabel" ng-pattern="/^[0-9a-zA-Z\\.\\:\\<\\>\\ \\_\\@\\!\\(\\)\\{\\}\\,\\-\\[\\]]+$/"><div ng-show="createForm.label.$invalid && (createForm.label.$viewValue.length > 0)"><p class="help-block">Character not allowed</p></div><div ng-show="createForm.label.$error.required"><p class="help-block" ng-show="createForm.label.$error.required">This field is required.</p></div></div></div><div class="form-group"><label for="obsDefDescription" class="col-sm-2 control-label">Description</label><div class="col-sm-10"><input type="text" name="description" ng-model="vm.description" class="form-control" id="obsDefDescription"></div></div><div class="form-group"><label class="col-sm-2 control-label">Files</label><div class="col-sm-6"><input id="field_file" type="hidden" name="files" ng-model="vm.files" required> <span class="help-block" ng-show="createForm.files.$error.required">Please load file(s) (*.obs, *.dfd, *.fmp)</span><ul style="padding: 6px 0 0 10px"><li ng-repeat="f in vm.files" style="font:smaller">{{f.name}}</li></ul></div><div class="col-sm-4"><button id="uploadButton" class="btn btn-primary pull-right" ngf-select="vm.uploadFiles($files)" multiple="multiple"><span class="glyphicon glyphicon-folder-open"></span>&nbsp;&nbsp;<span>Load Files</span></button></div></div><div class="form-group"><div class="col-sm-2"></div><div class="col-sm-10"><button id="saveButton" class="btn btn-success pull-right" ng-disabled="!createForm.$valid" ng-click="vm.save()"><span class="glyphicon glyphicon-save"></span>&nbsp;&nbsp;<span>Create</span></button></div></div></form></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.ascending" callback="vm.sortTable()"><th jh-sort-by="label"><span>Label</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="timestamp"><span>Creation Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="description"><span>Description</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="username"><span>Username</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="observationDefinition in vm.observationDefinitions"><td>{{observationDefinition.label}}</td><td>{{vm.formatIsoZuluDateString(observationDefinition.timestamp)}}</td><td>{{observationDefinition.description}}</td><td>{{observationDefinition.username}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="observation-definitions-detail({id:observationDefinition.label})" class="btn btn-primary btn-sm" data-toggle="tooltip" data-placement="bottom" title="View" delay="1000"><span class="glyphicon glyphicon-eye-open"></span></button> <button id="buttonDelete_{{observationDefinition.label}}" type="submit" ng-click="vm.openDeleteDialog(observationDefinition.label)" class="btn btn-danger btn-sm" has-authority="ROLE_PLAN_COORDINATOR" data-toggle="tooltip" data-placement="bottom" title="Delete" delay="1000"><span class="glyphicon glyphicon-remove-circle"></span></button></div></td></tr></tbody></table></div><div class="alert-fixed"><jhi-alert-error></jhi-alert-error><jhi-alert></jhi-alert></div>');
$templateCache.put('app/entities/planning/change-metis-compatibility.html','<form name="dialogForm" role="form" class="form-horizontal" novalidate show-validation><div ng-include="\'app/entities/dialog-header.html\'"></div><div class="modal-body"><div class="form-group"><label class="col-sm-3 control-label">METIS Compability</label><div class="col-sm-9"><select ng-model="vm.selectedMetisCompability" ng-options="metisCompability for metisCompability in vm.schema.attributeClasses[\'metiscompType\'].values"></select></div></div><div class="form-group"><label class="col-sm-3 control-label">Start Time</label><div class="col-sm-9"><input class="form-control" name="startTime" id="startTime" maxlength="20" size="20" type="text" ng-model="vm.startTime"> <span class="label label-danger" ng-show="!vm.isValidDate(vm.startTime)">Invalid Date</span></div></div><div class="form-group"><label class="col-sm-3 control-label">End Time</label><div class="col-sm-9"><input class="form-control" name="endTime" id="endTime" maxlength="20" size="20" type="text" ng-model="vm.endTime"> <span class="label label-danger" ng-show="!vm.isValidDate(vm.endTime)">Invalid Date</span></div></div></div><div ng-include="\'app/entities/dialog-footer.html\'"></div></form>');
$templateCache.put('app/entities/planning/clone-plan.html','<form name="dialogForm" role="form" class="form-horizontal" novalidate show-validation><div ng-include="\'app/entities/dialog-header.html\'"></div><div class="modal-body"><div class="form-group" ng-repeat="parameter in vm.parameters track by $index"><label for="{{parameter.name}}" class="col-sm-2 control-label">{{parameter.name}}</label><div class="col-sm-10"><input class="form-control" name="{{parameter.name}}" id="{{parameter.name}}" ng-model="vm.parameter[parameter.name]" type="text" required><div ng-show="dialogForm.{{parameter.name}}.$invalid"><p class="help-block" ng-show="dialogForm.{{parameter.name}}.$error.required">This field is required.</p></div></div></div></div><div ng-include="\'app/entities/dialog-footer.html\'"></div></form>');
$templateCache.put('app/entities/planning/create-soop-from-timeline.html','<form name="dialogForm" class="form-horizontal"><div ng-include="\'app/entities/dialog-header.html\'"></div><div class="modal-body"><div><table class="jh-table table table-striped table-bordered"><tbody><tr ng-repeat="obs in vm.observations"><td>{{obs.experiment}}</td><td>{{obs.module}}</td><td>{{obs.name}}</td><td>{{obs.startDate}} => {{obs.endDate}}</td></tr></tbody></table></div><div class="text-muted">Observations total duration is <strong>{{vm.durationLetters}}</strong></div><hr><div class="form-group"><div class="col-sm-2"></div><div class="col-sm-10"><input type="checkbox" name="saveAsSoopTemplate" value="saveSoopInPlan" id="saveSoopInPlan" ng-model="vm.saveSoopInPlan" ng-required="!vm.saveSoopTemplate && !vm.savePlanTemplate"> Save as SOOP Instance in Plan<br></div></div><div class="form-group"><div class="col-sm-2"></div><div class="col-sm-10"><input type="checkbox" name="saveAsSoopTemplate" value="saveSoopTemplate" id="saveSoopTemplate" ng-model="vm.saveSoopTemplate" ng-required="!vm.saveSoopInPlan && !vm.savePlanTemplate"> Save as SOOP template in SOOP library<br></div></div><div class="form-group" ng-show="vm.saveSoopTemplate"><label for="SoopDuration" class="col-sm-2 control-label">Duration</label><div class="col-sm-10"><input id="SoopDuration" type="text" name="SoopDuration" ng-model="vm.soopDurationString" class="form-control" ng-required="vm.saveSoopTemplate" ng-pattern="/^(\\d+d)+(\\d+h)?(\\d+m)?(\\d+s)?$/" placeholder="Time value such as 10d5h30m10s, to represent days (d), hours (h) min. (m) and sec. (s). Minimum value is 1d"><div ng-show="dialogForm.SoopDuration.$invalid"><p class="help-block label label-danger" style="color:#f0ad4e" ng-show="dialogForm.SoopDuration.$invalid && (dialogForm.SoopDuration.$viewValue.length > 0)">Incorrect format.</p><p class="help-block label label-danger" ng-show="dialogForm.SoopDuration.$error.required">Required.</p></div></div></div><div class="form-group" ng-show="vm.saveSoopTemplate"><label for="SoopPlanLabel" class="col-sm-2 control-label">Label</label><div class="col-sm-10"><input id="SoopPlanLabel" type="text" name="SoopPlanLabel" maxlength="40" ng-model="vm.soopPlanLabel" class="form-control" ng-required="vm.saveSoopTemplate" ng-pattern="/^[0-9a-zA-Z\\.\\:\\<\\>\\ \\_\\@\\!\\(\\)\\{\\}\\,\\-\\[\\]]+$/"><div ng-show="dialogForm.SoopPlanLabel.$invalid && (dialogForm.SoopPlanLabel.$viewValue.length > 0)"><p class="help-block label label-danger">Character not allowed</p></div><div ng-show="dialogForm.SoopPlanLabel.$error.required"><p class="help-block label label-danger">Required.</p></div></div></div><div class="form-group" ng-show="vm.saveSoopInPlan || vm.saveSoopTemplate"><label for="selectSoopType" class="col-sm-2 control-label">SOOP Type</label><div class="col-sm-10"><select id="selectSoopType" name="selectSoopType" ng-required="vm.saveSoopInPlan || vm.saveSoopTemplate" ng-model="vm.selectedSoopType" class="form-control"><option ng-repeat="soopType in vm.soopTypes" value="{{soopType}}">{{soopType}}</option></select><div ng-show="dialogForm.selectSoopType.$error.required"><p class="help-block label label-danger">Required.</p></div></div></div><div class="form-group" ng-show="vm.saveSoopTemplate"><label for="selectSoopLeadInstrument" class="col-sm-2 control-label">Lead Instrument</label><div class="col-sm-10"><select id="selectSoopLeadInstrument" name="selectSoopLeadInstrument" ng-model="vm.selectedSoopLeadInstrument" class="form-control"><option></option><option ng-repeat="instrument in vm.instruments" value="{{instrument}}">{{instrument}}</option></select></div></div><div class="form-group"><div class="col-sm-2"></div><div class="col-sm-10"><input type="checkbox" name="saveInPlan" value="savePlanTemplate" id="savePlanTemplate" ng-model="vm.savePlanTemplate" ng-required="!vm.saveSoopInPlan && !vm.saveSoopTemplate"> Save as floating timeline<br></div></div><div class="form-group" ng-show="vm.savePlanTemplate"><label for="TemplateDuration" class="col-sm-2 control-label">Duration</label><div class="col-sm-10"><input id="TemplateDuration" type="text" name="TemplateDuration" ng-model="vm.templateDurationString" class="form-control" ng-required="vm.savePlanTemplate" ng-pattern="/^(\\d+d)+(\\d+h)?(\\d+m)?(\\d+s)?$/" placeholder="Time value such as 10d5h30m10s, to represent days (d), hours (h) min. (m) and sec. (s). Minimum value is 1d"><div ng-show="dialogForm.TemplateDuration.$invalid"><p class="help-block" style="color:#f0ad4e" ng-show="dialogForm.TemplateDuration.$invalid && (dialogForm.TemplateDuration.$viewValue.length > 0)">Incorrect format.</p><p class="help-block label label-danger" ng-show="dialogForm.TemplateDuration.$error.required">Required.</p></div></div></div><div class="form-group" ng-show="vm.savePlanTemplate"><label for="TemplatePlanLabel" class="col-sm-2 control-label">Label</label><div class="col-sm-10"><input id="TemplatePlanLabel" type="text" name="TemplatePlanLabel" maxlength="40" ng-model="vm.templatePlanLabel" class="form-control" ng-required="vm.savePlanTemplate" ng-pattern="/^[0-9a-zA-Z\\.\\:\\<\\>\\ \\_\\@\\!\\(\\)\\{\\}\\,\\-\\[\\]]+$/"><div ng-show="dialogForm.TemplatePlanLabel.$invalid && (dialogForm.TemplatePlanLabel.$viewValue.length > 0)"><p class="help-block label label-danger">Character not allowed</p></div><div ng-show="dialogForm.TemplatePlanLabel.$error.required"><p class="help-block label label-danger">Required.</p></div></div></div></div><div ng-include="\'app/entities/dialog-footer.html\'"></div></form>');
$templateCache.put('app/entities/planning/edit-soop-dialog.html','<form name="dialogForm" role="form" class="form-horizontal" novalidate show-validation><div ng-include="\'app/entities/dialog-header.html\'"></div><div class="modal-body"><div class="form-group"><label class="col-sm-3 control-label">Time</label><div class="col-sm-9"><input class="form-control" name="anchorTime" id="anchorTime" maxlength="20" size="20" type="text" ng-model="vm.anchorTime"> <span class="label label-danger" ng-show="!vm.isValidDate(vm.anchorTime)">Invalid Date</span></div></div></div><div ng-include="\'app/entities/dialog-footer.html\'"></div></form>');
$templateCache.put('app/entities/planning/insert-plan.html','<form name="dialogForm" role="form" class="form-horizontal" novalidate show-validation><div ng-include="\'app/entities/dialog-header.html\'"></div><div class="modal-body"><div class="form-group"><label class="col-sm-3 control-label">Operational Plan</label><div class="col-sm-9"><select class="form-control" ng-change="vm.onSelectOperationalPlan()" name="planSelectOp" id="planSelectOp" ng-model="vm.selectedOperationalPlan" ng-options="item as item.label for item in vm.operationalPlanToImport"></select></div></div><div class="form-group"><label class="col-sm-3 control-label">Child Plan</label><div class="col-sm-9"><select class="form-control" ng-change="vm.onSelectChildPlan()" name="planSelectChild" id="planSelectChild" ng-model="vm.selectedChildPlan" ng-options="item as item.label for item in vm.childPlanToImport"></select></div></div><div class="form-group"><div class="panel-body"><div class="row"><div class="col-md-12"><div class="checkbox" style="display: inline-block; padding-left: 5px; padding-right: 15px"><span class="glyphicon glyphicon-check" ng-show="vm.checkedAll" id="checkedAll_checked" ng-click="vm.toggleCheckAll()"><label style="padding-left: 5px">All&nbsp;Instruments</label></span><span class="glyphicon glyphicon-unchecked" ng-show="vm.checkedAll===false" id="checkedAll_unchecked" ng-click="vm.toggleCheckAll()"><label style="padding-left: 5px"><del>All&nbsp;Instruments</del></label></span></div><div ng-repeat="group in vm.groups" style="display: inline-block; padding-left: 5px; padding-right: 15px"><div class="checkbox"><span class="glyphicon glyphicon-check" ng-show="vm.checkedValue[group]" id="{{group}}" ng-click="vm.groupChange(group)"><label style="padding-left: 5px">{{group}}</label></span><span class="glyphicon glyphicon-unchecked" ng-show="vm.checkedValue[group]===false" id="{{group}}_unchecked" ng-click="vm.groupChange(group)"><label style="padding-left: 5px"><del>{{group}}</del></label></span></div></div></div></div></div></div><div class="form-group"><label class="col-sm-3 control-label">Internal Version</label><div class="col-sm-9"><input id="internalVersion" name="internalVersion" type="number" min="0" max="{{vm.maxInternalVersion}}" ng-model="vm.selectedInternalVersion" ng-trim="false"> <span id="errorRange" class="label label-danger" ng-show="dialogForm.internalVersion.$error.min || dialogForm.internalVersion.$error.max">The value must be in range 0 to {{vm.maxInternalVersion}}!</span> <span id="errorValidNumber" class="label label-danger" ng-show="dialogForm.internalVersion.number">Not valid number!</span> <span><em>Version 0 means the latest version</em></span></div></div><div class="form-group"><label class="col-sm-3 control-label">From Date</label><div class="col-sm-9"><input id="fromTime" name="fromTime" placeholder="Date in UTC Zulu format: 2000-01-01T00:00:00Z" class="form-control" ng-pattern="/^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}Z$/" maxlength="20" size="20" type="text" ng-model="vm.fromTime"> <span id="errorValidFromDate" class="label label-danger" ng-show="dialogForm.fromTime.$invalid">Not valid date!</span></div></div><div class="form-group"><label class="col-sm-3 control-label">To Date</label><div class="col-sm-9"><input id="toTime" name="toTime" class="form-control" placeholder="Date in UTC Zulu format: 2000-01-01T00:00:00Z" ng-pattern="/^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}Z$/" maxlength="20" size="20" type="text" ng-model="vm.toTime"> <span id="errorValidToDate" class="label label-danger" ng-show="dialogForm.toTime.$invalid">Not valid date!</span></div></div></div><div ng-include="\'app/entities/dialog-footer.html\'"></div></form>');
$templateCache.put('app/entities/planning/insert-soc-events-in-plan.html','<div class="create-entity"><button type="button" class="close" ng-click="vm.close()" style="margin-top: -10px; margin-right: -10px"><span aria-hidden="true">&times;</span></button><br><form name="createForm" class="form-horizontal" has-authority="ROLE_PLAN_COORDINATOR"><!-- File Upload Section --><div class="form-group"><label class="col-sm-3 control-label">Files to Upload **</label><div class="col-sm-9"><div class="input-group"><input id="field_file" type="hidden" name="files" ng-model="vm.files" required><ul style="padding: 6px 0 0 10px; list-style-type: none; margin-left: -10px"><li ng-repeat="f in vm.files" style="font-size: smaller">{{f.name}}</li></ul><span class="input-group-btn"><button id="uploadButton" class="btn btn-primary" ngf-select="vm.uploadFiles($files)" multiple="multiple"><span class="glyphicon glyphicon-folder-open"></span>&nbsp;&nbsp;<span>Load Files</span></button></span></div><span class="help-block" ng-show="createForm.files.$error.required">Please load file(s) (*.xml)</span></div></div><div class="form-group"><label class="col-sm-3 control-label">Upload Strategy</label><div class="col-sm-9"><div class="radio"><label><input type="radio" ng-model="vm.uploadStrategy" value="conflicts" ng-init="vm.uploadStrategy=\'conflicts\'"> Show conflicts</label></div><div class="radio"><label><input type="radio" ng-model="vm.uploadStrategy" value="merge"> Merge with existing events (keep new ones only)</label></div><div class="radio"><label><input type="radio" ng-model="vm.uploadStrategy" value="overwrite"> Delete all previous events and insert new ones</label></div></div></div><div class="form-group"><div class="col-sm-offset-3 col-sm-9"><button id="saveButton" class="btn btn-success" ng-click="vm.upload()" ng-disabled="!vm.files || vm.files.length === 0"><span class="glyphicon glyphicon-arrow-up"></span>&nbsp;&nbsp;<span>Upload</span></button></div></div><hr><!-- Visual separator --><!-- Pointings Export Section --><div class="form-group"><div class="col-sm-12 text-center"><button id="downloadButton" class="btn btn-info" ng-click="vm.downloadPointings()"><span class="glyphicon glyphicon-download-alt"></span>&nbsp;&nbsp;<span>Download Pointings</span></button></div></div></form></div><br><div class="alert-fixed"><jhi-alert-error></jhi-alert-error><jhi-alert></jhi-alert></div>');
$templateCache.put('app/entities/planning/insert-soop-template.html','<form name="dialogForm" role="form" class="form-horizontal" novalidate show-validation><div ng-include="\'app/entities/dialog-header.html\'"></div><div class="modal-body"><div class="form-group"><label class="col-sm-3 control-label">SOOP Type</label><div class="col-sm-9"><select class="form-control" name="soopTypeSelect" id="soopTypeSelect" ng-model="vm.selectedType" ng-options="type for type in vm.soopTypes" ng-change="vm.selectedSoop = \'\'"></select></div></div><div class="form-group"><label class="col-sm-3 control-label">SOOP Template</label><div class="col-sm-9"><select class="form-control" name="soopNameSelect" id="soopNameSelect" ng-model="vm.selectedSoop" ng-options="item as item.label disable when item.disabled for item in vm.soops[vm.selectedType]"></select></div></div><div class="form-group"><label class="col-sm-3 control-label">Time</label><div class="col-sm-9"><input class="form-control" name="anchorTime" id="anchorTime" maxlength="20" size="20" type="text" ng-model="vm.anchorTime"> <span class="label label-danger" ng-show="!vm.isValidDate(vm.anchorTime)">Invalid Date</span></div></div></div><div ng-include="\'app/entities/dialog-footer.html\'"></div></form>');
$templateCache.put('app/entities/planning/insert-template.html','<form name="dialogForm" role="form" class="form-horizontal" novalidate show-validation><div ng-include="\'app/entities/dialog-header.html\'"></div><div class="modal-body"><div class="form-group"><label class="col-sm-2 control-label">Template</label><div class="col-sm-10"><select class="form-control" name="templateSelect" id="templateSelect" ng-model="vm.selectedTemplate" ng-options="item as item.label disable when item.disabled for item in vm.templates"></select></div></div><div class="form-group"><label class="col-sm-2 control-label">Time</label><div class="col-sm-10"><input class="form-control" name="anchorTime" id="anchorTime" maxlength="20" size="20" type="text" ng-model="vm.anchorTime"> <span class="label label-danger" ng-show="!vm.isValidDate(vm.anchorTime)">Invalid Date</span></div></div></div><div ng-include="\'app/entities/dialog-footer.html\'"></div></form>');
$templateCache.put('app/entities/planning/manage-users.html','<form name="dialogForm" role="form" class="form-horizontal" novalidate show-validation><div ng-include="\'app/entities/dialog-header.html\'"></div><div class="modal-body"><label><input type="checkbox" id="selectAll" ng-model="checkAllUsers" ng-click="vm.checkAllUsers(vm.allUsers, checkAllUsers)"> Select All</label><div class="table-wrapper-scroll-y"><table class="table table-striped"><tbody><tr ng-repeat="user in vm.allUsers"><td><label><input type="checkbox" id="user" value="{{user}}" ng-checked="vm.selectedUsers.indexOf(user) > -1" ng-click="vm.toggleSelection(user)"> {{user}}</label></td></tr></tbody></table></div><br><div class="panel panel-default"><div class="panel-heading">Selected Users</div><div class="panel-body">{{vm.selectedUsers.sort().join(", ")}}</div></div></div><div ng-include="\'app/entities/dialog-footer.html\'"></div></form>');
$templateCache.put('app/entities/planning/move-events.html','<form name="dialogForm" role="form" class="form-horizontal" novalidate show-validation><div ng-include="\'app/entities/dialog-header.html\'"></div><div class="modal-body"><table class="jh-table table table-striped"><tbody><tr ng-repeat="event in vm.events"><td>{{event.name}}</td><td>{{event.startDate}} => {{event.endDate}}</td></tr></tbody></table><div class="form-group"><label class="col-sm-3 control-label">Time</label><div class="col-sm-9"><input class="form-control" name="anchorTime" id="anchorTime" maxlength="20" size="20" type="text" ng-model="vm.anchorTime"> <span class="label label-danger" ng-show="!vm.isValidDate(vm.anchorTime)">Invalid Date</span></div></div></div><div ng-include="\'app/entities/dialog-footer.html\'"></div></form>');
$templateCache.put('app/entities/planning/move-obs.html','<form name="dialogForm" role="form" class="form-horizontal" novalidate show-validation><div ng-include="\'app/entities/dialog-header.html\'"></div><div class="modal-body"><table class="jh-table table table-striped"><tbody><tr ng-repeat="obs in vm.observations"><td>{{obs.experiment}}</td><td>{{obs.module}}</td><td>{{obs.name}}</td><td>{{obs.startDate}} => {{obs.endDate}}</td></tr></tbody></table><div class="form-group"><label class="col-sm-3 control-label">Time</label><div class="col-sm-9"><input class="form-control" name="anchorTime" id="anchorTime" maxlength="20" size="20" type="text" ng-model="vm.anchorTime"> <span class="label label-danger" ng-show="!vm.isValidDate(vm.anchorTime)">Invalid Date</span></div></div></div><div ng-include="\'app/entities/dialog-footer.html\'"></div></form>');
$templateCache.put('app/entities/planning/move-soop.html','<form name="dialogForm" role="form" class="form-horizontal" novalidate show-validation><div ng-include="\'app/entities/dialog-header.html\'"></div><div class="modal-body"><div class="form-group"><label class="col-sm-3 control-label">Time</label><div class="col-sm-9"><input class="form-control" name="anchorTime" id="anchorTime" maxlength="20" size="20" type="text" ng-model="vm.anchorTime"> <span class="label label-danger" ng-show="!vm.isValidDate(vm.anchorTime)">Invalid Date</span></div></div></div><div ng-include="\'app/entities/dialog-footer.html\'"></div></form>');
$templateCache.put('app/entities/planning/planning-automatic-event-dialog.html','<form name="editForm" role="form" novalidate show-validation><head><meta name="viewport" content="width=device-width,initial-scale=1"><style>.loader {\n                border: 16px solid #f3f3f3;\n                border-radius: 50%;\n                border-top: 16px solid #3498db;\n                width: 120px;\n                height: 120px;\n                -webkit-animation: spin 2s linear infinite; /* Safari */\n                animation: spin 2s linear infinite;\n            }\n\n            /* Safari */\n            @-webkit-keyframes spin {\n                0% { -webkit-transform: rotate(0deg); }\n                100% { -webkit-transform: rotate(360deg); }\n            }\n\n            @keyframes spin {\n                0% { transform: rotate(0deg); }\n                100% { transform: rotate(360deg); }\n            }</style></head><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button></div><div class="modal-body"><div class="form-group"><p class="input-group"><label>Automatic Insertion of Events: {{vm.status.description}}</label></p><table><tr><td valign="bottom"><label>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Start:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</label></td><td valign="bottom">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<input title="start" ng-focus="vm.focusCallback($event)" ng-change="vm.validateDate()" name="startDate" id="startDate" maxlength="20" size="20" type="text" class="form-control" ng-model="vm.picker.date"> <span class="error" ng-show="vm.invalidateStartDate">Invalid Date</span></td><td valign="bottom"><label>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;End:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</label></td><td valign="bottom">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <input title="end" id="endDate" name="endDate" maxlength="20" size="20" ng-focus="vm.focusCallback($event)" ng-change="vm.validateDate()" type="text" class="form-control" ng-model="vm.picker2.date"> <span class="error" ng-show="vm.invalidateEndDate">Invalid Date </span><span ng-show="vm.invalidateDateRange()" class="error">The end date is earlier than the start date!</span></td></tr><tr ng-show="vm.status.hasTimeSlot"><td valign="bottom"><label>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Preferred time slot:</label></td><td valign="bottom"><input type="time" title="Primary Time Slot. Format HH:mm (12h in Firefox)" name="timeSlot" id="timeSlot" class="form-control" ng-focus="vm.focusCallbackTime($event)" ng-change="vm.validateTime()" ng-model="vm.timeSlot" ng-model-options="{timezone: \'UTC\'}" required></td><td><span class="error" ng-show="vm.invalidateTimeSlot">Invalid Time</span></td></tr><tr ng-show="vm.status.hasBackupTimeSlot"><td valign="bottom"><label>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Backup time slot:</label></td><td valign="bottom"><input type="time" title="Backup Time Slot. Format HH:mm (12h in Firefox)" name="backupTimeSlot" id="backupTimeSlot" class="form-control" ng-focus="vm.focusCallbackTime($event)" ng-change="vm.validateTime()" ng-model="vm.backupTimeSlot" ng-model-options="{timezone: \'UTC\'}" required></td><td><span class="error" ng-show="vm.invalidateTimeSlotBackup">Invalid Time</span></td></tr><tr><td colspan="1" valign="bottom"><label>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Cadence:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</label></td><td colspan="3" valign="bottom"><input name="lettersSeparation" title="(You can specify a time unit after a time value \'X\', such as Xd, Xh, Xm, Xs, to represent days (d), hours (h) minutes (m) and seconds (s), respectively)" id="lettersSeparation" ng-change="vm.updateSeparation()" ng-model="vm.lettersSeparation" required readonly="readonly"> <span id="separationLettersError" class="error" ng-show="vm.separationLettersInvalid()">Wrong format </span>= <input title="separation" id="separation" name="separation" ng-change="vm.updateSeparationLetters()" type="number" ng-model="vm.separation" required readonly="readonly"> s <span id="errorValidSeparation" class="error" ng-show="editForm.separation.$error.number">Not valid number!</span></td></tr><tr ng-show="vm.status.hasMinimumDuration"><td colspan="1" valign="bottom"><label>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Min Duration:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</label></td><td colspan="3" valign="bottom"><input name="lettersDuration" title="(You can specify a time unit after a time value \'X\', such as Xd, Xh, Xm, Xs, to represent days (d), hours (h) minutes (m) and seconds (s), respectively)" id="lettersDuration" ng-change="vm.updateDuration()" ng-model="vm.lettersDuration" required> <span id="lettersDurationError" class="error" ng-show="vm.durationLettersInvalid()">Wrong format </span>= <input title="duration" id="duration" name="duration" ng-change="vm.updateDurationLetters()" type="number" ng-model="vm.duration" required> s <span id="errorValidDuration" class="error" ng-show="editForm.duration.$error.number">Not valid number!</span></td></tr><tr ng-show="vm.status.hasBackupTimeSlot"><td colspan="2" vertical-align="bottom"><label>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Generate Automatic&nbsp;IS_COORD_BURST events&nbsp;</label><input type="checkbox" title="isCoordBurstAutomatic" name="isCoordBurstAutomatic" id="isCoordBurstAutomatic" ng-model="vm.isCoordBurstAutomatic"></td><td valign="bottom"></td></tr></table></div><div ng-show="vm.unsuccesfulDates != null"><textarea name="multilinetext" ng-model="vm.unsuccesfulDates" rows="8" cols="100" wrap="soft" width="100%" height="100%" box-sizing="border-box">\n            </textarea></div><div ng-show="vm.checkLoader == true" class="loader"></div></div><div class="modal-footer"><jhi-alert-error></jhi-alert-error><jhi-alert></jhi-alert><button ng-show="vm.status.check != null" type="submit" id="checkButton" class="btn btn-info" ng-click="vm.check()"><span class="glyphicon glyphicon glyphicon-alert"></span>&nbsp;<span>Check</span></button> <button type="submit" id="applyButton" class="btn btn-primary" ng-click="vm.apply()"><span class="glyphicon glyphicon glyphicon-saved"></span>&nbsp;<span>Apply</span></button> <button id="finishButton" type="button" class="btn btn-success" data-dismiss="modal" ng-click="vm.finish()"><span class="glyphicon glyphicon-record"></span>&nbsp;<span>Finish</span></button> <button id="cancelButton" type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Cancel</span></button></div></form>');
$templateCache.put('app/entities/planning/planning-child-plans.html','<div class="create-entity" ng-show="vm.showCreateMenu[1] && vm.activeTab == 1"><br><form name="myChildPlanForm" class="form-horizontal"><div class="form-group"><label for="selectParent" class="col-sm-2 control-label">Parent plan</label><div class="col-sm-10"><select id="selectParent" name="selectParent" required ng-model="vm.selectedParentLabel" class="form-control"><option ng-repeat="label in vm.parentPlanLabels" value="{{label}}">{{label}}</option></select><div ng-show="myChildPlanForm.selectParent.$invalid"><p class="help-block" ng-show="myChildPlanForm.selectParent.$error.required">This field is required.</p></div></div></div><div class="form-group"><label for="ChildPlanLabel" class="col-sm-2 control-label">Label</label><div class="col-sm-10"><input id="ChildPlanLabel" name="ChildPlanLabel" type="text" name="label" ng-model="vm.childPlanLabel" class="form-control" maxlength="40" required ng-pattern="/^[0-9a-zA-Z\\.\\:\\<\\>\\ \\_\\@\\!\\(\\)\\{\\}\\,\\-\\[\\]]+$/"><div ng-show="myChildPlanForm.ChildPlanLabel.$invalid && (myChildPlanForm.ChildPlanLabel.$viewValue.length > 0)"><p class="help-block">Character not allowed</p></div><div ng-show="myChildPlanForm.ChildPlanLabel.$error.required"><p class="help-block">This field is required.</p></div></div></div><div class="form-group"><div class="col-sm-2"></div><div class="col-sm-10"><button id="createChildPlanButton" class="btn btn-success pull-right" ng-disabled="!myChildPlanForm.$valid" ng-click="vm.createChildPlan()"><span class="glyphicon glyphicon-save"></span>&nbsp;&nbsp;<span>Create</span></button></div></div></form></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.sortChildPlanTable(vm.childPlans, vm.predicate, vm.reverse)"><th jh-sort-by="label"><span>Label</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="internalVersion"><span>Version</span><span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="created"><span>Creation Date</span><span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="timestamp"><span>Modification Date</span><span class="glyphicon glyphicon-sort"></span></th><th><span>Delta</span></th><th jh-sort-by="observationDefinitionsLabel"><span>Observation Definitions</span><span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="parent"><span>Parent</span><span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="owner"><span>Owner</span><span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="planMeta in vm.childPlans track by $index"><td>{{planMeta.label}}</td><td>{{planMeta.internalVersion}}</td><td>{{vm.formatIsoZuluDateString(planMeta.created)}}</td><td>{{vm.formatIsoZuluDateString(planMeta.deltas[0].timestamp)}}</td><td><span valign="bottom" class="glyphicon glyphicon-plus" ng-show="!vm.showDelta[planMeta.label]" id="buttonChildDelta_plus" ng-click="vm.showDelta[planMeta.label] = true"></span> <span valign="bottom" class="glyphicon glyphicon-minus" ng-show="vm.showDelta[planMeta.label]" id="buttonChildDelta_minus" ng-click="vm.showDelta[planMeta.label] = false"><div ng-repeat="delta in planMeta.deltas">{{delta.prettyString}}</div></span></td><td>{{planMeta.observationDefinitionsLabel}}</td><td>{{planMeta.parent}}</td><td>{{planMeta.planUserInfo.owner}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><span ng-show="planMeta.locked" style="margin:4px"><img alt="lock" height="22" width="22" src="content/images/lock.png"> </span><button id="buttonChildDetail_{{$index}}" type="submit" ui-sref="planning-detail({id:planMeta.label, baselineVersion:planMeta.baselineVersion, planType: vm.getPlanType(planMeta.planType)})" class="btn btn-primary btn-sm" data-toggle="tooltip" data-placement="bottom" title="View" delay="1000"><span class="glyphicon glyphicon-eye-open"></span></button> <button id="buttonChildVersions_{{$index}}" type="submit" ui-sref="planning.versions({id:planMeta.label, planType: vm.getPlanType(planMeta.planType)})" class="btn btn-primary btn-sm" data-toggle="tooltip" data-placement="bottom" title="Versions" delay="1000"><span class="glyphicon glyphicon-list"></span></button> <button id="buttonChildRename_{{$index}}" ng-disabled="planMeta.locked" has-authority="ROLE_PLAN_COORDINATOR" is-user-tables="{{planMeta.planUserInfo.owner}}" type="submit" ng-click="vm.renamePlan(planMeta.label, vm.getPlanType(planMeta.planType))" class="btn btn-primary btn-sm" data-toggle="tooltip" data-placement="bottom" title="Rename" delay="1000"><span class="glyphicon glyphicon-pencil"></span></button> <button id="buttonChildDelete_{{$index}}" ng-disabled="planMeta.locked" has-authority="ROLE_PLAN_COORDINATOR" is-user-tables="{{planMeta.planUserInfo.owner}}" type="submit" ng-click="vm.deletePlan(planMeta.label, vm.getPlanType(planMeta.planType))" class="btn btn-danger btn-sm" data-toggle="tooltip" data-placement="bottom" title="Delete" delay="1000"><span class="glyphicon glyphicon-remove-circle"></span></button></div></td></tr></tbody></table></div>');
$templateCache.put('app/entities/planning/planning-delete-dialog.html','<form name="dialogForm" class="form-horizontal"><div ng-include="\'app/entities/dialog-header.html\'"></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete the Plan with the label {{vm.label}}?</p></div><div ng-include="\'app/entities/dialog-footer.html\'"></div></form>');
$templateCache.put('app/entities/planning/planning-detail.html','<div class="wrapper"><!-- Content Wrapper. Contains page content --><div class="content-wrapper"><!-- Content Header (Page header) --><section class="content-header"><table style="width: 100%"><tr><td style="display: table-cell;  text-align: left">Plan: <span id="planningLabel" class="label label-info label-xs">{{vm.planning.label}}</span> <span ng-show="vm.planning.baselineVersion>0">Baseline: <span class="label label-info label-xs">{{vm.planning.baselineVersion}}</span></span> <span>Version: <span class="label label-info label-xs">{{vm.planning.internalVersion}}</span></span> <span ng-if="vm.isSoop">Type: <span class="label label-info label-xs">{{vm.planning.soopType}}</span></span> <span ng-if="vm.isSoop && vm.planning.leadInstrument">Lead: <span class="label label-info label-xs">{{vm.planning.leadInstrument}}</span></span> <span ng-if="vm.isMaster && vm.planning.efecsVersion > 0">E-fecs Version: <span class="label label-info label-xs">{{vm.planning.efecsVersion}}</span></span> <span ng-if="vm.isMaster && vm.planning.prime">Prime: <span class="label label-info label-xs">{{vm.planning.prime}}</span></span></td><td style="display: table-cell; vertical-align: middle">Observations: <span class="label label-info label-xs"><strong>{{vm.planning.observationDefinitions.label}}</strong></span> <button ng-if="vm.isMaster" ng-show="!vm.changeObsDefVisible && !vm.isVersion && !vm.isLocked" has-authority="ROLE_PLAN_COORDINATOR" id="changeObsButton" type="button" class="btn btn-primary btn-xs" ng-click="vm.changeObsDefVisible = !vm.changeObsDefVisible"><span class="glyphicon glyphicon-cog"></span></button> <button ng-if="vm.isChild" ng-show="!vm.changeObsDefVisible && !vm.isVersion && !vm.isLocked" has-authority="ROLE_PLAN_COORDINATOR" is-user="{{vm.planning.planUserInfo.owner}}" is-in-users-authorities="ROLE_INSTRUMENT_COORDINATOR" is-in-users="{{vm.planning.planUserInfo.usersWithRights}}" id="changeObsButton" type="button" class="btn btn-primary btn-xs" ng-click="vm.changeObsDefVisible = !vm.changeObsDefVisible"><span class="glyphicon glyphicon-cog"></span></button> <button ng-if="vm.isTemplate" ng-show="!vm.changeObsDefVisible && !vm.isVersion && !vm.isLocked" has-authority="ROLE_PLAN_COORDINATOR" is-user="{{vm.planning.planUserInfo.owner}}" is-in-users-authorities="ROLE_INSTRUMENT_COORDINATOR" is-in-users="{{vm.planning.planUserInfo.usersWithRights}}" id="changeObsButton" type="button" class="btn btn-primary btn-xs" ng-click="vm.changeObsDefVisible = !vm.changeObsDefVisible"><span class="glyphicon glyphicon-cog"></span></button> <button ng-if="vm.isSoop" ng-show="!vm.changeObsDefVisible && !vm.isVersion && !vm.isLocked" has-authority="ROLE_PLAN_COORDINATOR" id="changeObsButton" type="button" class="btn btn-primary btn-xs" ng-click="vm.changeObsDefVisible = !vm.changeObsDefVisible"><span class="glyphicon glyphicon-cog"></span></button><div style="display: table-cell; vertical-align: middle; padding-top:5px" ng-show="vm.changeObsDefVisible"><select title="selectObsDef" id="selectObsDef" ng-model="vm.selectedNewObservationDefinitions" ng-options="item for item in vm.observationDefinitions"></select><button id="submitNewObsDefButton" ng-disabled="!vm.canUpdateObsDef()" type="button" class="btn btn-primary btn-xs" ng-click="vm.submitNewObsDef()"><span class="glyphicon glyphicon-ok"></span></button> <button id="cancelNewObsDefButton" type="button" class="btn btn-primary btn-xs" ng-click="vm.changeObsDefVisible=false;"><span class="glyphicon glyphicon-remove"></span></button></div></td><td ng-if="vm.isChild" style="display: table-cell; vertical-align: middle">Parent: <span class="label label-info label-xs"><strong>{{vm.planning.parentLabel}}</strong></span> <button ng-show="!vm.changeParentVisible && !vm.isVersion && !vm.isLocked" has-authority="ROLE_PLAN_COORDINATOR" is-user="{{vm.planning.planUserInfo.owner}}" is-in-users-authorities="ROLE_INSTRUMENT_COORDINATOR" is-in-users="{{vm.planning.planUserInfo.usersWithRights}}" id="changeParentButton" type="button" class="btn btn-primary btn-xs" ng-click="vm.changeParentVisible = !vm.changeParentVisible"><span class="glyphicon glyphicon-cog"></span></button><div style="display: table-cell; vertical-align: middle; padding-top:5px" ng-show="vm.changeParentVisible"><select title="selectParent" id="selectParent" ng-model="vm.selectedNewParentLabel" ng-options="item for item in vm.parentPlans"></select><button id="submitNewParentButton" ng-disabled="!vm.canUpdateParent()" type="button" class="btn btn-primary btn-xs" ng-click="vm.updateParent()"><span class="glyphicon glyphicon-ok"></span></button> <button id="cancelNewParentButton" type="button" class="btn btn-primary btn-xs" ng-click="vm.changeParentVisible=false;"><span class="glyphicon glyphicon-remove"></span></button></div></td><td ng-if="vm.isMaster" style="display: table-cell; vertical-align: middle">Events: <span class="label label-info label-xs">{{vm.planning.eventCollections.label}}</span> <button ng-show="!vm.changeEvCollecVisible && !vm.isVersion && !vm.isLocked" has-authority="ROLE_PLAN_COORDINATOR" id="changeButton" type="button" class="btn btn-primary btn-xs" ng-click="vm.changeEvCollecVisible = !vm.changeEvCollecVisible"><span class="glyphicon glyphicon-cog"></span></button><div style="display: table-cell; vertical-align: middle; padding-top:5px" ng-show="vm.changeEvCollecVisible"><select title="selectEventCollections" id="selectEventCollections" ng-model="vm.selectedNewEventCollections" ng-options="item for item in vm.eventCollections"></select><button id="submitButton" ng-disabled="!vm.canUpdateEvents()" type="button" class="btn btn-primary btn-xs" ng-click="vm.submitNewEvCollection()"><span class="glyphicon glyphicon-ok"></span></button> <button id="cancelButton" type="button" class="btn btn-primary btn-xs" ng-click="vm.changeEvCollecVisible=false;"><span class="glyphicon glyphicon-remove"></span></button></div></td><td style="display: table-cell; vertical-align: middle; horizontal-align: right; text-align: right"><span ng-show="vm.isLocked" style="margin:4px"><img alt="lock" ng-show="vm.isLocked && vm.isMaster" has-authority="ROLE_PLAN_COORDINATOR" ng-click="vm.unlock(vm.planning.label)" height="22" width="22" src="content/images/lock.png"> <img alt="lock" ng-show="vm.isLocked && vm.isChild" has-authority="ROLE_PLAN_COORDINATOR" is-user="{{vm.planning.planUserInfo.owner}}" is-in-users-authorities="ROLE_INSTRUMENT_COORDINATOR" is-in-users="{{vm.planning.planUserInfo.usersWithRights}}" ng-click="vm.unlock(vm.planning.label)" height="22" width="22" src="content/images/lock.png"> <img alt="lock" ng-show="vm.isLocked && vm.isTemplate" has-authority="ROLE_PLAN_COORDINATOR" is-user="{{vm.planning.planUserInfo.owner}}" is-in-users-authorities="ROLE_INSTRUMENT_COORDINATOR" is-in-users="{{vm.planning.planUserInfo.usersWithRights}}" ng-click="vm.unlock(vm.planning.label)" height="22" width="22" src="content/images/lock.png"> <img alt="lock" ng-show="vm.isLocked && vm.isSoop" has-authority="ROLE_PLAN_COORDINATOR" ng-click="vm.unlock(vm.planning.label)" height="22" width="22" src="content/images/lock.png"> </span><button ng-if="!vm.isVersion && !vm.isLocked && vm.isMaster && vm.isEfecs" has-authority="ROLE_PLAN_COORDINATOR" popover-placement="bottom" id="setEfecsVersionButton" class="btn btn-primary btn-sm" data-toggle="tooltip" data-placement="bottom" title="Set E-FECS Version & Prime" delay="1000" ng-click="vm.setEfecsVersion()"><em class="glyphicon glyphicon-tags"></em></button> <button ng-if="!vm.isVersion && !vm.isLocked && vm.isMaster" has-authority="ROLE_PLAN_COORDINATOR" type="button" class="btn btn-primary btn-sm" popover-placement="bottom" id="expandEventsButton" class="btn btn-primary btn-sm" data-toggle="tooltip" data-placement="bottom" title="Expand Events" delay="1000" ng-click="vm.expandEvents()"><span class="glyphicon glyphicon-expand"></span></button> <button ng-if="!vm.isVersion && !vm.isLocked && vm.isMaster" has-any-authority="ROLE_PLAN_COORDINATOR,ROLE_POWER_USER" is-in-users-authorities="ROLE_INSTRUMENT_COORDINATOR" is-in-users="{{vm.planning.planUserInfo.usersWithRights}}" popover-placement="bottom" id="importButton" class="btn btn-primary btn-sm" data-toggle="tooltip" data-placement="bottom" title="Import" delay="1000" ng-click="vm.insertPlan()"><em class="glyphicon glyphicon-import"></em></button> <button ng-if="!vm.isVersion && !vm.isLocked && vm.isChild" has-any-authority="ROLE_PLAN_COORDINATOR,ROLE_POWER_USER" is-user="{{vm.planning.planUserInfo.owner}}" is-in-users-authorities="ROLE_INSTRUMENT_COORDINATOR,ROLE_INSTRUMENT_TEAM_MEMBER" is-in-users="{{vm.planning.planUserInfo.usersWithRights}}" popover-placement="bottom" id="importButton" class="btn btn-primary btn-sm" data-toggle="tooltip" data-placement="bottom" title="Import" delay="1000" ng-click="vm.insertPlan()"><em class="glyphicon glyphicon-import"></em></button> <button ng-if="!vm.isVersion && !vm.isLocked && vm.isTemplate" has-any-authority="ROLE_PLAN_COORDINATOR,ROLE_POWER_USER" is-user="{{vm.planning.planUserInfo.owner}}" is-in-users-authorities="ROLE_INSTRUMENT_COORDINATOR,ROLE_INSTRUMENT_TEAM_MEMBER" is-in-users="{{vm.planning.planUserInfo.usersWithRights}}" ng-show="!vm.showPlanToImport" popover-placement="bottom" id="importButton" class="btn btn-primary btn-sm" data-toggle="tooltip" data-placement="bottom" title="Import" delay="1000" ng-click="vm.showPlanToImport = true"><em class="glyphicon glyphicon-import"></em></button> <button ng-if="!vm.isVersion && !vm.isLocked && vm.isSoop" has-any-authority="ROLE_PLAN_COORDINATOR,ROLE_POWER_USER" is-in-users-authorities="ROLE_INSTRUMENT_COORDINATOR,ROLE_INSTRUMENT_TEAM_MEMBER" is-in-users="{{vm.planning.planUserInfo.usersWithRights}}" ng-show="!vm.showPlanToImport" popover-placement="bottom" id="importButton" class="btn btn-primary btn-sm" data-toggle="tooltip" data-placement="bottom" title="Import" delay="1000" ng-click="vm.showPlanToImport = true"><em class="glyphicon glyphicon-import"></em></button> <button ng-if="!vm.isVersion && !vm.isLocked" has-any-authority="ROLE_PLAN_COORDINATOR,ROLE_POWER_USER" is-user="{{vm.planning.planUserInfo.owner}}" is-in-users-authorities="ROLE_INSTRUMENT_COORDINATOR,ROLE_INSTRUMENT_TEAM_MEMBER" is-in-users="{{vm.planning.planUserInfo.usersWithRights}}" popover-placement="bottom" id="importSOCEventsButton" class="btn btn-primary btn-sm" data-toggle="tooltip" data-placement="bottom" title="Import" delay="1000" ng-click="vm.insertSOCEvents()"><em class="glyphicon glyphicon-sound-dolby"></em></button><select ng-show="vm.showPlanToImport" title="selectPlanToImport" id="selectPlanToImport" ng-model="vm.selectedPlanToImport" ng-options="item for item in vm.planToImport"></select><button ng-show="vm.showPlanToImport" id="confirmImportButton" ng-disabled="!vm.canImport()" type="button" class="btn btn-primary btn-xs" ng-click="vm.importPlan()"><span class="glyphicon glyphicon-ok"></span></button> <button ng-show="vm.showPlanToImport" id="cancelImportButton" type="button" class="btn btn-primary btn-xs" ng-click="vm.showPlanToImport=false;"><span class="glyphicon glyphicon-remove"></span></button> <button ng-if="vm.isTemplate" has-authority="ROLE_PLAN_COORDINATOR" type="button" class="btn btn-primary btn-sm" id="soopify" title="Create SOOP" ng-click="vm.soopify()"><span class="glyphicon glyphicon-tint"></span></button> <button ng-if="vm.isSoop" has-authority="ROLE_PLAN_COORDINATOR" type="button" class="btn btn-primary btn-sm" id="soopify" title="Create Floating Timeline" ng-click="vm.unsoopify()"><span class="glyphicon glyphicon-tint"></span></button> <button ng-if="vm.isMaster" has-authority="ROLE_PLAN_COORDINATOR" type="button" class="btn btn-primary btn-sm" id="manageUsers" title="Manage Users" ng-click="vm.manageUsers()"><span class="glyphicon glyphicon-user"></span></button> <button ng-if="vm.isChild" has-authority="ROLE_PLAN_COORDINATOR" is-user="{{vm.planning.planUserInfo.owner}}" type="button" class="btn btn-primary btn-sm" id="manageUsers" title="Manage Users" ng-click="vm.manageUsers()"><span class="glyphicon glyphicon-user"></span></button> <button ng-if="vm.isTemplate" has-authority="ROLE_PLAN_COORDINATOR" is-user="{{vm.planning.planUserInfo.owner}}" type="button" class="btn btn-primary btn-sm" id="manageUsers" title="Manage Users" ng-click="vm.manageUsers()"><span class="glyphicon glyphicon-user"></span></button> <button ng-if="vm.isSoop" has-authority="ROLE_PLAN_COORDINATOR" type="button" class="btn btn-primary btn-sm" id="manageUsers" title="Manage Users" ng-click="vm.manageUsers()"><span class="glyphicon glyphicon-user"></span></button> <button ng-if="vm.isMaster" popover-placement="bottom" uib-popover-html="vm.moreInfo" type="submit" id="infoButton" class="btn btn-primary btn-sm"><em class="glyphicon glyphicon-info-sign"></em></button> <button type="button" class="btn btn-primary btn-sm" id="leftScroll" ng-click="vm.movePlanLeft()"><span class="glyphicon glyphicon-menu-left"></span></button> <button type="button" class="btn btn-primary btn-sm" id="zoomOut" ng-click="vm.zoomOut()"><span class="glyphicon glyphicon-zoom-out"></span></button> <button type="button" class="btn btn-primary btn-sm" id="zoomIn" ng-click="vm.zoomIn()"><span class="glyphicon glyphicon-zoom-in"></span></button> <button type="button" class="btn btn-primary btn-sm" id="rightScroll" ng-click="vm.movePlanRight()"><span class="glyphicon glyphicon-menu-right"></span></button> <button type="button" class="btn btn-primary btn-sm" id="refreshButton" ng-click="vm.reload()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span>Refresh</span></button><div style="clear: both"></div><div style="display: inline-block; float: right; padding-top:5px"><div class="input-group"><span class="input-group-addon">Start</span> <input type="text" id="startDatePoint" name="startDatePoint" maxlength="10" ng-model="vm.pickerPoint1.date" class="form-control" style="min-width: 100px"> <span class="input-group-addon">End</span> <input type="text" id="endDatePoint" name="endDatePoint" maxlength="10" ng-model="vm.pickerPoint2.date" class="form-control" style="min-width: 100px"> <span class="input-group-btn"><button id="applyButtonPoint" ng-click="vm.applyPoints()" class="btn btn-primary"><span class="glyphicon glyphicon-transfer"></span>&nbsp;<span>Fill in timeline</span></button></span></div></div></td></tr></table></section><!-- Main content --><section class="content"><br><div class="dropdown" id="timeline-context-menu" ng-style="visContextDropdownStyle" ng-if="vm.isThereContextMenu"><ul ng-show="!vm.isLocked && !vm.isVersion" class="dropdown-menu" ng-style="visContextDropdownMenuStyle"><li ng-repeat="menuItem in vm.contextMenu" ng-if="menuItem.userAccessPermitted() && menuItem.contextPermitted()"><a href="" ng-click="vm.rightClickAction(menuItem)">{{menuItem.text}}</a></li></ul></div><div id="visualization" style="background-color: {{vm.isLockedColor}}"><wait></div><br><div class="panel panel-default"><div class="panel-body"><div class="row"><div class="col-md-2"><div class="input-group"><span class="input-group-addon">Start</span><input type="text" id="startDate" name="startDate" maxlength="10" size="10" ng-model="vm.picker.date" ng-change="vm.updateEndDate()" class="form-control" aria-describedby="basic-addon1"></div><span class="label label-danger" ng-show="vm.isValidDate(vm.getPickerDate()) == false">Invalid Date</span></div><div class="col-md-2"><div class="input-group"><span class="input-group-addon">Duration</span><input type="text" name="durationLetters" title="(You can specify a time unit after a time value \'X\', such as Xd, Xh, Xm, Xs, to represent days (d), hours (h) minutes (m) and seconds (s), respectively)" id="durationLetters" ng-change="vm.updateLetters()" ng-model="vm.durationLetters" required ng-trim="false" class="form-control" aria-describedby="basic-addon1"></div><span class="label label-danger" id="durationLettersError" ng-show="vm.durationLettersInvalid()">Wrong Format!!</span></div><div class="col-md-3"><div class="input-group"><span class="input-group-addon">End</span><input id="endDate" ng-change="vm.updateDuration()" name="endDate" maxlength="10" size="10" type="text" class="form-control" ng-model="vm.picker2.date" aria-describedby="basic-addon1"> <span class="input-group-btn"><button id="applyButton" ng-click="vm.applyWidth()" class="btn btn-primary"><span class="glyphicon glyphicon-transfer"></span>&nbsp;<span>Apply</span></button> <button id="resetWidthButton" ng-click="vm.resetWidth()" class="btn btn-primary"><span class="glyphicon glyphicon-fast-backward"></span>&nbsp;<span>Reset</span></button></span></div><span class="label label-danger" ng-show="vm.isValidDate(vm.getPickerDate2()) == false">Invalid Date </span><span ng-show="vm.invalidateDateRange()" class="label label-danger">The end date is earlier than the start date!</span></div><div class="col-md-2"><div class="input-group"><input id="searchText" aria-describedby="basic-addon1" name="searchText" type="text" class="form-control" ng-model="vm.searchText"> <span class="input-group-btn"><button id="searchButton" ng-click="vm.search(vm.searchText)" class="btn btn-primary"><span class="glyphicon glyphicon-search"></span>&nbsp;<span>Search</span></button></span></div></div><div class="col-md-3"><div class="pull-right"><button ng-if="vm.isMaster" id="automaticEventsButton" ng-disabled="vm.isVersion" has-authority="ROLE_PLAN_COORDINATOR" ng-disabled="false === vm.showAutomaticButton()" ng-click="vm.openAutomaticEventWindow()" class="btn btn-primary"><span class="glyphicon glyphicon-king"></span>&nbsp;<span> {{vm.status.description}}</span></button></div></div></div></div><div class="alert-fixed"><jhi-alert-error></jhi-alert-error><jhi-alert></jhi-alert></div><div class="row"><div class="col-md-10"><div class="panel panel-default"><div class="panel-heading"><h3 class="panel-title">Show/Hide Group(s)</h3></div><div class="panel-body"><div class="row"><div class="col-md-12"><div class="checkbox" style="display: inline-block; padding-left: 5px; padding-right: 15px"><span class="glyphicon glyphicon-check" ng-show="vm.checkedAll" id="checkedAll_checked" ng-click="vm.toggleCheckAll()"><label style="padding-left: 5px">All&nbsp;Instruments</label></span><span class="glyphicon glyphicon-unchecked" ng-show="vm.checkedAll===false" id="checkedAll_unchecked" ng-click="vm.toggleCheckAll()"><label style="padding-left: 5px"><del>All&nbsp;Instruments</del></label></span></div><div ng-repeat="group in vm.groups" style="display: inline-block; padding-left: 5px; padding-right: 15px"><div class="checkbox"><span class="glyphicon glyphicon-check" ng-show="vm.checkedValue[group]" id="{{group}}" ng-click="vm.groupChange(group)"><label style="padding-left: 5px">{{group}}</label></span><span class="glyphicon glyphicon-unchecked" ng-show="vm.checkedValue[group]===false" id="{{group}}_unchecked" ng-click="vm.groupChange(group)"><label style="padding-left: 5px"><del>{{group}}</del></label></span></div></div></div></div></div></div></div><div class="col-md-2"><div class="panel panel-default"><div class="panel-heading"><h3 class="panel-title">Resource Profiles</h3></div><div class="panel-body"><div class="btn-group btn-flex" uib-dropdown is-open="status.isopen"><button id="single-profile-button" type="button" class="btn btn-primary" uib-dropdown-toggle ng-disabled="disabled"><div class="pull-left">Select Instrument</div><div class="pull-right"><span class="caret"></span></div></button><ul class="dropdown-menu" uib-dropdown-menu role="menu" aria-labelledby="single-button"><li><a href="" ng-click="vm.openProfile(\'All\')">All Instruments</a></li><li role="separator" class="divider"></li><li class="dropdown-header">Remote Sensing</li><li ng-repeat="rsInstrument in vm.rsInstruments"><a href="" ng-click="vm.openProfile(rsInstrument)">{{rsInstrument}}</a></li><li class="dropdown-header">In Situ</li><li ng-repeat="isInstrument in vm.isInstruments"><a href="" ng-click="vm.openProfile(isInstrument)">{{isInstrument}}</a></li></ul></div></div></div></div></div></div></section><!--<button id="backButton" type="submit" ui-sref="{{ vm.previousState(vm.previousParams) }}" class="btn btn-primary">--> <button id="backButton" type="submit" ng-click="vm.goBack()" class="btn btn-primary"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button ng-show="vm.isVersion == false && vm.isMaster" ng-disabled="vm.isLocked" has-any-authority="ROLE_PLAN_COORDINATOR,ROLE_POWER_USER" is-in-users-authorities="ROLE_INSTRUMENT_COORDINATOR" is-in-users="{{vm.planning.planUserInfo.usersWithRights}}" id="panicButton" type="button" class="btn btn-primary" ng-click="vm.panic()"><span class="glyphicon glyphicon-lock"></span>&nbsp;<span>Panic</span></button> <button ng-show="vm.isVersion == false && vm.isTemplate" ng-disabled="vm.isLocked" has-any-authority="ROLE_PLAN_COORDINATOR,ROLE_POWER_USER" is-user="{{vm.planning.planUserInfo.owner}}" is-in-users-authorities="ROLE_INSTRUMENT_COORDINATOR,ROLE_INSTRUMENT_TEAM_MEMBER" is-in-users="{{vm.planning.planUserInfo.usersWithRights}}" id="panicButton" type="button" class="btn btn-primary" ng-click="vm.panic()"><span class="glyphicon glyphicon-lock"></span>&nbsp;<span>Panic</span></button> <button ng-show="vm.isVersion == false && vm.isSoop" ng-disabled="vm.isLocked" has-any-authority="ROLE_PLAN_COORDINATOR,ROLE_POWER_USER" is-in-users-authorities="ROLE_INSTRUMENT_COORDINATOR,ROLE_INSTRUMENT_TEAM_MEMBER" is-in-users="{{vm.planning.planUserInfo.usersWithRights}}" id="panicButton" type="button" class="btn btn-primary" ng-click="vm.panic()"><span class="glyphicon glyphicon-lock"></span>&nbsp;<span>Panic</span></button> <button ng-show="vm.isVersion == false && vm.isChild" ng-disabled="vm.isLocked" has-any-authority="ROLE_PLAN_COORDINATOR,ROLE_POWER_USER" is-user="{{vm.planning.planUserInfo.owner}}" is-in-users-authorities="ROLE_INSTRUMENT_COORDINATOR,ROLE_INSTRUMENT_TEAM_MEMBER" is-in-users="{{vm.planning.planUserInfo.usersWithRights}}" id="panicButton" type="button" class="btn btn-primary" ng-click="vm.panic()"><span class="glyphicon glyphicon-lock"></span>&nbsp;<span>Panic</span></button> <button ng-show="vm.isMaster && vm.isVersion == false" ng-disabled="vm.isLocked" has-authority="ROLE_PLAN_COORDINATOR" id="saveBaselineButton" type="button" class="btn btn-primary" ng-click="vm.saveBaseline()"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save Baseline</span></button> <button ng-show="vm.isChild && vm.isVersion == false" ng-disabled="vm.isLocked" has-authority="ROLE_PLAN_COORDINATOR" is-user="{{vm.planning.planUserInfo.owner}}" is-in-users-authorities="ROLE_INSTRUMENT_COORDINATOR" is-in-users="{{vm.planning.planUserInfo.usersWithRights}}" id="saveBaselineButton" type="button" class="btn btn-primary" ng-click="vm.saveBaseline()"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save Baseline</span></button> <button ng-show="vm.isTemplate && vm.isVersion == false" ng-disabled="vm.isLocked" has-authority="ROLE_PLAN_COORDINATOR" is-user="{{vm.planning.planUserInfo.owner}}" is-in-users-authorities="ROLE_INSTRUMENT_COORDINATOR" is-in-users="{{vm.planning.planUserInfo.usersWithRights}}" id="saveBaselineButton" type="button" class="btn btn-primary" ng-click="vm.saveBaseline()"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save Baseline</span></button> <button ng-show="vm.isSoop && vm.isVersion == false" ng-disabled="vm.isLocked" has-authority="ROLE_PLAN_COORDINATOR" id="saveBaselineButton" type="button" class="btn btn-primary" ng-click="vm.saveBaseline()"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save Baseline</span></button> <button ng-if="vm.isMaster" ng-disabled="vm.isLocked" has-any-authority="ROLE_PLAN_COORDINATOR,ROLE_POWER_USER" is-in-users-authorities="ROLE_INSTRUMENT_COORDINATOR" is-in-users="{{vm.planning.planUserInfo.usersWithRights}}" id="bookmarkButton" type="button" class="btn btn-primary" ng-click="vm.bookMark()"><span class="glyphicon glyphicon-bookmark"></span>&nbsp;<span>Bookmark</span></button> <button ng-if="vm.isChild" ng-disabled="vm.isLocked" has-any-authority="ROLE_PLAN_COORDINATOR,ROLE_POWER_USER" is-user="{{vm.planning.planUserInfo.owner}}" is-in-users-authorities="ROLE_INSTRUMENT_COORDINATOR,ROLE_INSTRUMENT_TEAM_MEMBER" is-in-users="{{vm.planning.planUserInfo.usersWithRights}}" id="bookmarkButton" type="button" class="btn btn-primary" ng-click="vm.bookMark()"><span class="glyphicon glyphicon-bookmark"></span>&nbsp;<span>Bookmark</span></button> <button ng-if="vm.isTemplate" ng-disabled="vm.isLocked" has-any-authority="ROLE_PLAN_COORDINATOR,ROLE_POWER_USER" is-user="{{vm.planning.planUserInfo.owner}}" is-in-users-authorities="ROLE_INSTRUMENT_COORDINATOR,ROLE_INSTRUMENT_TEAM_MEMBER" is-in-users="{{vm.planning.planUserInfo.usersWithRights}}" id="bookmarkButton" type="button" class="btn btn-primary" ng-click="vm.bookMark()"><span class="glyphicon glyphicon-bookmark"></span>&nbsp;<span>Bookmark</span></button> <button ng-if="vm.isSoop" ng-disabled="vm.isLocked" has-any-authority="ROLE_PLAN_COORDINATOR,ROLE_POWER_USER" is-in-users-authorities="ROLE_INSTRUMENT_COORDINATOR,ROLE_INSTRUMENT_TEAM_MEMBER" is-in-users="{{vm.planning.planUserInfo.usersWithRights}}" id="bookmarkButton" type="button" class="btn btn-primary" ng-click="vm.bookMark()"><span class="glyphicon glyphicon-bookmark"></span>&nbsp;<span>Bookmark</span></button> <button ng-if="vm.isMaster" ng-show="vm.isVersion == false" ng-disabled="vm.isLocked" has-authority="ROLE_PLAN_COORDINATOR" id="validityButton" type="button" class="btn btn-primary" ng-click="vm.setValidityPeriod()"><span class="glyphicon glyphicon-scissors"></span>&nbsp;<span>Restrict Planning Period</span></button> <button id="versionsButton" type="submit" ui-sref="planning.versions({id:vm.planning.label, planType: vm.planType})" class="btn btn-primary"><span class="glyphicon glyphicon-list"></span>&nbsp;<span>Versions</span></button><div class="btn-group pull-left"></div></div><!-- /.content-wrapper --><!-- /.modal-dialog --></div><!-- /.modal -->');
$templateCache.put('app/entities/planning/planning-dialog.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h3 class="modal-title">{{vm.dialogTitle}} an Observation in Plan <span class="label label-info">{{vm.plan.label}}</span>, Version <span class="label label-info">{{vm.plan.internalVersion}}</span></h3></div><div class="modal-body"><div class="text-center" ng-show="vm.belongsToASOOP() && vm.cut"><h6 class="label label-danger">WARNING: This Observation belongs to a SOOP, by editing, the SOOP may be broken.</h6><div><br></div></div><uib-tabset active="activeJustified" justified="true"><uib-tab index="0" heading="Observation details"><form name="editForm" role="form" class="form-horizontal" novalidate show-validation><div ng-if="vm.ids.length>0 && vm.cut" class="form-group"><label class="col-sm-2 control-label">SOC OBS_IDs</label><label class="col-sm-10 control-label" style="text-align: left"><div ng-repeat="id in vm.ids">{{id}}</div></label></div><div class="form-group"><label class="col-sm-2 control-label">Instrument</label><div class="col-sm-10"><select class="form-control" ng-disabled="!vm.isEditable || vm.isObsUpdate" name="selectExperiment" id="selectExperiment" ng-model="vm.selectedExperiment" ng-options="o as o for o in vm.availableExperiments" ng-change="vm.update()"></select></div></div><div class="form-group"><label class="col-sm-2 control-label">Start / End</label><div class="col-sm-10"><div class="input-group"><input class="form-control" ng-disabled="!vm.isEditable" name="startDate" id="startDate" ng-style="vm.startDateStyle" maxlength="20" size="20" ng-change="vm.onStartDateUpdate()" type="text" ng-model="vm.startDate"> <span class="input-group-addon">/</span> <input id="endDate" name="endDate" ng-style="vm.endDateStyle" ng-change="vm.onEndDateUpdate()" maxlength="20" size="20" ng-disabled="vm.isDurationDisabled()" type="text" class="form-control" ng-model="vm.endDate"></div><span class="label label-danger" ng-show="vm.invalidateStartDate">Invalid start date </span><span ng-show="vm.startOutOfRangeDate()" class="label label-danger">The start date is out of the validity range: {{vm.plan.validityStartTime}} -> {{vm.plan.validityEndTime}} </span><span class="label label-danger" ng-show="vm.invalidateEndDate">Invalid end Date </span><span ng-show="vm.invalidateDateRange()" class="label label-danger">The end date is earlier than the start date! </span><span ng-show="vm.endOutOfRangeDate()" class="label label-danger">The end date is out of the validity range: {{vm.getValidityRange()}}</span></div></div><div class="form-group"><div class="col-sm-10 col-sm-offset-2"><input type="radio" ng-model="vm.preserveRatio" value="dates" ng-click="vm.onPreserveRatioClick()" name="preserveDates" id="preserveDates">&nbsp;Preserve other date&nbsp;&nbsp;&nbsp;<input type="radio" ng-model="vm.preserveRatio" value="duration" ng-click="vm.onPreserveRatioClick()" name="preserveDates" id="preserveDatesUnchecked">&nbsp;Preserve duration</div></div><div class="form-group"><label class="col-sm-2 control-label">Module</label><div class="col-sm-10"><select class="form-control" id="selectModule" ng-disabled="!vm.isEditable" name="selectModule" ng-model="vm.selectedModule" ng-options="o as o for o in  vm.availableModules" ng-change="vm.updateModule()"></select></div></div><div class="form-group"><label class="col-sm-2 control-label">Observation</label><div class="col-sm-10"><select class="form-control" ng-disabled="!vm.isEditable" id="selectObservationId" name="selectObservationId" ng-model="vm.selectedObservationId" ng-options="o as o for o in vm.availableObservations" ng-change="vm.updateSelectedObservation()"></select></div></div><div ng-show="vm.numberParameters && vm.numberParameters.length > 0"><div class="form-group"><label class="col-sm-2 control-label">Number Parameters</label><div class="col-sm-10"><table class="table table-bordered table-striped"><tr ng-repeat="numberParameter in vm.numberParameters track by $index"><td width="30%">{{numberParameter}}<div id="range_{{numberParameter}}" ng-show="vm.parameterNumberMin[numberParameter] > -1e+308">(Range: {{vm.parameterNumberMin[numberParameter]}} to {{vm.parameterNumberMax[numberParameter]}})</div></td><td><div class="input-group"><input id="value_{{numberParameter}}" name="numberParameter_{{$index}}" class="form-control" ng-disabled="!vm.isEditable" ng-change="vm.resetEvaluation()" type="number" min="{{vm.parameterNumberMin[numberParameter]}}" max="{{vm.parameterNumberMax[numberParameter]}}" ng-model="vm.numberParameterValue[numberParameter]" required ng-trim="false"><div class="input-group-addon">{{vm.parameterNumberUnit[numberParameter]}}</div></div><span id="errorRange" class="label label-danger" ng-show="editForm[\'numberParameter_\' + $index].$error.min || editForm[\'numberParameter_\' + $index].$error.max">The value must be in range {{vm.parameterNumberMin[numberParameter]}} to {{vm.parameterNumberMax[numberParameter]}}! </span><span id="errorValidNumber" class="label label-danger" ng-show="editForm[\'numberParameter_\' + $index].$error.number">Not valid number!</span> <span id="errorRequired" class="label label-danger" ng-show="editForm[\'numberParameter_\' + $index].$error.required">Required value!</span></td></tr></table></div></div></div><div ng-show="vm.listParameters && vm.listParameters.length > 0"><div class="form-group"><label class="col-sm-2 control-label">List Parameters</label><div class="col-sm-10"><table class="table table-bordered table-striped"><tr ng-repeat="listParameter in vm.listParameters track by $index"><td width="30%">{{listParameter}}</td><td><select class="form-control" ng-disabled="!vm.isEditable" ng-change="vm.resetEvaluation()" id="value_{{listParameter}}" ng-model="vm.listParameterValue[listParameter]" name="listParameter" ng-options="p as p for p in vm.listParameterAvailableValues[listParameter]" required></select><span id="errorRequired_list" class="label label-danger" ng-show="editForm.listParameter.$error.required">Required value!</span></td></tr></table></div></div></div><div ng-show="vm.selectedObservationId"><div class="form-group"><label class="col-sm-2 control-label">Other Parameters</label><div class="col-sm-10"><table class="table table-bordered table-striped"><tr><td width="30%">Duration<div id="range_duration" ng-show="vm.obsDef.duration.min > -1e+308">(Range: {{vm.obsDef.duration.min}} to {{vm.obsDef.duration.max}})</div></td><td><input name="durationLetters" title="(You can specify a time unit after a time value \'X\', such as Xd, Xh, Xm, Xs, to represent days (d), hours (h) minutes (m) and seconds (s), respectively)" id="durationLetters" ng-change="vm.updateLetters()" ng-disabled="vm.isDurationDisabled()" ng-model="vm.durationLetters" required ng-trim="false" ng-style="vm.durationLettersStyle"> <span id="durationLettersError" class="label label-danger" ng-show="vm.durationLettersInvalid()">Wrong format </span>= <input id="duration" name="duration" ng-change="vm.updateCalendar()" type="number" ng-disabled="vm.isDurationDisabled()" ng-model="vm.duration" required ng-trim="false" ng-style="vm.durationStyle"> s <span id="errorValidDuration" class="label label-danger" ng-show="editForm.duration.$error.number">Not valid number!</span> <span id="errorRangeDuration" class="label label-danger" ng-show="vm.duration>vm.obsDef.duration.max || vm.duration<vm.obsDef.duration.min">Duration out of Range!! ({{vm.obsDef.duration.min}} to {{vm.obsDef.duration.max}})</span></td></tr><tr><td>Flush</td><td>{{vm.selectedObservation.flush}} {{vm.obsDef.flush.unit}}<span id="flush" ng-show="vm.obsDef.flush.flushType!=null"> ({{vm.obsDef.flush.flushType}})</span></td></tr><tr><td>Power</td><td>{{vm.selectedObservation.power}} {{vm.obsDef.power.unit}}</td></tr><tr><td>Comment:</td><td><textarea id="comment" ng-change="vm.resetEvaluation()" name="comment" type="text" ng-model="vm.comment" rows="10" cols="50" ng-disabled="!vm.isEditable"></textarea></td></tr></table></div></div></div><div ng-show="vm.selectedObservation.flows"><div class="form-group"><label class="col-sm-2 control-label">Flows | Volume</label><div class="col-sm-10"><table class="table table-bordered table-striped"><tr ng-repeat="(flowName, flowValue) in vm.selectedObservation.flows track by $index"><td id="flow_name_{{$index}}" width="30%">{{flowName}} ({{vm.obsDef.flows[flowName].flowType}})</td><td id="flow_value_{{$index}}">{{vm.roundDecimals(flowValue,2)}} {{flow.unit}} | {{vm.roundDecimals(vm.selectedObservation.volumes[flowName], 3)}} Mibytes</td></tr></table></div></div></div><div ng-show="vm.volumes().length>0"><div class="form-group"><label class="col-sm-2 control-label">Volume</label><div class="col-sm-10"><table class="table table-bordered table-striped"><tr ng-repeat="volume  in vm.volumes() track by $index"><td width="30%">{{volume}}</td><td>{{vm.roundDecimals(vm.selectedObservation.volumes[volume], 3)}} MiBytes</td></tr></table></div></div></div><div ng-show="vm.selectedObservationId && vm.isEditable && !vm.isObsUpdate"><div class="form-group"><div class="col-sm-offset-2 col-sm-10"><div class="checkbox"><label><input type="checkbox" ng-model="vm.repeat" name="repeat" id="repeat"> Repeat</label></div></div></div></div><div ng-show="vm.repeat && !vm.isObsUpdate"><div class="form-group"><div class="col-sm-offset-2 col-sm-10"><table class="table table-bordered table-striped"><tr><td width="30%">Frequency:</td><td><input name="durationLettersFrequency" title="(You can specify a time unit after a time value \'X\', such as Xd, Xh, Xm, Xs, to represent days (d), hours (h) minutes (m) and seconds (s), respectively)" id="durationLettersFrequency" ng-change="vm.updateLettersFrequency()" ng-model="vm.durationLettersFrequency" required ng-trim="false"> = <input id="frequency" name="frequency" ng-change="vm.updateFrequency()" type="number" ng-model="vm.frequency" required ng-trim="false"> s <span id="durationLettersErrorFrequency" class="label label-danger" ng-show="vm.durationLettersInvalidFrequency()">Wrong format </span><span id="errorValidFrequency" class="label label-danger" ng-show="editForm.frequency.$error.number">Not valid number!</span> <span id="errorRepeatWrong" class="label label-danger" ng-show="vm.repeatWrong()">The frequency must be greater than the duration.</span></td></tr><tr><td>Number of Occurrences:</td><td><input id="numberOccurences" name="numberOccurences" type="number" ng-model="vm.numberOccurences" ng-change="vm.updateLettersFrequency()" required ng-trim="false"></td></tr><tr><td>Last Observation end time:</td><td>{{vm.lastEndTime}} <span id="repeatOutOfRangeDate" class="label label-danger" ng-show="vm.repeatOutOfRangeDate()">The last repetition is after the validity date.</span></td></tr></table></div></div></div></form><wait ng-show="vm.waiting"></wait><div class="modal-footer"><button ng-if="vm.isMaster" has-any-authority="ROLE_PLAN_COORDINATOR,ROLE_POWER_USER" is-in-users-authorities="ROLE_INSTRUMENT_COORDINATOR" is-in-users="{{vm.plan.planUserInfo.usersWithRights}}" has-instrument="{{vm.selectedExperiment}}" ng-disabled="vm.deleteDisabled() || vm.waiting" id="delete" type="button" class="btn btn-danger" ng-click="vm.deleteObservation()"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button> <button ng-if="vm.isChild" has-any-authority="ROLE_PLAN_COORDINATOR,ROLE_POWER_USER" is-user="{{vm.plan.planUserInfo.owner}}" is-in-users-authorities="ROLE_INSTRUMENT_COORDINATOR,ROLE_INSTRUMENT_TEAM_MEMBER" is-in-users="{{vm.plan.planUserInfo.usersWithRights}}" ng-disabled="vm.deleteDisabled() || vm.waiting" id="delete" type="button" class="btn btn-danger" ng-click="vm.deleteObservation()"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button> <button ng-if="vm.isTemplate" has-any-authority="ROLE_PLAN_COORDINATOR,ROLE_POWER_USER" is-user="{{vm.plan.planUserInfo.owner}}" is-in-users-authorities="ROLE_INSTRUMENT_COORDINATOR,ROLE_INSTRUMENT_TEAM_MEMBER" is-in-users="{{vm.plan.planUserInfo.usersWithRights}}" ng-disabled="vm.deleteDisabled() || vm.waiting" id="delete" type="button" class="btn btn-danger" ng-click="vm.deleteObservation()"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button> <button ng-if="vm.isSoop" has-any-authority="ROLE_PLAN_COORDINATOR,ROLE_POWER_USER" is-in-users-authorities="ROLE_INSTRUMENT_COORDINATOR,ROLE_INSTRUMENT_TEAM_MEMBER" is-in-users="{{vm.plan.planUserInfo.usersWithRights}}" ng-disabled="vm.deleteDisabled() || vm.waiting" id="delete" type="button" class="btn btn-danger" ng-click="vm.deleteObservation()"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button> <button id="cancelButton" type="button" class="btn btn-info" data-dismiss="modal" ng-click="vm.clear()" ng-disabled="vm.waiting"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button id="resetButton" type="button" class="btn btn-primary" ng-click="vm.reset()" ng-disabled="vm.resetDisabled() || vm.waiting"><span class="glyphicon glyphicon-repeat"></span>&nbsp; <span>Reset</span></button> <button id="evaluateButton" type="button" class="btn btn-primary" ng-click="vm.evaluate()" ng-disabled="vm.evaluateDisabled() || vm.waiting"><span class="glyphicon glyphicon-scale"></span>&nbsp; <span>Evaluate</span></button> <button ng-if="vm.isMaster" id="saveButton" has-any-authority="ROLE_PLAN_COORDINATOR,ROLE_POWER_USER" is-in-users-authorities="ROLE_INSTRUMENT_COORDINATOR" is-in-users="{{vm.plan.planUserInfo.usersWithRights}}" has-instrument="{{vm.selectedExperiment}}" type="button" class="btn btn-success" ng-click="vm.save()" ng-disabled="vm.saveDisabled() || vm.waiting"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button> <button ng-if="vm.isChild" id="saveButton" has-any-authority="ROLE_PLAN_COORDINATOR,ROLE_POWER_USER" is-user="{{vm.plan.planUserInfo.owner}}" is-in-users-authorities="ROLE_INSTRUMENT_COORDINATOR,ROLE_INSTRUMENT_TEAM_MEMBER" is-in-users="{{vm.plan.planUserInfo.usersWithRights}}" type="button" class="btn btn-success" ng-click="vm.save()" ng-disabled="vm.saveDisabled() || vm.waiting"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button> <button ng-if="vm.isTemplate" id="saveButton" has-any-authority="ROLE_PLAN_COORDINATOR,ROLE_POWER_USER" is-user="{{vm.plan.planUserInfo.owner}}" is-in-users-authorities="ROLE_INSTRUMENT_COORDINATOR,ROLE_INSTRUMENT_TEAM_MEMBER" is-in-users="{{vm.plan.planUserInfo.usersWithRights}}" type="button" class="btn btn-success" ng-click="vm.save()" ng-disabled="vm.saveDisabled() || vm.waiting"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button> <button ng-if="vm.isSoop" id="saveButton" has-any-authority="ROLE_PLAN_COORDINATOR,ROLE_POWER_USER" is-in-users-authorities="ROLE_INSTRUMENT_COORDINATOR,ROLE_INSTRUMENT_TEAM_MEMBER" is-in-users="{{vm.plan.planUserInfo.usersWithRights}}" type="button" class="btn btn-success" ng-click="vm.save()" ng-disabled="vm.saveDisabled() || vm.waiting"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></uib-tab><uib-tab index="1" heading="SOOP details" disable="vm.soopsItBelongs.length == 0 || !vm.cut"><form name="soopForm" role="form" class="form-horizontal" novalidate show-validation><div ng-if="vm.ids.length>0" class="form-group"><label class="col-sm-2 control-label">SOC OBS_IDs</label><label class="col-sm-10 control-label" style="text-align: left"><div ng-repeat="id in vm.ids">{{id}}</div></label></div><div has-authority="ROLE_PLAN_COORDINATOR" is-user="{{vm.plan.planUserInfo.owner}}" is-in-users-authorities="ROLE_INSTRUMENT_COORDINATOR" is-in-users="{{vm.plan.planUserInfo.usersWithRights}}" class="form-group" ng-show="vm.soopsItBelongs.length > 0"><label class="col-sm-2 control-label">SOOPs</label><div class="col-sm-10"><table class="table table-bordered table-striped"><tr ng-repeat="soop in vm.soopsItBelongs"><td width="30%"><input type="checkbox" ng-disabled="!vm.isEditable" name="soop{{$index + 1}}" value="vm.soop" ng-model="vm.soopBelonging[$index]"> SOOP {{soop.encodedSoopType}}/{{soop.soopInstanceId}}</td><td>{{vm.ids[$index]}}</td></tr></table></div></div><div class="modal-footer" has-authority="ROLE_PLAN_COORDINATOR" is-user="{{vm.plan.planUserInfo.owner}}" is-in-users-authorities="ROLE_INSTRUMENT_COORDINATOR" is-in-users="{{vm.plan.planUserInfo.usersWithRights}}"><button id="detachSOOPButton" has-any-authority="ROLE_PLAN_COORDINATOR,ROLE_POWER_USER" is-in-users-authorities="ROLE_INSTRUMENT_COORDINATOR,ROLE_INSTRUMENT_TEAM_MEMBER" is-in-users="{{vm.plan.planUserInfo.usersWithRights}}" type="button" class="btn btn-success" ng-click="vm.detachSOOP()" ng-disabled="vm.soopsSelectedSOOPToRemove()==false"><span class="glyphicon glyphicon-pushpin"></span>&nbsp;<span>Detach</span></button> <button id="autonomizeSOOPButton" has-any-authority="ROLE_PLAN_COORDINATOR,ROLE_POWER_USER" is-in-users-authorities="ROLE_INSTRUMENT_COORDINATOR,ROLE_INSTRUMENT_TEAM_MEMBER" is-in-users="{{vm.plan.planUserInfo.usersWithRights}}" type="button" class="btn btn-success" ng-click="vm.autonomize()" ng-show="!vm.isIndependent()"><span class="glyphicon glyphicon-remove"></span>&nbsp;<span>Mark as independent</span></button> <button id="deautonomizeSOOPButton" has-any-authority="ROLE_PLAN_COORDINATOR,ROLE_POWER_USER" is-in-users-authorities="ROLE_INSTRUMENT_COORDINATOR,ROLE_INSTRUMENT_TEAM_MEMBER" is-in-users="{{vm.plan.planUserInfo.usersWithRights}}" type="button" class="btn btn-success" ng-click="vm.deautonomize()" ng-show="vm.isIndependent()"><span class="glyphicon glyphicon-remove"></span>&nbsp;<span>Remove independence</span></button> <button id="cancelButton" type="button" class="btn btn-info" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button></div></form></uib-tab></uib-tabset><jhi-alert-error></jhi-alert-error><jhi-alert></jhi-alert></div>');
$templateCache.put('app/entities/planning/planning-event-dialog.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h3 class="modal-title">{{vm.dialogTitle}} an Event in Plan <span class="label label-info">{{vm.plan.label}}</span>, Version <span class="label label-info">{{vm.plan.internalVersion}}</span></h3></div><div class="modal-body"><form name="editForm" role="form" class="form-horizontal" novalidate show-validation><div class="form-group"><label class="col-sm-2 control-label">Event</label><div class="col-sm-10"><select ng-disabled="vm.disableCombobox" name="selectEvent" id="selectEvent" class="form-control" ng-model="vm.selectedEventName" ng-options="o as o for o in vm.events" ng-change="vm.update()"></select></div><label class="col-sm-2 control-label">Start / End</label><div class="col-sm-10"><div class="input-group"><input ng-disabled="vm.isStartDateDisabled()" name="startDate" id="startDate" maxlength="20" size="20" ng-change="vm.onStartDateUpdate()" ng-style="vm.startDateStyle" type="text" class="form-control" ng-model="vm.startDate"> <span class="input-group-addon">/</span> <input id="endDate" name="endDate" ng-change="vm.onEndDateUpdate()" maxlength="20" size="20" ng-disabled="vm.isEndDateDisabled()" type="text" class="form-control" ng-model="vm.endDate" ng-style="vm.endDateStyle"></div><span class="label label-danger" ng-show="vm.invalidateStartDate">Invalid Start Date </span><span ng-show="vm.startOutOfRangeDate()" class="label label-danger">The start date is out of the validity range: {{vm.plan.validityStartTime}} -> {{vm.plan.validityEndTime}} </span><span class="label label-danger" ng-show="vm.invalidateEndDate">Invalid End Date </span><span ng-show="vm.invalidateDateRange()" class="label label-danger">The end date is earlier than the start date! </span><span ng-show="vm.endOutOfRangeDate()" class="label label-danger">The end date is out of the validity range: {{vm.plan.validityStartTime}} -> {{vm.plan.validityEndTime}}</span></div></div><div ng-show="vm.selectedEventName && vm.isEditable  && !vm.socEvents.includes(vm.selectedEventName)"><div class="form-group"><div class="col-sm-10 col-sm-offset-2" ng-show="vm.containsDuration"><input type="radio" ng-model="vm.preserveRatio" value="dates" ng-click="vm.onPreserveRatioClick()" id="preserveDates">&nbsp;Preserve other date&nbsp;&nbsp;&nbsp; <input type="radio" ng-model="vm.preserveRatio" value="duration" ng-click="vm.onPreserveRatioClick()" id="preserveDatesUnchecked">&nbsp;Preserve duration</div><div class="col-sm-10 col-sm-offset-2" ng-show="!vm.containsDuration"><input type="radio" ng-model="vm.preserveRatio" value="duration" id="preserveDatesChecked">&nbsp;Preserve duration</div></div></div><div ng-show="vm.selectedEventName && vm.isEditable"><div class="form-group"><label class="col-sm-2 control-label">Attributes</label><div class="col-sm-10"><table class="table table-bordered table-striped"><tr ng-repeat="attribute  in vm.selectedEvent.attributes track by $index" ng-show="attribute.name!=\'time\' && attribute.attributeClassName != \'durationType\'"><td width="30%">{{attribute.name}}</td><td><ng-form name="innerEnumForm"><span ng-show="vm.attributeClassMap[attribute.attributeClassName].type==\'ENUM\'"><select ng-disabled="vm.disableInputs || vm.selectedEvent.canModify==false || vm.selectedEvent.canCreate==false" name="attribute.name" id="selectEnum{{attribute.name}}" ng-change="vm.updateAtributeEnum(attribute.name)" ng-model="vm.selectedEnum[attribute.name]" ng-required="attribute.required" ng-options="a as a for a in vm.attributeClassMap[attribute.attributeClassName].values"><option></option></select><span ng-show="innerEnumForm.$error.required" id="errorRequiredEnum" class="label label-danger">Required value!</span></span></ng-form><ng-form name="innerStringForm"><span ng-show="vm.attributeClassMap[attribute.attributeClassName].type==\'STRING\'"><input ng-required="attribute.required" ng-disabled="vm.disableInputs || vm.selectedEvent.canModify==false" id="{{attribute.name}}" name="stringParameter" ng-model="vm.selectedAtt[attribute.name]" ng-trim="false"></span></ng-form><ng-form name="innerForm" ng-show="attribute.attributeClassName != \'durationType\' && (vm.attributeClassMap[attribute.attributeClassName].type==\'INTEGER\' || vm.attributeClassMap[attribute.attributeClassName].type==\'FLOAT\')"><input ng-disabled="vm.disableInputs || vm.isEditable==false || vm.selectedEvent.canModify==false" id="value_{{attribute.name}}" name="attributeName" min="{{vm.attributeClassMap[attribute.attributeClassName].lowLimit}}" max="{{vm.attributeClassMap[attribute.attributeClassName].highLimit}}" ng-model="vm.selectedNumber[attribute.name]" ng-change="vm.updateAtributeNumber(attribute.name)" type="number" ng-required="attribute.required" ng-trim="false" ng-trim="false"> <span id="errorRange" class="label label-danger" ng-show="innerForm.attributeName.$error.min || innerForm.attributeName.$error.max">The value must be in range {{vm.attributeClassMap[attribute.attributeClassName].lowLimit}} to {{vm.attributeClassMap[attribute.attributeClassName].highLimit}}!</span> <span id="errorValidNumber" class="label label-danger" ng-show="innerForm.attributeName.$error.number">Not valid number!</span> <span id="errorRequired" class="label label-danger" ng-show="innerForm.attributeName.$error.required">Required value!</span></ng-form></td></tr><tr ng-show="vm.containsDuration"><td>Duration</td><td><input ng-disabled="vm.isDurationDisabled()" name="durationLetters" title="(You can specify a time unit after a time value \'X\', such as Xd, Xh, Xm, Xs, to represent days (d), hours (h) minutes (m) and seconds (s), respectively)" id="durationLetters" ng-change="vm.updateLetters()" ng-model="vm.durationLetters" ng-style="vm.durationLettersStyle" required ng-trim="false"> <span id="durationLettersError" class="label label-danger" ng-show="vm.durationLettersInvalid()">Wrong format </span>= <input ng-disabled="vm.isDurationDisabled()" id="duration" name="durationEvent" ng-change="vm.updateCalendar()" type="number" ng-model="vm.duration" required ng-style="vm.durationStyle" ng-trim="false"> s <span id="errorValidDuration" class="label label-danger" ng-show="editForm.durationEvent.$error.number">Not valid number!</span> <span id="errorRequiredDuration" class="label label-danger" ng-show="editForm.durationEvent.$error.required">Required value!</span></td></tr></table></div></div></div><div ng-show="vm.selectedEventName && vm.isEditable"><div class="form-group"><div class="col-sm-offset-2 col-sm-10"><div class="checkbox"><label><input type="checkbox" ng-model="vm.repeat" name="repeat" id="repeat"> Repeat</label></div></div></div></div><div ng-show="vm.repeat"><div class="form-group"><div class="col-sm-offset-2 col-sm-10"><table class="table table-bordered table-striped"><tr><td width="30%">Frequency:</td><td><input name="durationLettersFrequency" title="(You can specify a time unit after a time value \'X\', such as Xd, Xh, Xm, Xs, to represent days (d), hours (h) minutes (m) and seconds (s), respectively)" id="durationLettersFrequency" ng-change="vm.updateFrequency()" ng-model="vm.durationLettersFrequency" required ng-trim="false"> <span id="durationLettersErrorFrequency" class="label label-danger" ng-show="vm.durationLettersInvalidFrequency()">Wrong format </span>= <input id="frequency" name="frequency" ng-change="vm.updateLettersFrequency()" type="number" ng-model="vm.frequency" required ng-trim="false"> s <span id="errorValidFrequency" class="label label-danger" ng-show="editForm.frequency.$error.number">Not valid number!</span> <span id="errorRepeatWrong" class="label label-danger" ng-show="vm.repeatWrong()">The frequency must be greater than the duration.</span></td></tr><tr><td>Number of Occurrences:</td><td><input id="numberOccurences" name="numberOccurences" type="number" ng-model="vm.numberOccurences" ng-change="vm.updateLettersFrequency()" required ng-trim="false"></td></tr><tr><td>Last Event end time:</td><td>{{vm.lastEndTime}} <span id="repeatOutOfRangeDate" class="label label-danger" ng-show="vm.repeatOutOfRangeDate()">The last repetition is after the validity date.</span></td></tr></table></div></div></div></form><div ng-show="vm.showWarningForSOCEvents"><div class="alert alert-info"><span class="glyphicon glyphicon-info-sign"></span>&nbsp;Warning: {{vm.selectedEventName}} is a SOC event and the expanded events will be also deleted</div></div><div ng-show="vm.showWarningForSOCEventSets"><div class="alert alert-info"><span class="glyphicon glyphicon-info-sign"></span>&nbsp;Warning: {{vm.eventSetMap[vm.selectedEventName] }} events will be generated</div></div><div class="modal-footer"><button ng-disabled="vm.deleteDisabled()" id="delete" type="button" class="btn btn-danger" ng-click="vm.deleteEvent()"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button> <button id="cancelButton" type="button" class="btn btn-info" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button ng-show="parameters.occurrence != null" id="resetButton" type="button" class="btn btn-primary" ng-click="vm.reset()"><span class="glyphicon glyphicon-repeat"></span>&nbsp;<span>Reset</span></button> <button ng-disabled="vm.parametersWrong() || vm.selectedEvent.canModify==false ||  vm.deleteDisabled() || vm.disableSave" id="saveButton" has-any-authority="ROLE_PLAN_COORDINATOR,ROLE_POWER_USER" type="button" class="btn btn-success" ng-click="vm.save()"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div><jhi-alert-error></jhi-alert-error><jhi-alert></jhi-alert></div>');
$templateCache.put('app/entities/planning/planning-floating-timelines.html','<div class="create-entity" ng-show="vm.showCreateMenu[2] && vm.activeTab == 2"><br><form name="myTemplatePlanForm" class="form-horizontal"><div class="form-group"><label for="selectTemplateObservationDefinitions" class="col-sm-2 control-label">Observation Definitions</label><div class="col-sm-10"><select id="selectTemplateObservationDefinitions" name="selectTemplateObservationDefinitions" required ng-model="vm.selectedTemplateObservationDefinitions" class="form-control"><option ng-repeat="label in vm.templateObservationDefinitions" value="{{label}}">{{label}}</option></select><div ng-show="myTemplatePlanForm.selectTemplateObservationDefinitions.$invalid"><p class="help-block" ng-show="myTemplatePlanForm.selectTemplateObservationDefinitions.$error.required">This field is required.</p></div></div></div><div class="form-group"><label for="TemplateDuration" class="col-sm-2 control-label">Duration</label><div class="col-sm-10"><input id="TemplateDuration" type="text" name="TemplateDuration" ng-model="vm.templateDurationString" class="form-control" required ng-pattern="/^(\\d+d)+(\\d+h)?(\\d+m)?(\\d+s)?$/" placeholder="You can specify a time unit after a time value \'X\', such as Xd, Xh, Xm, Xs, to represent days (d), hours (h) minutes (m) and seconds (s), respectively. Minimum value is 1d"><div ng-show="myTemplatePlanForm.TemplateDuration.$invalid"><p class="help-block" style="color:#f0ad4e" ng-show="myTemplatePlanForm.TemplateDuration.$invalid && (myTemplatePlanForm.TemplateDuration.$viewValue.length > 0)">Incorrect format.</p><p class="help-block" ng-show="myTemplatePlanForm.TemplateDuration.$error.required">This field is required.</p></div></div></div><div class="form-group"><label for="TemplatePlanLabel" class="col-sm-2 control-label">Label</label><div class="col-sm-10"><input id="TemplatePlanLabel" type="text" name="TemplatePlanLabel" maxlength="40" ng-model="vm.templatePlanLabel" class="form-control" required ng-pattern="/^[0-9a-zA-Z\\.\\:\\<\\>\\ \\_\\@\\!\\(\\)\\{\\}\\,\\-\\[\\]]+$/"><div ng-show="myTemplatePlanForm.TemplatePlanLabel.$invalid && (myTemplatePlanForm.TemplatePlanLabel.$viewValue.length > 0)"><p class="help-block">Character not allowed</p></div><div ng-show="myTemplatePlanForm.TemplatePlanLabel.$error.required"><p class="help-block">This field is required.</p></div></div></div><div class="form-group"><div class="col-sm-2"></div><div class="col-sm-10"><button id="createTemplatePlanButton" class="btn btn-success pull-right" ng-disabled="!myTemplatePlanForm.$valid" ng-click="vm.createTemplatePlan()"><span class="glyphicon glyphicon-save"></span>&nbsp;&nbsp;<span>Create</span></button></div></div></form></div><br><h4>Floating timelines available for scheduling</h4><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicateTemplateBaselined" ascending="vm.reverseTemplateBaselined" callback="vm.sortTemplatePlanTableBaselined(vm.templatePlansBaselined, vm.predicateTemplateBaselined, vm.reverseTemplateBaselined)"><th jh-sort-by="label"><span>Label</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="internalVersion"><span>Baseline Version</span><span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="created"><span>Creation Date</span><span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="timestamp"><span>Modification Date</span><span class="glyphicon glyphicon-sort"></span></th><th><span>Delta</span></th><th jh-sort-by="observationDefinitionsLabel"><span>Observation Definitions</span><span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="owner"><span>Owner</span><span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="planMeta in vm.templatePlansBaselined track by $index"><td>{{planMeta.label}}</td><td>{{planMeta.baselineVersion}}</td><td>{{vm.formatIsoZuluDateString(planMeta.created)}}</td><td>{{vm.formatIsoZuluDateString(planMeta.deltas[0].timestamp)}}</td><td><span valign="bottom" class="glyphicon glyphicon-plus" ng-show="!vm.showDelta[planMeta.label]" id="buttonTemplateDelta_plus" ng-click="vm.showDelta[planMeta.label] = true"></span> <span valign="bottom" class="glyphicon glyphicon-minus" ng-show="vm.showDelta[planMeta.label]" id="buttonTemplateDelta_minus" ng-click="vm.showDelta[planMeta.label] = false"><div ng-repeat="delta in planMeta.deltas">{{delta.prettyString}}</div></span></td><td>{{planMeta.observationDefinitionsLabel}}</td><td>{{planMeta.planUserInfo.owner}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><span ng-show="planMeta.locked" style="margin:4px"><img alt="lock" height="22" width="22" src="content/images/lock.png"> </span><button id="buttonTemplateDetail_{{$index}}" type="submit" ui-sref="planning-detail({id:planMeta.label, baselineVersion:planMeta.baselineVersion, planType: vm.getPlanType(planMeta.planType)})" class="btn btn-primary btn-sm" data-toggle="tooltip" data-placement="bottom" title="View" delay="1000"><span class="glyphicon glyphicon-eye-open"></span></button> <button id="buttonTemplateVersions_{{$index}}" type="submit" ui-sref="planning.versions({id:planMeta.label, planType: vm.getPlanType(planMeta.planType)})" class="btn btn-primary btn-sm" data-toggle="tooltip" data-placement="bottom" title="Versions" delay="1000"><span class="glyphicon glyphicon-list"></span></button> <button id="buttonTemplateRename_{{$index}}" ng-disabled="planMeta.locked" has-authority="ROLE_PLAN_COORDINATOR" is-user-tables="{{planMeta.planUserInfo.owner}}" type="submit" ng-click="vm.renamePlan(planMeta.label, vm.getPlanType(planMeta.planType))" class="btn btn-primary btn-sm" data-toggle="tooltip" data-placement="bottom" title="Rename" delay="1000"><span class="glyphicon glyphicon-pencil"></span></button> <button id="buttonTemplateDelete_{{$index}}" ng-disabled="planMeta.locked" has-authority="ROLE_PLAN_COORDINATOR" is-user-tables="{{planMeta.planUserInfo.owner}}" type="submit" ng-click="vm.deletePlan(planMeta.label, vm.getPlanType(planMeta.planType))" class="btn btn-danger btn-sm" data-toggle="tooltip" data-placement="bottom" title="Delete" delay="1000"><span class="glyphicon glyphicon-remove-circle"></span></button></div></td></tr></tbody></table></div><h4>Floating timelines in progress (not baselined)</h4><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicateTemplateInProgress" ascending="vm.reverseTemplateInProgress" callback="vm.sortTemplatePlanTableInProgress(vm.templatePlansInProgress, vm.predicateTemplateInProgress, vm.reverseTemplateInProgress)"><th jh-sort-by="label"><span>Label</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="internalVersion"><span>Baseline Version</span><span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="created"><span>Creation Date</span><span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="timestamp"><span>Modification Date</span><span class="glyphicon glyphicon-sort"></span></th><th><span>Delta</span></th><th jh-sort-by="observationDefinitionsLabel"><span>Observation Definitions</span><span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="owner"><span>Owner</span><span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="planMeta in vm.templatePlansInProgress track by $index" ng-if="planMeta.baselineVersion <= 0"><td>{{planMeta.label}}</td><td>{{planMeta.baselineVersion}}</td><td>{{vm.formatIsoZuluDateString(planMeta.created)}}</td><td>{{vm.formatIsoZuluDateString(planMeta.deltas[0].timestamp)}}</td><td><span valign="bottom" class="glyphicon glyphicon-plus" ng-show="!vm.showDelta[planMeta.label]" id="buttonTemplateDelta_plus" ng-click="vm.showDelta[planMeta.label] = true"></span> <span valign="bottom" class="glyphicon glyphicon-minus" ng-show="vm.showDelta[planMeta.label]" id="buttonTemplateDelta_minus" ng-click="vm.showDelta[planMeta.label] = false"><div ng-repeat="delta in planMeta.deltas">{{delta.prettyString}}</div></span></td><td>{{planMeta.observationDefinitionsLabel}}</td><td>{{planMeta.planUserInfo.owner}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><span ng-show="planMeta.locked" style="margin:4px"><img alt="lock" height="22" width="22" src="content/images/lock.png"> </span><button id="buttonTemplateDetail_{{$index}}" type="submit" ui-sref="planning-detail({id:planMeta.label, baselineVersion:planMeta.baselineVersion, planType: vm.getPlanType(planMeta.planType)})" class="btn btn-primary btn-sm" data-toggle="tooltip" data-placement="bottom" title="View" delay="1000"><span class="glyphicon glyphicon-eye-open"></span></button> <button id="buttonTemplateVersions_{{$index}}" type="submit" ui-sref="planning.versions({id:planMeta.label, planType: vm.getPlanType(planMeta.planType)})" class="btn btn-primary btn-sm" data-toggle="tooltip" data-placement="bottom" title="Versions" delay="1000"><span class="glyphicon glyphicon-list"></span></button> <button id="buttonTemplateRename_{{$index}}" ng-disabled="planMeta.locked" has-authority="ROLE_PLAN_COORDINATOR" is-user-tables="{{planMeta.planUserInfo.owner}}" type="submit" ng-click="vm.renamePlan(planMeta.label, vm.getPlanType(planMeta.planType))" class="btn btn-primary btn-sm" data-toggle="tooltip" data-placement="bottom" title="Rename" delay="1000"><span class="glyphicon glyphicon-pencil"></span></button> <button id="buttonTemplateDelete_{{$index}}" ng-disabled="planMeta.locked" has-authority="ROLE_PLAN_COORDINATOR" is-user-tables="{{planMeta.planUserInfo.owner}}" type="submit" ng-click="vm.deletePlan(planMeta.label, vm.getPlanType(planMeta.planType))" class="btn btn-danger btn-sm" data-toggle="tooltip" data-placement="bottom" title="Delete" delay="1000"><span class="glyphicon glyphicon-remove-circle"></span></button></div></td></tr></tbody></table></div>');
$templateCache.put('app/entities/planning/planning-operational-plans.html','<div class="create-entity" ng-show="vm.showCreateMenu[0] && vm.activeTab == 0"><br><form name="createPlanForm" class="form-horizontal"><div class="form-group"><label for="selectObservationDefinitions" class="col-sm-2 control-label">Observation Definitions</label><div class="col-sm-10"><select id="selectObservationDefinitions" name="selectObservationDefinitions" required ng-model="vm.selectedObservationDefinitions" class="form-control"><option ng-repeat="label in vm.observationDefinitions" value="{{label}}">{{label}}</option></select><div ng-show="createPlanForm.selectObservationDefinitions.$invalid"><p class="help-block" ng-show="createPlanForm.selectObservationDefinitions.$error.required">This field is required.</p></div></div></div><div class="form-group"><label for="selectEventCollections" class="col-sm-2 control-label">Event Collections</label><div class="col-sm-10"><select id="selectEventCollections" name="selectEventCollections" required ng-model="vm.selectedEventCollections" class="form-control"><option ng-repeat="label in vm.eventCollections" value="{{label}}">{{label}}</option></select><div ng-show="createPlanForm.selectEventCollections.$invalid"><p class="help-block" ng-show="createPlanForm.selectEventCollections.$error.required">This field is required.</p></div></div></div><div class="form-group"><label for="selectedPlanProfile" class="col-sm-2 control-label">Plan Profile</label><div class="col-sm-10"><select id="selectedPlanProfile" name="selectedPlanProfile" required ng-model="vm.selectedPlanProfile" class="form-control"><option ng-repeat="profile in vm.planProfiles" value="{{profile}}">{{profile}}</option></select><div ng-show="createPlanForm.selectedPlanProfile.$invalid"><p class="help-block" ng-show="createPlanForm.selectedPlanProfile.$error.required">This field is required.</p></div></div></div><div class="form-group"><label for="selectedEventSchema" class="col-sm-2 control-label">Event Schema</label><div class="col-sm-10"><select id="selectedEventSchema" name="selectedEventSchema" required ng-model="vm.selectedEventSchema" class="form-control"><option ng-repeat="schema in vm.eventSchemas" value="{{schema}}">{{schema}}</option></select><div ng-show="createPlanForm.selectedEventSchema.$invalid"><p class="help-block" ng-show="createPlanForm.selectedEventSchema.$error.required">This field is required.</p></div></div></div><div class="form-group"><label for="PlanLabel" class="col-sm-2 control-label">Label</label><div class="col-sm-10"><input id="PlanLabel" type="text" name="PlanLabel" ng-model="vm.planLabel" class="form-control" maxlength="40" required ng-pattern="/^[0-9a-zA-Z\\.\\:\\<\\>\\ \\_\\@\\!\\(\\)\\{\\}\\,\\-\\[\\]]+$/"><div ng-show="createPlanForm.PlanLabel.$invalid && (createPlanForm.PlanLabel.$viewValue.length > 0)"><p class="help-block">Character not allowed</p></div><div ng-show="createPlanForm.PlanLabel.$error.required"><p class="help-block">This field is required.</p></div></div></div><div class="form-group"><label for="PlanId" class="col-sm-2 control-label">ID</label><div class="col-sm-10"><input id="PlanId" type="text" name="PlanId" ng-model="vm.planId" class="form-control" required><div ng-show="createPlanForm.PlanId.$invalid"><p class="help-block" ng-show="createPlanForm.PlanId.$error.required">This field is required.</p></div></div></div><div class="form-group"><div class="col-sm-2"></div><div class="col-sm-10"><button id="createPlanButton" class="btn btn-success pull-right" ng-disabled="!createPlanForm.$valid" ng-click="vm.createPlan()"><span class="glyphicon glyphicon-save"></span>&nbsp;&nbsp;<span>Create</span></button></div></div></form></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.sortPlanTable(vm.plans, vm.predicate, vm.reverse)"><th jh-sort-by="label"><span>Label</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="planId"><span>ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="internalVersion"><span>Version</span><span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="created"><span>Creation Date</span><span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="timestamp"><span>Modification Date</span><span class="glyphicon glyphicon-sort"></span></th><th><span>Delta</span></th><th jh-sort-by="observationDefinitionsLabel"><span>Observation Definitions</span><span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="eventCollectionsLabel"><span>Event Collections</span><span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="status"><span>Status</span><span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="planMeta in vm.plans track by $index" style="{{vm.isCurrentPlanStyle(vm.planValidityRange[planMeta.eventCollectionsLabel], vm.planStatus[planMeta.label], planMeta.presentationProfile)}}"><td>{{planMeta.label}}</td><td>{{planMeta.planId}}</td><td>{{planMeta.internalVersion}}</td><td>{{vm.formatIsoZuluDateString(planMeta.created)}}</td><td>{{vm.formatIsoZuluDateString(planMeta.deltas[0].timestamp)}}</td><td><span valign="bottom" class="glyphicon glyphicon-plus" ng-show="!vm.showDelta[planMeta.label]" id="buttonDelta_plus" ng-click="vm.showDelta[planMeta.label] = true"></span> <span valign="bottom" class="glyphicon glyphicon-minus" ng-show="vm.showDelta[planMeta.label]" id="buttonDelta_minus" ng-click="vm.showDelta[planMeta.label] = false"><div ng-repeat="delta in planMeta.deltas">{{delta.prettyString}}</div></span></td><td>{{planMeta.observationDefinitionsLabel}}</td><td>{{planMeta.eventCollectionsLabel}}</td><td><select ng-show="vm.isPlanCoordinator" title="status" id="status_{{planMeta.label}}" ng-model="vm.planStatus[planMeta.label]" ng-change="vm.changeStatus(vm.getPlanType(planMeta.planType), planMeta.label)" ng-options="item for item in vm.allPlanStatus" ng-style="status_in_progress"></select><span ng-show="!vm.isPlanCoordinator" class="label {{vm.planStatusLabel[vm.planStatus[planMeta.label]]}} label-xs">{{vm.planStatus[planMeta.label]}}</span> <span class="glyphicon glyphicon-map-marker" ng-show="vm.isCurrentPlan(vm.planValidityRange[planMeta.eventCollectionsLabel], vm.planStatus[planMeta.label], planMeta.presentationProfile)"></span></td><td class="text-right"><div class="btn-group flex-btn-group-container"><span ng-show="planMeta.locked" style="margin:4px"><img alt="lock" height="22" width="22" src="content/images/lock.png"> </span><button popover-placement="left" uib-popover-html="vm.moreInfo[planMeta.label]" id="infoButton_{{$index}}" type="submit" class="btn btn-primary btn-sm" data-toggle="tooltip" data-placement="bottom" title="Info" delay="1000"><span class="glyphicon glyphicon-info-sign"></span></button> <button id="buttonDetail_{{$index}}" type="submit" ui-sref="planning-detail({id:planMeta.label, baselineVersion:planMeta.baselineVersion, planType: vm.getPlanType(planMeta.planType)})" class="btn btn-primary btn-sm" data-toggle="tooltip" data-placement="bottom" title="View" delay="1000"><span class="glyphicon glyphicon-eye-open"></span></button> <button id="buttonVersions_{{$index}}" type="submit" ui-sref="planning.versions({id:planMeta.label, planType: vm.getPlanType(planMeta.planType)})" class="btn btn-primary btn-sm" data-toggle="tooltip" data-placement="bottom" title="Versions" delay="1000"><span class="glyphicon glyphicon-list"></span></button> <button id="buttonRename_{{$index}}" ng-disabled="planMeta.locked" has-authority="ROLE_PLAN_COORDINATOR" type="submit" ng-click="vm.renamePlan(planMeta.label, vm.getPlanType(planMeta.planType))" class="btn btn-primary btn-sm" data-toggle="tooltip" data-placement="bottom" title="Rename" delay="1000"><span class="glyphicon glyphicon-pencil"></span></button> <button id="buttonDelete_{{$index}}" ng-disabled="planMeta.locked" has-authority="ROLE_PLAN_COORDINATOR" type="submit" ng-click="vm.deletePlan(planMeta.label, vm.getPlanType(planMeta.planType))" class="btn btn-danger btn-sm" data-toggle="tooltip" data-placement="bottom" title="Delete" delay="1000"><span class="glyphicon glyphicon-remove-circle"></span></button></div></td></tr></tbody></table></div>');
$templateCache.put('app/entities/planning/planning-profile.html','<div class="modal-content"><div class="modal-header" style="border-bottom: 0"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h1 class="modal-title">{{vm.group}} Profile for plan: <span class="label label-info">{{vm.planning.label}}</span></h1></div><div class="modal-body"><uib-tabset active="activeJustified"><uib-tab index="0" heading="Power" ng-if="vm.instrumentProfile"><h3>Maximum Instrument Power (Watts)</h3><table class="table table-striped"><tr><td>Value</td><td>Time</td></tr><tr><td>{{vm.roundDecimals(vm.powerMaxValue.value)}}</td><td>{{vm.powerMaxValue.time}}</td></tr></table><p class="input-group"></p><h3>Maximum Instrument Power per Module (Watts)</h3><div ng-repeat="power in vm.modulePowers" ng-show="vm.instrumentProfile.powerProfiles[power].maxValue.value != null"><h5>{{power}}</h5><table class="table table-striped"><tr><td>Value</td><td>Time</td></tr><tr><td>{{vm.roundDecimals(vm.instrumentProfile.powerProfiles[power].maxValue.value)}}</td><td>{{vm.instrumentProfile.powerProfiles[power].maxValue.time}}</td></tr></table></div></uib-tab><uib-tab index="vm.instrumentProfile ? 1 : 0" heading="Volume"><h3 ng-show="vm.containsVolumes == true">Final Instrument Volume (Mibytes)</h3><table class="table table-striped"><!-- Dates --><tr><td><label for="startDate">Start Date:</label><input type="datetime-local" id="startDate" ng-model="vm.startDate" ng-change="vm.calculateVolumes(vm.startDate, vm.endDate)"></td><td><label for="endDate">End Date:</label><input type="datetime-local" id="endDate" ng-model="vm.endDate" ng-change="vm.calculateVolumes(vm.startDate, vm.endDate)"></td></tr></table><div ng-repeat="volume in vm.currentInstrumentVolumes"><h5 style="font-weight: bold; color: blue">{{volume}}</h5><table class="table table-striped"><tr><td>Value</td><td>Time</td></tr><tr><td>{{vm.roundDecimals(vm.planning.planResourcesProfile.volumeProfiles[volume].maxValue.value)}}</td><td>{{vm.planning.planResourcesProfile.volumeProfiles[volume].maxValue.time}}</td></tr><tr><td>{{vm.roundDecimals(vm.volumeGroups[volume])}}</td><td>{{vm.startDate.toLocaleString()}} / {{vm.endDate.toLocaleString()}}</td></tr></table></div></uib-tab><!--        <uib-tab index="2" heading="Flow"> </uib-tab> </uib-tabset>--></uib-tabset></div></div>');
$templateCache.put('app/entities/planning/planning-restrict-period.html','<form name="restrictPeriodForm" role="form" novalidate show-validation><div class="modal-header"><label>Restrict the planning period between the dates: [{{vm.collectionsStart}} - {{vm.collectionsEnd}}]</label><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.cancel()">&times;</button></div><div class="modal-body"><div class="form-group row"><div class="col-md-4"><div class="input-group"><span class="input-group-addon">Start</span> <input type="text" id="startDate" name="startDate" ng-maxlength="10" ng-minlength="10" size="10" class="form-control" aria-describedby="basic-addon1" ng-model="vm.picker.date" ng-change="vm.updateEndDate()"></div><span class="label label-danger" ng-show="vm.isValidDate(vm.picker.date) == false">Invalid Date</span></div><div class="col-md-4"><div class="input-group"><span class="input-group-addon">Duration</span> <input type="text" name="durationLetters" id="durationLetters" class="form-control" aria-describedby="basic-addon1" title="(You can specify a time unit after a time value \'X\', such as Xd, Xh, Xm, Xs, to represent days (d), hours (h) minutes (m) and seconds (s), respectively)" ng-change="vm.updateLetters()" ng-model="vm.durationLetters" required ng-trim="false"></div><span class="label label-danger" id="durationLettersError" ng-show="vm.durationLettersInvalid()">Wrong Format!!</span></div><div class="col-md-4"><div class="input-group"><span class="input-group-addon">End</span> <input id="endDate" name="endDate" ng-maxlength="10" ng-minlength="10" size="10" type="text" class="form-control" aria-describedby="basic-addon1" ng-change="vm.updateDuration()" ng-model="vm.picker2.date"></div><span class="label label-danger" ng-show="vm.isValidDate(vm.picker2.date) == false">Invalid Date</span> <span ng-show="vm.invalidDateRange()" class="label label-danger">The end date is earlier than the start date!</span></div></div></div><div class="modal-footer"><jhi-alert-error></jhi-alert-error><jhi-alert></jhi-alert><button type="submit" id="applyButton" class="btn btn-primary" ng-click="vm.apply()"><span class="glyphicon glyphicon glyphicon-saved"></span><span>&nbsp;Apply</span></button> <button id="resetWidthButton" ng-click="vm.reset()" class="btn btn-primary"><span class="glyphicon glyphicon-fast-backward"></span>&nbsp;<span>Reset</span></button> <button id="cancelButton" type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.cancel()"><span class="glyphicon glyphicon-remove-circle"></span><span>&nbsp;Cancel</span></button></div></form>');
$templateCache.put('app/entities/planning/planning-soops.html','<div class="create-entity" ng-show="vm.showCreateMenu[3] && vm.activeTab == 3"><br><form name="mySoopPlanForm" class="form-horizontal"><div class="form-group"><label for="selectSoopObservationDefinitions" class="col-sm-2 control-label">Observation Definitions</label><div class="col-sm-10"><select id="selectSoopObservationDefinitions" name="selectSoopObservationDefinitions" required ng-model="vm.selectedSoopObservationDefinitions" class="form-control"><option ng-repeat="label in vm.soopObservationDefinitions" value="{{label}}">{{label}}</option></select><div ng-show="mySoopPlanForm.selectSoopObservationDefinitions.$invalid"><p class="help-block" ng-show="mySoopPlanForm.selectSoopObservationDefinitions.$error.required">This field is required.</p></div></div></div><div class="form-group"><label for="SoopDuration" class="col-sm-2 control-label">Duration</label><div class="col-sm-10"><input id="SoopDuration" type="text" name="SoopDuration" ng-model="vm.soopDurationString" class="form-control" required ng-pattern="/^(\\d+d)+(\\d+h)?(\\d+m)?(\\d+s)?$/" placeholder="You can specify a time unit after a time value \'X\', such as Xd, Xh, Xm, Xs, to represent days (d), hours (h) minutes (m) and seconds (s), respectively. Minimum value is 1d"><div ng-show="mySoopPlanForm.SoopDuration.$invalid"><p class="help-block" style="color:#f0ad4e" ng-show="mySoopPlanForm.SoopDuration.$invalid && (mySoopPlanForm.SoopDuration.$viewValue.length > 0)">Incorrect format.</p><p class="help-block" ng-show="mySoopPlanForm.SoopDuration.$error.required">This field is required.</p></div></div></div><div class="form-group"><label for="SoopPlanLabel" class="col-sm-2 control-label">Label</label><div class="col-sm-10"><input id="SoopPlanLabel" type="text" name="SoopPlanLabel" maxlength="40" ng-model="vm.soopPlanLabel" class="form-control" required ng-pattern="/^[0-9a-zA-Z\\.\\:\\<\\>\\ \\_\\@\\!\\(\\)\\{\\}\\,\\-\\[\\]]+$/"><div ng-show="mySoopPlanForm.SoopPlanLabel.$invalid && (mySoopPlanForm.SoopPlanLabel.$viewValue.length > 0)"><p class="help-block">Character not allowed</p></div><div ng-show="mySoopPlanForm.SoopPlanLabel.$error.required"><p class="help-block">This field is required.</p></div></div></div><div class="form-group"><label for="selectSoopType" class="col-sm-2 control-label">SOOP Type</label><div class="col-sm-10"><select id="selectSoopType" name="selectSoopType" required ng-model="vm.selectedSoopType" class="form-control"><option ng-repeat="soopType in vm.soopTypes" value="{{soopType}}">{{soopType}}</option></select><div ng-show="mySoopPlanForm.selectSoopType.$invalid"><p class="help-block" ng-show="mySoopPlanForm.selectSoopType.$error.required">This field is required.</p></div></div></div><div class="form-group"><label for="selectSoopLeadInstrument" class="col-sm-2 control-label">Lead Instrument</label><div class="col-sm-10"><select id="selectSoopLeadInstrument" name="selectSoopLeadInstrument" ng-model="vm.selectedSoopLeadInstrument" class="form-control"><option></option><option ng-repeat="instrument in vm.instruments" value="{{instrument}}">{{instrument}}</option></select></div></div><div class="form-group"><div class="col-sm-2"></div><div class="col-sm-10"><button id="createSoopPlanButton" class="btn btn-success pull-right" ng-disabled="!mySoopPlanForm.$valid" ng-click="vm.createSoopPlan()"><span class="glyphicon glyphicon-save"></span>&nbsp;&nbsp;<span>Create</span></button></div></div></form></div><br><h4>SOOPs available for scheduling</h4><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicateSoopBaselined" ascending="vm.reverseSoopBaselined" callback="vm.sortSoopPlanTableBaselined(vm.soopPlansBaselined, vm.predicateSoopBaselined, vm.reverseSoopBaselined)"><th jh-sort-by="label"><span>Label</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="baselineVersion"><span>Baseline Version</span><span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="soopType"><span>SOOP Type</span><span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="leadInstrument"><span>Lead Instrument</span><span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="created"><span>Creation Date</span><span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="timestamp"><span>Modification Date</span><span class="glyphicon glyphicon-sort"></span></th><th><span>Delta</span></th><th jh-sort-by="observationDefinitionsLabel"><span>Observation Definitions</span><span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="planMeta in vm.soopPlansBaselined track by $index"><td>{{planMeta.label}}</td><td>{{planMeta.baselineVersion}}</td><td>{{planMeta.soopType}}</td><td>{{planMeta.leadInstrument}}</td><td>{{vm.formatIsoZuluDateString(planMeta.created)}}</td><td>{{vm.formatIsoZuluDateString(planMeta.deltas[0].timestamp)}}</td><td><span valign="bottom" class="glyphicon glyphicon-plus" ng-show="!vm.showDelta[planMeta.label]" id="buttonSoopBaselinedDelta_plus" ng-click="vm.showDelta[planMeta.label] = true"></span> <span valign="bottom" class="glyphicon glyphicon-minus" ng-show="vm.showDelta[planMeta.label]" id="buttonSoopBaselinedDelta_minus" ng-click="vm.showDelta[planMeta.label] = false"><div ng-repeat="delta in planMeta.deltas">{{delta.prettyString}}</div></span></td><td>{{planMeta.observationDefinitionsLabel}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><span ng-show="planMeta.locked" style="margin:4px"><img alt="lock" height="22" width="22" src="content/images/lock.png"> </span><button id="buttonSoopBaselinedDetail_{{$index}}" type="submit" ui-sref="planning-detail({id:planMeta.label, baselineVersion:planMeta.baselineVersion, planType: vm.getPlanType(planMeta.planType)})" class="btn btn-primary btn-sm" data-toggle="tooltip" data-placement="bottom" title="View" delay="1000"><span class="glyphicon glyphicon-eye-open"></span></button> <button id="buttonSoopBaselinedVersions_{{$index}}" type="submit" ui-sref="planning.versions({id:planMeta.label, planType: vm.getPlanType(planMeta.planType)})" class="btn btn-primary btn-sm" data-toggle="tooltip" data-placement="bottom" title="Versions" delay="1000"><span class="glyphicon glyphicon-list"></span></button> <button id="buttonSoopBaselinedRename_{{$index}}" ng-disabled="planMeta.locked" has-authority="ROLE_PLAN_COORDINATOR" is-user-tables="{{planMeta.planUserInfo.owner}}" type="submit" ng-click="vm.renamePlan(planMeta.label, vm.getPlanType(planMeta.planType))" class="btn btn-primary btn-sm" data-toggle="tooltip" data-placement="bottom" title="Rename" delay="1000"><span class="glyphicon glyphicon-pencil"></span></button> <button id="buttonSoopBaselinedDelete_{{$index}}" ng-disabled="planMeta.locked" has-authority="ROLE_PLAN_COORDINATOR" is-user-tables="{{planMeta.planUserInfo.owner}}" type="submit" ng-click="vm.deletePlan(planMeta.label, vm.getPlanType(planMeta.planType))" class="btn btn-danger btn-sm" data-toggle="tooltip" data-placement="bottom" title="Delete" delay="1000"><span class="glyphicon glyphicon-remove-circle"></span></button></div></td></tr></tbody></table></div><h4>SOOPs in progress (not baselined)</h4><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicateSoopInProgress" ascending="vm.reverseSoopInProgress" callback="vm.sortSoopPlanTableInProgress(vm.soopPlansInProgress, vm.predicateSoopInProgress, vm.reverseSoopInProgress)"><th jh-sort-by="label"><span>Label</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="baselineVersion"><span>Baseline Version</span><span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="soopType"><span>SOOP Type</span><span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="leadInstrument"><span>Lead Instrument</span><span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="created"><span>Creation Date</span><span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="timestamp"><span>Modification Date</span><span class="glyphicon glyphicon-sort"></span></th><th><span>Delta</span></th><th jh-sort-by="observationDefinitionsLabel"><span>Observation Definitions</span><span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="planMeta in vm.soopPlansInProgress track by $index"><td>{{planMeta.label}}</td><td>{{planMeta.baselineVersion}}</td><td>{{planMeta.soopType}}</td><td>{{planMeta.leadInstrument}}</td><td>{{vm.formatIsoZuluDateString(planMeta.created)}}</td><td>{{vm.formatIsoZuluDateString(planMeta.deltas[0].timestamp)}}</td><td><span valign="bottom" class="glyphicon glyphicon-plus" ng-show="!vm.showDelta[planMeta.label]" id="buttonSoopInProgressDelta_plus" ng-click="vm.showDelta[planMeta.label] = true"></span> <span valign="bottom" class="glyphicon glyphicon-minus" ng-show="vm.showDelta[planMeta.label]" id="buttonSoopInProgressDelta_minus" ng-click="vm.showDelta[planMeta.label] = false"><div ng-repeat="delta in planMeta.deltas">{{delta.prettyString}}</div></span></td><td>{{planMeta.observationDefinitionsLabel}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><span ng-show="planMeta.locked" style="margin:4px"><img alt="lock" height="22" width="22" src="content/images/lock.png"> </span><button id="buttonSoopInProgressDetail_{{$index}}" type="submit" ui-sref="planning-detail({id:planMeta.label, baselineVersion:planMeta.baselineVersion, planType: vm.getPlanType(planMeta.planType)})" class="btn btn-primary btn-sm" data-toggle="tooltip" data-placement="bottom" title="View" delay="1000"><span class="glyphicon glyphicon-eye-open"></span></button> <button id="buttonSoopInProgressVersions_{{$index}}" type="submit" ui-sref="planning.versions({id:planMeta.label, planType: vm.getPlanType(planMeta.planType)})" class="btn btn-primary btn-sm" data-toggle="tooltip" data-placement="bottom" title="Versions" delay="1000"><span class="glyphicon glyphicon-list"></span></button> <button id="buttonSoopInProgressRename_{{$index}}" ng-disabled="planMeta.locked" has-authority="ROLE_PLAN_COORDINATOR" is-user-tables="{{planMeta.planUserInfo.owner}}" type="submit" ng-click="vm.renamePlan(planMeta.label, vm.getPlanType(planMeta.planType))" class="btn btn-primary btn-sm" data-toggle="tooltip" data-placement="bottom" title="Rename" delay="1000"><span class="glyphicon glyphicon-pencil"></span></button> <button id="buttonSoopInProgressDelete_{{$index}}" ng-disabled="planMeta.locked" has-authority="ROLE_PLAN_COORDINATOR" is-user-tables="{{planMeta.planUserInfo.owner}}" type="submit" ng-click="vm.deletePlan(planMeta.label, vm.getPlanType(planMeta.planType))" class="btn btn-danger btn-sm" data-toggle="tooltip" data-placement="bottom" title="Delete" delay="1000"><span class="glyphicon glyphicon-remove-circle"></span></button></div></td></tr></tbody></table></div>');
$templateCache.put('app/entities/planning/planning-versions-maintenance.html','<form name="dialogForm" role="form" class="form-horizontal" novalidate show-validation><div ng-include="\'app/entities/dialog-header.html\'"></div><div class="modal-body"><h5>Delete all internal versions before baseline: {{vm.selectedBaselineToDelete}}</h5><div class="header"><button id="cancelButton" type="button" class="btn btn-info" data-dismiss="modal" ng-click="vm.clear()" ng-disabled="vm.waiting"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>{{vm.cancelText}}</span></button> <button id="saveButton" type="button" class="btn btn-success" ng-click="vm.downloadFile()"><span class="glyphicon glyphicon-save-file"></span>&nbsp;<span>Download</span></button> <button class="btn btn-danger" ng-click="vm.deleteVersions()" ng-disabled="vm.waiting"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div><div class="table-responsive"><table class="table table-striped"><thead><tr><th width="5%"><span>Internal Version</span></th><th width="95%"><span>Delta</span></th></tr></thead><tbody><tr ng-repeat="plan in vm.plans"><td class="text-right"><span>{{plan.internalVersion}}</span></td><td class="text-left"><span valign="bottom" class="glyphicon glyphicon-plus" ng-show="!vm.showDelta[plan.internalVersion]" id="buttonDelta_plus" ng-click="vm.showDelta[plan.internalVersion] = true"></span> <span valign="bottom" class="glyphicon glyphicon-minus" ng-show="vm.showDelta[plan.internalVersion]" id="buttonDelta_minus" ng-click="vm.showDelta[plan.internalVersion] = false"><div ng-repeat="delta in plan.deltas">{{delta.prettyString}}</div></span></td></tr></tbody></table></div></div></form>');
$templateCache.put('app/entities/planning/planning-versions.html','<h2>Mission Timeline: {{vm.planning.label}} <span ng-show="vm.locked"><img alt="lock" ng-show="vm.locked" height="22" width="22" src="content/images/lock.png"></span><div class="pull-right"><button id="buttonLivePlan" type="submit" ui-sref="planning-detail({id:vm.planning.label, planType:vm.planType})" class="btn btn-primary"><span class="glyphicon glyphicon-eye-open"></span>&nbsp;<span>Live Plan</span></button></div></h2><hr><div class="row"><div class="col-md-4"><div class="panel panel-default"><div class="panel-heading"><h3 class="panel-title">Filter by Version Type(s)....</h3></div><div class="panel-body"><div class="row"><div class="col-md-12"><div class="checkbox" style="display: inline-block; padding-left: 5px; padding-right: 15px"><span class="glyphicon glyphicon-check" ng-show="vm.checkedBaselines" id="buttonBaselines" ng-click="vm.checkedAll=false;vm.toggleBaselines();"><label>Baselines</label></span><span class="glyphicon glyphicon-unchecked" ng-show="vm.checkedBaselines==false" id="buttonBaselines_unchecked" ng-click="vm.toggleBaselines()"><label><del>Baselines</del></label></span></div><div class="checkbox" style="display: inline-block; padding-left: 5px; padding-right: 15px"><span class="glyphicon glyphicon-check" ng-show="vm.checkedBookmarks" id="buttonBookmarks" ng-click="vm.checkedAll=false;vm.toggleBookmarks();"><label>Bookmarks</label></span><span class="glyphicon glyphicon-unchecked" ng-show="vm.checkedBookmarks==false" id="buttonBookmarks_unchecked" ng-click="vm.toggleBookmarks();"><label><del>Bookmarks</del></label></span></div><div class="checkbox" style="display: inline-block; padding-left: 5px; padding-right: 15px"><span class="glyphicon glyphicon-check" ng-show="vm.checkedAll" id="buttonAll" ng-click="vm.toggleAllVersions()"><label>All</label></span><span class="glyphicon glyphicon-unchecked" ng-show="vm.checkedAll==false" id="buttonAll_unchecked" ng-click="vm.toggleAllVersions()"><label><del>All</del></label></span></div></div></div></div></div></div><div class="col-md-8"><div class="panel panel-default"><div class="panel-heading"><h3 class="panel-title">Filter by Instrument(s)/Events</h3></div><div class="panel-body"><div class="row"><div class="col-md-12"><div ng-repeat="instrument in vm.instruments" style="display: inline-block; padding-left: 5px; padding-right: 15px"><div class="checkbox"><span class="glyphicon glyphicon-check" ng-show="vm.checkedInstrument[instrument]" id="checkbox{{instrument}}" ng-click="vm.uncheckInstrument(instrument)"><label>{{instrument}}</label></span><span class="glyphicon glyphicon-unchecked" ng-show="vm.checkedInstrument[instrument]==false" id="checkbox{{instrument}}_unchecked" ng-click="vm.checkInstrument(instrument)"><label><del>{{instrument}}</del></label></span></div></div><div class="checkbox" style="display: inline-block; padding-left: 5px; padding-right: 15px"><span class="glyphicon glyphicon-check" ng-show="vm.checkedEvents" id="checkbox_checkedEvents" ng-click="vm.uncheckEvents()"><label>Events</label></span><span class="glyphicon glyphicon-unchecked" ng-show="vm.checkedEvents===false" id="checkbox_checkedEvents_unchecked" ng-click="vm.checkEvents()"><label><del>Events</del></label></span></div><div class="checkbox" style="display: inline-block; padding-left: 5px; padding-right: 15px"><span class="glyphicon glyphicon-check" ng-show="vm.checkedAllInstrument" id="checkbox_checkedAllInstrument" ng-click="vm.uncheckAllInstruments()"><label>All</label></span><span class="glyphicon glyphicon-unchecked" ng-show="vm.checkedAllInstrument===false" id="checkbox_checkedAllInstrument_unchecked" ng-click="vm.checkAllInstruments()"><label><del>All</del></label></span></div></div></div></div></div></div></div><div class="row" has-authority="ROLE_PLAN_COORDINATOR"><div class="col-md-4"><div class="panel panel-default"><div class="panel-heading"><h3 class="panel-title">Version Maintenance</h3></div><div class="panel-body"><div class="row"><div class="col-md-12"><div style="display: inline-block; padding-left: 5px; padding-right: 15px"><span class="glyphicon glyphicon-remove-circle" id="delete_versions_from" ng-click="vm.deleteVersions()"><label>Delete</label></span>&nbsp;&nbsp;all(*) internal versions before baseline</div><div style="display: inline-block; padding-left: 5px; padding-right: 15px"><span><select name="selectBaselineToDelete" id="selectBaselineToDelete" class="form-control" ng-model="vm.selectedBaselineToDelete" ng-options="o as o for o in vm.baselinesToDelete"></select></span></div></div></div><div class="row"><div class="col-md-12"><div style="display: inline-block; padding-left: 5px; padding-right: 15px">* No baselined or bookmarked version will be deleted.</div></div></div></div></div></div><!--    <div class="col-md-8">--><!--        <div class="panel panel-default" has-any-authority="ROLE_POWER_USER,ROLE_PLAN_COORDINATOR">--><!--            <div class="panel-heading">--><!--                <h3 class="panel-title">Commit Simulation</h3>--><!--            </div>--><!--            <div class="panel-body">--><!--                <div class="row">--><!--                    <div class="col-md-12">--><!--                        <div style="display: inline-block; padding-left: 5px; padding-right: 15px">--><!--                            Commit files from the last simulation executed--><!--                            <button--><!--                                ng-if="vm.isMaster"--><!--                                id="commit" ng-click="vm.commitSimulation(plan)" class="btn btn-primary btn-sm" data-toggle="tooltip" data-placement="bottom"--><!--                                title="Simulate" delay="1000">--><!--                                <span class="glyphicon glyphicon-cloud-upload"></span>--><!--                            </button>--><!--                        </div>--><!--                    </div>--><!--                </div>--><!--            </div>--><!--        </div>--><!--    </div>--></div><hr><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.ascending" callback="vm.sortTable()"><th jh-sort-by="baselineVersion"><span>Baseline Version</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="internalVersion"><span>Internal Version</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="timestamp" width="10%"><span>TimeStamp</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="comment" width="30%"><span>Comment</span> <span class="glyphicon glyphicon-sort"></span></th><th width="50%"><span>Delta</span></th><th width="10%"><span></span></th></tr></thead><tbody><tr ng-repeat="plan in vm.plans " ng-show="vm.displayVersion(plan) && vm.instrumentChecked(plan)"><td class="text-right"><span ng-show="plan.baselineVersion > 0">{{plan.baselineVersion}}</span></td><td class="text-right"><span>{{plan.internalVersion}}</span></td><td>{{plan.timestamp}}</td><td><span ng-show="plan.isBookmarked" class="glyphicon glyphicon-bookmark"></span> <span ng-show="plan.baselineVersion > 0" class="glyphicon glyphicon-leaf"></span> <span ng-show="plan.comment != null">{{plan.comment}}<span ng-show="plan.internalVersion === vm.planning.internalVersion" class="label label-info">LAST VERSION</span></span></td><td><span valign="bottom" class="glyphicon glyphicon-plus" ng-show="!vm.showDelta[plan.internalVersion]" id="buttonDelta_plus" ng-click="vm.showDelta[plan.internalVersion] = true"></span> <span valign="bottom" class="glyphicon glyphicon-minus" ng-show="vm.showDelta[plan.internalVersion]" id="buttonDelta_minus" ng-click="vm.showDelta[plan.internalVersion] = false"><div ng-repeat="delta in plan.deltas">{{delta.prettyString}}</div></span></td><td><div class="btn-group flex-btn-group-container"><button ng-if="vm.isMaster" has-any-authority="ROLE_PLAN_COORDINATOR,ROLE_POWER_USER" id="buttonChecks_{{plan.internalVersion}}" ng-click="vm.sanityChecks(plan.internalVersion)" class="btn btn-primary btn-sm" data-toggle="tooltip" data-placement="bottom" title="Run Sanity Checks" delay="1000"><span class="glyphicon glyphicon-flash"></span></button> <button id="buttonView_{{plan.internalVersion}}" type="submit" ui-sref="planning-detail-version({id:plan.label, internalVersion:plan.internalVersion, planType: vm.planType})" class="btn btn-primary btn-sm" data-toggle="tooltip" data-placement="bottom" title="View plan version {{plan.internalVersion}}" delay="1000"><span class="glyphicon glyphicon-eye-open"></span></button> <button ng-if="vm.isMaster" has-authority="ROLE_PLAN_COORDINATOR" id="buttonClone_{{plan.internalVersion}}" ng-click="vm.clone(plan.internalVersion)" class="btn btn-primary btn-sm" data-toggle="tooltip" data-placement="bottom" title="Clone" delay="1000"><span class="glyphicon glyphicon-duplicate"></span></button> <button ng-if="vm.isChild" has-any-authority="ROLE_PLAN_COORDINATOR,ROLE_INSTRUMENT_COORDINATOR,ROLE_POWER_USER" id="buttonClone_{{plan.internalVersion}}" ng-click="vm.clone(plan.internalVersion)" class="btn btn-primary btn-sm" data-toggle="tooltip" data-placement="bottom" title="Clone" delay="1000"><span class="glyphicon glyphicon-duplicate"></span></button> <button ng-if="vm.isTemplate" has-any-authority="ROLE_PLAN_COORDINATOR,ROLE_INSTRUMENT_TEAM_MEMBER,ROLE_INSTRUMENT_COORDINATOR,ROLE_POWER_USER" id="buttonClone_{{plan.internalVersion}}" ng-click="vm.clone(plan.internalVersion)" class="btn btn-primary btn-sm" data-toggle="tooltip" data-placement="bottom" title="Clone" delay="1000"><span class="glyphicon glyphicon-duplicate"></span></button> <button ng-if="vm.isSoop" has-authority="ROLE_PLAN_COORDINATOR" id="buttonClone_{{plan.internalVersion}}" ng-click="vm.clone(plan.internalVersion)" class="btn btn-primary btn-sm" data-toggle="tooltip" data-placement="bottom" title="Clone" delay="1000"><span class="glyphicon glyphicon-duplicate"></span></button> <button id="export" ng-click="vm.downloadFile(plan)" class="btn btn-primary btn-sm" data-toggle="tooltip" data-placement="bottom" title="Export" delay="1000"><span class="glyphicon glyphicon-save-file"></span></button> <button id="export_comparison" ng-click="vm.downloadComparison(plan)" class="btn btn-primary btn-sm" data-toggle="tooltip" data-placement="bottom" title="Comparison Export" delay="1000"><span class="glyphicon glyphicon-transfer"></span></button> <button ng-if="vm.isMaster && vm.isLtp" has-any-authority="ROLE_POWER_USER,ROLE_PLAN_COORDINATOR" id="simulate" ng-click="vm.simulatePlan(plan)" class="btn btn-primary btn-sm" data-toggle="tooltip" data-placement="bottom" title="Simulate" delay="1000"><span class="glyphicon glyphicon-play"></span></button> <button ng-if="vm.isMaster && vm.isLtp" has-any-authority="ROLE_POWER_USER,ROLE_PLAN_COORDINATOR" id="draftS15TDR" ng-click="vm.draftS15TDR(plan)" class="btn btn-primary btn-sm" data-toggle="tooltip" data-placement="bottom" title="Draft S15 TDR" delay="1000"><span class="glyphicon glyphicon-file"></span></button> <button ng-if="vm.isMaster && vm.isLtp" has-any-authority="ROLE_POWER_USER,ROLE_PLAN_COORDINATOR" id="plotsGeneration" ng-click="vm.plotsGeneration(plan)" class="btn btn-primary btn-sm" data-toggle="tooltip" data-placement="bottom" title="Plots Generation" delay="500"><span class="glyphicon glyphicon-signal"></span></button> <button ng-if="vm.isMaster && vm.isLtp" has-any-authority="ROLE_POWER_USER,ROLE_PLAN_COORDINATOR" id="downloadResult" ng-click="vm.donwloadResults(plan, false)" class="btn btn-primary btn-sm" data-toggle="tooltip" data-placement="bottom" title="Download" delay="1000"><span class="glyphicon glyphicon-download"></span></button> <button ng-if="vm.isMaster && vm.isLtp" has-any-authority="ROLE_POWER_USER,ROLE_PLAN_COORDINATOR" id="editTDR" ng-click="vm.editTDR(plan)" class="btn btn-primary btn-sm" data-toggle="tooltip" data-placement="bottom" title="TDR Editor" delay="500"><span class="glyphicon glyphicon-list-alt"></span></button> <button ng-if="vm.isMaster && vm.isLtp" has-any-authority="ROLE_POWER_USER,ROLE_PLAN_COORDINATOR" id="commitPush" ng-click="vm.commitPush(plan)" class="btn btn-primary btn-sm" data-toggle="tooltip" data-placement="bottom" title="Commit" delay="1000"><span class="glyphicon glyphicon-cloud-upload"></span></button> <button ng-if="vm.isMaster" id="buttonRollback" has-authority="ROLE_PLAN_COORDINATOR" ng-show="vm.locked" id="buttonRollback" ng-click="vm.rollback(plan.internalVersion)" class="btn btn-primary btn-sm" data-toggle="tooltip" data-placement="bottom" title="Rollback" delay="1000"><span class="glyphicon glyphicon-retweet"></span></button> <button ng-if="vm.isChild" id="buttonRollback" has-authority="ROLE_PLAN_COORDINATOR" is-user="{{vm.planning.planUserInfo.owner}}" is-in-users-authorities="ROLE_INSTRUMENT_COORDINATOR" is-in-users="{{vm.planning.planUserInfo.usersWithRights}}" ng-show="vm.locked" id="buttonRollback" ng-click="vm.rollback(plan.internalVersion)" class="btn btn-primary btn-sm" data-toggle="tooltip" data-placement="bottom" title="Rollback" delay="1000"><span class="glyphicon glyphicon-retweet"></span></button> <button ng-if="vm.isTemplate" id="buttonRollback" has-authority="ROLE_PLAN_COORDINATOR" is-user="{{vm.planning.planUserInfo.owner}}" is-in-users-authorities="ROLE_INSTRUMENT_COORDINATOR" is-in-users="{{vm.planning.planUserInfo.usersWithRights}}" ng-show="vm.locked" id="buttonRollback" ng-click="vm.rollback(plan.internalVersion)" class="btn btn-primary btn-sm" data-toggle="tooltip" data-placement="bottom" title="Rollback" delay="1000"><span class="glyphicon glyphicon-retweet"></span></button> <button ng-if="vm.isSoop" id="buttonRollback" has-authority="ROLE_PLAN_COORDINATOR" ng-show="vm.locked" id="buttonRollback" ng-click="vm.rollback(plan.internalVersion)" class="btn btn-primary btn-sm" data-toggle="tooltip" data-placement="bottom" title="Rollback" delay="1000"><span class="glyphicon glyphicon-retweet"></span></button></div></td></tr></tbody></table></div><button id="backButton" type="submit" ui-sref="{{vm.previousState}}({{vm.previousParams}})" class="btn btn-primary"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button><div class="alert-fixed"><jhi-alert-error></jhi-alert-error><jhi-alert></jhi-alert></div>');
$templateCache.put('app/entities/planning/planning.html','<h2>Planning</h2><div ng-repeat="n in [0,1,2,3]"><div ng-if="vm.activeTab === n" has-any-authority="{{vm.tabAuthorities[n]}}" class="pull-right"><button id="openCreateMenuButton" class="btn btn-primary btn-sm h2-btn-margin" ng-click="vm.showCreateMenu[n] = ! vm.showCreateMenu[n]"><span ng-switch="vm.showCreateMenu[n]"><span ng-switch-when="false" class="glyphicon glyphicon-plus-sign"></span> <span ng-switch-when="true" class="glyphicon glyphicon-minus-sign"></span> <span ng-switch-default class="glyphicon glyphicon-plus-sign"></span> </span>&nbsp;&nbsp;<span>Create new</span></button></div></div><uib-tabset active="vm.activeTab"><uib-tab index="0" heading="Operational Plans" select="vm.setActiveTab(0)" popover-placement="right-top" uib-popover-html="vm.masterPlanInfo" popover-popup-delay="1000" popover-trigger="mouseenter"><div ng-include="\'app/entities/planning/planning-operational-plans.html\'"></div></uib-tab><uib-tab index="1" heading="Child Plans" select="vm.setActiveTab(1)" popover-placement="right-top" uib-popover-html="vm.childPlanInfo" popover-popup-delay="1000" popover-trigger="mouseenter"><div ng-include="\'app/entities/planning/planning-child-plans.html\'"></div></uib-tab><uib-tab index="2" heading="Floating Timelines" select="vm.setActiveTab(2)" popover-placement="right-top" uib-popover-html="vm.templatePlanInfo" popover-popup-delay="1000" popover-trigger="mouseenter"><div ng-include="\'app/entities/planning/planning-floating-timelines.html\'"></div></uib-tab><uib-tab index="3" heading="SOOPs" select="vm.setActiveTab(3)" popover-placement="right-top" uib-popover-html="vm.soopPlanInfo" popover-popup-delay="1000" popover-trigger="mouseenter"><div ng-include="\'app/entities/planning/planning-soops.html\'"></div></uib-tab></uib-tabset><div class="alert-fixed"><jhi-alert-error></jhi-alert-error><jhi-alert></jhi-alert></div>');
$templateCache.put('app/entities/planning/rename-plan.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear(\'cancel\')">&times;</button><h3 class="modal-title">Rename Plan <span class="label label-info">{{vm.existingLabel}}</span></h3></div><div class="modal-body"><form name="renameForm" role="form" class="form-horizontal" novalidate show-validation><div class="form-group"><label for="NewPlanLabel" class="col-sm-2 control-label">New Label</label><div class="col-sm-10"><input class="form-control" name="NewPlanLabel" id="NewPlanLabel" ng-model="vm.newPlanLabel" maxlength="40" size="40" type="text" required ng-pattern="/^[0-9a-zA-Z\\.\\:\\<\\>\\ \\_\\@\\!\\(\\)\\{\\}\\,\\-\\[\\]]+$/"><div ng-show="renameForm.NewPlanLabel.$invalid && (renameForm.NewPlanLabel.$viewValue.length > 0)"><p class="help-block">Character not allowed</p></div><div ng-show="renameForm.NewPlanLabel.$error.required"><p class="help-block">This field is required.</p></div></div></div></form><div class="modal-footer"><button id="cancelButton" type="button" class="btn btn-info" data-dismiss="modal" ng-click="vm.clear(\'cancel\')"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button id="saveButton" type="button" class="btn btn-success" ng-click="vm.rename()" ng-disabled="!renameForm.$valid"><span class="glyphicon glyphicon-duplicate"></span>&nbsp;<span>Rename</span></button></div><jhi-alert-error></jhi-alert-error><jhi-alert></jhi-alert></div>');
$templateCache.put('app/entities/planning/set-efecs-version.html','<form name="dialogForm" role="form" class="form-horizontal" novalidate show-validation><div ng-include="\'app/entities/dialog-header.html\'"></div><div class="modal-body"><div class="form-group"><label class="col-sm-6 control-label">Efecs Version</label><div class="col-sm-6"><input class="form-control" name="efecsVersion" id="efecsVersion" size="2" max="99" min="1" type="number" ng-model="vm.efecsVersion" required></div></div><div class="form-group"><label class="col-sm-6 control-label">Prime</label><div class="col-sm-6"><input class="form-control" name="prime" id="prime" maxlength="1" size="1" type="text" ng-model="vm.prime" required></div></div></div><div ng-include="\'app/entities/dialog-footer.html\'"></div></form>');
$templateCache.put('app/entities/planning/soopify.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h3 class="modal-title">Create SOOP out of Plan <span class="label label-info">{{vm.labelToSoopify}}</span>, Version <span class="label label-info">{{vm.internalVersionToSoopify}}</span></h3></div><div class="modal-body"><form name="mySoopPlanForm" class="form-horizontal"><div class="form-group"><label for="SoopPlanLabel" class="col-sm-3 control-label">Label</label><div class="col-sm-9"><input id="SoopPlanLabel" type="text" name="SoopPlanLabel" ng-model="vm.planLabel" class="form-control" required ng-pattern="/^[0-9a-zA-Z\\.\\:\\<\\>\\ \\_\\@\\!\\(\\)\\{\\}\\,\\-\\[\\]]+$/"><div ng-show="mySoopPlanForm.SoopPlanLabel.$invalid && (mySoopPlanForm.SoopPlanLabel.$viewValue.length > 0)"><p class="help-block">Character not allowed</p></div><div ng-show="mySoopPlanForm.SoopPlanLabel.$error.required"><p class="help-block">This field is required.</p></div></div></div><div class="form-group"><label for="selectSoopType" class="col-sm-3 control-label">SOOP Type</label><div class="col-sm-9"><select id="selectSoopType" name="selectSoopType" required ng-model="vm.selectedSoopType" class="form-control"><option ng-repeat="soopType in vm.soopTypes" value="{{soopType}}">{{soopType}}</option></select><div ng-show="mySoopPlanForm.selectSoopType.$invalid"><p class="help-block" ng-show="mySoopPlanForm.selectSoopType.$error.required">This field is required.</p></div></div></div><div class="form-group"><label for="selectSoopLeadInstrument" class="col-sm-3 control-label">Lead Instrument</label><div class="col-sm-9"><select id="selectSoopLeadInstrument" name="selectSoopLeadInstrument" ng-model="vm.selectedSoopLeadInstrument" class="form-control"><option></option><option ng-repeat="instrument in vm.instruments" value="{{instrument}}">{{instrument}}</option></select></div></div></form><div class="modal-footer"><button id="cancelButton" type="button" class="btn btn-info" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button id="saveButton" type="button" class="btn btn-success" ng-click="vm.save()" ng-disabled="!mySoopPlanForm.$valid"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Create</span></button></div><jhi-alert-error></jhi-alert-error><jhi-alert></jhi-alert></div>');
$templateCache.put('app/entities/planning/unsoopify.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h3 class="modal-title">Create Floating Timeline out of Plan <span class="label label-info">{{vm.labelToUnsoopify}}</span>, Version <span class="label label-info">{{vm.internalVersionToUnsoopify}}</span></h3></div><div class="modal-body"><form name="myTemplatePlanForm" class="form-horizontal"><div class="form-group"><label for="TemplatePlanLabel" class="col-sm-2 control-label">Label</label><div class="col-sm-10"><input id="TemplatePlanLabel" type="text" name="TemplatePlanLabel" ng-model="vm.planLabel" class="form-control" required ng-pattern="/^[0-9a-zA-Z\\.\\:\\<\\>\\ \\_\\@\\!\\(\\)\\{\\}\\,\\-\\[\\]]+$/"><div ng-show="myTemplatePlanForm.TemplatePlanLabel.$invalid && (myTemplatePlanForm.TemplatePlanLabel.$viewValue.length > 0)"><p class="help-block">Character not allowed</p></div><div ng-show="myTemplatePlanForm.TemplatePlanLabel.$error.required"><p class="help-block">This field is required.</p></div></div></div></form></div><div class="modal-footer"><button id="cancelButton" type="button" class="btn btn-info" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button id="saveButton" type="button" class="btn btn-success" ng-click="vm.save()" ng-disabled="!myTemplatePlanForm.$valid"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Create</span></button></div><jhi-alert-error></jhi-alert-error><jhi-alert></jhi-alert>');
$templateCache.put('app/layouts/error/accessdenied.html','<div ng-cloak><div class="row"><div class="col-md-3"><span class="hipster img-responsive img-rounded"></span></div><div class="col-md-7"><div class="row"><div class="col-md-12"><h1 class="page-header">Error Page!</h1><div class="alert alert-danger">You are not authorized to access the page.</div></div></div></div></div></div>');
$templateCache.put('app/layouts/error/error.html','<div ng-cloak><div class="row"><div class="col-md-3"><span class="hipster img-responsive img-rounded"></span></div><div class="col-md-7"><div class="row"><div class="col-md-12"><h1 class="page-header">Error Page!</h1><div ng-show="errorMessage"><div class="alert alert-danger">{{errorMessage}}</div></div></div></div></div></div></div>');
$templateCache.put('app/layouts/navbar/navbar.html','<nav class="navbar navbar-default" role="navigation"><div><div class="navbar-header"><button type="button" class="navbar-toggle" ng-click="vm.toggleNavbar()"><span class="sr-only">Toggle navigation</span> <span class="icon-bar"></span> <span class="icon-bar"></span> <span class="icon-bar"></span></button> <a class="navbar-brand logo" href="#/" ng-click="vm.collapseNavbar()"><img class="logo-img" src="content/images/LogoSoopKitchen_200px.png" alt="logo"> <span>Soopkitchen</span> <span class="navbar-version">v{{VERSION}}</span></a></div><div class="navbar-collapse" uib-collapse="vm.isNavbarCollapsed" ng-switch="vm.isAuthenticated()"><ul class="nav navbar-nav navbar-right"><li ui-sref-active="active"><a ui-sref="home" ng-click="vm.collapseNavbar()" id="home-link"><span class="glyphicon glyphicon-home"></span> <span class="hidden-sm">Home</span></a></li><li ng-class="{active: vm.$state.includes(\'observation-definitions\')}" ng-switch-when="true" has-any-authority="ROLE_INSTRUMENT_COORDINATOR,ROLE_INSTRUMENT_TEAM_MEMBER,ROLE_ADMIN,ROLE_USER,ROLE_POWER_USER,ROLE_PLAN_COORDINATOR"><a ui-sref="observation-definitions" ng-click="vm.collapseNavbar()" id="observation-definitions-link"><span class="glyphicon glyphicon-list-alt"></span>&nbsp; <span>Observation Definitions</span></a></li><li ng-class="{active: vm.$state.includes(\'event-collections\')}" ng-switch-when="true" has-any-authority="ROLE_INSTRUMENT_COORDINATOR,ROLE_INSTRUMENT_TEAM_MEMBER,ROLE_ADMIN,ROLE_USER,ROLE_POWER_USER,ROLE_PLAN_COORDINATOR"><a ui-sref="event-collections" ng-click="vm.collapseNavbar()" id="event-collections-link"><span class="glyphicon glyphicon-calendar"></span>&nbsp; <span>Event Collections</span></a></li><li ng-class="{active: vm.$state.includes(\'planning\')}" ng-switch-when="true" has-any-authority="ROLE_INSTRUMENT_COORDINATOR,ROLE_INSTRUMENT_TEAM_MEMBER,ROLE_ADMIN,ROLE_USER,ROLE_POWER_USER,ROLE_PLAN_COORDINATOR" id="planning-link"><a ui-sref="planning" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-blackboard"></span>&nbsp; <span>Planning</span></a></li><!-- jhipster-needle-add-element-to-menu - JHipster will add new menu items here --><!--                 <li ng-class="{active: vm.$state.includes(\'entity\')}" ng-switch-when="true" has-any-authority="ROLE_USER,ROLE_POWER_USER,ROLE_PLAN_COORDINATOR" uib-dropdown class="dropdown pointer"> --><!--                     <a class="dropdown-toggle" uib-dropdown-toggle href="" id="entity-menu"> --><!--                         <span> --><!--                             <span class="glyphicon glyphicon-th-list"></span> --><!--                             <span class="hidden-sm"> --><!--                                 Entities --><!--                             </span> --><!--                             <b class="caret"></b> --><!--                         </span> --><!--                     </a> --><!--                     <ul class="dropdown-menu" uib-dropdown-menu> --><!--                         <li ui-sref-active="active"> --><!--                             <a ui-sref="observation-definitions" ng-click="vm.collapseNavbar()"> --><!--                                 <span class="glyphicon glyphicon-asterisk"></span>&nbsp; --><!--                                 <span >Observation Definitions</span> --><!--                             </a> --><!--                         </li> --><!--                         <li ui-sref-active="active"> --><!--                             <a ui-sref="event-collections" ng-click="vm.collapseNavbar()"> --><!--                                 <span class="glyphicon glyphicon-asterisk"></span>&nbsp; --><!--                                 <span >Event Collections</span> --><!--                             </a> --><!--                         </li> --><!--                         <li ui-sref-active="active"> --><!--                             <a ui-sref="planning" ng-click="vm.collapseNavbar()"> --><!--                                 <span class="glyphicon glyphicon-asterisk"></span>&nbsp; --><!--                                 <span >Planning</span> --><!--                             </a> --><!--                         </li> --><!--                         jhipster-needle-add-entity-to-menu - JHipster will add entities to the menu here --><!--                     </ul> --><!--                 </li> --><li ng-class="{active: vm.$state.includes(\'account\')}" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="account-menu"><span><span class="glyphicon glyphicon-user"></span> <span class="hidden-sm">Account </span><strong class="caret"></strong></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active" ng-switch-when="true"><a ui-sref="settings" ng-click="vm.collapseNavbar()" id="settings-link"><span class="glyphicon glyphicon-wrench"></span>&nbsp; <span>Settings</span></a></li><li ui-sref-active="active" ng-switch-when="true"><a ui-sref="password" ng-click="vm.collapseNavbar()" id="password-link"><span class="glyphicon glyphicon-lock"></span>&nbsp; <span>Password</span></a></li><li ui-sref-active="active" ng-switch-when="true" id="sessions-link"><a ui-sref="sessions" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-cloud"></span>&nbsp; <span>Sessions</span></a></li><li ui-sref-active="active" ng-switch-when="true"><a href="" ng-click="vm.logout()" id="logout" id="sign-out-link"><span class="glyphicon glyphicon-log-out"></span>&nbsp; <span>Sign out</span></a></li><li ui-sref-active="active" ng-switch-when="false"><a href="" ng-click="vm.login()" id="login"><span class="glyphicon glyphicon-log-in"></span>&nbsp; <span>Sign in</span></a></li><li ui-sref-active="active" ng-switch-when="false"><a ui-sref="register" ng-click="vm.collapseNavbar()" id="register-link"><span class="glyphicon glyphicon-plus-sign"></span>&nbsp; <span>Register</span></a></li></ul></li><li ng-class="{active: vm.$state.includes(\'admin\')}" ng-switch-when="true" has-authority="ROLE_ADMIN" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="admin-menu"><span><span class="glyphicon glyphicon-tower"></span> <span class="hidden-sm">Administration</span> <strong class="caret"></strong></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active"><a ui-sref="user-management" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-user"></span>&nbsp; <span>User management</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-tracker" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-eye-open"></span>&nbsp; <span>User tracker</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-metrics" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-dashboard"></span>&nbsp; <span>Metrics</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-health" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-heart"></span>&nbsp; <span>Health</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-configuration" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-list-alt"></span>&nbsp; <span>Configuration</span></a></li><li ui-sref-active="active"><a ui-sref="audits" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-bell"></span>&nbsp; <span>Audits</span></a></li><li ui-sref-active="active"><a ui-sref="logs" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-tasks"></span>&nbsp; <span>Logs</span></a></li><li ng-show="vm.swaggerEnabled" ui-sref-active="active"><a ui-sref="docs" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-book"></span>&nbsp; <span>API</span></a></li><!-- jhipster-needle-add-element-to-admin-menu - JHipster will add entities to the admin menu here --></ul></li></ul></div></div></nav>');
$templateCache.put('app/account/reset/finish/reset.finish.html','<div><div class="row"><div class="col-md-4 col-md-offset-4"><h1>Reset password</h1><div class="alert alert-danger" ng-show="vm.keyMissing"><strong>The password reset key is missing.</strong></div><div class="alert alert-warning" ng-hide="vm.success || vm.keyMissing"><p>Choose a new password</p></div><div class="alert alert-danger" ng-show="vm.error"><p>Your password couldn\'t be reset. Remember a password request is only valid for 24 hours.</p></div><div class="alert alert-success" ng-show="vm.success"><p><strong>Your password has been reset.</strong> Please <a class="alert-link" href="" ng-click="vm.login()">sign in</a>.</p></div><div class="alert alert-danger" ng-show="vm.doNotMatch">The password and its confirmation do not match!</div><div ng-hide="vm.keyMissing"><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.finishReset()" show-validation><div class="form-group"><label class="control-label" for="password">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="New password" ng-model="vm.resetAccount.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.resetAccount.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="Confirm the new password" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required">Your password confirmation is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength">Your password confirmation is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength">Your password confirmation cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary">Reset Password</button></form></div></div></div></div>');
$templateCache.put('app/account/reset/request/reset.request.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1>Reset your password</h1><div class="alert alert-danger" ng-show="vm.errorEmailNotExists"><strong>E-Mail address isn\'t registered!</strong> Please check and try again.</div><div class="alert alert-warning" ng-hide="vm.success"><p>Enter the e-mail address you used to register.</p></div><div class="alert alert-success" ng-show="vm.success == \'OK\'"><p>Check your e-mails for details on how to reset your password.</p></div><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.requestReset()" show-validation><div class="form-group"><label class="control-label" for="email">E-mail</label><input type="email" class="form-control" id="email" name="email" placeholder="Your e-mail" ng-model="vm.resetAccount.email" ng-minlength="5" ng-maxlength="100" required><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required">Your e-mail is required.</p><p class="help-block" ng-show="form.email.$error.email">Your e-mail is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength">Your e-mail is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength">Your e-mail cannot be longer than 100 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary">Reset</button></form></div></div></div>');}]);})();